/*
*	MG2 Media JS Framework
*	@author  François Vandal
*	@version: 0.9.4
*	Last update: 6 september 2016
*/

(function ($, global, undefined) {
	var html = $('html');
	var lang = html.attr('lang');
	var defaultLang = html.attr('data-default-lang');

	var modules = {};
	var components = {};
	var pages = {};

	/* Modules */
	var createModule = function createModule(module) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageChange: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop,
			pageStartChange: $.noop
		}, module);
	};

	var exportModule = function exportModule(key, module) {
		modules[key] = createModule(module);

		return modules[key];
	};

	/* Pages */
	var createPage = function createPage(page) {
		return $.extend({
			init: $.noop,
			pageLoad: $.noop,
			pageEnter: $.noop,
			pageLeave: $.noop
		}, page);
	};

	var exportPage = function exportPage(key, page) {
		pages[key] = createPage(page);

		return pages[key];
	};

	var checkForPage = function checkForPage(pageIdNum) {
		var currPage = $('.main-content .page[data-page-id-num=' + pageIdNum + ']').attr('data-page-id');

		if (pages[pageIdNum] !== undefined) {
			pages[pageIdNum].init('#page-' + currPage);
			pages[pageIdNum].pageLoad('#page-' + currPage);
		}
	};

	/* Components */
	var createComponent = function createComponent(component) {
		return $.extend({ init: $.noop }, component);
	};

	var exportComponent = function exportComponent(key, component) {
		components[key] = createPage(component);

		return pages[key];
	};

	var start = function start() {
		var lang = $('html').attr('lang');
		var defaultLang = $('html').attr('data-default-lang');

		var currPathname = location.pathname;
		var currentIdNum = $('.main-content .page').data('pageIdNum');

		if (currPathname !== '/' && currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		if (lang !== defaultLang) {
			currPathname = currPathname.substring(lang.length);
		}

		currPathname = currPathname !== '/' ? currPathname : 'home';

		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname + 'home';
		}

		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		currPathname = currPathname.split('?')[0];
		if (currPathname.substring(currPathname.length - 1) === '/') {
			currPathname = currPathname.substring(0, currPathname.length - 1);
		}

		if (lang !== defaultLang) {
			if (currPathname.substring(0, lang.length) === lang) {
				currPathname = currPathname.substring(lang.length);
			}
		}

		if (currPathname.substring(0, 1) === '/') {
			currPathname = currPathname.substring(1);
		}

		currPathname = currPathname.split('/')[0];

		$.each(Fw.modules.models(), function () {
			this.init('body');
			this.pageLoad('body');
		});

		$('html').attr('data-curr-page', 'page-' + currPathname);
		checkForPage(currentIdNum);

		return Fw;
	};

	global.Fw = $.extend(global.Fw, {
		data: '',

		modules: {
			models: function models() {
				return modules;
			},

			export: exportModule
		},

		component: {
			models: function models() {
				return components;
			},

			export: exportComponent
		},

		page: {
			models: function models() {
				return pages;
			},

			export: exportPage,

			checkForPage: checkForPage
		},

		start: start
	});
})(jQuery, window);
(function ($, undefined) {
	'use strict';

	var toggleAccordion = function toggleAccordion() {
		var t = $(this);
		var id = t.closest('.accordion-outer-ctn').attr('data-id');

		if ($('.accordion-outer-ctn.open').length && $('.accordion-outer-ctn.open').attr('data-id') !== id) {
			$('.accordion-outer-ctn.open').find('.accordion-content').slideUp();
			$('.accordion-outer-ctn.open').removeClass('open');
		}

		t.closest('.accordion-outer-ctn').toggleClass('open').find('.accordion-content').slideToggle();
	};

	var init = function init() {
		$('.accordion-header-ctn').click(toggleAccordion);
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var popup;
	var form;
	var savesPage;
	var sliders;

	var submitSaveForm = function submitSaveForm() {
		var t = $(this);
		var currForm = t.closest('.artists-com-save-form');

		var demoId = $('input[name="demoId"]', currForm).val();
		var count = 0;
		var total = $('.artist-demo-add-to-save-item:not(.clone)', currForm).length;

		popup.closeAllPopup();

		$('.artist-demo-add-to-save-item:not(.clone)', currForm).each(function () {
			var item = $(this);
			var saveId = $('input[name="saveId"]', item).val();
			var demosArray = $('input[name="demosArray"]', item).val().split(',');
			var isChecked = $('.artist-demo-add-to-save-item-check input', item).is(':checked');

			if (!isChecked && demosArray.indexOf(demoId) !== -1) {
				demosArray.splice(demosArray.indexOf(demoId), 1);
			} else if (isChecked && demosArray.indexOf(demoId) === -1) {
				demosArray.push(demoId);
			}

			//Remove empty array element caused by empty split
			demosArray = demosArray.filter(function (el) {
				return el != '';
			});

			$('input[name="saveId"][value="' + saveId + '"]').each(function () {
				var allSaveItems = $(this).closest('.artist-demo-add-to-save-item').find('[name="demosArray"]').val(demosArray.toString());
			});

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: saveId,
					field3: demosArray.toString(),
					ajax: true
				},
				success: function success(response) {
					console.log('save-demo-added : ' + response);
					count++;

					if (count === total) {
						form.showErrorPopupAnimation('form-save-added');
					}
				}
			});
		});
	};

	var submitAddSave = function submitAddSave() {
		var t = $(this);
		var currForm = t.closest('.artists-com-save-form');
		var list = $('.artists-com-save-popup-item-list');

		var currTitleInput = $('.form-input[name="artist-demo-add-to-save-item-add-title"]', currForm);
		var personId = $('input[name="personId"]', currForm).val();

		savesPage.createNewSave(currTitleInput.val(), personId, '', function (response) {
			var newElt = $('.artist-demo-add-to-save-item.clone', currForm).clone().removeClass('clone');
			$('.form-check-value', newElt).html(currTitleInput.val());
			$('input[name="saveId"]', newElt).val(response.substring('success-'.length));
			$('input[name="demosArray"]', newElt).val('');

			list.append(newElt);

			currTitleInput.val('').removeClass('success error').closest('.form-input-big-ctn').removeClass('error success');
		});
	};

	var init = function init() {
		popup = Fw.component.models().popup;
		form = Fw.component.models().form;
		savesPage = Fw.page.models().saves;

		$('body').on('click', '.artist-demo-add-to-save-item-submit', submitSaveForm);
		$('body').on('click', '.artist-demo-add-to-save-item-add-btn', submitAddSave);

		$('.artists-com-ctn').each(function () {
			var slider = $('.all-artists-com-slider', this);
			var prevArrow = $('.slider-btn.prev', this);
			var nextArrow = $('.slider-btn.next', this);

			slider.slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: true,
				swipeToSlide: true,
				dots: false,
				prevArrow: prevArrow,
				nextArrow: nextArrow,
				responsive: [{
					breakpoint: 480,
					settings: {
						variableWidth: false
					}
				}]
			});

			$(this).closest('.artists-com-ctn').slideDown();
		});
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var form;

	var init = function init() {
		form = Fw.component.models().form;

		$('body').on('click', '.js-clipboard-link', function () {
			var textarea = $('<textarea>' + $(this).attr('data-url') + '</textarea>');
			$('body').append(textarea);

			textarea[0].select();
			document.execCommand('copy');

			textarea.remove();

			form.showErrorPopupAnimation('clipboard-success');
		});
	};

	$(init);
})(jQuery);
(function ($, undefined) {
	'use strict';

	var account;
	var form;
	var submitBtn;
	var fileInput;

	var previewFile = function previewFile(e) {
		var t = $(this);
		var currForm = t.closest('.demo-form');
		var isVideo = t.closest('.demo-form').hasClass('video');
		var $ctn = t.closest('.form-input-big-ctn');
		var allowedExt = isVideo ? ['mp4', 'webm', 'mov'] : ['mp3', 'm4a', 'wav'];
		var allowedSize = isVideo ? 104857600 : 10485760; // 100mb video / 10mb audio
		var media;
		var file = currForm.find(fileInput)[0].files[0];
		var size;
		var re = /(?:\.([^.]+))?$/;
		var ext;

		if (file) {
			size = file.size;
			ext = re.exec(file.name)[1];

			if (size <= allowedSize) {
				if (allowedExt.indexOf(ext.toLowerCase()) !== -1) {
					if (isVideo) {
						media = document.createElement('VIDEO');
					} else {
						media = new Audio();
					}

					media.src = window.URL.createObjectURL(e.target.files[0]);
					media.controls = 'controls';

					$ctn.children('audio, video').remove();
					$ctn.append(media);
				} else {
					currForm.find(fileInput).val('');
					if (isVideo) {
						form.showErrorPopupAnimation('audition-form-artist-file-ext-video-error');
					} else {
						form.showErrorPopupAnimation('audition-form-artist-file-ext-error');
					}
				}
			} else {
				currForm.find(fileInput).val('');
				if (isVideo) {
					form.showErrorPopupAnimation('demo-form-file-video-size-message-error');
				} else {
					form.showErrorPopupAnimation('demo-form-file-size-message-error');
				}
			}
		}
	};

	var getNewPersonTags = function getNewPersonTags(personTags, demoTags) {
		var joinedTags = personTags.concat(demoTags.split(','));
		var arr = [];

		$.each(joinedTags, function (i, el) {
			if ($.inArray(el, arr) === -1) {
				arr.push(el);
			}
		});

		return arr;
	};

	var submitForm = function submitForm() {
		var t = $(this);
		var currForm = t.closest('.demo-form');
		var popup = t.closest('.popup');

		form.validateForm(currForm);

		if (!currForm.hasClass('has-error')) {
			popup.addClass('is-processing');
			t.addClass('disabled');

			var personIntLang = currForm.attr('data-person-int-lang').split(',');
			var personType = currForm.attr('data-person-type').split(',');
			var personTimbre = currForm.attr('data-person-timbre').split(',');
			var personIntType = currForm.attr('data-person-int-type').split(',');
			var personVoiceAge = currForm.attr('data-voice-age').split(',');
			var personTypeVideo = currForm.attr('data-person-type-video').split(',');
			var personFormatVideo = currForm.attr('data-person-format-video').split(',');
			var personIntTypeVideo = currForm.attr('data-person-int-type-video').split(',');

			var newIntLang = account.formatStringArray('.account-demo-int-lang-list', currForm);
			var newType = account.formatStringArray('.account-demo-type-list', currForm);
			var newTimbre = account.formatStringArray('.account-demo-timbre-list', currForm);
			var newIntType = account.formatStringArray('.account-demo-interpretation-type-list', currForm);
			var newVoiceAge = account.formatStringArray('.account-demo-voice-age-list', currForm);
			var newTypeVideo = account.formatStringArray('.account-demo-type-video-list', currForm);
			var newFormatVideo = account.formatStringArray('.account-demo-format-video-list', currForm);
			var newIntTypeVideo = account.formatStringArray('.account-demo-interpretation-type-video-list', currForm);

			//Here is to add the new specs to the profile
			var newPersonIntLang = getNewPersonTags(personIntLang, newIntLang);
			var newPersonType = getNewPersonTags(personType, newType);
			var newPersonTimbre = getNewPersonTags(personTimbre, newTimbre);
			var newPersonIntType = getNewPersonTags(personIntType, newIntType);
			var newPersonVoiceAge = getNewPersonTags(personVoiceAge, newVoiceAge);
			var newPersonTypeVideo = getNewPersonTags(personTypeVideo, newTypeVideo);
			var newPersonFormatVideo = getNewPersonTags(personFormatVideo, newFormatVideo);
			var newPersonIntTypeVideo = getNewPersonTags(personIntTypeVideo, newIntTypeVideo);

			$('.form-input:not([name="demo-year"]):not([name="demo-text"])', currForm).addClass('required').closest('.form-input-big-ctn').addClass('required');

			var data = {
				field1: 'demo',
				field2: $('.form-input[name="demo-title"]', currForm).val(),
				field4: newVoiceAge,
				field5: newIntLang,
				field6: newType,
				field7: newTimbre,
				field8: $('.form-input[name="demo-text"]', currForm).val(),
				field9: currForm.attr('data-person-id'),
				field14: newIntType,
				field16: $('input[name="fictive"]', currForm).prop('checked'),
				field17: $('select[name="demo-year"]', currForm).val(),
				field19: $('input[name="field19"]', currForm).val(),
				field20: newTypeVideo,
				field21: newFormatVideo,
				field22: newIntTypeVideo,
				dateField1Year: new Date().getFullYear(),
				dateField1Month: new Date().getMonth(),
				dateField1Day: new Date().getDate(),
				dateField1Hour: new Date().getHours(),
				dateField1Minute: new Date().getMinutes(),
				dateField1Second: new Date().getSeconds(),
				friendlyUrlField: 'field2',
				ajax: true
			};

			if ($('input[name="demo-file-id"]', currForm).val().length !== 0) {
				data.field3 = $('input[name="demo-file-id"]', currForm).val();
			}

			if ($('input[name="demo-file-size"]', currForm).val().length !== 0) {
				data.field12 = $('input[name="demo-file-size"]', currForm).val();
			}

			if (currForm.attr('data-id') !== undefined && currForm.attr('data-id') !== '') {
				data.id = currForm.attr('data-id');
			}

			var file = currForm.find(fileInput)[0].files[0];
			var size;
			var re = /(?:\.([^.]+))?$/;
			var ext;

			var _update = function _update() {
				var ajaxCount = 2;

				$.ajax({
					url: '/action/manageGenData',
					cache: false,
					method: 'POST',
					data: data,
					success: function success(response) {
						ajaxCount--;
						if (ajaxCount <= 0) {
							window.location.reload();
						}
					}
				});

				$.ajax({
					url: '/action/updatePerson',
					cache: false,
					data: {
						field4: newPersonType.toString(),
						field18: newPersonIntLang.toString(),
						field19: newPersonVoiceAge.toString(),
						field20: newPersonIntType.toString(),
						field29: newPersonTimbre.toString(),
						field32: newPersonTypeVideo.toString(),
						field33: newPersonFormatVideo.toString(),
						field34: newPersonIntTypeVideo.toString(),
						ajax: true
					},
					success: function success(response) {
						ajaxCount--;
						if (ajaxCount <= 0) {
							window.location.reload();
						}
					}
				});
			};

			if (file) {
				size = file.size;
				ext = re.exec(file.name)[1];

				var fd = new FormData();
				fd.append('image', file);
				fd.append('customLabel', 'file');
				fd.append('directory', 'Demos');
				fd.append('ajax', 'true');

				$.ajax({
					url: '/action/uploadCroppedImage',
					cache: false,
					contentType: false,
					processData: false,
					method: 'POST',
					data: fd,
					success: function success(response) {
						var newId = response.substring(response.indexOf('mediaId=') + 'mediaId='.length).trim();
						$('input[name="demo-file-id"]', currForm).val(newId);
						$('input[name="demo-file-size"]', currForm).val(size);
						data.field3 = newId;
						data.field12 = size;
						data.field18 = ext;

						_update();
					},
					error: function error(xhr, textStatus) {
						console.error(textStatus);

						t.removeClass('disabled');
						popup.removeClass('is-processing');
					}
				});

				$('.form-item-upload-input', currForm).removeClass('error').closest('.form-input-big-ctn').removeClass('error');
			} else {
				_update();
			}
		}
	};

	var init = function init() {
		account = Fw.page.models().account;
		form = Fw.component.models().form;
		submitBtn = $('.demo-form-btn');
		fileInput = $('input[name="demo-file"]');

		submitBtn.click(submitForm);
		fileInput.change(previewFile);
	};

	$(init);
})(jQuery);
(function ($, undefined) {
	'use strict';

	var tooltip;
	var main;
	var max = {};
	// var max;
	var selectedList;
	var notSelectedList;
	var delBtn;
	var moveUpBtn;
	var moveDownBtn;
	var featuredBtn;
	var changeDemoColumnBtn;

	var processItem = function processItem(t, tag) {
		var ctn = t.closest('.tab-ctn');
		var personId = t.attr("data-personId");
		var data;

		console.log('before: ' + t.attr('data-position'));

		$('.demo-selection-item', selectedList).each(function (i) {
			var t = $(this);
			t.attr('data-position', i);
		});
		handleDemoTooltips();

		console.log('after: ' + t.attr('data-position'));

		if (tag === 'selected') {
			data = {
				id: t.attr('data-id'),
				field10: tag,
				targetField1: "demo",
				field: "field9",
				value: personId,
				targetPosition: t.attr('data-position'),
				targetPositionField: "field11",
				ajax: true
			};
		} else {
			data = {
				id: t.attr('data-id'),
				field10: tag,
				ajax: true
			};
		}

		if ($('.demo-selection-item-date', t).html() !== undefined) {
			if ($('.demo-selection-item-date', t).html().length === 0) {
				data.dateField1Year = new Date().getFullYear();
				data.dateField1Month = new Date().getMonth();
				data.dateField1Day = new Date().getDate();
				data.dateField1Hour = new Date().getHours();
				data.dateField1Minute = new Date().getMinutes();
				data.dateField1Second = new Date().getSeconds();
			}
		}

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			method: 'POST',
			data: data,
			success: function success(response) {
				console.log(response);
			}
		});
	};

	var delItem = function delItem() {
		var t = $(this);
		t.closest('.popup').addClass('is-processing');

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			method: 'POST',
			data: {
				id: t.attr('data-item-id'),
				delete: true,
				ajax: true
			},
			success: function success(response) {
				window.location.reload();
			}
		});
	};

	var moveDemoUp = function moveDemoUp() {
		var id = $(this).closest('.tooltip-big-ctn').attr('data-id');
		var demo = $('.demo-selection-item[data-id=' + id + ']');
		var parentCtn = demo.closest(selectedList);
		var prevSibling = demo.prev('.demo-selection-item');

		if (prevSibling.length) {
			demo.remove();
			parentCtn.find(prevSibling).before(demo);
			processItem(demo, 'selected');
			tooltip.outsideTooltipClose();
			tooltip.resetTooltips();
		}
	};

	var moveDemoDown = function moveDemoDown() {
		var id = $(this).closest('.tooltip-big-ctn').attr('data-id');
		var demo = $('.demo-selection-item[data-id=' + id + ']');
		var parentCtn = demo.closest(selectedList);
		var nextSibling = demo.next('.demo-selection-item');

		if (nextSibling.length) {
			demo.remove();
			parentCtn.find(nextSibling).after(demo);
			processItem(demo, 'selected');
			tooltip.outsideTooltipClose();
			tooltip.resetTooltips();
		}
	};

	var featureDemo = function featureDemo() {
		var t = $(this);
		var maxAllowed = max[t.closest('.tab-ctn').index()];
		var id = t.closest('.tooltip-big-ctn').attr('data-id');
		var demo = $('.demo-selection-item[data-id=' + id + ']');
		var ctn = demo.closest(main).find(selectedList);

		if (maxAllowed === 'infinite' || maxAllowed !== 'infinite' && (ctn.length || demo.closest('.demo-selection-list').length && ctn.find('.demo-selection-item').length < maxAllowed)) {
			demo.remove();
			ctn.prepend(demo);
			processItem(demo, 'selected');
			tooltip.outsideTooltipClose();
			tooltip.resetTooltips();
		}
	};

	var changeDemoColumn = function changeDemoColumn() {
		var t = $(this);
		var id = t.closest('.tooltip-big-ctn').attr('data-id');
		var demo = $('.demo-selection-item[data-id=' + id + ']');
		var maxAllowed = max[demo.closest('.tab-ctn').index()];
		var selectedCtn = demo.closest(main).find(selectedList);
		var isSelected = demo.closest(selectedList).length;
		var unselectedCtn = demo.closest(main).find(notSelectedList);
		var isUnselected = demo.closest(notSelectedList).length;

		console.log(maxAllowed);
		console.log(demo.closest('.demo-selection-list').length);
		console.log(selectedCtn.find('.demo-selection-item').length);

		if (isSelected) {
			demo.remove();
			unselectedCtn.append(demo);
			processItem(demo, 'unselected');
			tooltip.outsideTooltipClose();
			tooltip.resetTooltips();
		} else {
			if (maxAllowed === 'infinite' || maxAllowed !== 'infinite' && demo.closest('.demo-selection-list').length && selectedCtn.find('.demo-selection-item').length < maxAllowed) {
				demo.remove();
				selectedCtn.append(demo);
				processItem(demo, 'selected');
				tooltip.outsideTooltipClose();
				tooltip.resetTooltips();
			}
		}
	};

	var handleDemoTooltips = function handleDemoTooltips() {
		$('.demo-selection-item').each(function () {
			var demo = $(this);
			var maxAllowed = max[demo.closest('.tab-ctn').index()];
			var id = demo.attr('data-id');
			var tooltip = $('.demo-selection-item-tooltip[data-id=' + id + ']');
			var selectedCtn = demo.closest(main).find(selectedList);
			var isSelected = demo.closest(selectedList).length;
			var isUnselected = demo.closest(notSelectedList).length;

			if (!isSelected) {
				tooltip.find(moveUpBtn).addClass('hide');
				tooltip.find(moveDownBtn).addClass('hide');
			} else {
				tooltip.find(moveUpBtn).removeClass('hide');
				tooltip.find(moveDownBtn).removeClass('hide');
			}

			if (maxAllowed === 'infinite' || maxAllowed !== 'infinite' && demo.closest('.demo-selection-list').length && selectedCtn.find('.demo-selection-item').length < maxAllowed) {
				tooltip.find(featuredBtn).removeClass('disabled');
				tooltip.find(changeDemoColumnBtn).removeClass('disabled');
			} else {
				if (!isSelected) {
					tooltip.find(featuredBtn).addClass('disabled');
					tooltip.find(changeDemoColumnBtn).addClass('disabled');
				}
			}

			if (demo.index() === 0) {
				tooltip.find(moveUpBtn).addClass('disabled');
				if (isSelected) {
					tooltip.find(featuredBtn).addClass('disabled');
				}
			} else {
				tooltip.find(moveUpBtn).removeClass('disabled');
				tooltip.find(featuredBtn).removeClass('disabled');
			}

			if (demo.index() === selectedCtn.find('.demo-selection-item').length - 1) {
				tooltip.find(moveDownBtn).addClass('disabled');
			} else {
				tooltip.find(moveDownBtn).removeClass('disabled');
			}
		});
	};

	var manageHandles = function manageHandles(t) {
		var i = t.closest('.tab-ctn').index();
		var count = parseInt(t.attr('data-count'));
		var obj;

		max[i] = t.attr('data-max') !== 'infinite' ? parseInt(t.attr('data-max')) : 'infinite';

		var settings = {
			handle: '.demo-selection-item-handle',
			items: '.demo-selection-item',
			scrollSensitivity: 40,
			helper: fixHelper,
			start: function start(event, ui) {
				t.addClass('from-unselected');
				obj = ui.item;
			},
			receive: function receive(event, ui) {
				var newCount = $('.demo-selection-selected-body .demo-selection-item', t).length;
				if ($('.demo-selection').attr('data-max') !== undefined && max[i] !== 'infinite') {
					if (newCount > max[i]) {
						$(ui.sender).sortable('cancel');

						if ($('.change-plan-popup-btn', t).length > 0) {
							$('.change-plan-popup-btn', t).trigger('click');
						}
					}
				}
			},
			stop: function stop(event, ui) {
				var newCount = $('.demo-selection-selected-body .demo-selection-item', t).length;
				var $targ = obj.prev(".demo-selection-item");
				var index = parseInt($targ.attr("data-position")) + 1;

				if ($targ.length === 0) {
					index = 0;
				}
				t.attr('data-count', newCount);
				$('.demo-selection-selected-title-count', t).html(newCount);

				t.removeClass('from-unselected');

				if (max[i] === index) {
					t.addClass('max-reached');
				} else {
					t.removeClass('max-reached');
				}

				var status = "selected";
				var dropList = ui.item.parent();
				if (!dropList.hasClass("demo-selection-selected-body")) {
					status = "unselected";
				}
				processItem(obj, status);
				tooltip.resetTooltips();
			}
		};

		$('.demo-selection-selected-body', t).sortable($.extend({}, settings, {
			connectWith: '.demo-selection-list-body'
		}));
		$('.demo-selection-list-body', t).sortable($.extend({}, settings, {
			connectWith: '.demo-selection-selected-body'
		}));
	};

	var init = function init() {
		tooltip = Fw.component.models().tooltip;
		main = $('.demo-selection');
		selectedList = $('.demo-selection-selected-body');
		notSelectedList = $('.demo-selection-list-body');
		delBtn = $('.demo-del-form-confirm');

		moveUpBtn = $('.move-demo-up-btn');
		moveDownBtn = $('.move-demo-down-btn');
		featuredBtn = $('.move-demo-to-featured-btn');
		changeDemoColumnBtn = $('.change-demo-column-btn');

		moveUpBtn.click(moveDemoUp);
		moveDownBtn.click(moveDemoDown);
		featuredBtn.click(featureDemo);
		changeDemoColumnBtn.click(changeDemoColumn);

		main.each(function () {
			manageHandles($(this));
		});

		handleDemoTooltips();

		$('.demo-selection-list-body, .demo-selection-selected-body', main).scroll(function () {
			$('.tooltip-big-ctn').removeClass('show');
			tooltip.resetTooltips();
			tooltip.outsideTooltipClose();
		});

		$('.demos-selection-tab').click(function () {
			setTimeout(function () {
				tooltip.resetTooltips();
			}, 500);
		});

		delBtn.click(delItem);
	};

	var fixHelper = function fixHelper(e, ui) {
		ui.children().each(function () {
			$(this).width($(this).width());
		});
		return ui;
	};

	$(init);
})(jQuery);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function ($, undefined) {

	'use strict';

	var doc = $(document);
	var currPage;
	var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
	var body;
	var items;
	var checkLabel;
	var checkboxItems;
	var checkboxItemsInner;
	var file;
	var fileInput;
	var formSwitch;
	var formCheck;
	var selectCountry;
	var file;
	var fileInput;
	var validateAndSubmitBtn;
	var passwordField;
	var formPopupCloseBtn;

	var validateForm = function validateForm(ctn, showError) {
		ctn.each(function () {
			var t = $(this);
			var toValidateItems = $('.form-input:not(.select-state-input:not(.selected)).required', t);
			var toValidateUpload = $('.form-item-upload-input.required', t);
			var toValidateCheck = $('.form-check-input.required', t);
			var toValidateWysiwyg = $('.form-wysiwyg-ctn.required', t);
			var password = $('.js-password', t);
			var passwordConfirm = $('.js-password-confirm', t);
			var email = $('.js-email', t);
			var emailConfirm = $('.js-email-confirm', t);
			var btn = $('.js-form-btn', t);
			var isOk = true;
			var passwordOk = true;
			var passwordConfirmOk = true;
			var passwordRequirementsOk = true;
			var termsOk = true;
			var checkOk = true;
			var emailOk = true;
			var wysOk = true;
			var fieldsErrorMessage = $('.js-form-error-message.fields', t);
			var fieldsErrorCheckbox = $('.js-form-error-message.checkbox', t);
			var fieldsErrorTerms = $('.js-form-error-message.terms', t);
			var fieldsErrorPassword = $('.js-form-error-message.password', t);
			var fieldsErrorEmail = $('.js-form-error-message.email-check', t);

			toValidateItems = toValidateItems.filter(function () {
				return $(this).closest('.clone').length === 0;
			});

			toValidateUpload = toValidateUpload.filter(function () {
				return $(this).closest('.clone').length === 0;
			});

			toValidateCheck = toValidateCheck.filter(function () {
				return $(this).closest('.clone').length === 0;
			});

			toValidateWysiwyg = toValidateWysiwyg.filter(function () {
				return $(this).closest('.clone').length === 0;
			});

			toValidateItems.each(function () {
				var tChild = $(this);
				validateField(tChild, t);
				if (tChild.hasClass('error')) {
					isOk = false;
				}
			});

			toValidateUpload.each(function () {
				var input = $(this);
				var tUpload = input.closest('.form-input-big-ctn');

				if (input.val() === '') {
					tUpload.add(input).addClass('error');
					$('.form-error-message.field', tUpload).slideDown(300);
				} else {
					tUpload.add(input).removeClass('error');
					$('.form-error-message.field', tUpload).slideUp(300);
				}

				if (tUpload.hasClass('error')) {
					isOk = false;
				}
			});

			toValidateCheck.each(function () {
				var tCheck = $(this);
				var tCtn = tCheck.closest('.form-checkbox-ctn');

				if (!tCheck.is(':checked')) {
					tCtn.addClass('error');

					if (tCtn.attr('name') !== 'terms') {
						checkOk = false;
					}
				} else {
					tCtn.removeClass('error');
				}

				if (tCheck.attr('name') === 'terms' && tCtn.hasClass('error')) {
					termsOk = false;
				}

				if (tCtn.hasClass('error')) {
					termsOk = false;
				}
			});

			toValidateWysiwyg.each(function () {
				var content = tinymce.get($('.form-input', $(this)).attr('id')).getContent();

				if (content === '') {
					wysOk = false;
					$(this).find('.form-input-ctn').addClass('error');
				} else {
					$(this).find('.form-input-ctn').removeClass('error');
				}
			});

			if (email.length !== 0 && emailConfirm.length !== 0 && (email.val() !== emailConfirm.val() || email.val().length === 0)) {
				if (email.val().length === 0) {
					email.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					email.addClass('success').removeClass('error');
					emailOk = true;
				}

				if (email.val() !== emailConfirm.val() || email.val().length === 0) {
					emailConfirm.removeClass('success').addClass('error');
					emailOk = false;
				} else {
					emailConfirm.removeClass('error');
					emailOk = true;

					if (email.val().length !== 0) {
						emailConfirm.addClass('success');
					}
				}
			}

			if (password.hasClass('error')) {
				passwordOk = false;
			}
			if (passwordConfirm.hasClass('error')) {
				passwordConfirmOk = false;
			}

			t.addClass('is-checked');

			if (!termsOk) {
				fieldsErrorTerms.slideDown(300);
			} else {
				fieldsErrorTerms.slideUp(300);
			}

			if (!checkOk) {
				fieldsErrorCheckbox.slideDown(300);
			} else {
				fieldsErrorCheckbox.slideUp(300);
			}

			if (email.length !== 0 && emailConfirm.length !== 0) {
				if (email.length !== 0 && emailOk) {
					ctn.addClass('has-email');
					email.add(emailConfirm).removeClass('error');
					fieldsErrorEmail.slideUp(300);
				} else {
					ctn.removeClass('has-email');
					email.add(emailConfirm).addClass('error');
					fieldsErrorEmail.slideDown(300);
				}
			}

			if (!isOk) {
				fieldsErrorMessage.slideDown(300);
			} else {
				fieldsErrorMessage.slideUp(300);
			}

			if (!isOk || !passwordOk || !passwordConfirmOk || !passwordRequirementsOk || !termsOk || !checkOk || !emailOk || !wysOk) {
				btn.addClass('disabled');
				ctn.addClass('has-error');

				if (showError) {
					showErrorPopup();
				}

				if (!passwordOk && password.hasClass('required')) {
					ctn.addClass('error-password');
				} else {
					ctn.removeClass('error-password');
				}
				return false;
			} else {
				btn.removeClass('disabled');
				ctn.removeClass('has-error').removeClass('error-password');

				fieldsErrorTerms.slideUp(300);
				return true;
			}
		});
	};

	var validateField = function validateField(elt, form) {
		var tag = elt[0].tagName;
		var type = elt.attr('type');
		var val = elt.hasClass('select-value') ? elt.attr('data-value') : elt.val();
		var attrClass = elt.attr('data-validator-apply-class-on');
		var classTarget = attrClass !== undefined ? elt.closest(attrClass) : elt;
		//Choises for validate are : "email", "url", "tel" or "default". By default, an input type email takes the email validation,
		//the input type tel takes the tel validation and if the validate value is "default", then it do a normal check if the input has char
		var validate = elt.attr('data-validate');
		var reEmail = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		var reUrl = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
		var reTel = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
		var emailValid = true;
		var whiteSpaceValid = true;
		var urlValid = true;
		var telValid = true;
		var inputValid = true;
		var isSelectMultiple = elt.closest('.account-multiple-select-ctn').length;

		if (!val.replace(/\s/g, '').length) {
			whiteSpaceValid = false;
		}

		if (tag === 'INPUT' && (type === 'email' || validate === 'email') && validate !== 'default') {
			emailValid = reEmail.test(val);
		} else if (tag === 'INPUT' && validate === 'url' && validate !== 'default') {
			urlValid = reUrl.test(val);
		} else if (tag === 'INPUT' && (type === 'tel' || validate === 'tel') && validate !== 'default') {
			telValid = reTel.test(val);
		} else if (elt.hasClass('form-input-upload-input')) {
			if (classTarget.add(elt).hasClass('required') && elt.val() !== '') {
				classTarget.add(elt).removeClass('error').addClass('success');
			} else {
				classTarget.add(elt).addClass('error').removeClass('success');
			}
		} else {
			classTarget.add(elt).addClass('success').removeClass('error');
			if (classTarget.hasClass('required') && $.trim(val).length === 0) {
				classTarget.add(elt).removeClass('success').addClass('error');
				inputValid = false;
			} else if (!classTarget.hasClass('required') && val.length === 0) {
				classTarget.add(elt).removeClass('success').removeClass('error');
			}
		}

		if (classTarget.hasClass('required') && type !== 'password') {
			if (emailValid) {
				$('.form-error-message.email', classTarget).slideUp(200);
			} else if (val.substring(0, 4) !== 'mg2-') {
				$('.form-error-message.email', classTarget).slideDown(200);
			}
			if (urlValid) {
				$('.form-error-message.url', classTarget).slideUp(200);
			} else {
				$('.form-error-message.url', classTarget).slideDown(200);
			}
			if (telValid) {
				$('.form-error-message.tel', classTarget).slideUp(200);
			} else {
				$('.form-error-message.tel', classTarget).slideDown(200);
			}

			if (inputValid && whiteSpaceValid) {
				$('.form-error-message.field', classTarget).slideUp(200);
			} else {
				if (emailValid && urlValid && telValid) {
					$('.form-error-message.field', classTarget).slideDown(200);
				}
			}
		}

		if (elt.hasClass('js-password') || elt.hasClass('js-password-confirm')) {
			validatePassword(form);
		} else {
			if (isSelectMultiple) {
				var multipleSelectCtn = elt.closest('.account-multiple-select-ctn');

				if ($('.account-option-item:not(.clone)', multipleSelectCtn).length) {
					classTarget.add(elt).removeClass('error').addClass('success');
				} else if (elt.hasClass('required')) {
					classTarget.add(elt).addClass('error').removeClass('success');
					//#TODO remove console log
					// console.log('input error : ' + elt.attr('name'));
				}
			} else if (emailValid && urlValid && telValid && inputValid && whiteSpaceValid) {
				classTarget.add(elt).removeClass('error').addClass('success');
			} else if (val.length === 0 && !classTarget.hasClass('required')) {
				classTarget.add(elt).removeClass('error').removeClass('success');
			} else if (type !== 'email' || type === 'email' && val.substring(0, 4) !== 'mg2-') {
				classTarget.add(elt).addClass('error').removeClass('success');
				//#TODO remove console log
				// console.log('input error : ' + elt.attr('name'));
			}
		}
	};

	var validatePassword = function validatePassword(t) {
		var standalone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

		var password = $('.js-password', t);
		var passwordConfirm = $('.js-password-confirm', t);
		var passwordParent = password.closest(password.attr('data-validator-apply-class-on')) !== undefined ? password.closest(password.attr('data-validator-apply-class-on')) : password;
		var passwordConfirmParent = passwordConfirm.closest(passwordConfirm.attr('data-validator-apply-class-on')) !== undefined ? passwordConfirm.closest(password.attr('data-validator-apply-class-on')) : password;

		var passwordOk = true;
		var passwordConfirmOk = true;
		var passwordRequirementsOk = true;

		if (password.val().length === 0) {
			passwordOk = false;
		}

		if (password.val() !== passwordConfirm.val()) {
			if (password.val().length === 0) {
				passwordOk = false;
			} else {
				passwordOk = true;
			}

			if (password.val() !== passwordConfirm.val() || passwordConfirm.val().length === 0) {
				passwordConfirmOk = false;
			} else {
				passwordConfirmOk = true;
			}
		}

		if (password.val().length !== 0) {
			if (password.val().length < 5) {
				passwordRequirementsOk = false;
				// console.log('pass-length');
			}
			if (!/\d/.test(password.val())) {
				passwordRequirementsOk = false;
				// console.log('pass-numbers');
			}
			if (!/[a-zA-Z]/.test(password.val())) {
				passwordRequirementsOk = false;
				// console.log('pass-letters');
			}
		}

		password.add(passwordConfirm).removeClass('success error');
		passwordParent.add(passwordConfirmParent).removeClass('success error');
		if (passwordOk && passwordRequirementsOk) {
			password.addClass('success').removeClass('error');
			passwordParent.addClass('success').removeClass('error');
			$('.form-error-message.password', passwordParent).slideUp(200);
		} else {
			password.removeClass('success').addClass('error');
			passwordParent.removeClass('success').addClass('error');
			$('.form-error-message.password', passwordParent).slideDown(200);
		}

		if (passwordConfirmOk) {
			passwordConfirm.removeClass('error');
			passwordConfirmParent.removeClass('error');
			$('.form-error-message.password-check', passwordConfirmParent).slideUp(200);

			if (password.val().length !== 0) {
				passwordConfirm.addClass('success');
				passwordConfirmParent.addClass('success');
			}
		} else {
			passwordConfirm.removeClass('success').addClass('error');
			passwordConfirmParent.removeClass('success').addClass('error');
			$('.form-error-message.password-check', passwordConfirmParent).slideDown(200);
		}

		if (standalone) {
			t.toggleClass('has-error', !passwordOk || !passwordConfirmOk || !passwordRequirementsOk);
		}
	};

	var formItemsBlur = function formItemsBlur(t) {
		var elt = t.target === undefined ? t : $(this);
		var ctn = elt.closest('.form-input');
		var form = ctn.closest('.js-form');

		validateField(elt, form);

		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var formCheckChange = function formCheckChange() {
		var t = $(this);
		var ctn = t.closest('.form-checkbox-ctn');
		var form = ctn.closest('.js-form');

		if (form.hasClass('is-checked')) {
			validateForm(form);

			if (t.is(':checked')) {
				ctn.removeClass('error');
			}
		}
	};

	var checkLabelClick = function checkLabelClick() {
		var t = $(this);
		var ctn = t.closest('.register-checkbox');

		if (ctn.hasClass('is-checked')) {
			ctn.removeClass('is-checked');
		} else {
			ctn.addClass('is-checked');
		}
	};

	var toggleCheckbox = function toggleCheckbox() {
		var t = $(this);
		var ctn = t.closest('.form-input-checkbox');
		var input = $('.form-input-checkbox-input', t);

		if (ctn.hasClass('checked')) {
			ctn.removeClass('checked');
			input.removeAttr('checked');
		} else {
			ctn.addClass('checked');
			input.attr('checked', 'checked');
		}
	};

	var formSwitchClick = function formSwitchClick() {
		var t = $(this);
		var elem = $(t).find('.checkbox');

		t.find('.form-checkbox-slider').toggleClass('active');
		if (elem.prop("checked")) {
			elem.removeAttr("checked");
		} else {
			elem.attr("checked", "checked");
		}
	};

	var updateStateSelect = function updateStateSelect() {
		var t = $(this);
		var val = t.val();
		var id = t.attr('data-id');
		var statesCtn = $('.select-state-ctn[data-id="' + id + '"]');
		var selectCtns = $('.form-select-ctn', statesCtn);

		var _doSelection = function _doSelection(claz) {
			selectCtns.filter(claz).addClass('selected').find('.form-select').addClass('selected').attr('name', function () {
				return !this.hasAttribute('data-name') || this.getAttribute('data-name') === '' ? this.name : this.getAttribute('data-name');
			});
		};

		selectCtns.removeClass('selected').find('.form-select').removeClass('selected');
		selectCtns.find('.form-select').attr('name', function (index, value) {
			if (!this.hasAttribute('data-name') || this.getAttribute('data-name') === '') {
				this.setAttribute('data-name', value);
			}
			return '';
		});
		if (val === 'CA' || val === 'CAN' || val === 'canada' || val === 'Canada') {
			_doSelection('.canada');
		} else if (val === 'US' || val === 'USA' || val === 'United-States' || val === 'united-states') {
			_doSelection('.us');
		} else {
			_doSelection('.other');
		}
	};

	var checkIfHasChar = function checkIfHasChar() {
		var t = $(this);
		var value = $.trim(t.val());
		var ctn = t.closest(t.attr('data-validator-apply-class-on'));

		if (value.length !== 0) {
			ctn.add(t).addClass('has-char');
		} else {
			ctn.add(t).removeClass('has-char');
		}
	};

	var fileInputChange = function fileInputChange() {
		var t = $(this);
		var label = t.closest('.form-item-upload-input-label');
		var labelDefault = label.attr('data-default-value');
		var labelValue = $('.form-item-upload-input-label-value', label);
		var ctn = t.closest(t.attr('data-validator-apply-class-on'));
		var form = ctn.closest('.js-form');
		var bigCtn = t.closest('.form-input-big-ctn');
		var updateTitle = bigCtn.hasClass('update-title');

		if (t.val() !== '') {
			ctn.removeClass('error').addClass('success');

			if (updateTitle) {
				labelValue.html(t.val().split('\\')[t.val().split('\\').length - 1]);
			}
		} else if (t.hasClass('required')) {
			ctn.addClass('error').removeClass('success');
			labelValue.html(labelDefault);
		}

		if (form.hasClass('is-checked')) {
			validateForm(form);
		}
	};

	var initMCE = function initMCE() {
		var settings = {
			selector: '.form-wysiwyg',
			menubar: false,
			plugins: 'paste link textcolor lists',
			toolbar: 'formatselect | bold italic strikethrough forecolor | alignleft aligncenter alignright alignjustify  | numlist bullist | link | removeformat',
			entity_encoding: "raw",
			paste_as_text: true
		};

		initMCERecur(settings);
	};

	function initMCERecur(settings) {
		if ((typeof tinymce === 'undefined' ? 'undefined' : _typeof(tinymce)) === 'object') {
			tinymce.init(settings);
		} else {
			setTimeout(function () {
				initMCERecur(settings);
			}, 1000);
		}
	}

	var validateAndSubmit = function validateAndSubmit(t) {
		var form = t.closest('form');
		var showError = false;

		if (t.hasClass('show-error')) {
			showError = true;
		}

		validateForm(form, showError);

		if (!form.hasClass('has-error')) {
			t.addClass('disabled');
			form.submit();
		}
	};

	var showSuccessPopup = function showSuccessPopup(successClass) {
		var success = successClass;
		if (success === undefined) {
			success = 'form-success';
		}

		showErrorPopupAnimation(success);
	};

	var showErrorPopup = function showErrorPopup(errorClass) {
		var error = errorClass;
		if (error === undefined) {
			error = 'form-error';
		}

		showErrorPopupAnimation(error);
	};

	var showErrorPopupAnimation = function showErrorPopupAnimation(messageClass) {
		var message = $('.form-popup-message.' + messageClass);

		$('.form-popup-message').removeClass('show');
		message.addClass('show');

		setTimeout(function () {
			message.removeClass('show');
		}, 5000);
	};

	var passwordChecker = function passwordChecker() {
		var t = $(this);
		var name = t.attr('data-strength');
		var progressbar = $('.password-strength-progress-bar#' + name);
		var progressbarCtn = progressbar.closest('.password-strength-ctn');

		var strPassword = t.val();
		var charPassword = strPassword.split("");
		var minPasswordLength = 5;
		var baseScore = 0,
		    score = 0;

		var num = {};
		num.Excess = 0;
		num.Upper = 0;
		num.Numbers = 0;
		num.Symbols = 0;

		var bonus = {};
		bonus.Excess = 3;
		bonus.Upper = 4;
		bonus.Numbers = 5;
		bonus.Symbols = 5;
		bonus.Combo = 0;
		bonus.FlatLower = 0;
		bonus.FlatNumber = 0;

		for (var i = 0; i < charPassword.length; i++) {
			if (charPassword[i].match(/[A-Z]/g)) {
				num.Upper++;
			}
			if (charPassword[i].match(/[0-9]/g)) {
				num.Numbers++;
			}
			if (charPassword[i].match(/(.*[!,@,#,$,%,^,&,*,?,_,~])/)) {
				num.Symbols++;
			}
		}

		num.Excess = charPassword.length - minPasswordLength;

		if (num.Upper && num.Numbers && num.Symbols) {
			bonus.Combo = 25;
		} else if (num.Upper && num.Numbers || num.Upper && num.Symbols || num.Numbers && num.Symbols) {
			bonus.Combo = 15;
		}

		if (strPassword.match(/^[\sa-z]+$/)) {
			bonus.FlatLower = -15;
		}

		if (strPassword.match(/^[\s0-9]+$/)) {
			bonus.FlatNumber = -35;
		}

		score = baseScore + num.Excess * bonus.Excess + num.Upper * bonus.Upper + num.Numbers * bonus.Numbers + num.Symbols * bonus.Symbols + bonus.Combo + bonus.FlatLower + bonus.FlatNumber;

		progressbar.width(score + '%');

		// progressbar.removeClass('warning secure perfect');
		progressbarCtn.removeClass('warning secure perfect');
		if (score >= 0 && score < 40) {
			// progressbar.addClass('warning');
			progressbarCtn.addClass('warning');
		} else if (score >= 40 && score < 80) {
			// progressbar.addClass('secure');
			progressbarCtn.addClass('secure');
		} else if (score >= 80) {
			// progressbar.addClass('perfect');
			progressbarCtn.addClass('perfect');
		}
	};

	var closeFirmPopup = function closeFirmPopup() {
		$(this).closest('.form-popup-message').removeClass('show');
		var qkey = this.getAttribute('data-qkey');
		if (qkey && qkey !== '') {
			Fw.component.models().utils.changeURLState(qkey, null, {});
		}
	};

	var resetUpload = function resetUpload(t) {
		var fieldCtn = t.closest('.form-input-big-ctn');
		t.wrap('<form>').closest('form').get(0).reset();
		t.unwrap();
		var defaultLabel = $('.form-item-upload-input-label', fieldCtn).attr('data-default-value');
		$('.form-item-upload-input-label-value', fieldCtn).html(defaultLabel);
		fieldCtn.find('audio').remove();
		fieldCtn.removeClass('error success');
	};

	var init = function init(page) {
		body = $('body');
		items = $('.form-input:not([type=file])');

		checkLabel = $('.register-checkbox-label');
		checkboxItems = $('.form-input-checkbox');
		checkboxItemsInner = $('.form-input-checkbox-inner', checkboxItems);
		fileInput = $('.form-input-upload-input', file);
		formSwitch = $('.form-switch');
		formCheck = $('.form-check-input');
		selectCountry = $('.select-country-input');
		file = $('.form-item-upload', currPage);
		fileInput = $('.form-item-upload-input', file);
		validateAndSubmitBtn = $('.validate-and-submit-form-btn');
		passwordField = $('.js-password');
		formPopupCloseBtn = $('.form-popup-message-close-btn');

		checkLabel.click(checkLabelClick);
		checkboxItemsInner.click(toggleCheckbox);
		fileInput.change(fileInputChange);
		formSwitch.click(formSwitchClick);
		formCheck.change(formCheckChange);
		selectCountry.change(updateStateSelect);
		validateAndSubmitBtn.click(function (e) {
			e.preventDefault();
			validateAndSubmit($(this));
		});
		passwordField.keyup(passwordChecker);
		formPopupCloseBtn.click(closeFirmPopup);

		initMCE();

		/*items.each(function () {
  	if (!$(this).hasClass('no-blur')) {
  		$(this).blur(formItemsBlur);
  	}
  });*/

		items.keyup(checkIfHasChar);

		if ($('html').attr('lang') === 'fr') {
			$.datetimepicker.setLocale('fr');
		}

		$('.datepicker').each(function () {
			var showTime = $(this).hasClass('show-time');
			var showDate = $(this).hasClass('show-dates');
			var showDateFromToday = $(this).hasClass('show-dates-from-today');

			$(this).datetimepicker({
				format: (showTime ? 'H:i' : '') + (showTime && showDate ? ' ' : '') + (showDate ? 'd-m-Y' : ''),
				step: 15,
				closeOnDateSelect: true,
				timepicker: showTime,
				datepicker: showDate,
				minDate: showDateFromToday ? '0' : '-1970/01/02',
				defaultTime: '12:00'
			});
		});
	};

	$(init);

	Fw.component.export('form', {
		init: init,
		validateForm: validateForm,
		showSuccessPopup: showSuccessPopup,
		showErrorPopup: showErrorPopup,
		showErrorPopupAnimation: showErrorPopupAnimation,
		resetUpload: resetUpload,
		validatePassword: validatePassword
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var prev = '';
	var next = '';
	var end = '';
	var gendataId;
	var personId;
	var refresh;
	var leftMenuBtn;
	var leftMenu;
	var accountNav;
	var isDev;

	var initGuide = function initGuide(guide, total) {
		var name = guide;
		var steps = $('[data-guide-name=' + name + ']');
		var count = 0;
		var stepsSettings = [];
		var backdropActive = true;

		if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1) {
			/* Microsoft Internet Explorer detected */
			backdropActive = false;
		}

		var _stepsLoop = function _stepsLoop() {
			var stepFound = false;
			var loopCounts = 0;

			steps.each(function () {
				var t = $(this);
				var respCondition = t.attr('data-guide-responsive');
				var show = true;
				loopCounts++;

				if (respCondition !== '') {
					// I KNOW C'EST LAID #TUCONNAISPAUL
					var respCssCheck = true;
					var respResolution;

					if (respCondition.indexOf('responsive') !== -1) {
						respResolution = respCondition.split('responsive-')[1];
						respCssCheck = $('.resp-detector-' + respResolution).css('visibility') === 'visible';
					} else if (respCondition.indexOf('desktop') !== -1) {
						respResolution = respCondition.split('desktop-')[1];
						respCssCheck = $('.resp-detector-' + respResolution).css('visibility') === 'hidden';
					}

					show = respCssCheck;
				}

				if (!show) {
					t.addClass('guide-ignore');
					steps = $(':not(.guide-ignore)[data-guide-name=' + name + ']');
				}

				if (t.data('guide-step') === count) {
					stepFound = true;
					if (show) {
						count++;

						var step = {
							element: $('#' + t.attr('id')),
							title: t.attr('data-guide-title'),
							content: t.attr('data-guide-content') ? t.attr('data-guide-content') : ' ',
							placement: t.attr('data-guide-placement') ? t.attr('data-guide-placement') : 'auto',
							backdropPadding: t.attr('data-guide-backdrop-padding') ? JSON.parse(t.attr('data-guide-backdrop-padding')) : 10,
							onShow: function onShow(tour) {
								handleOnShow(tour);
							},
							onShown: function onShown(tour) {
								handleOnShown(tour);
							},
							onNext: function onNext(tour) {
								if (t.attr('data-guide-next').length > 0) {
									$(t.attr('data-guide-next')).first().trigger('click');
								} else {
									handleNextStepClick(tour);
								}
							},
							onPrev: function onPrev(tour) {
								if (t.attr('data-guide-prev').length > 0) {
									$(t.attr('data-guide-prev')).first().trigger('click');
								} else {
									handlePrevStepClick(tour);
								}
							}
						};

						stepsSettings.push(step);
					}
				}
			});

			if (isDev) {
				if (!stepFound) {
					console.log('step ' + name + ' #' + count + ' found: ' + stepFound);
				} else {
					console.log('step ' + name + ' found: ' + stepFound);
				}
			}

			if (count >= total) {
				var tour = new Tour({
					name: name,
					steps: stepsSettings,
					backdrop: backdropActive,
					template: '<div class="popover" role="tooltip">\n\t\t\t\t\t\t\t<div class="arrow"></div>\n\t\t\t\t\t\t\t<h3 class="popover-title"></h3>\n\t\t\t\t\t\t\t<div class="popover-content"></div>\n\t\t\t\t\t\t\t<div class="popover-navigation">\n\t\t\t\t\t\t\t\t<div class="btn-group full-width">\n\t\t\t\t\t\t\t\t\t<button class="btn btn-default small full grey" data-role="prev">' + prev + '</button>\n\t\t\t\t\t\t\t\t\t<button class="btn btn-default small full" data-role="next">' + next + '</button>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<button class="btn btn-default small mt10" data-role="end">' + end + '</button>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>',
					onEnd: function onEnd(tour) {
						saveTourSeen(tour);
					}
				});

				tour.setCurrentStep(0);
				tour.init();
				tour.start(true);
			} else {
				// continue looping only if 1 step found or start looking for next step (prevent infinite loop)
				if (!stepFound) {
					count++;
				}
				_stepsLoop();
			}
		};

		_stepsLoop();
	};

	var handleOnShow = function handleOnShow(tour) {
		console.log(tour);

		// PAGE DASHBOARD - SEARCHER
		if (tour._options.name === 'searcher-field4') {
			// RESPONSIVE SM
			if ($('.resp-detector-sm').css('visibility') === 'visible') {
				if (tour._current === 0) {
					$('.mobile-side-menu.left').addClass('open');
				}
			}
		}
	};

	var handleOnShown = function handleOnShown(tour) {
		console.log(tour);

		// PAGE MODIF PROFIL - ARTISTE
		if (tour._options.name === 'artist-field6') {
			if (tour._current === 0) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=personnal-detail]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('personnal-detail');
					accountNav.trigger('change');
				}
			}
		}

		// PAGE MODIF PROFIL - AGENCY
		if (tour._options.name === 'agency-field6') {
			if (tour._current === 0) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=personnal-detail]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('personnal-detail');
					accountNav.trigger('change');
				}
			}
		}
	};

	var handleNextStepClick = function handleNextStepClick(tour) {
		console.log(tour);

		// PAGE DASHBOARD - SEARCHER
		if (tour._options.name === 'searcher-field4') {
			// RESPONSIVE SM
			if ($('.resp-detector-sm').css('visibility') === 'visible') {
				if (tour._current === 2 || tour._current === 3 || tour._current === 4) {
					leftMenuBtn.trigger('click');
				}
			}
		}

		// PAGE AUDITION FORM - SEARCHER
		if (tour._options.name === 'searcher-field6') {
			if (tour._current === 2) {
				$('.audition-forms-step.audition-details .audition-forms-header').trigger('click');
			}
			if (tour._current === 6) {
				$('.audition-forms-step.audition-recording .audition-forms-header').trigger('click');
			}
			if (tour._current === 8) {
				$('.audition-forms-step.audition-contract .audition-forms-header').trigger('click');
			}
			if (tour._current === 9) {
				$('.audition-forms-step.audition-profile .audition-forms-header').trigger('click');
			}
		}

		// PAGE FICHE AUDITION - SEARCHER
		if (tour._options.name === 'searcher-field8') {
			if (tour._current === 2) {
				$('.audition-actions-btn').trigger('click');
			}
			// RESPONSIVE SIDE BREAKPOINT
			if ($('.resp-detector-side-bp').css('visibility') === 'visible') {
				if (tour._current === 0) {
					$('.audition-single-details-btn:not(.close)').trigger('click');
				}
				if (tour._current === 1) {
					$('.audition-single-details-btn.close').trigger('click');
				}
			}
		}

		// PAGE DASHBOARD - ARTIST
		if (tour._options.name === 'artist-field4') {
			if (tour._current === 0 || tour._current === 1) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.header-account-btn:not(.close)').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					$('.header-account-responsive-btn').trigger('click');
				}
			}

			// RESPONSIVE SM
			if ($('.resp-detector-sm').css('visibility') === 'visible') {
				if (tour._current === 2 || tour._current === 4) {
					leftMenuBtn.trigger('click');
				}
			}
		}

		// PAGE MODIF PROFIL - ARTISTE
		if (tour._options.name === 'artist-field6') {
			if (tour._current === 1) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=more-detail]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('more-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 3) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=agency-link]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('agency-link');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 7) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=preferences]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('preferences');
					accountNav.trigger('change');
				}
			}
		}

		// PAGE FICHE AUDITION - ARTISTE
		if (tour._options.name === 'artist-field8') {
			if (tour._current === 1 || tour._current === 4) {
				$('.audition-actions-btn').trigger('click');
			}
		}

		// PAGE DASHBOARD - AGENCY
		if (tour._options.name === 'agency-field4') {
			if (tour._current === 0 || tour._current === 2) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.header-account-btn:not(.close)').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					$('.header-account-responsive-btn').trigger('click');
				}
			}

			// // RESPONSIVE SM
			if ($('.resp-detector-sm').css('visibility') === 'visible') {
				if (tour._current === 2 || tour._current === 6) {
					leftMenuBtn.trigger('click');
				}
			}
		}

		// PAGE MODIF PROFIL - AGENCY
		if (tour._options.name === 'agency-field6') {
			if (tour._current === 0) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('more-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 1) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('agency-link');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 2) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('social');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 3) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('preferences');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 4) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('personnal-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 5) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('agency-link');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 9) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('preferences');
					accountNav.trigger('change');
				}
			}
		}

		// PAGE SUBSCRIPTIONS - AGENCY
		if (tour._options.name === 'agency-field9') {
			if (tour._current === 0) {
				$('.table-outer-ctn').animate({ scrollLeft: $('.hijack-user-btn').position().left }, 300);
			}
			if (tour._current === 1) {
				$('.table-outer-ctn').animate({ scrollLeft: $('.modify-artist-subscription-table-btn').position().left }, 300);
			}
			if (tour._current === 2) {
				if (!$('#agency-field9-2').closest('td').hasClass('open')) {
					$('#agency-field9-2').trigger('click');
				}
				$('.table-outer-ctn').animate({ scrollLeft: $('.user-subscription-modif-form').position().left }, 300);
			}
			if (tour._current === 3 && $('#agency-field9-3').closest('form').find('[data-id=cc-box-form]').css('display') === 'none') {
				$('#agency-field9-3').find('[name=useCardPersonId]').val('new-card');
				$('#agency-field9-3').find('[name=useCardPersonId]').trigger('change');
			}
		}
	};

	var handlePrevStepClick = function handlePrevStepClick(tour) {
		console.log(tour);

		// PAGE DASHBOARD - SEARCHER
		if (tour._options.name === 'searcher-field4') {
			// RESPONSIVE SM
			if ($('.resp-detector-sm').css('visibility') === 'visible') {
				if (tour._current === 3 || tour._current === 4 || tour._current === 5) {
					leftMenuBtn.trigger('click');
				}
			}
		}

		// PAGE AUDITION FORM - SEARCHER
		if (tour._options.name === 'searcher-field6') {
			if (tour._current === 3) {
				$('.audition-forms-step.audition-details .audition-forms-header').trigger('click');
			}
			if (tour._current === 7) {
				$('.audition-forms-step.audition-recording .audition-forms-header').trigger('click');
			}
			if (tour._current === 9) {
				$('.audition-forms-step.audition-contract .audition-forms-header').trigger('click');
			}
			if (tour._current === 10) {
				$('.audition-forms-step.audition-profile .audition-forms-header').trigger('click');
			}
		}

		// PAGE FICHE AUDITION - SEARCHER
		if (tour._options.name === 'searcher-field8') {
			if (tour._current === 3) {
				$('.audition-actions-btn').trigger('click');
			}
			// RESPONSIVE SIDE BREAKPOINT
			if ($('.resp-detector-side-bp').css('visibility') === 'visible') {
				if (tour._current === 1) {
					$('.audition-single-details-btn.close').trigger('click');
				}
				if (tour._current === 2) {
					$('.audition-single-details-btn:not(.close)').trigger('click');
				}
			}
		}

		// PAGE DASHBOARD - ARTIST
		if (tour._options.name === 'artist-field4') {
			if (tour._current === 1 || tour._current === 2) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.header-account-btn:not(.close)').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					$('.header-account-responsive-btn').trigger('click');
				}
			}

			// RESPONSIVE SM
			if ($('.resp-detector-sm').css('visibility') === 'visible') {
				if (tour._current === 3 || tour._current === 5) {
					leftMenuBtn.trigger('click');
				}
			}
		}

		// PAGE MODIF PROFIL - ARTISTE
		if (tour._options.name === 'artist-field6') {
			if (tour._current === 2) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=personnal-detail]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('personnal-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 4) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=more-detail]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('more-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 8) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.tab[data-tab=agency-link]').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('agency-link');
					accountNav.trigger('change');
				}
			}
		}

		// PAGE FICHE AUDITION - ARTISTE
		if (tour._options.name === 'artist-field8') {
			if (tour._current === 2 || tour._current === 5) {
				$('.audition-actions-btn').trigger('click');
			}
		}

		// PAGE DASHBOARD - AGENCY
		if (tour._options.name === 'agency-field4') {
			if (tour._current === 1 || tour._current === 3) {
				// DESKTOP XS
				if ($('.resp-detector-xs').css('visibility') === 'hidden') {
					$('.header-account-btn:not(.close)').trigger('click');
				}
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					$('.header-account-responsive-btn').trigger('click');
				}
			}

			// // RESPONSIVE SM
			if ($('.resp-detector-sm').css('visibility') === 'visible') {
				if (tour._current === 3 || tour._current === 7) {
					leftMenuBtn.trigger('click');
				}
			}
		}

		// PAGE MODIF PROFIL - AGENCY
		if (tour._options.name === 'agency-field6') {
			if (tour._current === 1) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('personnal-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 2) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('more-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 3) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('agency-link');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 4) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('social');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 5) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('preferences');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 6) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('personnal-detail');
					accountNav.trigger('change');
				}
			}
			if (tour._current === 10) {
				// RESPONSIVE XS
				if ($('.resp-detector-xs').css('visibility') === 'visible') {
					accountNav.val('agency-link');
					accountNav.trigger('change');
				}
			}
		}

		// PAGE SUBSCRIPTIONS - AGENCY
		if (tour._options.name === 'agency-field9') {
			if (tour._current === 2) {
				$('.table-outer-ctn').animate({ scrollLeft: $('.hijack-user-btn').position().left }, 300);
			}
			if (tour._current === 3) {
				$('.table-outer-ctn').animate({ scrollLeft: $('.modify-artist-subscription-table-btn').position().left }, 300);
			}
		}
	};

	var saveTourSeen = function saveTourSeen(tour) {
		// console.log(tour._options.name);
		refresh = false;
		$('.toggle-guide-check').trigger('click');
	};

	var saveGuideData = function saveGuideData() {
		var t = $(this);
		var popup = t.closest('.popup');
		var seeCurrGuide = t.hasClass('confirm-see-guide-btn');
		var cancelGuide = t.hasClass('cancel-see-guide-btn');
		var currGuideNames = $('input[name=curr-guides]').val().split(',');

		var data = {
			id: gendataId,
			field1: 'guide',
			field2: personId,
			ajax: true
		};

		if (popup.length > 0) {
			var checkboxChecked = popup.find('.form-check-input').prop('checked');

			data['field3'] = !checkboxChecked;

			// if "do not ask again" checked 
			if (checkboxChecked) {
				$('input[name=all-guides]').val().split(',').forEach(function (field) {
					// if field is not current page guide and if show/hide guide value doesn't already exist for that field
					if (currGuideNames.indexOf(field) === -1 && $('input[name=guide-' + field + ']').val().length === 0) {
						data[field.split('-')[1]] = seeCurrGuide ? true : false;
					}
				});
			}
		}

		currGuideNames.forEach(function (el) {
			data[el.split('-')[1]] = seeCurrGuide ? true : false;
		});
		popup.addClass('is-processing');
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			method: 'POST',
			data: data,
			success: function success(response) {
				// console.log(response);
				if (!cancelGuide) {
					window.location.reload();
				} else {
					$('.js-popup-close-btn', popup).click();
					popup.removeClass('is-processing');
				}
			}
		});
	};

	var togglePageGuide = function togglePageGuide() {
		var t = $(this);
		var field = t.attr('name').split('-')[1];

		var data = {
			id: gendataId,
			field1: 'guide',
			field2: personId,
			ajax: true
		};

		data[field] = t.prop('checked');

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			method: 'POST',
			data: data,
			success: function success(response) {
				if (refresh) {
					$('.whole-container').addClass('is-processing');
					// console.log(response);
					window.location.reload();
				}
				refresh = true;
			}
		});
	};

	var init = function init() {
		gendataId = $('input[name=guide-id]').val();
		personId = $('input[name=person-id]').val();
		leftMenu = $('.mobile-side-menu.left');
		leftMenuBtn = $('.site-header-menu-toggle-btn');
		accountNav = $('.account-nav-select');
		isDev = $('html').data('is-dev') === true || $('html').data('is-staging') === true;

		refresh = true;

		if ($('input[name=guide-prev]').length > 0) {
			prev = $('input[name=guide-prev]').val();
		}

		if ($('input[name=guide-next]').length > 0) {
			next = $('input[name=guide-next]').val();
		}

		if ($('input[name=guide-end]').length > 0) {
			end = $('input[name=guide-end]').val();
		}

		var initGuideInputs = $('input[name=init-guide]');
		if (initGuideInputs.length > 0) {
			setTimeout(function () {
				initGuideInputs.each(function () {
					initGuide($(this).val(), $(this).data('total-steps'));
				});
			}, 350);
		}

		$('.confirm-see-guide-btn').click(saveGuideData);
		$('.cancel-see-guide-btn').click(saveGuideData);
		$('.toggle-guide-check').change(togglePageGuide);
	};

	$(window).ready(function () {
		init();
	});

	Fw.component.export('guide', {
		initGuide: initGuide
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var volume = 0.5;
	var fileType;

	var togglePopupAudio = function togglePopupAudio() {
		var t = $(this);
		var ctn = t.closest('.demo-js');
		var popupId = t.attr('data-id');
		var popup = $('.audition-single-artist-ctn').length > 0 ? $('.audition-single-artist-ctn:visible .popup[data-id=' + popupId + ']') : $('.popup[data-id=' + popupId + ']');
		var openId = $('.demo-player-popup.open').attr('data-id');
		var delay = 0;

		if ($('.demo-player-popup.open').length > 0 && $('.demo-player-popup.open').attr('data-id') !== popupId) {
			var openPlayer = $('.popup[data-id=' + openId + ']');

			delay = 300;

			openPlayer.find('audio').trigger('pause');
			openPlayer.find('video').trigger('pause');
			openPlayer.removeClass('open');
			$('.demo-js[data-id=' + openId + ']').removeClass('playing');
		}

		if ($('.demo-js.playing').length > 0 && $('.demo-js.playing').attr('data-popup-id') !== popupId) {
			var playingId = $('.demo-js.playing').attr('data-popup-id');
			var player = $('.popup[data-id=' + playingId + ']');

			player.find('audio').trigger('pause');
			$('.demo-js[data-id=' + openId + ']').removeClass('playing');
		}

		setTimeout(function () {
			var playerCtn = $('.audition-single-artist-ctn').length > 0 ? $('.audition-single-artist-ctn:visible .popup[data-id="' + popupId + '"] .player-container') : $('.popup[data-id="' + popupId + '"] .player-container');
			var mediaType = playerCtn.attr('data-type');

			if (!!document.createElement(mediaType).canPlayType && !playerCtn.hasClass('is-init')) {
				initPlayer(playerCtn, function () {
					popup.removeClass('is-processing');
				});
				ctn.toggleClass('playing');
				popup.addClass('open is-processing');
				//                if (!(navigator.userAgent.indexOf('Safari') !== -1 &&
				//                        navigator.userAgent.indexOf('Chrome') === -1 &&
				//                        navigator.userAgent.indexOf('CriOS/') === -1)) {
				playerCtn.find('.play-audio-btn').trigger('click');
				//                }
			} else if (!!document.createElement(mediaType).canPlayType) {
				ctn.toggleClass('playing');
				//                if (!(navigator.userAgent.indexOf('Safari') !== -1 &&
				//                        navigator.userAgent.indexOf('Chrome') === -1 &&
				//                        navigator.userAgent.indexOf('CriOS/') === -1)) {
				playerCtn.find('.play-audio-btn').trigger('click');
				//                }
				popup.addClass('open');
			}
		}, delay);
	};

	var initPlayer = function initPlayer(t, callback) {
		var path = t.attr('data-sound');
		var ext = t.attr('data-ext');
		var fileType = t.attr('data-type');
		var gendataId = t.attr('data-demoid');

		if (ext !== '') {
			initPlayerComponents(t, callback);
		} else {
			//Check for ext
			checkIfFileExistWithExt('mp3');
			checkIfFileExistWithExt('m4a');
			checkIfFileExistWithExt('mp4');
			checkIfFileExistWithExt('webm');
			checkIfFileExistWithExt('mov');
			checkIfFileExistWithExt('wav');
		}

		function checkIfFileExistWithExt(currExt) {
			$.ajax({
				url: path + currExt,
				method: 'HEAD',
				error: function error(jqXHR, textStatus, errorThrown) {
					// console.log('Not found : ' + path + currExt);
					// console.log(jqXHR);
					// console.log(errorThrown);
				},
				success: function success() {
					// console.log('File IS found : ' + path + currExt);
					path = path + currExt;
					ext = currExt;
					initPlayerComponents(t, callback);

					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						data: {
							id: gendataId,
							field18: currExt,
							ajax: true
						},
						success: function success(response) {
							// console.log('Demo ext change : ' + response);
						}
					});
				}
			});
		}

		function initPlayerComponents(t, callback) {
			var media;
			var timeleft = $('.time-left', t);
			var slider = $('.time .slider', t);
			var progressBar = $('.time .progress', t);
			var volumeSlider = $('.volume .slider', t);
			var volumeBar = $('.volume .progress', t);
			var duration;
			var animSlider;
			var animProgressBar;
			var id = t.closest('.popup').attr('data-id');
			var demoCtn = $('.demo-js[data-popup-id=' + id + ']');
			var count = $('.demo-js[data-popup-id=' + id + '] .listen-count, .profile-top-right-ctn .listen-count');

			if (t.attr('data-type') === 'video') {
				media = document.createElement("video");
				media.setAttribute("src", path);
			} else {
				media = new Audio(path);
			}

			if (demoCtn.length === 0) {
				demoCtn = $('.demo-js[data-id=' + id + ']');
			}

			//console.log('audio-init id: ' + t.attr('data-sound'));
			media.volume = volume;
			volumeSlider.val(volume);
			volumeBar.css('width', volume * 100 + '%');

			if (t.closest('.popup-inner').find('.media-ctn').length > 0) {
				t.closest('.popup-inner').find('.media-ctn').append(media);
			} else {
				t.append(media);
			}

			$(media).on('loadedmetadata', function () {
				slider.attr('max', media.duration);

				if (t.closest('.is-processing').length > 0) {
					t.closest('.is-processing').removeClass('is-processing');
				}

				if (t.hasClass('playing')) {
					animSlider = $({ val: media.currentTime }).animate({ val: media.duration }, {
						duration: (media.duration - media.currentTime) * 1000,
						easing: 'linear',
						step: function step(val) {
							slider.val(val);
						}
					});
					animProgressBar = $({ width: media.currentTime / media.duration * 100 }).animate({ width: 100 }, {
						duration: (media.duration - media.currentTime) * 1000,
						easing: 'linear',
						step: function step(val) {
							progressBar.css('width', val + '%');
						}
					});
				}
			});

			$(media).bind('timeupdate', function () {
				var rem = parseInt(media.duration - media.currentTime, 10),
				    mins = Math.floor(rem / 60, 10),
				    secs = rem - mins * 60;

				timeleft.text('-' + mins + ':' + (secs > 9 ? secs : '0' + secs));
			});

			$(media).bind('play', function () {
				// console.log(media.currentTime);
				if (media.currentTime < 0.01 && !t.hasClass('no-count')) {
					var newCount = parseInt(count.html()) + 1;
					// console.log(gendataId);
					// console.log(newCount);

					// ADD TO PLAY COUNTER
					$.ajax({
						url: '/action/vcUpdateCounter',
						cache: false,
						method: 'POST',
						data: {
							id: gendataId,
							field: "field13",
							ajax: true
						},
						success: function success(response) {
							// console.log('add count: ' + response);
							count.html(response);
						}
					});
				}

				animSlider = $({ val: media.currentTime }).animate({ val: media.duration }, {
					duration: (media.duration - media.currentTime) * 1000,
					easing: 'linear',
					step: function step(val) {
						slider.val(val);
					}
				});
				animProgressBar = $({ width: media.currentTime / media.duration * 100 }).animate({ width: 100 }, {
					duration: (media.duration - media.currentTime) * 1000,
					easing: 'linear',
					step: function step(val) {
						progressBar.css('width', val + '%');
					}
				});
				t.addClass('playing');
				demoCtn.addClass('playing');
			}).bind('pause ended', function () {
				t.removeClass('playing');
				if (animSlider !== undefined) {
					animSlider.stop();
					animProgressBar.stop();
					demoCtn.removeClass('playing');
				}
			});

			$(media).on('ended', function () {
				slider.val(0);
				progressBar.css('width', 0);
				demoCtn.removeClass('playing');
				// t.closest('.popup').removeClass('open');
			});

			$(".play-audio-btn", t).click(function () {
				if (media.paused) {
					media.play();
				} else {
					media.pause();
				}
			});

			// **** tester waiting et playing, ajuster animations en consequence

			// SLIDERS

			slider.on('input', function () {
				if (animSlider !== undefined) {
					animSlider.stop();
					animProgressBar.stop();
				}
				media.currentTime = slider.val();
				progressBar.css('width', media.currentTime / media.duration * 100 + '%');
			});

			slider.change(function () {
				media.currentTime = slider.val();
				progressBar.css('width', media.currentTime / media.duration * 100 + '%');

				if (!media.paused) {
					animSlider = $({ val: media.currentTime }).animate({ val: media.duration }, {
						duration: (media.duration - media.currentTime) * 1000,
						easing: 'linear',
						step: function step(val) {
							slider.val(val);
						}
					});
					animProgressBar = $({ width: media.currentTime / media.duration * 100 }).animate({ width: 100 }, {
						duration: (media.duration - media.currentTime) * 1000,
						easing: 'linear',
						step: function step(val) {
							progressBar.css('width', val + '%');
						}
					});
				}
			});

			volumeSlider.on('input', function () {
				volume = volumeSlider.val();
				media.volume = volume;
				volumeBar.css('width', volume * 100 + '%');
			});

			volumeSlider.change(function () {
				volume = volumeSlider.val();
				media.volume = volume;
				volumeBar.css('width', volume * 100 + '%');
			});

			if (callback) {
				$(media).on('loadedmetadata', function () {
					callback();
				});
			}

			t.addClass('is-init');
		}
	};

	var init = function init() {
		$('.player-container.initOnInit').each(function () {
			initPlayer($(this));
		});

		$('body').on('click', '.play-audio-btn.open-player', togglePopupAudio);

		$('body').on('click', '.demo-player-popup.open .js-popup-close-btn', function () {
			var mediaType = $('.demo-player-popup.open').find('.player-container').attr('data-type');

			$('.demo-player-popup.open').find(mediaType).trigger('pause');
		});
	};

	$(window).ready(init);

	Fw.component.export('player', {
		togglePopupAudio: togglePopupAudio
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var header;

	var openPopup = function openPopup(p) {
		var id = $(this).attr('data-id');
		var popup;

		p.length !== undefined ? popup = p : popup = $('.popup[data-id="' + id + '"]');

		popup.addClass('open');
		if (!popup.hasClass('no-overlay')) {
			$('body').addClass('popup-show');
		}
		if (!popup.hasClass('scroll-enabled')) {
			header.removeScroll();
		}
		if (popup.find('.init-addthis').length > 0) {
			popup.find('.init-addthis').addClass(popup.find('.init-addthis').attr('data-class'));
			addthis.layers.refresh();
		}
	};

	var closePopup = function closePopup() {
		//Le popup ne perd pas sa class .open
		var popup = $(this).closest('.popup');

		popup.removeClass('open');
		if (!popup.hasClass('no-overlay')) {
			$('body').removeClass('popup-show');
		}
		if (!popup.hasClass('scroll-enabled')) {
			header.addScroll();
		}
		popup.trigger("popup_closed");
	};

	var closeAllPopup = function closeAllPopup() {
		$('.popup').removeClass('open');
		$('body').removeClass('popup-show');
		header.addScroll();

		var currentPopup = $(this).closest('.popup');
		if (currentPopup) {
			currentPopup.trigger("popup_closed");
		}
	};

	var init = function init() {
		header = Fw.modules.models().header;

		$('body').on('click', '.popup-btn', openPopup);
		$('body').on('click', '.js-popup-close-btn', closeAllPopup);
	};

	$(window).ready(function () {
		init();
	});

	var popup = Fw.component.export('popup', {
		openPopup: openPopup,
		closePopup: closePopup,
		closeAllPopup: closeAllPopup
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var form;
	var sliders;

	var init = function init() {
		$('.public-auditions-com').each(function () {
			var slider = $('.auditions-list', this);
			var prevArrow = $('.slider-btn.prev', this);
			var nextArrow = $('.slider-btn.next', this);

			slider.slick({
				infinite: true,
				slidesToShow: 2,
				slidesToScroll: 1,
				variableWidth: true,
				swipeToSlide: true,
				dots: false,
				prevArrow: prevArrow,
				nextArrow: nextArrow,
				responsive: [{
					breakpoint: 480,
					settings: {
						slidesToShow: 1,
						variableWidth: false
					}
				}]
			});
		});
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var videoCtn;

	var toggleVideoSound = function toggleVideoSound() {
		var t = $(this);
		var parentCtn = t.closest('.video-ctn');
		var video = parentCtn.find('video');

		if (video.prop('muted')) {
			video.prop('muted', false);
			t.removeClass('off');
		} else {
			video.prop('muted', true);
			t.addClass('off');
		}
	};

	var checkIfMobile = function checkIfMobile() {
		if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
			videoCtn.remove();
		} else {
			videoCtn.each(function () {
				// $(this).find('video').attr('src', $(this).find('video').attr('data-src'));
				$(this).fadeIn();
			});
		}
	};

	var init = function init() {
		$('.video-sound-btn').click(toggleVideoSound);
		videoCtn = $('.video-ctn');

		if (videoCtn.length > 0) {
			checkIfMobile();
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {
	/*
  * Mathilde Paccoud
  * Last update 25/03/2017
  * 
  * Purpose : Allows to store a session variable
  * 
  * @param : key - unique key to store a value in
  * @param : val - value to store in the label; if val is null : session variable is deleted
  * @param : callback - any function to be called once value is stored
  * 
  * Call : var session = Fw.component.models().session;
  */
	'use strict';

	var save = function save(key, val, callback) {
		if (val === null) {
			ajax("/action/sessionVariables?key=" + key, callback, true);
		} else {
			ajax("/action/sessionVariables?key=" + key + "&value=" + val, callback, true);
		}
	};

	var init = function init(page) {
		var currPage = $(page);
	};

	var session = Fw.component.export('session', {
		init: init,
		save: save
	});

	$(window).on("load", function () {
		init();
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var utils;
	var form;

	var demoCall = function demoCall() {
		processForm({
			t: this,
			formClass: '.demo-share-form',
			popupClass: '.demo-share-form-popup',
			fileName: 'demo-share'
		});
	};

	var saveCall = function saveCall() {
		processForm({
			t: this,
			formClass: '.save-share-form',
			popupClass: '.save-share-form-popup',
			fileName: 'save-share'
		});
	};

	var auditionCall = function auditionCall() {
		var name = $(this).attr('data-extra');
		processForm({
			t: this,
			formClass: '.audition-share-form',
			popupClass: '.audition-share-form-popup',
			fileName: 'audition-share',
			extra: name
		});
	};

	var subscriptionUpdateCall = function subscriptionUpdateCall() {
		processForm({
			t: this,
			formClass: '.send-message-upgrade-package-form',
			popupClass: '.send-message-upgrade-package-form-popup',
			fileName: 'upgrade-package-share'
		});
	};

	var processForm = function processForm(data) {
		var t = $(data.t);
		var currForm = t.closest(data.formClass);
		var currPopup = currForm.closest(data.popupClass);

		form.validateForm(currForm);

		if (!currForm.hasClass('has-error')) {
			currPopup.addClass('is-processing');

			var lang = $('html').attr('lang');
			var subject = $('input[name="subject"]', currForm).val().trim();
			var urlToShare = $('input[name="urlToShare"]', currForm).val().trim();
			var name = $('.form-input[name="name"]', currForm).val().trim();
			var fromEmail = $('.form-input[name="fromEmail"]', currForm).val().trim();
			var sendEmail = $('.form-input[name="sendEmail"]', currForm).val().split(',');
			var message = $('.form-input[name="message"]', currForm).val().trim();
			var copy = $('.form-check-input[name="copy"]', currForm).is(':checked');

			var count = sendEmail.length;
			var doneCount = 0;

			if (copy) {
				count++;
			}

			for (var i = sendEmail.length - 1; i >= 0; i--) {
				utils.sendEmail(sendEmail[i].trim(), subject, message, data.fileName + "-" + lang, { "field1": name, "field2": fromEmail, "field3": urlToShare, "field4": data.extra }, function (response) {
					console.log(data.fileName + ' : ' + response);
					doneCount++;

					if (doneCount === count) {
						showSuccess(currPopup);
					}
				});
			}

			if (copy) {
				utils.sendEmail(fromEmail, subject, message, data.fileName + "-" + lang, { "field1": name, "field2": fromEmail, "field3": urlToShare }, function (response) {
					console.log(data.fileName + ' : ' + response);
					doneCount++;

					if (doneCount === count) {
						showSuccess(currPopup);
					}
				});
			}
		}
	};

	var showSuccess = function showSuccess(currPopup) {
		currPopup.removeClass('is-processing');
		$('.popup-close-btn', currPopup).trigger('click');

		if (!$('body').hasClass('is-signed-in')) {
			$('.form-input[name="name"]').val('');
			$('.form-input[name="fromEmail"]').val('');
		}

		$('.form-input[name="name"]').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success');
		$('.form-input[name="fromEmail"]').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success');

		$('.form-input[name="sendEmail"]').val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success');
		$('.form-input[name="message"]').val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success');
		$('.form-check-input[name="copy"]').prop('checked', false);
	};

	var updateSaveType = function updateSaveType() {
		var select = $(this);
		var form = $(select).closest('.fieldset');
		var upload = $('.form-item-upload', form);
		var gendataId = $('input[name="gendataId"]', form).val();
		var mediaId = $('input[name="userMediaId"]', form).val();

		if (select.val() == 'customImage') {
			upload.removeClass('hide');

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: gendataId,
					field4: 'true',
					ajax: true
				},
				success: function success(response) {
					console.log('save-share : ' + response);
				}
			});
		} else if (select.val() == 'profileImage') {
			upload.addClass('hide');

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: gendataId,
					field4: 'true',
					field5: '/static/uploaded/Profile/' + mediaId + '-main.jpg',
					ajax: true
				},
				success: function success(response) {
					console.log('save-share : ' + response);
				}
			});
		} else {
			upload.addClass('hide');

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: gendataId,
					field4: 'false',
					ajax: true
				},
				success: function success(response) {
					console.log('save-share : ' + response);
				}
			});
		}
	};

	var changeSavePic = function changeSavePic() {
		var t = $(this);
		var form = $(t).closest('.fieldset');
		var gendataId = $('input[name="gendataId"]', form).val();
		var files = t[0].files;
		var size = files[0].size;

		console.log('size : ' + size);

		if (files !== undefined) {
			if (size <= 1048576) {
				// 1MB
				// $('.account-pic-img-ctn').addClass('is-processing');

				for (var i = 0; i < files.length; i++) {

					var re = /(?:\.([^.]+))?$/;
					var ext = re.exec(files[i].name)[1].toLowerCase();

					if (ext === 'jpg' || ext === 'jpeg' || ext === 'png') {
						var data = new FormData();
						data.append('image', files[i]);
						data.append('customLabel', 'save');
						data.append('directory', 'Save');
						data.append('ajax', 'true');

						$.ajax({
							url: '/action/uploadCroppedImage',
							cache: false,
							contentType: false,
							processData: false,
							method: 'POST',
							data: data,
							success: function success(response) {
								console.log(response);
								var newFileId = response.substring(response.indexOf('mediaId=') + 'mediaId='.length).trim();
								console.log('file: ' + newFileId);

								var newDate = new Date();

								$.ajax({
									url: '/action/manageGenData',
									cache: false,
									data: {
										id: gendataId,
										field4: 'true',
										field5: '/static/uploaded/Save/' + newFileId + '-save.jpg',
										ajax: true
									},
									success: function success(genResponse) {
										// var newScriptId = genResponse.substring('success-'.length);
										console.log('Gendata: ' + genResponse);

										// fileCtn.removeClass('is-processing');
										// form.resetUpload(file);

										// callback(newFileId, ext, filename, newScriptId);
									}
								});
							}
						});
					} else {
						$('.account-pic').removeClass('is-processing');
						var errorMessage = $('.form-popup-message.profile-pic-error');

						errorMessage.addClass('show');

						setTimeout(function () {
							errorMessage.removeClass('show');
						}, 5000);
					}
				}
			} else {
				form.showErrorPopupAnimation('profile-pic-size-message-error');
			}
		}
	};

	var init = function init() {
		utils = Fw.component.models().utils;
		form = Fw.component.models().form;

		$('body').on('click', '.demo-share-form-submit', demoCall);
		$('body').on('click', '.save-share-form-submit', saveCall);
		$('body').on('click', '.audition-share-form-submit', auditionCall);
		$('body').on('click', '.send-message-upgrade-package-form-submit', subscriptionUpdateCall);
		$('body').on('change', '[name="save-share-form-type"]', updateSaveType);
		$('body').on('change', '[name="save-share-custom-pic"]', changeSavePic);
	};

	$(init);
})(jQuery);
(function ($, undefined) {
	'use strict';

	var init = function init() {
		$('.sponsors-com').each(function () {
			var slider = $('.all-sponsors-ctn-inner', this);
			var prevArrow = $('.slider-btn.prev', this);
			var nextArrow = $('.slider-btn.next', this);

			slider.slick({
				infinite: true,
				slidesToShow: 6,
				slidesToScroll: 1,
				dots: false,
				autoplay: true,
				prevArrow: prevArrow,
				nextArrow: nextArrow,
				responsive: [{
					breakpoint: 1280,
					settings: {
						slidesToShow: 5
					}
				}, {
					breakpoint: 1024,
					settings: {
						slidesToShow: 4
					}
				}, {
					breakpoint: 768,
					settings: {
						slidesToShow: 3
					}
				}, {
					breakpoint: 600,
					settings: {
						slidesToShow: 2
					}
				}, {
					breakpoint: 480,
					settings: {
						slidesToShow: 1
					}
				}]
			});
		});
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
//import 
//<script src="https://js.stripe.com/v3/"></script>
//
//
// Card numbers && tokens for testing : https://stripe.com/docs/testing

//TO DO : 
//- In your checkout or manageCard page, call the com : 
//		stripe = Fw.component.models().stripeToken;	  
//	  stripe.init();
//- Edit your form style below (style var) : https://stripe.com/docs/stripe-js/reference#element-options
//- Create a <div> with an id corresponding to var ccFieldsId (line 29) (your fields (CCNumber, exp, cvv) will automatically appear here)
//- Make sure you have a container with id : var cardErrorsId (line 28). In case of an error in the CC, the message will appear here. You can customize the messages. (replace event.error.message and result.error.message with your own messsage)
//- Specify the button class on which you want the listener to be (to generate de token) : var button = $('.membership-payment-submit-btn'); line 27
// - Get the token : result.token.id and send it to the BE (param : cardToken) in the final step of the payment OR in the manageCard action (save card)
//
//- Once LIVE : Get the PUBLIC API KEY from the client and replace [YOUR PUBLIC API KEY] with it.

(function ($, undefined) {

	'use strict';

	var APIK_TEST = 'pk_test_HhX3YNMlO2VMhFdx6AFnBe3q';
	var APIK_LIVE = 'pk_live_08KZKWGnxV1jteoU25abL1bH';

	var validateForm = function validateForm(t) {
		if (typeof Stripe !== "function") return;

		// Create a Stripe client.
		var stripe = Stripe($("html").attr("data-is-dev") === 'true' || $("html").attr("data-is-staging") === 'true' ? APIK_TEST : APIK_LIVE);

		var ccFields = t;
		var form = ccFields.closest('form');
		var button = $('.get-stripe-token', form);
		var ccFieldsId = ccFields.attr('id');
		var cardErrors = $('.card-errors', form);

		if ($('#' + ccFieldsId).length !== 0) {
			// Create an instance of Elements.
			var elements = stripe.elements();

			// Custom styling can be passed to options when creating an Element.
			var style = {
				base: {
					color: '#212121',
					lineHeight: '22px',
					fontFamily: 'Lato, "Helvetica Neue", Helvetica, sans-serif',
					fontSmoothing: 'antialiased',
					fontSize: '16px',
					'::placeholder': {
						color: '#c5c5c5'
					}
				},
				invalid: {
					color: '#e73024',
					iconColor: '#e73024'
				}
			};

			//// Create an instance of the card Element. Remove hidePostalCode if PC validation required
			var card = elements.create('card', {
				hidePostalCode: true, style: style });

			card.mount('#' + ccFieldsId);

			// Handle real-time validation errors from the card Element.
			card.addEventListener('change', function (event) {
				if (event.error) {
					cardErrors.html(event.error.message);
				} else {
					cardErrors.html('');
				}
			});

			// Handle form submission.
			button.on('click', function (event) {
				event.preventDefault();

				stripe.createToken(card).then(function (result) {
					if (result.error) {
						// Inform the user if there was an error.
						cardErrors.html(result.error.message);
					} else {
						var m;
						if (result.token.card.exp_month < 10) {
							m = '0' + result.token.card.exp_month;
						} else {
							m = result.token.card.exp_month;
						}

						// Send the token in a stripeToken param in the payment
						$('input[name=cardToken]', form).val(result.token.id);
						// Send cc inputs to backend
						$('input[type=hidden].ccType', form).val(result.token.card.brand);
						$('input[type=hidden].cc', form).val(result.token.card.last4);
						$('input[type=hidden].mm', form).val(m);
						$('input[type=hidden].yy', form).val(result.token.card.exp_year.toString().substring(2));
					}
					// In subscription checkout the validation will go through recaptcha next so no submission after
					if (form.find('.recaptcha-ctn').length === 0) {
						form.trigger('submit');
					} else if (!!grecaptcha) {
						grecaptcha.execute(button.attr('data-widget-id'));
					}
				});
			});
		}
	};

	Fw.component.export('stripeToken', {
		init: validateForm
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	$(window).ready(function () {
		var util = Fw.component.models().utils;
		var state = {};

		$('.tab').click(function () {
			var t = $(this);
			var tab = t.attr('data-tab');
			var family = t.attr('data-tab-family');
			var param = t.attr('data-param');

			$('.tab[data-tab-family="' + family + '"]').removeClass('selected');
			t.addClass('selected');

			$('.tab-ctn[data-tab-family="' + family + '"]').removeClass('selected');
			$('.tab-ctn[data-tab-family="' + family + '"][data-tab="' + tab + '"]').addClass('selected');

			state = { t: tab, tf: family };
			util.changeURLState(param, tab, Object.assign({}, state));
		});

		if ($('.tab')[0]) {
			window.addEventListener("popstate", function (e) {
				var tab = e.state ? e.state.t : state.t;
				var family = e.state ? e.state.tf : state.tf;
				$('.tab[data-tab-family="' + family + '"]').removeClass('selected');
				$('.tab[data-tab-family="' + family + '"][data-tab="' + tab + '"]').addClass('selected');
				$('.tab-ctn[data-tab-family="' + family + '"]').removeClass('selected');
				$('.tab-ctn[data-tab-family="' + family + '"][data-tab="' + tab + '"]').addClass('selected');
			});
		}
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var SUBMITTING_FORM = false;

	var updateBgPosLabel = function updateBgPosLabel() {
		var t = $(this);
		var value = t.val() + "%";
		var key = t.data('key');

		var langs = $('html').attr('data-all-langs');
		updateLabelLangs(key, value, langs, function () {}, true);
	};

	var changeBgPos = function changeBgPos() {
		var t = $(this);
		var ctn = $('.background-img-' + t.attr('data-id'));
		var currentPosition = ctn.css('backgroundPosition');
		var value = t.val();
		var otherVal;

		// change background
		if (t.hasClass('horizontal')) {
			otherVal = currentPosition.split('% ');
			ctn.css('backgroundPosition', value + '% ' + otherVal[1]);
		} else if (t.hasClass('vertical')) {
			otherVal = currentPosition.split(' ');
			ctn.css('backgroundPosition', otherVal[0] + ' ' + value + '%');
		}
	};

	var toggleElement = function toggleElement() {
		var t = $(this);
		var ctn = t.closest('.toggle-outer-ctn');
		var el = ctn.find('.element-to-toggle');

		if (!ctn.length || !el.length) {
			el = $('.element-to-toggle[data-id=' + t.attr('data-id') + ']');
			ctn = t.parent();
		}

		if (t.hasClass('required-toggle')) {
			if (el.css('display') === 'block' && el.find('input, select, .form-input').hasClass('required')) {
				el.find('input.required, select.required, .form-input.required, .form-input-big-ctn.required').removeClass('required').addClass('derequired');
			} else if (el.css('display') !== 'block' && el.find('input, select, .form-input').hasClass('derequired')) {
				el.find('input.derequired, select.derequired, .form-input.derequired, .form-input-big-ctn.derequired').removeClass('derequired').addClass('required');
			}
		}

		if (t.hasClass('delete-val-toggle')) {
			el.find('input').val('');
		}

		ctn.toggleClass('open');
		el.slideToggle();
	};

	var settingsInputChange = function settingsInputChange() {
		var t = $(this);
		var label = t.attr('name');
		var val = t.is(':checked').toString();

		if (t.attr('value')) {
			val = t.attr('value');
		}

		updateLabelLangs(label, val, 'fr,en', function () {}, true);
	};

	var submitFilterForm = function submitFilterForm() {
		if (!SUBMITTING_FORM) {
			SUBMITTING_FORM = true;
			$(this).closest('form').submit();
		}
	};

	var scrollToAnchor = function scrollToAnchor() {
		var anchor = window.location.href.split('#')[1];

		if (anchor !== '') {
			var content = $('[data-anchor=' + anchor + ']');
			var tabCtn = content.closest('.tab-ctn');

			if (content.length) {
				if (tabCtn !== undefined && !tabCtn.hasClass('selected')) {
					var id = tabCtn.attr('data-tab');
					var fam = tabCtn.attr('data-tab-family');

					$('.tab[data-tab=' + id + '][data-tab-family=' + fam + ']').trigger('click');
				}

				var target = content.offset().top - $('.site-header').height();

				$('html').animate({ scrollTop: target });
				$('body').animate({ scrollTop: target });
			}
		}
	};

	var moveMessagePopups = function moveMessagePopups() {
		$('.tooltip-ctn .popup.new-message-popup').each(function () {
			var clone = $(this).clone();
			$('body').append(clone);

			$(this).remove();
		});
	};

	var typeNumbersOnly = function typeNumbersOnly(e) {
		var allowed = [0, 8, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57];

		if ($(this).hasClass('phone')) {
			allowed.push(45);
		}

		if (!e.shiftKey && allowed.indexOf(e.which) !== -1) {
			return true;
		} else {
			e.preventDefault();
			return false;
		}
	};

	var submitClosestForm = function submitClosestForm() {
		$(this).closest('form').submit();
	};

	var init = function init() {
		var bgPosRange = $('.image-bg-pos');
		$('input.numbers-only').keypress(typeNumbersOnly);
		$('body').on('click', '.toggle-trigger-element', toggleElement);
		$('.toggle-settings-label-input').change(settingsInputChange);
		$('.filter-select').change(submitFilterForm);
		bgPosRange.on('change', updateBgPosLabel);
		bgPosRange.on('input', changeBgPos);
		$('.submit-on-change').change(submitClosestForm);

		if ($('button.trigger-on-load').length) {
			$('button.trigger-on-load').trigger('click');
		}

		$('.trigger-anchor').click(function () {
			setTimeout(function () {
				scrollToAnchor();
			}, 300);
		});

		if (window.location.href.indexOf('#') !== -1) {
			scrollToAnchor();
		}

		if ($('.tooltip-ctn .popup.new-message-popup').length !== 0) {
			moveMessagePopups();
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {
	'use strict';

	var win = $(window);
	var body;

	var winWidth;
	var winHeight;

	var toggleTooltip = function toggleTooltip() {
		var t = $(this);
		var assocTooltip = $('.tooltip-big-ctn[data-id="' + t.attr('data-id') + '"]');
		var isShown;

		if (assocTooltip.length > 1) {
			assocTooltip = t.closest('.tooltip-outer-ctn').find('.tooltip-big-ctn[data-id="' + t.attr('data-id') + '"]');
		}
		isShown = assocTooltip.hasClass('show');

		$('.tooltip-big-ctn').removeClass('show');
		if (!isShown) {
			assocTooltip.addClass('show');
			body.on('click', outsideTooltipClose);
		} else {
			body.off('click', outsideTooltipClose);
		}
	};

	var outsideTooltipClose = function outsideTooltipClose(e) {
		if (e !== undefined) {
			if (!$(e.target).closest('.tooltip-big-ctn').length && !$(e.target).closest('.toggle-tooltip-btn').length && !$(e.target).closest('.popover').length && !$(e.target).closest('.tour-backdrop').length) {
				closeAllTooltips();
				body.off('click', outsideTooltipClose);
			}
		} else {
			closeAllTooltips();
		}
	};

	var closeAllTooltips = function closeAllTooltips() {
		$('.tooltip-big-ctn').removeClass('show');
	};

	var resetTooltips = function resetTooltips() {
		var tooltips = $('.tooltip-big-ctn:not(.no-reset)');

		tooltips.each(function () {
			var t = $(this);
			var assocItem = $('.toggle-tooltip-btn[data-id="' + t.attr('data-id') + '"]');
			body.append(tooltips);

			if (assocItem.length) {
				var innerCtn = $('.tooltip-ctn', t);
				var pos = assocItem.offset();

				if (innerCtn.hasClass('bottom')) {
					t.css({
						top: pos.top,
						left: pos.left + assocItem.outerWidth() / 2
					});
				} else if (innerCtn.hasClass('top')) {
					t.css({
						top: pos.top + assocItem.outerHeight(),
						left: pos.left + assocItem.outerWidth() / 2
					});
				}
			}
		});
	};

	var init = function init() {
		winWidth = win.width();
		winHeight = win.height();
		body = $('body');

		body.on('click', '.toggle-tooltip-btn', toggleTooltip);

		setTimeout(resetTooltips, 250);

		win.resize(function () {
			if (win.width() != winWidth) {
				winHeight = win.height();
				winWidth = win.width();
				resetTooltips();
			}
		});
	};

	$(window).ready(init);

	Fw.component.export('tooltip', {
		resetTooltips: resetTooltips,
		outsideTooltipClose: outsideTooltipClose
	});
})(jQuery);
(function ($, d, g) {
	'use strict';

	var recaptchaApiKey = '6LdaAn0UAAAAAIilSwqh3TJw8YSsHEdlIlStAYjV';
	var recaptchaInitLimit = 3000;

	var mailchimpOptions = {
		"baseUrl": "mc.us9.list-manage.com",
		"uuid": "69c5444a4ab8780ae4e556425",
		"lid": "99636fb7b3",
		"uniqueMethods": true
	};

	// Object to export
	var utils = {
		/**
   * RECAPTCHA UTIL FUNCTION Render recaptchas dynamically.
   * 
   * @param   btn		 An element referencing the button or a string 
   *					  referencing the Id of the element.
   * @param   callback	A function to be called after recaptcha has 
   *					  completed its check. The function is passed back
   *					  the recaptcha response and the form element.
   * @param   validate	(optional) A boolean to know if a form needs to be 
   *					  validated using the formValidator in com/form.js.
   * @param   form		(optional) A jQuery object reference the form to be
   *					  validated using formValidator in com/form.js.
   */
		recaptcha: function recaptcha(btn, _callback, validate, form) {
			if (!btn || --recaptchaInitLimit <= 0) {
				return;
			}

			var it = this;
			if (!!g.grecaptcha) {
				if (grecaptcha.render) {
					grecaptcha.render(btn, {
						'sitekey': recaptchaApiKey,
						'callback': function callback(response) {
							var formValidator = Fw.component.models().form.validateForm;
							var validated = true;
							if (validate) {
								validated = false;
								formValidator(form);
								if (!form.hasClass('has-error')) {
									validated = true;
								}
							}

							if (validated) {
								_callback(response, form);
							} else {
								grecaptcha.reset();
							}
						},
						'badge': 'inline'
					});
				} else {
					setTimeout(function () {
						it.recaptcha(btn, _callback, validate, form);
					}, 250);
				}
			} else if (!g.grecaptcha) {
				setTimeout(function () {
					it.recaptcha(btn, _callback, validate, form);
				}, 250);
			}
		},

		recaptcha2: function recaptcha2(btn, _callback2) {
			if (!btn || --recaptchaInitLimit <= 0) {
				return;
			}

			var it = this;
			if (!!g.grecaptcha && !!grecaptcha.render) {
				var div = $('<div class="recaptcha-ctn"></div>').insertBefore(btn);
				var widgetId = grecaptcha.render(div[0], {
					'sitekey': recaptchaApiKey,
					'callback': function callback(response) {
						_callback2.call(btn, response);
					},
					'badge': 'inline',
					'size': 'invisible'
				});
				btn.setAttribute('data-widget-id', widgetId);
				// Flow of register: stripe token -> recaptcha -> form validation -> submit
				if (!$(btn).hasClass('get-sripe-token')) {
					$(btn).on('click', function () {
						grecaptcha.execute(widgetId);
					});
				}
			} else {
				setTimeout(function () {
					it.recaptcha2(btn, _callback2);
				}, 250);
			}
		},

		sendEmail: function sendEmail(email, subject, message, file, fields, callback) {
			var params = {
				email: email,
				subject: subject,
				file: file
			};
			if (message) {
				params.message = message;
			}
			for (var key in fields) {
				if (fields.hasOwnProperty(key) && /^field[123456]$/.test(key)) {
					params[key] = fields[key];
				}
			}
			$.ajax({
				url: "/action/sendEmail",
				method: "post",
				data: params,
				complete: function complete(response) {
					if (typeof callback === "function") callback(response.responseText);
				}
			});
		},

		getQuery: function getQuery(param, search) {
			var se = search !== undefined ? search : g.location.search;
			var qs = se.replace("?", "");
			if (!param || param === "") return qs;
			if (qs === "") return null;

			var qa = qs.split("&");
			for (var i = 0; i < qa.length; i++) {
				var q = qa[i];
				if (q.indexOf("=") > -1) {
					var a = q.split("=");
					if (a[0] === param) return a[1];
				} else {
					if (q === param) return "";
				}
			}
		},

		setQuery: function setQuery(param, value, search) {
			var se = search !== undefined ? search : g.location.search;
			var v = encodeURIComponent(value);
			if (se !== "") {
				var qa = se.replace("?", "").split("&");
				var qa2 = [];
				var isNew = true;

				for (var i = 0; i < qa.length; i++) {
					var qi = qa[i];
					var j = qi.indexOf("=");
					var qname = j > -1 ? qi.substring(0, j) : qi;
					if (qname === param) {
						if (v && v !== "") {
							qi = param + "=" + v;
						} else {
							qi = param;
						}
						isNew = false;
					}
					qa2.push(qi);
				}
				if (isNew) qa2.push(param + "=" + v);

				return qa2.join("&");
			} else if (v && v !== "") {
				return param + "=" + v;
			} else {
				return param;
			}
		},

		removeQuery: function removeQuery(param, search) {
			var se = search !== undefined ? search : g.location.search;
			if (!param || param === "") return se.replace("?", "");

			var qa = se.replace("?", "").split("&");
			var qa2 = [];
			for (var i = 0; i < qa.length; i++) {
				var qi = qa[i];
				var j = qi.indexOf("=");
				var qname = j > -1 ? qi.substring(0, j) : qi;

				if (qname !== param) qa2.push(qi);
			}

			return qa2.join("&");
		},

		changeURLState: function changeURLState(q, x, state, title) {
			var qs = "";
			var url = g.location.pathname;

			if (!q || typeof q !== "string") {
				return null;
			}

			if (x === null || x === undefined) {
				qs = this.removeQuery(q);
			} else {
				qs = this.setQuery(q, x);
			}
			if (qs !== "") {
				qs = "?" + qs;
			}
			url += qs + g.location.hash;

			return g.history.pushState(state, title ? title : q + " " + x, url);
		},

		showMCPopup: function showMCPopup() {
			g.dojoRequire(["mojo/signup-forms/Loader"], function (L) {
				L.start(mailchimpOptions);
			});
			d.cookie = "MCPopupClosed=;expires=Thu, 01 Jan 1970 00:00:00 UTC";
		},

		animateCheck: function animateCheck(response, container) {
			if (response.indexOf('success') !== -1) {
				container.find('.confirmation-check').addClass('run-animation');

				setTimeout(function () {
					container.find('.confirmation-check').removeClass('run-animation');
				}, 5000);
			}
		}
	};

	Fw.component.export('utils', utils);
})(jQuery, document, window);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* ========================================================================
 * bootstrap-tour - v0.12.0
 * http://bootstraptour.com
 * ========================================================================
 * Copyright 2012-2015 Ulrich Sossou
 *
 * ========================================================================
 * Licensed under the MIT License (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://opensource.org/licenses/MIT
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================================
 */

/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap');

    var transEndEventNames = {
      WebkitTransition: 'webkitTransitionEnd',
      MozTransition: 'transitionend',
      OTransition: 'oTransitionEnd otransitionend',
      transition: 'transitionend'
    };

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] };
      }
    }

    return false; // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false;
    var $el = this;
    $(this).one('bsTransitionEnd', function () {
      called = true;
    });
    var callback = function callback() {
      if (!called) $($el).trigger($.support.transition.end);
    };
    setTimeout(callback, duration);
    return this;
  };

  $(function () {
    $.support.transition = transitionEnd();

    if (!$.support.transition) return;

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function handle(e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments);
      }
    };
  });
}(jQuery);

/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function Tooltip(element, options) {
    this.type = null;
    this.options = null;
    this.enabled = null;
    this.timeout = null;
    this.hoverState = null;
    this.$element = null;
    this.inState = null;

    this.init('tooltip', element, options);
  };

  Tooltip.VERSION = '3.3.7';

  Tooltip.TRANSITION_DURATION = 150;

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  };

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled = true;
    this.type = type;
    this.$element = $(element);
    this.options = this.getOptions(options);
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport);
    this.inState = { click: false, hover: false, focus: false };

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!');
    }

    var triggers = this.options.trigger.split(' ');

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i];

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this));
      } else if (trigger != 'manual') {
        var eventIn = trigger == 'hover' ? 'mouseenter' : 'focusin';
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout';

        this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this));
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this));
      }
    }

    this.options.selector ? this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' }) : this.fixTitle();
  };

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS;
  };

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options);

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      };
    }

    return options;
  };

  Tooltip.prototype.getDelegateOptions = function () {
    var options = {};
    var defaults = this.getDefaults();

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value;
    });

    return options;
  };

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
      $(obj.currentTarget).data('bs.' + this.type, self);
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true;
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in';
      return;
    }

    clearTimeout(self.timeout);

    self.hoverState = 'in';

    if (!self.options.delay || !self.options.delay.show) return self.show();

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show();
    }, self.options.delay.show);
  };

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true;
    }

    return false;
  };

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
      $(obj.currentTarget).data('bs.' + this.type, self);
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false;
    }

    if (self.isInStateTrue()) return;

    clearTimeout(self.timeout);

    self.hoverState = 'out';

    if (!self.options.delay || !self.options.delay.hide) return self.hide();

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide();
    }, self.options.delay.hide);
  };

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type);

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e);

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
      if (e.isDefaultPrevented() || !inDom) return;
      var that = this;

      var $tip = this.tip();

      var tipId = this.getUID(this.type);

      this.setContent();
      $tip.attr('id', tipId);
      this.$element.attr('aria-describedby', tipId);

      if (this.options.animation) $tip.addClass('fade');

      var placement = typeof this.options.placement == 'function' ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement;

      var autoToken = /\s?auto?\s?/i;
      var autoPlace = autoToken.test(placement);
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top';

      $tip.detach().css({ top: 0, left: 0, display: 'block' }).addClass(placement).data('bs.' + this.type, this);

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);
      this.$element.trigger('inserted.bs.' + this.type);

      var pos = this.getPosition();
      var actualWidth = $tip[0].offsetWidth;
      var actualHeight = $tip[0].offsetHeight;

      if (autoPlace) {
        var orgPlacement = placement;
        var viewportDim = this.getPosition(this.$viewport);

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top' : placement == 'top' && pos.top - actualHeight < viewportDim.top ? 'bottom' : placement == 'right' && pos.right + actualWidth > viewportDim.width ? 'left' : placement == 'left' && pos.left - actualWidth < viewportDim.left ? 'right' : placement;

        $tip.removeClass(orgPlacement).addClass(placement);
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);

      this.applyPlacement(calculatedOffset, placement);

      var complete = function complete() {
        var prevHoverState = that.hoverState;
        that.$element.trigger('shown.bs.' + that.type);
        that.hoverState = null;

        if (prevHoverState == 'out') that.leave(that);
      };

      $.support.transition && this.$tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
    }
  };

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip = this.tip();
    var width = $tip[0].offsetWidth;
    var height = $tip[0].offsetHeight;

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10);
    var marginLeft = parseInt($tip.css('margin-left'), 10);

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop)) marginTop = 0;
    if (isNaN(marginLeft)) marginLeft = 0;

    offset.top += marginTop;
    offset.left += marginLeft;

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function using(props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        });
      }
    }, offset), 0);

    $tip.addClass('in');

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth = $tip[0].offsetWidth;
    var actualHeight = $tip[0].offsetHeight;

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight;
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);

    if (delta.left) offset.left += delta.left;else offset.top += delta.top;

    var isVertical = /top|bottom/.test(placement);
    var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';

    $tip.offset(offset);
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical);
  };

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow().css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%').css(isVertical ? 'top' : 'left', '');
  };

  Tooltip.prototype.setContent = function () {
    var $tip = this.tip();
    var title = this.getTitle();

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title);
    $tip.removeClass('fade in top bottom left right');
  };

  Tooltip.prototype.hide = function (callback) {
    var that = this;
    var $tip = $(this.$tip);
    var e = $.Event('hide.bs.' + this.type);

    function complete() {
      if (that.hoverState != 'in') $tip.detach();
      if (that.$element) {
        // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element.removeAttr('aria-describedby').trigger('hidden.bs.' + that.type);
      }
      callback && callback();
    }

    this.$element.trigger(e);

    if (e.isDefaultPrevented()) return;

    $tip.removeClass('in');

    $.support.transition && $tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();

    this.hoverState = null;

    return this;
  };

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element;
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '');
    }
  };

  Tooltip.prototype.hasContent = function () {
    return this.getTitle();
  };

  Tooltip.prototype.getPosition = function ($element) {
    $element = $element || this.$element;

    var el = $element[0];
    var isBody = el.tagName == 'BODY';

    var elRect = el.getBoundingClientRect();
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top });
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement;
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset = isBody ? { top: 0, left: 0 } : isSvg ? null : $element.offset();
    var scroll = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() };
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null;

    return $.extend({}, elRect, scroll, outerDims, elOffset);
  };

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'top' ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'left' ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
    /* placement == 'right' */{ top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };
  };

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 };
    if (!this.$viewport) return delta;

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0;
    var viewportDimensions = this.getPosition(this.$viewport);

    if (/right|left/.test(placement)) {
      var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll;
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;
      if (topEdgeOffset < viewportDimensions.top) {
        // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset;
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
        // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
      }
    } else {
      var leftEdgeOffset = pos.left - viewportPadding;
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth;
      if (leftEdgeOffset < viewportDimensions.left) {
        // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset;
      } else if (rightEdgeOffset > viewportDimensions.right) {
        // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
      }
    }

    return delta;
  };

  Tooltip.prototype.getTitle = function () {
    var title;
    var $e = this.$element;
    var o = this.options;

    title = $e.attr('data-original-title') || (typeof o.title == 'function' ? o.title.call($e[0]) : o.title);

    return title;
  };

  Tooltip.prototype.getUID = function (prefix) {
    do {
      prefix += ~~(Math.random() * 1000000);
    } while (document.getElementById(prefix));
    return prefix;
  };

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template);
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!');
      }
    }
    return this.$tip;
  };

  Tooltip.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow');
  };

  Tooltip.prototype.enable = function () {
    this.enabled = true;
  };

  Tooltip.prototype.disable = function () {
    this.enabled = false;
  };

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled;
  };

  Tooltip.prototype.toggle = function (e) {
    var self = this;
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type);
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions());
        $(e.currentTarget).data('bs.' + this.type, self);
      }
    }

    if (e) {
      self.inState.click = !self.inState.click;
      if (self.isInStateTrue()) self.enter(self);else self.leave(self);
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self);
    }
  };

  Tooltip.prototype.destroy = function () {
    var that = this;
    clearTimeout(this.timeout);
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type);
      if (that.$tip) {
        that.$tip.detach();
      }
      that.$tip = null;
      that.$arrow = null;
      that.$viewport = null;
      that.$element = null;
    });
  };

  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.tooltip');
      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;

      if (!data && /destroy|hide/.test(option)) return;
      if (!data) $this.data('bs.tooltip', data = new Tooltip(this, options));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.tooltip;

  $.fn.tooltip = Plugin;
  $.fn.tooltip.Constructor = Tooltip;

  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old;
    return this;
  };
}(jQuery);

/* ========================================================================
 * Bootstrap: popover.js v3.3.7
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function Popover(element, options) {
    this.init('popover', element, options);
  };

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js');

  Popover.VERSION = '3.3.7';

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  });

  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype);

  Popover.prototype.constructor = Popover;

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS;
  };

  Popover.prototype.setContent = function () {
    var $tip = this.tip();
    var title = this.getTitle();
    var content = this.getContent();

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title);
    $tip.find('.popover-content').children().detach().end()[// we use append for html objects to maintain js events
    this.options.html ? typeof content == 'string' ? 'html' : 'append' : 'text'](content);

    $tip.removeClass('fade top bottom left right in');

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide();
  };

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent();
  };

  Popover.prototype.getContent = function () {
    var $e = this.$element;
    var o = this.options;

    return $e.attr('data-content') || (typeof o.content == 'function' ? o.content.call($e[0]) : o.content);
  };

  Popover.prototype.arrow = function () {
    return this.$arrow = this.$arrow || this.tip().find('.arrow');
  };

  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this);
      var data = $this.data('bs.popover');
      var options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;

      if (!data && /destroy|hide/.test(option)) return;
      if (!data) $this.data('bs.popover', data = new Popover(this, options));
      if (typeof option == 'string') data[option]();
    });
  }

  var old = $.fn.popover;

  $.fn.popover = Plugin;
  $.fn.popover.Constructor = Popover;

  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old;
    return this;
  };
}(jQuery);

var bind = function bind(fn, me) {
  return function () {
    return fn.apply(me, arguments);
  };
};

(function (window, factory) {
  if (typeof define === 'function' && define.amd) {
    return define(['jquery'], function (jQuery) {
      return window.Tour = factory(jQuery);
    });
  } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
    return module.exports = factory(require('jquery'));
  } else {
    return window.Tour = factory(window.jQuery);
  }
})(window, function ($) {
  var Tour, document;
  document = window.document;
  Tour = function () {
    function Tour(options) {
      this._showPopoverAndOverlay = bind(this._showPopoverAndOverlay, this);
      var storage;
      try {
        storage = window.localStorage;
      } catch (error) {
        storage = false;
      }
      this._options = $.extend({
        name: 'tour',
        steps: [],
        container: 'body',
        autoscroll: true,
        keyboard: true,
        storage: storage,
        debug: false,
        backdrop: false,
        backdropContainer: 'body',
        backdropPadding: 0,
        redirect: true,
        orphan: false,
        duration: false,
        delay: false,
        basePath: '',
        template: '<div class="popover" role="tooltip"> <div class="arrow"></div> <h3 class="popover-title"></h3> <div class="popover-content"></div> <div class="popover-navigation"> <div class="btn-group"> <button class="btn btn-sm btn-default" data-role="prev">&laquo; Prev</button> <button class="btn btn-sm btn-default" data-role="next">Next &raquo;</button> <button class="btn btn-sm btn-default" data-role="pause-resume" data-pause-text="Pause" data-resume-text="Resume">Pause</button> </div> <button class="btn btn-sm btn-default" data-role="end">End tour</button> </div> </div>',
        afterSetState: function afterSetState(key, value) {},
        afterGetState: function afterGetState(key, value) {},
        afterRemoveState: function afterRemoveState(key) {},
        onStart: function onStart(tour) {},
        onEnd: function onEnd(tour) {},
        onShow: function onShow(tour) {},
        onShown: function onShown(tour) {},
        onHide: function onHide(tour) {},
        onHidden: function onHidden(tour) {},
        onNext: function onNext(tour) {},
        onPrev: function onPrev(tour) {},
        onPause: function onPause(tour, duration) {},
        onResume: function onResume(tour, duration) {},
        onRedirectError: function onRedirectError(tour) {}
      }, options);
      this._force = false;
      this._inited = false;
      this._current = null;
      this.backdrops = [];
      this;
    }

    Tour.prototype.addSteps = function (steps) {
      var j, len, step;
      for (j = 0, len = steps.length; j < len; j++) {
        step = steps[j];
        this.addStep(step);
      }
      return this;
    };

    Tour.prototype.addStep = function (step) {
      this._options.steps.push(step);
      return this;
    };

    Tour.prototype.getStep = function (i) {
      if (this._options.steps[i] != null) {
        return $.extend({
          id: "step-" + i,
          path: '',
          host: '',
          placement: 'right',
          title: '',
          content: '<p></p>',
          next: i === this._options.steps.length - 1 ? -1 : i + 1,
          prev: i - 1,
          animation: true,
          container: this._options.container,
          autoscroll: this._options.autoscroll,
          backdrop: this._options.backdrop,
          backdropContainer: this._options.backdropContainer,
          backdropPadding: this._options.backdropPadding,
          redirect: this._options.redirect,
          reflexElement: this._options.steps[i].element,
          backdropElement: this._options.steps[i].element,
          orphan: this._options.orphan,
          duration: this._options.duration,
          delay: this._options.delay,
          template: this._options.template,
          onShow: this._options.onShow,
          onShown: this._options.onShown,
          onHide: this._options.onHide,
          onHidden: this._options.onHidden,
          onNext: this._options.onNext,
          onPrev: this._options.onPrev,
          onPause: this._options.onPause,
          onResume: this._options.onResume,
          onRedirectError: this._options.onRedirectError
        }, this._options.steps[i]);
      }
    };

    Tour.prototype.init = function (force) {
      this._force = force;
      if (this.ended()) {
        this._debug('Tour ended, init prevented.');
        return this;
      }
      this.setCurrentStep();
      this._initMouseNavigation();
      this._initKeyboardNavigation();
      this._onResize(function (_this) {
        return function () {
          return _this.showStep(_this._current);
        };
      }(this));
      this._onScroll();
      // this._onScroll((function(_this) {
      //   return function() {
      //     return _this._showPopoverAndOverlay(_this._current);
      //   };
      // })(this));
      if (this._current !== null) {
        this.showStep(this._current);
      }
      this._inited = true;
      return this;
    };

    Tour.prototype.start = function (force) {
      var promise;
      if (force == null) {
        force = false;
      }
      if (!this._inited) {
        this.init(force);
      }
      if (this._current === null) {
        promise = this._makePromise(this._options.onStart != null ? this._options.onStart(this) : void 0);
        this._callOnPromiseDone(promise, this.showStep, 0);
      }
      return this;
    };

    Tour.prototype.next = function () {
      var promise;
      promise = this.hideStep(this._current, this._current + 1);
      return this._callOnPromiseDone(promise, this._showNextStep);
    };

    Tour.prototype.prev = function () {
      var promise;
      promise = this.hideStep(this._current, this._current - 1);
      return this._callOnPromiseDone(promise, this._showPrevStep);
    };

    Tour.prototype.goTo = function (i) {
      var promise;
      promise = this.hideStep(this._current, i);
      return this._callOnPromiseDone(promise, this.showStep, i);
    };

    Tour.prototype.end = function () {
      var endHelper, promise;
      endHelper = function (_this) {
        return function (e) {
          $(document).off("click.tour-" + _this._options.name);
          $(document).off("keyup.tour-" + _this._options.name);
          $(window).off("resize.tour-" + _this._options.name);
          $(window).off("scroll.tour-" + _this._options.name);
          _this._setState('end', 'yes');
          _this._inited = false;
          _this._force = false;
          _this._clearTimer();
          if (_this._options.onEnd != null) {
            return _this._options.onEnd(_this);
          }
        };
      }(this);
      promise = this.hideStep(this._current);
      return this._callOnPromiseDone(promise, endHelper);
    };

    Tour.prototype.ended = function () {
      return !this._force && !!this._getState('end');
    };

    Tour.prototype.restart = function () {
      this._removeState('current_step');
      this._removeState('end');
      this._removeState('redirect_to');
      return this.start();
    };

    Tour.prototype.pause = function () {
      var step;
      step = this.getStep(this._current);
      if (!(step && step.duration)) {
        return this;
      }
      this._paused = true;
      this._duration -= new Date().getTime() - this._start;
      window.clearTimeout(this._timer);
      this._debug("Paused/Stopped step " + (this._current + 1) + " timer (" + this._duration + " remaining).");
      if (step.onPause != null) {
        return step.onPause(this, this._duration);
      }
    };

    Tour.prototype.resume = function () {
      var step;
      step = this.getStep(this._current);
      if (!(step && step.duration)) {
        return this;
      }
      this._paused = false;
      this._start = new Date().getTime();
      this._duration = this._duration || step.duration;
      this._timer = window.setTimeout(function (_this) {
        return function () {
          if (_this._isLast()) {
            return _this.next();
          } else {
            return _this.end();
          }
        };
      }(this), this._duration);
      this._debug("Started step " + (this._current + 1) + " timer with duration " + this._duration);
      if (step.onResume != null && this._duration !== step.duration) {
        return step.onResume(this, this._duration);
      }
    };

    Tour.prototype.hideStep = function (i, iNext) {
      var hideDelay, hideStepHelper, promise, step;
      step = this.getStep(i);
      if (!step) {
        return;
      }
      this._clearTimer();
      promise = this._makePromise(step.onHide != null ? step.onHide(this, i) : void 0);
      hideStepHelper = function (_this) {
        return function (e) {
          var $element, next_step;
          $element = $(step.element);
          if (!($element.data('bs.popover') || $element.data('popover'))) {
            $element = $('body');
          }
          $element.popover('destroy').removeClass("tour-" + _this._options.name + "-element tour-" + _this._options.name + "-" + i + "-element").removeData('bs.popover');
          if (step.reflex) {
            $(step.reflexElement).removeClass('tour-step-element-reflex').off(_this._reflexEvent(step.reflex) + ".tour-" + _this._options.name);
          }
          if (step.backdrop) {
            next_step = iNext != null && _this.getStep(iNext);
            if (!next_step || !next_step.backdrop || next_step.backdropElement !== step.backdropElement) {
              _this._hideOverlayElement(step);
            }
          }
          if (step.onHidden != null) {
            return step.onHidden(_this);
          }
        };
      }(this);
      hideDelay = step.delay.hide || step.delay;
      if ({}.toString.call(hideDelay) === '[object Number]' && hideDelay > 0) {
        this._debug("Wait " + hideDelay + " milliseconds to hide the step " + (this._current + 1));
        window.setTimeout(function (_this) {
          return function () {
            return _this._callOnPromiseDone(promise, hideStepHelper);
          };
        }(this), hideDelay);
      } else {
        this._callOnPromiseDone(promise, hideStepHelper);
      }
      return promise;
    };

    Tour.prototype.showStep = function (i) {
      var path, promise, showDelay, showStepHelper, skipToPrevious, step;
      if (this.ended()) {
        this._debug('Tour ended, showStep prevented.');
        return this;
      }
      step = this.getStep(i);
      if (!step) {
        return;
      }
      skipToPrevious = i < this._current;
      promise = this._makePromise(step.onShow != null ? step.onShow(this, i) : void 0);
      this.setCurrentStep(i);
      path = function () {
        switch ({}.toString.call(step.path)) {
          case '[object Function]':
            return step.path();
          case '[object String]':
            return this._options.basePath + step.path;
          default:
            return step.path;
        }
      }.call(this);
      if (step.redirect && this._isRedirect(step.host, path, document.location)) {
        this._redirect(step, i, path);
        if (!this._isJustPathHashDifferent(step.host, path, document.location)) {
          return;
        }
      }
      showStepHelper = function (_this) {
        return function (e) {
          if (_this._isOrphan(step)) {
            if (step.orphan === false) {
              _this._debug("Skip the orphan step " + (_this._current + 1) + ".\nOrphan option is false and the element does not exist or is hidden.");
              if (skipToPrevious) {
                _this._showPrevStep();
              } else {
                _this._showNextStep();
              }
              return;
            }
            _this._debug("Show the orphan step " + (_this._current + 1) + ". Orphans option is true.");
          }
          if (step.autoscroll) {
            _this._scrollIntoView(i);
          } else {
            _this._showPopoverAndOverlay(i);
          }
          if (step.duration) {
            return _this.resume();
          }
        };
      }(this);
      showDelay = step.delay.show || step.delay;
      if ({}.toString.call(showDelay) === '[object Number]' && showDelay > 0) {
        this._debug("Wait " + showDelay + " milliseconds to show the step " + (this._current + 1));
        window.setTimeout(function (_this) {
          return function () {
            return _this._callOnPromiseDone(promise, showStepHelper);
          };
        }(this), showDelay);
      } else {
        this._callOnPromiseDone(promise, showStepHelper);
      }
      return promise;
    };

    Tour.prototype.getCurrentStep = function () {
      return this._current;
    };

    Tour.prototype.setCurrentStep = function (value) {
      if (value != null) {
        this._current = value;
        this._setState('current_step', value);
      } else {
        this._current = this._getState('current_step');
        this._current = this._current === null ? null : parseInt(this._current, 10);
      }
      return this;
    };

    Tour.prototype.redraw = function () {
      return this._showOverlayElement(this.getStep(this.getCurrentStep()));
    };

    Tour.prototype._setState = function (key, value) {
      var e, keyName;
      if (this._options.storage) {
        keyName = this._options.name + "_" + key;
        try {
          this._options.storage.setItem(keyName, value);
        } catch (error) {
          e = error;
          if (e.code === DOMException.QUOTA_EXCEEDED_ERR) {
            this._debug('LocalStorage quota exceeded. State storage failed.');
          }
        }
        return this._options.afterSetState(keyName, value);
      } else {
        if (this._state == null) {
          this._state = {};
        }
        return this._state[key] = value;
      }
    };

    Tour.prototype._removeState = function (key) {
      var keyName;
      if (this._options.storage) {
        keyName = this._options.name + "_" + key;
        this._options.storage.removeItem(keyName);
        return this._options.afterRemoveState(keyName);
      } else {
        if (this._state != null) {
          return delete this._state[key];
        }
      }
    };

    Tour.prototype._getState = function (key) {
      var keyName, value;
      if (this._options.storage) {
        keyName = this._options.name + "_" + key;
        value = this._options.storage.getItem(keyName);
      } else {
        if (this._state != null) {
          value = this._state[key];
        }
      }
      if (value === void 0 || value === 'null') {
        value = null;
      }
      this._options.afterGetState(key, value);
      return value;
    };

    Tour.prototype._showNextStep = function () {
      var promise, showNextStepHelper, step;
      step = this.getStep(this._current);
      showNextStepHelper = function (_this) {
        return function (e) {
          return _this.showStep(step.next);
        };
      }(this);
      promise = this._makePromise(step.onNext != null ? step.onNext(this) : void 0);
      return this._callOnPromiseDone(promise, showNextStepHelper);
    };

    Tour.prototype._showPrevStep = function () {
      var promise, showPrevStepHelper, step;
      step = this.getStep(this._current);
      showPrevStepHelper = function (_this) {
        return function (e) {
          return _this.showStep(step.prev);
        };
      }(this);
      promise = this._makePromise(step.onPrev != null ? step.onPrev(this) : void 0);
      return this._callOnPromiseDone(promise, showPrevStepHelper);
    };

    Tour.prototype._debug = function (text) {
      if (this._options.debug) {
        return window.console.log("Bootstrap Tour '" + this._options.name + "' | " + text);
      }
    };

    Tour.prototype._isRedirect = function (host, path, location) {
      var currentPath;
      if (host != null && host !== '' && ({}.toString.call(host) === '[object RegExp]' && !host.test(location.origin) || {}.toString.call(host) === '[object String]' && this._isHostDifferent(host, location))) {
        return true;
      }
      currentPath = [location.pathname, location.search, location.hash].join('');
      return path != null && path !== '' && ({}.toString.call(path) === '[object RegExp]' && !path.test(currentPath) || {}.toString.call(path) === '[object String]' && this._isPathDifferent(path, currentPath));
    };

    Tour.prototype._isHostDifferent = function (host, location) {
      switch ({}.toString.call(host)) {
        case '[object RegExp]':
          return !host.test(location.origin);
        case '[object String]':
          return this._getProtocol(host) !== this._getProtocol(location.href) || this._getHost(host) !== this._getHost(location.href);
        default:
          return true;
      }
    };

    Tour.prototype._isPathDifferent = function (path, currentPath) {
      return this._getPath(path) !== this._getPath(currentPath) || !this._equal(this._getQuery(path), this._getQuery(currentPath)) || !this._equal(this._getHash(path), this._getHash(currentPath));
    };

    Tour.prototype._isJustPathHashDifferent = function (host, path, location) {
      var currentPath;
      if (host != null && host !== '') {
        if (this._isHostDifferent(host, location)) {
          return false;
        }
      }
      currentPath = [location.pathname, location.search, location.hash].join('');
      if ({}.toString.call(path) === '[object String]') {
        return this._getPath(path) === this._getPath(currentPath) && this._equal(this._getQuery(path), this._getQuery(currentPath)) && !this._equal(this._getHash(path), this._getHash(currentPath));
      }
      return false;
    };

    Tour.prototype._redirect = function (step, i, path) {
      var href;
      if ($.isFunction(step.redirect)) {
        return step.redirect.call(this, path);
      } else {
        href = {}.toString.call(step.host) === '[object String]' ? "" + step.host + path : path;
        this._debug("Redirect to " + href);
        if (this._getState('redirect_to') === "" + i) {
          this._debug("Error redirection loop to " + path);
          this._removeState('redirect_to');
          if (step.onRedirectError != null) {
            return step.onRedirectError(this);
          }
        } else {
          this._setState('redirect_to', "" + i);
          return document.location.href = href;
        }
      }
    };

    Tour.prototype._isOrphan = function (step) {
      return step.element == null || !$(step.element).length || $(step.element).is(':hidden') && $(step.element)[0].namespaceURI !== 'http://www.w3.org/2000/svg';
    };

    Tour.prototype._isLast = function () {
      return this._current < this._options.steps.length - 1;
    };

    Tour.prototype._showPopoverAndOverlay = function (i) {
      var step;
      if (this.getCurrentStep() !== i || this.ended()) {
        return;
      }
      step = this.getStep(i);
      if (step.backdrop) {
        this._showOverlayElement(step);
      }
      this._showPopover(step, i);
      if (step.onShown != null) {
        step.onShown(this);
      }
      return this._debug("Step " + (this._current + 1) + " of " + this._options.steps.length);
    };

    Tour.prototype._showPopover = function (step, i) {
      var $element, $tip, isOrphan, options, shouldAddSmart;
      $(".tour-" + this._options.name).remove();
      options = $.extend({}, this._options);
      isOrphan = this._isOrphan(step);
      step.template = this._template(step, i);
      if (isOrphan) {
        step.element = 'body';
        step.placement = 'top';
      }
      $element = $(step.element);
      $element.addClass("tour-" + this._options.name + "-element tour-" + this._options.name + "-" + i + "-element");
      if (step.options) {
        $.extend(options, step.options);
      }
      if (step.reflex && !isOrphan) {
        $(step.reflexElement).addClass('tour-step-element-reflex').off(this._reflexEvent(step.reflex) + ".tour-" + this._options.name).on(this._reflexEvent(step.reflex) + ".tour-" + this._options.name, function (_this) {
          return function () {
            if (_this._isLast()) {
              return _this.next();
            } else {
              return _this.end();
            }
          };
        }(this));
      }
      shouldAddSmart = step.smartPlacement === true && step.placement.search(/auto/i) === -1;
      $element.popover({
        placement: shouldAddSmart ? "auto " + step.placement : step.placement,
        trigger: 'manual',
        title: step.title,
        content: step.content,
        html: true,
        animation: step.animation,
        container: step.container,
        template: step.template,
        selector: step.element
      }).popover('show');
      $tip = $element.data('bs.popover') ? $element.data('bs.popover').tip() : $element.data('popover').tip();
      $tip.attr('id', step.id);
      if ($element.css('position') === 'fixed') {
        $tip.css('position', 'fixed');
      }
      this._reposition($tip, step);
      if (isOrphan) {
        return this._center($tip);
      }
    };

    Tour.prototype._template = function (step, i) {
      var $navigation, $next, $prev, $resume, $template, template;
      template = step.template;
      if (this._isOrphan(step) && {}.toString.call(step.orphan) !== '[object Boolean]') {
        template = step.orphan;
      }
      $template = $.isFunction(template) ? $(template(i, step)) : $(template);
      $navigation = $template.find('.popover-navigation');
      $prev = $navigation.find('[data-role="prev"]');
      $next = $navigation.find('[data-role="next"]');
      $resume = $navigation.find('[data-role="pause-resume"]');
      if (this._isOrphan(step)) {
        $template.addClass('orphan');
      }
      $template.addClass("tour-" + this._options.name + " tour-" + this._options.name + "-" + i);
      if (step.reflex) {
        $template.addClass("tour-" + this._options.name + "-reflex");
      }
      if (step.prev < 0) {
        $prev.addClass('disabled').prop('disabled', true).prop('tabindex', -1);
      }
      if (step.next < 0) {
        $next.addClass('disabled').prop('disabled', true).prop('tabindex', -1);
      }
      if (!step.duration) {
        $resume.remove();
      }
      return $template.clone().wrap('<div>').parent().html();
    };

    Tour.prototype._reflexEvent = function (reflex) {
      if ({}.toString.call(reflex) === '[object Boolean]') {
        return 'click';
      } else {
        return reflex;
      }
    };

    Tour.prototype._reposition = function ($tip, step) {
      var offsetBottom, offsetHeight, offsetRight, offsetWidth, originalLeft, originalTop, tipOffset;
      offsetWidth = $tip[0].offsetWidth;
      offsetHeight = $tip[0].offsetHeight;
      tipOffset = $tip.offset();
      originalLeft = tipOffset.left;
      originalTop = tipOffset.top;
      offsetBottom = $(document).outerHeight() - tipOffset.top - $tip.outerHeight();
      if (offsetBottom < 0) {
        tipOffset.top = tipOffset.top + offsetBottom;
      }
      offsetRight = $('html').outerWidth() - tipOffset.left - $tip.outerWidth();
      if (offsetRight < 0) {
        tipOffset.left = tipOffset.left + offsetRight;
      }
      if (tipOffset.top < 0) {
        tipOffset.top = 0;
      }
      if (tipOffset.left < 0) {
        tipOffset.left = 0;
      }
      $tip.offset(tipOffset);
      if (step.placement === 'bottom' || step.placement === 'top') {
        if (originalLeft !== tipOffset.left) {
          return this._replaceArrow($tip, (tipOffset.left - originalLeft) * 2, offsetWidth, 'left');
        }
      } else {
        if (originalTop !== tipOffset.top) {
          return this._replaceArrow($tip, (tipOffset.top - originalTop) * 2, offsetHeight, 'top');
        }
      }
    };

    Tour.prototype._center = function ($tip) {
      return $tip.css('top', $(window).outerHeight() / 2 - $tip.outerHeight() / 2);
    };

    Tour.prototype._replaceArrow = function ($tip, delta, dimension, position) {
      return $tip.find('.arrow').css(position, delta ? 50 * (1 - delta / dimension) + '%' : '');
    };

    Tour.prototype._scrollIntoView = function (i) {
      var $element, $window, counter, height, offsetTop, scrollTop, step, windowHeight;
      step = this.getStep(i);
      $element = $(step.element);
      if (!$element.length) {
        return this._showPopoverAndOverlay(i);
      }
      $window = $(window);
      offsetTop = $element.offset().top;
      height = $element.outerHeight();
      windowHeight = $window.height();
      scrollTop = 0;
      switch (step.placement) {
        case 'top':
          scrollTop = Math.max(0, offsetTop - windowHeight / 2);
          break;
        case 'left':
        case 'right':
          scrollTop = Math.max(0, offsetTop + height / 2 - windowHeight / 2);
          break;
        case 'bottom':
          scrollTop = Math.max(0, offsetTop + height - windowHeight / 2);
      }
      this._debug("Scroll into view. ScrollTop: " + scrollTop + ". Element offset: " + offsetTop + ". Window height: " + windowHeight + ".");
      counter = 0;
      return $('body, html').stop(true, true).animate({
        scrollTop: Math.ceil(scrollTop)
      }, function (_this) {
        return function () {
          if (++counter === 2) {
            _this._showPopoverAndOverlay(i);
            return _this._debug("Scroll into view.\nAnimation end element offset: " + $element.offset().top + ".\nWindow height: " + $window.height() + ".");
          }
        };
      }(this));
    };

    Tour.prototype._onResize = function (callback, timeout) {
      return $(window).on("resize.tour-" + this._options.name, function () {
        clearTimeout(timeout);
        return timeout = setTimeout(callback, 100);
      });
    };

    Tour.prototype._onScroll = function (callback, timeout) {
      return $(window).on("scroll.tour-" + this._options.name, function () {
        clearTimeout(timeout);
        return timeout = setTimeout(callback, 100);
      });
    };

    Tour.prototype._initMouseNavigation = function () {
      var _this;
      _this = this;
      return $(document).off("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='prev']").off("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='next']").off("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='end']").off("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='pause-resume']").on("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='next']", function (_this) {
        return function (e) {
          e.preventDefault();
          return _this.next();
        };
      }(this)).on("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='prev']", function (_this) {
        return function (e) {
          e.preventDefault();
          if (_this._current > 0) {
            return _this.prev();
          }
        };
      }(this)).on("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='end']", function (_this) {
        return function (e) {
          e.preventDefault();
          return _this.end();
        };
      }(this)).on("click.tour-" + this._options.name, ".popover.tour-" + this._options.name + " *[data-role='pause-resume']", function (e) {
        var $this;
        e.preventDefault();
        $this = $(this);
        $this.text(_this._paused ? $this.data('pause-text') : $this.data('resume-text'));
        if (_this._paused) {
          return _this.resume();
        } else {
          return _this.pause();
        }
      });
    };

    Tour.prototype._initKeyboardNavigation = function () {
      if (!this._options.keyboard) {
        return;
      }
      return $(document).on("keyup.tour-" + this._options.name, function (_this) {
        return function (e) {
          if (!e.which) {
            return;
          }
          switch (e.which) {
            case 39:
              e.preventDefault();
              if (_this._isLast()) {
                return _this.next();
              } else {
                return _this.end();
              }
              break;
            case 37:
              e.preventDefault();
              if (_this._current > 0) {
                return _this.prev();
              }
          }
        };
      }(this));
    };

    Tour.prototype._makePromise = function (result) {
      if (result && $.isFunction(result.then)) {
        return result;
      } else {
        return null;
      }
    };

    Tour.prototype._callOnPromiseDone = function (promise, cb, arg) {
      if (promise) {
        return promise.then(function (_this) {
          return function (e) {
            return cb.call(_this, arg);
          };
        }(this));
      } else {
        return cb.call(this, arg);
      }
    };

    Tour.prototype._showBackground = function (step, data) {
      var $backdrop, base, height, j, len, pos, ref, results, width;
      height = $(document).height();
      width = $(document).width();
      ref = ['top', 'bottom', 'left', 'right'];
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        pos = ref[j];
        $backdrop = (base = this.backdrops)[pos] != null ? base[pos] : base[pos] = $('<div>', {
          "class": "tour-backdrop " + pos
        });
        $(step.backdropContainer).append($backdrop);
        switch (pos) {
          case 'top':
            results.push($backdrop.height(data.offset.top > 0 ? data.offset.top : 0).width(width).offset({
              top: 0,
              left: 0
            }));
            break;
          case 'bottom':
            results.push($backdrop.offset({
              top: data.offset.top + data.height,
              left: 0
            }).height(height - (data.offset.top + data.height)).width(width));
            break;
          case 'left':
            results.push($backdrop.offset({
              top: data.offset.top,
              left: 0
            }).height(data.height).width(data.offset.left > 0 ? data.offset.left : 0));
            break;
          case 'right':
            results.push($backdrop.offset({
              top: data.offset.top,
              left: data.offset.left + data.width
            }).height(data.height).width(width - (data.offset.left + data.width)));
            break;
          default:
            results.push(void 0);
        }
      }
      return results;
    };

    Tour.prototype._showOverlayElement = function (step) {
      var $backdropElement, elementData;
      $backdropElement = $(step.backdropElement);
      if ($backdropElement.length === 0) {
        elementData = {
          width: 0,
          height: 0,
          offset: {
            top: 0,
            left: 0
          }
        };
      } else {
        elementData = {
          width: $backdropElement.innerWidth(),
          height: $backdropElement.innerHeight(),
          offset: $backdropElement.offset()
        };
        $backdropElement.addClass('tour-step-backdrop');
        if (step.backdropPadding) {
          elementData = this._applyBackdropPadding(step.backdropPadding, elementData);
        }
      }
      return this._showBackground(step, elementData);
    };

    Tour.prototype._hideOverlayElement = function (step) {
      var $backdrop, pos, ref;
      $(step.backdropElement).removeClass('tour-step-backdrop');
      ref = this.backdrops;
      for (pos in ref) {
        $backdrop = ref[pos];
        if ($backdrop && $backdrop.remove !== void 0) {
          $backdrop.remove();
        }
      }
      return this.backdrops = [];
    };

    Tour.prototype._applyBackdropPadding = function (padding, data) {
      if ((typeof padding === 'undefined' ? 'undefined' : _typeof(padding)) === 'object') {
        if (padding.top == null) {
          padding.top = 0;
        }
        if (padding.right == null) {
          padding.right = 0;
        }
        if (padding.bottom == null) {
          padding.bottom = 0;
        }
        if (padding.left == null) {
          padding.left = 0;
        }
        data.offset.top = data.offset.top - padding.top;
        data.offset.left = data.offset.left - padding.left;
        data.width = data.width + padding.left + padding.right;
        data.height = data.height + padding.top + padding.bottom;
      } else {
        data.offset.top = data.offset.top - padding;
        data.offset.left = data.offset.left - padding;
        data.width = data.width + padding * 2;
        data.height = data.height + padding * 2;
      }
      return data;
    };

    Tour.prototype._clearTimer = function () {
      window.clearTimeout(this._timer);
      this._timer = null;
      return this._duration = null;
    };

    Tour.prototype._getProtocol = function (url) {
      url = url.split('://');
      if (url.length > 1) {
        return url[0];
      } else {
        return 'http';
      }
    };

    Tour.prototype._getHost = function (url) {
      url = url.split('//');
      url = url.length > 1 ? url[1] : url[0];
      return url.split('/')[0];
    };

    Tour.prototype._getPath = function (path) {
      return path.replace(/\/?$/, '').split('?')[0].split('#')[0];
    };

    Tour.prototype._getQuery = function (path) {
      return this._getParams(path, '?');
    };

    Tour.prototype._getHash = function (path) {
      return this._getParams(path, '#');
    };

    Tour.prototype._getParams = function (path, start) {
      var j, len, param, params, paramsObject;
      params = path.split(start);
      if (params.length === 1) {
        return {};
      }
      params = params[1].split('&');
      paramsObject = {};
      for (j = 0, len = params.length; j < len; j++) {
        param = params[j];
        param = param.split('=');
        paramsObject[param[0]] = param[1] || '';
      }
      return paramsObject;
    };

    Tour.prototype._equal = function (obj1, obj2) {
      var j, k, len, obj1Keys, obj2Keys, v;
      if ({}.toString.call(obj1) === '[object Object]' && {}.toString.call(obj2) === '[object Object]') {
        obj1Keys = Object.keys(obj1);
        obj2Keys = Object.keys(obj2);
        if (obj1Keys.length !== obj2Keys.length) {
          return false;
        }
        for (k in obj1) {
          v = obj1[k];
          if (!this._equal(obj2[k], v)) {
            return false;
          }
        }
        return true;
      } else if ({}.toString.call(obj1) === '[object Array]' && {}.toString.call(obj2) === '[object Array]') {
        if (obj1.length !== obj2.length) {
          return false;
        }
        for (k = j = 0, len = obj1.length; j < len; k = ++j) {
          v = obj1[k];
          if (!this._equal(v, obj2[k])) {
            return false;
          }
        }
        return true;
      } else {
        return obj1 === obj2;
      }
    };

    return Tour;
  }();
  return Tour;
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var DateFormatter;!function () {
  "use strict";
  var e, _t, _a, r, n, o;n = 864e5, o = 3600, e = function e(_e, t) {
    return "string" == typeof _e && "string" == typeof t && _e.toLowerCase() === t.toLowerCase();
  }, _t = function t(e, a, r) {
    var n = r || "0",
        o = e.toString();return o.length < a ? _t(n + o, a) : o;
  }, _a = function a(e) {
    var t, r;for (e = e || {}, t = 1; t < arguments.length; t++) {
      if (r = arguments[t]) for (var n in r) {
        r.hasOwnProperty(n) && ("object" == _typeof(r[n]) ? _a(e[n], r[n]) : e[n] = r[n]);
      }
    }return e;
  }, r = { dateSettings: { days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], meridiem: ["AM", "PM"], ordinal: function ordinal(e) {
        var t = e % 10,
            a = { 1: "st", 2: "nd", 3: "rd" };return 1 !== Math.floor(e % 100 / 10) && a[t] ? a[t] : "th";
      } }, separators: /[ \-+\/\.T:@]/g, validParts: /[dDjlNSwzWFmMntLoYyaABgGhHisueTIOPZcrU]/g, intParts: /[djwNzmnyYhHgGis]/g, tzParts: /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g, tzClip: /[^-+\dA-Z]/g }, DateFormatter = function DateFormatter(e) {
    var t = this,
        n = _a(r, e);t.dateSettings = n.dateSettings, t.separators = n.separators, t.validParts = n.validParts, t.intParts = n.intParts, t.tzParts = n.tzParts, t.tzClip = n.tzClip;
  }, DateFormatter.prototype = { constructor: DateFormatter, parseDate: function parseDate(t, a) {
      var r,
          n,
          o,
          i,
          s,
          d,
          u,
          l,
          f,
          c,
          m = this,
          h = !1,
          g = !1,
          p = m.dateSettings,
          y = { date: null, year: null, month: null, day: null, hour: 0, min: 0, sec: 0 };if (!t) return void 0;if (t instanceof Date) return t;if ("number" == typeof t) return new Date(t);if ("U" === a) return o = parseInt(t), o ? new Date(1e3 * o) : t;if ("string" != typeof t) return "";if (r = a.match(m.validParts), !r || 0 === r.length) throw new Error("Invalid date format definition.");for (n = t.replace(m.separators, "\x00").split("\x00"), o = 0; o < n.length; o++) {
        switch (i = n[o], s = parseInt(i), r[o]) {case "y":case "Y":
            f = i.length, 2 === f ? y.year = parseInt((70 > s ? "20" : "19") + i) : 4 === f && (y.year = s), h = !0;break;case "m":case "n":case "M":case "F":
            isNaN(i) ? (d = p.monthsShort.indexOf(i), d > -1 && (y.month = d + 1), d = p.months.indexOf(i), d > -1 && (y.month = d + 1)) : s >= 1 && 12 >= s && (y.month = s), h = !0;break;case "d":case "j":
            s >= 1 && 31 >= s && (y.day = s), h = !0;break;case "g":case "h":
            u = r.indexOf("a") > -1 ? r.indexOf("a") : r.indexOf("A") > -1 ? r.indexOf("A") : -1, c = n[u], u > -1 ? (l = e(c, p.meridiem[0]) ? 0 : e(c, p.meridiem[1]) ? 12 : -1, s >= 1 && 12 >= s && l > -1 ? y.hour = s + l : s >= 0 && 23 >= s && (y.hour = s)) : s >= 0 && 23 >= s && (y.hour = s), g = !0;break;case "G":case "H":
            s >= 0 && 23 >= s && (y.hour = s), g = !0;break;case "i":
            s >= 0 && 59 >= s && (y.min = s), g = !0;break;case "s":
            s >= 0 && 59 >= s && (y.sec = s), g = !0;}
      }if (h === !0 && y.year && y.month && y.day) y.date = new Date(y.year, y.month - 1, y.day, y.hour, y.min, y.sec, 0);else {
        if (g !== !0) return !1;y.date = new Date(0, 0, 0, y.hour, y.min, y.sec, 0);
      }return y.date;
    }, guessDate: function guessDate(e, t) {
      if ("string" != typeof e) return e;var a,
          r,
          n,
          o,
          i = this,
          s = e.replace(i.separators, "\x00").split("\x00"),
          d = /^[djmn]/g,
          u = t.match(i.validParts),
          l = new Date(),
          f = 0;if (!d.test(u[0])) return e;for (r = 0; r < s.length; r++) {
        switch (f = 2, n = s[r], o = parseInt(n.substr(0, 2)), r) {case 0:
            "m" === u[0] || "n" === u[0] ? l.setMonth(o - 1) : l.setDate(o);break;case 1:
            "m" === u[0] || "n" === u[0] ? l.setDate(o) : l.setMonth(o - 1);break;case 2:
            a = l.getFullYear(), n.length < 4 ? (l.setFullYear(parseInt(a.toString().substr(0, 4 - n.length) + n)), f = n.length) : (l.setFullYear = parseInt(n.substr(0, 4)), f = 4);break;case 3:
            l.setHours(o);break;case 4:
            l.setMinutes(o);break;case 5:
            l.setSeconds(o);}n.substr(f).length > 0 && s.splice(r + 1, 0, n.substr(f));
      }return l;
    }, parseFormat: function parseFormat(e, a) {
      var r,
          i = this,
          s = i.dateSettings,
          d = /\\?(.?)/gi,
          u = function u(e, t) {
        return r[e] ? r[e]() : t;
      };return r = { d: function d() {
          return _t(r.j(), 2);
        }, D: function D() {
          return s.daysShort[r.w()];
        }, j: function j() {
          return a.getDate();
        }, l: function l() {
          return s.days[r.w()];
        }, N: function N() {
          return r.w() || 7;
        }, w: function w() {
          return a.getDay();
        }, z: function z() {
          var e = new Date(r.Y(), r.n() - 1, r.j()),
              t = new Date(r.Y(), 0, 1);return Math.round((e - t) / n);
        }, W: function W() {
          var e = new Date(r.Y(), r.n() - 1, r.j() - r.N() + 3),
              a = new Date(e.getFullYear(), 0, 4);return _t(1 + Math.round((e - a) / n / 7), 2);
        }, F: function F() {
          return s.months[a.getMonth()];
        }, m: function m() {
          return _t(r.n(), 2);
        }, M: function M() {
          return s.monthsShort[a.getMonth()];
        }, n: function n() {
          return a.getMonth() + 1;
        }, t: function t() {
          return new Date(r.Y(), r.n(), 0).getDate();
        }, L: function L() {
          var e = r.Y();return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0 ? 1 : 0;
        }, o: function o() {
          var e = r.n(),
              t = r.W(),
              a = r.Y();return a + (12 === e && 9 > t ? 1 : 1 === e && t > 9 ? -1 : 0);
        }, Y: function Y() {
          return a.getFullYear();
        }, y: function y() {
          return r.Y().toString().slice(-2);
        }, a: function a() {
          return r.A().toLowerCase();
        }, A: function A() {
          var e = r.G() < 12 ? 0 : 1;return s.meridiem[e];
        }, B: function B() {
          var e = a.getUTCHours() * o,
              r = 60 * a.getUTCMinutes(),
              n = a.getUTCSeconds();return _t(Math.floor((e + r + n + o) / 86.4) % 1e3, 3);
        }, g: function g() {
          return r.G() % 12 || 12;
        }, G: function G() {
          return a.getHours();
        }, h: function h() {
          return _t(r.g(), 2);
        }, H: function H() {
          return _t(r.G(), 2);
        }, i: function i() {
          return _t(a.getMinutes(), 2);
        }, s: function s() {
          return _t(a.getSeconds(), 2);
        }, u: function u() {
          return _t(1e3 * a.getMilliseconds(), 6);
        }, e: function e() {
          var e = /\((.*)\)/.exec(String(a))[1];return e || "Coordinated Universal Time";
        }, T: function T() {
          var e = (String(a).match(i.tzParts) || [""]).pop().replace(i.tzClip, "");return e || "UTC";
        }, I: function I() {
          var e = new Date(r.Y(), 0),
              t = Date.UTC(r.Y(), 0),
              a = new Date(r.Y(), 6),
              n = Date.UTC(r.Y(), 6);return e - t !== a - n ? 1 : 0;
        }, O: function O() {
          var e = a.getTimezoneOffset(),
              r = Math.abs(e);return (e > 0 ? "-" : "+") + _t(100 * Math.floor(r / 60) + r % 60, 4);
        }, P: function P() {
          var e = r.O();return e.substr(0, 3) + ":" + e.substr(3, 2);
        }, Z: function Z() {
          return 60 * -a.getTimezoneOffset();
        }, c: function c() {
          return "Y-m-d\\TH:i:sP".replace(d, u);
        }, r: function r() {
          return "D, d M Y H:i:s O".replace(d, u);
        }, U: function U() {
          return a.getTime() / 1e3 || 0;
        } }, u(e, e);
    }, formatDate: function formatDate(e, t) {
      var a,
          r,
          n,
          o,
          i,
          s = this,
          d = "";if ("string" == typeof e && (e = s.parseDate(e, t), e === !1)) return !1;if (e instanceof Date) {
        for (n = t.length, a = 0; n > a; a++) {
          i = t.charAt(a), "S" !== i && (o = s.parseFormat(i, e), a !== n - 1 && s.intParts.test(i) && "S" === t.charAt(a + 1) && (r = parseInt(o), o += s.dateSettings.ordinal(r)), d += o);
        }return d;
      }return "";
    } };
}(), function (e) {
  "function" == typeof define && define.amd ? define(["jquery", "jquery-mousewheel"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = e : e(jQuery);
}(function (e) {
  "use strict";
  function t(e, t, a) {
    this.date = e, this.desc = t, this.style = a;
  }var a = { i18n: { ar: { months: ["كانون الثاني", "شباط", "آذار", "نيسان", "مايو", "حزيران", "تموز", "آب", "أيلول", "تشرين الأول", "تشرين الثاني", "كانون الأول"], dayOfWeekShort: ["ن", "ث", "ع", "خ", "ج", "س", "ح"], dayOfWeek: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت", "الأحد"] }, ro: { months: ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"], dayOfWeekShort: ["Du", "Lu", "Ma", "Mi", "Jo", "Vi", "Sâ"], dayOfWeek: ["Duminică", "Luni", "Marţi", "Miercuri", "Joi", "Vineri", "Sâmbătă"] }, id: { months: ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"], dayOfWeekShort: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"], dayOfWeek: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"] }, is: { months: ["Janúar", "Febrúar", "Mars", "Apríl", "Maí", "Júní", "Júlí", "Ágúst", "September", "Október", "Nóvember", "Desember"], dayOfWeekShort: ["Sun", "Mán", "Þrið", "Mið", "Fim", "Fös", "Lau"], dayOfWeek: ["Sunnudagur", "Mánudagur", "Þriðjudagur", "Miðvikudagur", "Fimmtudagur", "Föstudagur", "Laugardagur"] }, bg: { months: ["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"], dayOfWeekShort: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"], dayOfWeek: ["Неделя", "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота"] }, fa: { months: ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"], dayOfWeekShort: ["یکشنبه", "دوشنبه", "سه شنبه", "چهارشنبه", "پنجشنبه", "جمعه", "شنبه"], dayOfWeek: ["یک‌شنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنج‌شنبه", "جمعه", "شنبه", "یک‌شنبه"] }, ru: { months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"], dayOfWeekShort: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"], dayOfWeek: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"] }, uk: { months: ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень", "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"], dayOfWeekShort: ["Ндл", "Пнд", "Втр", "Срд", "Чтв", "Птн", "Сбт"], dayOfWeek: ["Неділя", "Понеділок", "Вівторок", "Середа", "Четвер", "П'ятниця", "Субота"] }, en: { months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], dayOfWeekShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"] }, el: { months: ["Ιανουάριος", "Φεβρουάριος", "Μάρτιος", "Απρίλιος", "Μάιος", "Ιούνιος", "Ιούλιος", "Αύγουστος", "Σεπτέμβριος", "Οκτώβριος", "Νοέμβριος", "Δεκέμβριος"], dayOfWeekShort: ["Κυρ", "Δευ", "Τρι", "Τετ", "Πεμ", "Παρ", "Σαβ"], dayOfWeek: ["Κυριακή", "Δευτέρα", "Τρίτη", "Τετάρτη", "Πέμπτη", "Παρασκευή", "Σάββατο"] }, de: { months: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"], dayOfWeekShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"], dayOfWeek: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"] }, nl: { months: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"], dayOfWeekShort: ["zo", "ma", "di", "wo", "do", "vr", "za"], dayOfWeek: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"] }, tr: { months: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"], dayOfWeekShort: ["Paz", "Pts", "Sal", "Çar", "Per", "Cum", "Cts"], dayOfWeek: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"] }, fr: { months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"], dayOfWeekShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"], dayOfWeek: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"] }, es: { months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"], dayOfWeekShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"], dayOfWeek: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"] }, th: { months: ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"], dayOfWeekShort: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."], dayOfWeek: ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัส", "ศุกร์", "เสาร์", "อาทิตย์"] }, pl: { months: ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"], dayOfWeekShort: ["nd", "pn", "wt", "śr", "cz", "pt", "sb"], dayOfWeek: ["niedziela", "poniedziałek", "wtorek", "środa", "czwartek", "piątek", "sobota"] }, pt: { months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"], dayOfWeekShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"], dayOfWeek: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"] }, ch: { months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], dayOfWeekShort: ["日", "一", "二", "三", "四", "五", "六"] }, se: { months: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"], dayOfWeekShort: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"] }, kr: { months: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"], dayOfWeekShort: ["일", "월", "화", "수", "목", "금", "토"], dayOfWeek: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"] }, it: { months: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"], dayOfWeekShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"], dayOfWeek: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"] }, da: { months: ["January", "Februar", "Marts", "April", "Maj", "Juni", "July", "August", "September", "Oktober", "November", "December"], dayOfWeekShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"], dayOfWeek: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"] }, no: { months: ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"], dayOfWeekShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"], dayOfWeek: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"] }, ja: { months: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"], dayOfWeekShort: ["日", "月", "火", "水", "木", "金", "土"], dayOfWeek: ["日曜", "月曜", "火曜", "水曜", "木曜", "金曜", "土曜"] }, vi: { months: ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"], dayOfWeekShort: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"], dayOfWeek: ["Chủ nhật", "Thứ hai", "Thứ ba", "Thứ tư", "Thứ năm", "Thứ sáu", "Thứ bảy"] }, sl: { months: ["Januar", "Februar", "Marec", "April", "Maj", "Junij", "Julij", "Avgust", "September", "Oktober", "November", "December"], dayOfWeekShort: ["Ned", "Pon", "Tor", "Sre", "Čet", "Pet", "Sob"], dayOfWeek: ["Nedelja", "Ponedeljek", "Torek", "Sreda", "Četrtek", "Petek", "Sobota"] }, cs: { months: ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"], dayOfWeekShort: ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"] }, hu: { months: ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"], dayOfWeekShort: ["Va", "Hé", "Ke", "Sze", "Cs", "Pé", "Szo"], dayOfWeek: ["vasárnap", "hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat"] }, az: { months: ["Yanvar", "Fevral", "Mart", "Aprel", "May", "Iyun", "Iyul", "Avqust", "Sentyabr", "Oktyabr", "Noyabr", "Dekabr"], dayOfWeekShort: ["B", "Be", "Ça", "Ç", "Ca", "C", "Ş"], dayOfWeek: ["Bazar", "Bazar ertəsi", "Çərşənbə axşamı", "Çərşənbə", "Cümə axşamı", "Cümə", "Şənbə"] }, bs: { months: ["Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"], dayOfWeekShort: ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"], dayOfWeek: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"] }, ca: { months: ["Gener", "Febrer", "Març", "Abril", "Maig", "Juny", "Juliol", "Agost", "Setembre", "Octubre", "Novembre", "Desembre"], dayOfWeekShort: ["Dg", "Dl", "Dt", "Dc", "Dj", "Dv", "Ds"], dayOfWeek: ["Diumenge", "Dilluns", "Dimarts", "Dimecres", "Dijous", "Divendres", "Dissabte"] }, "en-GB": { months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], dayOfWeekShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"] }, et: { months: ["Jaanuar", "Veebruar", "Märts", "Aprill", "Mai", "Juuni", "Juuli", "August", "September", "Oktoober", "November", "Detsember"], dayOfWeekShort: ["P", "E", "T", "K", "N", "R", "L"], dayOfWeek: ["Pühapäev", "Esmaspäev", "Teisipäev", "Kolmapäev", "Neljapäev", "Reede", "Laupäev"] }, eu: { months: ["Urtarrila", "Otsaila", "Martxoa", "Apirila", "Maiatza", "Ekaina", "Uztaila", "Abuztua", "Iraila", "Urria", "Azaroa", "Abendua"], dayOfWeekShort: ["Ig.", "Al.", "Ar.", "Az.", "Og.", "Or.", "La."], dayOfWeek: ["Igandea", "Astelehena", "Asteartea", "Asteazkena", "Osteguna", "Ostirala", "Larunbata"] }, fi: { months: ["Tammikuu", "Helmikuu", "Maaliskuu", "Huhtikuu", "Toukokuu", "Kesäkuu", "Heinäkuu", "Elokuu", "Syyskuu", "Lokakuu", "Marraskuu", "Joulukuu"], dayOfWeekShort: ["Su", "Ma", "Ti", "Ke", "To", "Pe", "La"], dayOfWeek: ["sunnuntai", "maanantai", "tiistai", "keskiviikko", "torstai", "perjantai", "lauantai"] }, gl: { months: ["Xan", "Feb", "Maz", "Abr", "Mai", "Xun", "Xul", "Ago", "Set", "Out", "Nov", "Dec"], dayOfWeekShort: ["Dom", "Lun", "Mar", "Mer", "Xov", "Ven", "Sab"], dayOfWeek: ["Domingo", "Luns", "Martes", "Mércores", "Xoves", "Venres", "Sábado"] }, hr: { months: ["Siječanj", "Veljača", "Ožujak", "Travanj", "Svibanj", "Lipanj", "Srpanj", "Kolovoz", "Rujan", "Listopad", "Studeni", "Prosinac"], dayOfWeekShort: ["Ned", "Pon", "Uto", "Sri", "Čet", "Pet", "Sub"], dayOfWeek: ["Nedjelja", "Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"] }, ko: { months: ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"], dayOfWeekShort: ["일", "월", "화", "수", "목", "금", "토"], dayOfWeek: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"] }, lt: { months: ["Sausio", "Vasario", "Kovo", "Balandžio", "Gegužės", "Birželio", "Liepos", "Rugpjūčio", "Rugsėjo", "Spalio", "Lapkričio", "Gruodžio"], dayOfWeekShort: ["Sek", "Pir", "Ant", "Tre", "Ket", "Pen", "Šeš"], dayOfWeek: ["Sekmadienis", "Pirmadienis", "Antradienis", "Trečiadienis", "Ketvirtadienis", "Penktadienis", "Šeštadienis"] }, lv: { months: ["Janvāris", "Februāris", "Marts", "Aprīlis ", "Maijs", "Jūnijs", "Jūlijs", "Augusts", "Septembris", "Oktobris", "Novembris", "Decembris"], dayOfWeekShort: ["Sv", "Pr", "Ot", "Tr", "Ct", "Pk", "St"], dayOfWeek: ["Svētdiena", "Pirmdiena", "Otrdiena", "Trešdiena", "Ceturtdiena", "Piektdiena", "Sestdiena"] }, mk: { months: ["јануари", "февруари", "март", "април", "мај", "јуни", "јули", "август", "септември", "октомври", "ноември", "декември"], dayOfWeekShort: ["нед", "пон", "вто", "сре", "чет", "пет", "саб"], dayOfWeek: ["Недела", "Понеделник", "Вторник", "Среда", "Четврток", "Петок", "Сабота"] }, mn: { months: ["1-р сар", "2-р сар", "3-р сар", "4-р сар", "5-р сар", "6-р сар", "7-р сар", "8-р сар", "9-р сар", "10-р сар", "11-р сар", "12-р сар"], dayOfWeekShort: ["Дав", "Мяг", "Лха", "Пүр", "Бсн", "Бям", "Ням"], dayOfWeek: ["Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба", "Ням"] }, "pt-BR": { months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"], dayOfWeekShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"], dayOfWeek: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"] }, sk: { months: ["Január", "Február", "Marec", "Apríl", "Máj", "Jún", "Júl", "August", "September", "Október", "November", "December"], dayOfWeekShort: ["Ne", "Po", "Ut", "St", "Št", "Pi", "So"], dayOfWeek: ["Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"] }, sq: { months: ["Janar", "Shkurt", "Mars", "Prill", "Maj", "Qershor", "Korrik", "Gusht", "Shtator", "Tetor", "Nëntor", "Dhjetor"], dayOfWeekShort: ["Die", "Hën", "Mar", "Mër", "Enj", "Pre", "Shtu"], dayOfWeek: ["E Diel", "E Hënë", "E Martē", "E Mërkurë", "E Enjte", "E Premte", "E Shtunë"] }, "sr-YU": { months: ["Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"], dayOfWeekShort: ["Ned", "Pon", "Uto", "Sre", "čet", "Pet", "Sub"], dayOfWeek: ["Nedelja", "Ponedeljak", "Utorak", "Sreda", "Četvrtak", "Petak", "Subota"] }, sr: { months: ["јануар", "фебруар", "март", "април", "мај", "јун", "јул", "август", "септембар", "октобар", "новембар", "децембар"], dayOfWeekShort: ["нед", "пон", "уто", "сре", "чет", "пет", "суб"], dayOfWeek: ["Недеља", "Понедељак", "Уторак", "Среда", "Четвртак", "Петак", "Субота"] }, sv: { months: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"], dayOfWeekShort: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"], dayOfWeek: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"] }, "zh-TW": { months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], dayOfWeekShort: ["日", "一", "二", "三", "四", "五", "六"], dayOfWeek: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"] }, zh: { months: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], dayOfWeekShort: ["日", "一", "二", "三", "四", "五", "六"], dayOfWeek: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"] }, he: { months: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"], dayOfWeekShort: ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", "שבת"], dayOfWeek: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת", "ראשון"] }, hy: { months: ["Հունվար", "Փետրվար", "Մարտ", "Ապրիլ", "Մայիս", "Հունիս", "Հուլիս", "Օգոստոս", "Սեպտեմբեր", "Հոկտեմբեր", "Նոյեմբեր", "Դեկտեմբեր"], dayOfWeekShort: ["Կի", "Երկ", "Երք", "Չոր", "Հնգ", "Ուրբ", "Շբթ"], dayOfWeek: ["Կիրակի", "Երկուշաբթի", "Երեքշաբթի", "Չորեքշաբթի", "Հինգշաբթի", "Ուրբաթ", "Շաբաթ"] }, kg: { months: ["Үчтүн айы", "Бирдин айы", "Жалган Куран", "Чын Куран", "Бугу", "Кулжа", "Теке", "Баш Оона", "Аяк Оона", "Тогуздун айы", "Жетинин айы", "Бештин айы"], dayOfWeekShort: ["Жек", "Дүй", "Шей", "Шар", "Бей", "Жум", "Ише"], dayOfWeek: ["Жекшемб", "Дүйшөмб", "Шейшемб", "Шаршемб", "Бейшемби", "Жума", "Ишенб"] }, rm: { months: ["Schaner", "Favrer", "Mars", "Avrigl", "Matg", "Zercladur", "Fanadur", "Avust", "Settember", "October", "November", "December"], dayOfWeekShort: ["Du", "Gli", "Ma", "Me", "Gie", "Ve", "So"], dayOfWeek: ["Dumengia", "Glindesdi", "Mardi", "Mesemna", "Gievgia", "Venderdi", "Sonda"] }, ka: { months: ["იანვარი", "თებერვალი", "მარტი", "აპრილი", "მაისი", "ივნისი", "ივლისი", "აგვისტო", "სექტემბერი", "ოქტომბერი", "ნოემბერი", "დეკემბერი"], dayOfWeekShort: ["კვ", "ორშ", "სამშ", "ოთხ", "ხუთ", "პარ", "შაბ"], dayOfWeek: ["კვირა", "ორშაბათი", "სამშაბათი", "ოთხშაბათი", "ხუთშაბათი", "პარასკევი", "შაბათი"] } }, value: "", rtl: !1, format: "Y/m/d H:i", formatTime: "H:i", formatDate: "Y/m/d", startDate: !1, step: 60, monthChangeSpinner: !0, closeOnDateSelect: !1, closeOnTimeSelect: !0, closeOnWithoutClick: !0, closeOnInputClick: !0, timepicker: !0, datepicker: !0, weeks: !1, defaultTime: !1, defaultDate: !1, minDate: !1, maxDate: !1, minTime: !1, maxTime: !1, disabledMinTime: !1, disabledMaxTime: !1, allowTimes: [], opened: !1, initTime: !0, inline: !1, theme: "", onSelectDate: function onSelectDate() {}, onSelectTime: function onSelectTime() {}, onChangeMonth: function onChangeMonth() {}, onGetWeekOfYear: function onGetWeekOfYear() {}, onChangeYear: function onChangeYear() {}, onChangeDateTime: function onChangeDateTime() {}, onShow: function onShow() {}, onClose: function onClose() {}, onGenerate: function onGenerate() {}, withoutCopyright: !0, inverseButton: !1, hours12: !1, next: "xdsoft_next", prev: "xdsoft_prev", dayOfWeekStart: 0, parentID: "body", timeHeightInTimePicker: 25, timepickerScrollbar: !0, todayButton: !0, prevButton: !0, nextButton: !0, defaultSelect: !0, scrollMonth: !0, scrollTime: !0, scrollInput: !0, lazyInit: !1, mask: !1, validateOnBlur: !0, allowBlank: !0, yearStart: 1950, yearEnd: 2050, monthStart: 0, monthEnd: 11, style: "", id: "", fixed: !1, roundTime: "round", className: "", weekends: [], highlightedDates: [], highlightedPeriods: [], allowDates: [], allowDateRe: null, disabledDates: [], disabledWeekDays: [], yearOffset: 0, beforeShowDay: null, enterLikeTab: !0, showApplyButton: !1 },
      r = null,
      n = "en",
      o = "en",
      i = { meridiem: ["AM", "PM"] },
      s = function s() {
    var t = a.i18n[o],
        n = { days: t.dayOfWeek, daysShort: t.dayOfWeekShort, months: t.months, monthsShort: e.map(t.months, function (e) {
        return e.substring(0, 3);
      }) };r = new DateFormatter({ dateSettings: e.extend({}, i, n) });
  };e.datetimepicker = { setLocale: function setLocale(e) {
      var t = a.i18n[e] ? e : n;o != t && (o = t, s());
    }, setDateFormatter: function setDateFormatter(e) {
      r = e;
    }, RFC_2822: "D, d M Y H:i:s O", ATOM: "Y-m-dTH:i:sP", ISO_8601: "Y-m-dTH:i:sO", RFC_822: "D, d M y H:i:s O", RFC_850: "l, d-M-y H:i:s T", RFC_1036: "D, d M y H:i:s O", RFC_1123: "D, d M Y H:i:s O", RSS: "D, d M Y H:i:s O", W3C: "Y-m-dTH:i:sP" }, s(), window.getComputedStyle || (window.getComputedStyle = function (e) {
    return this.el = e, this.getPropertyValue = function (t) {
      var a = /(\-([a-z]){1})/g;return "float" === t && (t = "styleFloat"), a.test(t) && (t = t.replace(a, function (e, t, a) {
        return a.toUpperCase();
      })), e.currentStyle[t] || null;
    }, this;
  }), Array.prototype.indexOf || (Array.prototype.indexOf = function (e, t) {
    var a, r;for (a = t || 0, r = this.length; r > a; a += 1) {
      if (this[a] === e) return a;
    }return -1;
  }), Date.prototype.countDaysInMonth = function () {
    return new Date(this.getFullYear(), this.getMonth() + 1, 0).getDate();
  }, e.fn.xdsoftScroller = function (t) {
    return this.each(function () {
      var a,
          r,
          n,
          o,
          i,
          s = e(this),
          d = function d(e) {
        var t,
            a = { x: 0, y: 0 };return "touchstart" === e.type || "touchmove" === e.type || "touchend" === e.type || "touchcancel" === e.type ? (t = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0], a.x = t.clientX, a.y = t.clientY) : ("mousedown" === e.type || "mouseup" === e.type || "mousemove" === e.type || "mouseover" === e.type || "mouseout" === e.type || "mouseenter" === e.type || "mouseleave" === e.type) && (a.x = e.clientX, a.y = e.clientY), a;
      },
          u = 100,
          l = !1,
          f = 0,
          c = 0,
          m = 0,
          h = !1,
          g = 0,
          p = function p() {};return "hide" === t ? void s.find(".xdsoft_scrollbar").hide() : (e(this).hasClass("xdsoft_scroller_box") || (a = s.children().eq(0), r = s[0].clientHeight, n = a[0].offsetHeight, o = e('<div class="xdsoft_scrollbar"></div>'), i = e('<div class="xdsoft_scroller"></div>'), o.append(i), s.addClass("xdsoft_scroller_box").append(o), p = function p(e) {
        var t = d(e).y - f + g;0 > t && (t = 0), t + i[0].offsetHeight > m && (t = m - i[0].offsetHeight), s.trigger("scroll_element.xdsoft_scroller", [u ? t / u : 0]);
      }, i.on("touchstart.xdsoft_scroller mousedown.xdsoft_scroller", function (a) {
        r || s.trigger("resize_scroll.xdsoft_scroller", [t]), f = d(a).y, g = parseInt(i.css("margin-top"), 10), m = o[0].offsetHeight, "mousedown" === a.type || "touchstart" === a.type ? (document && e(document.body).addClass("xdsoft_noselect"), e([document.body, window]).on("touchend mouseup.xdsoft_scroller", function n() {
          e([document.body, window]).off("touchend mouseup.xdsoft_scroller", n).off("mousemove.xdsoft_scroller", p).removeClass("xdsoft_noselect");
        }), e(document.body).on("mousemove.xdsoft_scroller", p)) : (h = !0, a.stopPropagation(), a.preventDefault());
      }).on("touchmove", function (e) {
        h && (e.preventDefault(), p(e));
      }).on("touchend touchcancel", function () {
        h = !1, g = 0;
      }), s.on("scroll_element.xdsoft_scroller", function (e, t) {
        r || s.trigger("resize_scroll.xdsoft_scroller", [t, !0]), t = t > 1 ? 1 : 0 > t || isNaN(t) ? 0 : t, i.css("margin-top", u * t), setTimeout(function () {
          a.css("marginTop", -parseInt((a[0].offsetHeight - r) * t, 10));
        }, 10);
      }).on("resize_scroll.xdsoft_scroller", function (e, t, d) {
        var l, f;r = s[0].clientHeight, n = a[0].offsetHeight, l = r / n, f = l * o[0].offsetHeight, l > 1 ? i.hide() : (i.show(), i.css("height", parseInt(f > 10 ? f : 10, 10)), u = o[0].offsetHeight - i[0].offsetHeight, d !== !0 && s.trigger("scroll_element.xdsoft_scroller", [t || Math.abs(parseInt(a.css("marginTop"), 10)) / (n - r)]));
      }), s.on("mousewheel", function (e) {
        var t = Math.abs(parseInt(a.css("marginTop"), 10));return t -= 20 * e.deltaY, 0 > t && (t = 0), s.trigger("scroll_element.xdsoft_scroller", [t / (n - r)]), e.stopPropagation(), !1;
      }), s.on("touchstart", function (e) {
        l = d(e), c = Math.abs(parseInt(a.css("marginTop"), 10));
      }), s.on("touchmove", function (e) {
        if (l) {
          e.preventDefault();var t = d(e);s.trigger("scroll_element.xdsoft_scroller", [(c - (t.y - l.y)) / (n - r)]);
        }
      }), s.on("touchend touchcancel", function () {
        l = !1, c = 0;
      })), void s.trigger("resize_scroll.xdsoft_scroller", [t]));
    });
  }, e.fn.datetimepicker = function (n, i) {
    var s,
        d,
        u = this,
        l = 48,
        f = 57,
        c = 96,
        m = 105,
        h = 17,
        g = 46,
        p = 13,
        y = 27,
        v = 8,
        b = 37,
        D = 38,
        k = 39,
        x = 40,
        T = 9,
        S = 116,
        w = 65,
        O = 67,
        M = 86,
        _ = 90,
        W = 89,
        F = !1,
        C = e.isPlainObject(n) || !n ? e.extend(!0, {}, a, n) : e.extend(!0, {}, a),
        P = 0,
        A = function A(e) {
      e.on("open.xdsoft focusin.xdsoft mousedown.xdsoft touchstart", function t() {
        e.is(":disabled") || e.data("xdsoft_datetimepicker") || (clearTimeout(P), P = setTimeout(function () {
          e.data("xdsoft_datetimepicker") || s(e), e.off("open.xdsoft focusin.xdsoft mousedown.xdsoft touchstart", t).trigger("open.xdsoft");
        }, 100));
      });
    };return s = function s(a) {
      function i() {
        var e,
            t = !1;return C.startDate ? t = j.strToDate(C.startDate) : (t = C.value || (a && a.val && a.val() ? a.val() : ""), t ? t = j.strToDateTime(t) : C.defaultDate && (t = j.strToDateTime(C.defaultDate), C.defaultTime && (e = j.strtotime(C.defaultTime), t.setHours(e.getHours()), t.setMinutes(e.getMinutes())))), t && j.isValidDate(t) ? J.data("changed", !0) : t = "", t || 0;
      }function s(t) {
        var r = function r(e, t) {
          var a = e.replace(/([\[\]\/\{\}\(\)\-\.\+]{1})/g, "\\$1").replace(/_/g, "{digit+}").replace(/([0-9]{1})/g, "{digit$1}").replace(/\{digit([0-9]{1})\}/g, "[0-$1_]{1}").replace(/\{digit[\+]\}/g, "[0-9_]{1}");return new RegExp(a).test(t);
        },
            n = function n(e) {
          try {
            if (document.selection && document.selection.createRange) {
              var t = document.selection.createRange();return t.getBookmark().charCodeAt(2) - 2;
            }if (e.setSelectionRange) return e.selectionStart;
          } catch (a) {
            return 0;
          }
        },
            o = function o(e, t) {
          if (e = "string" == typeof e || e instanceof String ? document.getElementById(e) : e, !e) return !1;if (e.createTextRange) {
            var a = e.createTextRange();return a.collapse(!0), a.moveEnd("character", t), a.moveStart("character", t), a.select(), !0;
          }return e.setSelectionRange ? (e.setSelectionRange(t, t), !0) : !1;
        };t.mask && a.off("keydown.xdsoft"), t.mask === !0 && (t.mask = "undefined" != typeof moment ? t.format.replace(/Y{4}/g, "9999").replace(/Y{2}/g, "99").replace(/M{2}/g, "19").replace(/D{2}/g, "39").replace(/H{2}/g, "29").replace(/m{2}/g, "59").replace(/s{2}/g, "59") : t.format.replace(/Y/g, "9999").replace(/F/g, "9999").replace(/m/g, "19").replace(/d/g, "39").replace(/H/g, "29").replace(/i/g, "59").replace(/s/g, "59")), "string" === e.type(t.mask) && (r(t.mask, a.val()) || (a.val(t.mask.replace(/[0-9]/g, "_")), o(a[0], 0)), a.on("keydown.xdsoft", function (i) {
          var s,
              d,
              u = this.value,
              C = i.which;if (C >= l && f >= C || C >= c && m >= C || C === v || C === g) {
            for (s = n(this), d = C !== v && C !== g ? String.fromCharCode(C >= c && m >= C ? C - l : C) : "_", C !== v && C !== g || !s || (s -= 1, d = "_"); /[^0-9_]/.test(t.mask.substr(s, 1)) && s < t.mask.length && s > 0;) {
              s += C === v || C === g ? -1 : 1;
            }if (u = u.substr(0, s) + d + u.substr(s + 1), "" === e.trim(u)) u = t.mask.replace(/[0-9]/g, "_");else if (s === t.mask.length) return i.preventDefault(), !1;for (s += C === v || C === g ? 0 : 1; /[^0-9_]/.test(t.mask.substr(s, 1)) && s < t.mask.length && s > 0;) {
              s += C === v || C === g ? -1 : 1;
            }r(t.mask, u) ? (this.value = u, o(this, s)) : "" === e.trim(u) ? this.value = t.mask.replace(/[0-9]/g, "_") : a.trigger("error_input.xdsoft");
          } else if (-1 !== [w, O, M, _, W].indexOf(C) && F || -1 !== [y, D, x, b, k, S, h, T, p].indexOf(C)) return !0;return i.preventDefault(), !1;
        }));
      }var d,
          u,
          P,
          A,
          Y,
          j,
          H,
          J = e('<div class="xdsoft_datetimepicker xdsoft_noselect"></div>'),
          z = e('<div class="xdsoft_copyright"><a target="_blank" href="http://xdsoft.net/jqplugins/datetimepicker/">xdsoft.net</a></div>'),
          I = e('<div class="xdsoft_datepicker active"></div>'),
          N = e('<div class="xdsoft_monthpicker"><button type="button" class="xdsoft_prev"></button><button type="button" class="xdsoft_today_button"></button><div class="xdsoft_label xdsoft_month"><span></span><i></i></div><div class="xdsoft_label xdsoft_year"><span></span><i></i></div><button type="button" class="xdsoft_next"></button></div>'),
          L = e('<div class="xdsoft_calendar"></div>'),
          E = e('<div class="xdsoft_timepicker active"><button type="button" class="xdsoft_prev"></button><div class="xdsoft_time_box"></div><button type="button" class="xdsoft_next"></button></div>'),
          R = E.find(".xdsoft_time_box").eq(0),
          B = e('<div class="xdsoft_time_variant"></div>'),
          V = e('<button type="button" class="xdsoft_save_selected blue-gradient-button">Save Selected</button>'),
          G = e('<div class="xdsoft_select xdsoft_monthselect"><div></div></div>'),
          U = e('<div class="xdsoft_select xdsoft_yearselect"><div></div></div>'),
          q = !1,
          X = 0;C.id && J.attr("id", C.id), C.style && J.attr("style", C.style), C.weeks && J.addClass("xdsoft_showweeks"), C.rtl && J.addClass("xdsoft_rtl"), J.addClass("xdsoft_" + C.theme), J.addClass(C.className), N.find(".xdsoft_month span").after(G), N.find(".xdsoft_year span").after(U), N.find(".xdsoft_month,.xdsoft_year").on("touchstart mousedown.xdsoft", function (t) {
        var a,
            r,
            n = e(this).find(".xdsoft_select").eq(0),
            o = 0,
            i = 0,
            s = n.is(":visible");for (N.find(".xdsoft_select").hide(), j.currentTime && (o = j.currentTime[e(this).hasClass("xdsoft_month") ? "getMonth" : "getFullYear"]()), n[s ? "hide" : "show"](), a = n.find("div.xdsoft_option"), r = 0; r < a.length && a.eq(r).data("value") !== o; r += 1) {
          i += a[0].offsetHeight;
        }return n.xdsoftScroller(i / (n.children()[0].offsetHeight - n[0].clientHeight)), t.stopPropagation(), !1;
      }), N.find(".xdsoft_select").xdsoftScroller().on("touchstart mousedown.xdsoft", function (e) {
        e.stopPropagation(), e.preventDefault();
      }).on("touchstart mousedown.xdsoft", ".xdsoft_option", function () {
        (void 0 === j.currentTime || null === j.currentTime) && (j.currentTime = j.now());var t = j.currentTime.getFullYear();j && j.currentTime && j.currentTime[e(this).parent().parent().hasClass("xdsoft_monthselect") ? "setMonth" : "setFullYear"](e(this).data("value")), e(this).parent().parent().hide(), J.trigger("xchange.xdsoft"), C.onChangeMonth && e.isFunction(C.onChangeMonth) && C.onChangeMonth.call(J, j.currentTime, J.data("input")), t !== j.currentTime.getFullYear() && e.isFunction(C.onChangeYear) && C.onChangeYear.call(J, j.currentTime, J.data("input"));
      }), J.getValue = function () {
        return j.getCurrentTime();
      }, J.setOptions = function (n) {
        var o = {};C = e.extend(!0, {}, C, n), n.allowTimes && e.isArray(n.allowTimes) && n.allowTimes.length && (C.allowTimes = e.extend(!0, [], n.allowTimes)), n.weekends && e.isArray(n.weekends) && n.weekends.length && (C.weekends = e.extend(!0, [], n.weekends)), n.allowDates && e.isArray(n.allowDates) && n.allowDates.length && (C.allowDates = e.extend(!0, [], n.allowDates)), n.allowDateRe && "[object String]" === Object.prototype.toString.call(n.allowDateRe) && (C.allowDateRe = new RegExp(n.allowDateRe)), n.highlightedDates && e.isArray(n.highlightedDates) && n.highlightedDates.length && (e.each(n.highlightedDates, function (a, n) {
          var i,
              s = e.map(n.split(","), e.trim),
              d = new t(r.parseDate(s[0], C.formatDate), s[1], s[2]),
              u = r.formatDate(d.date, C.formatDate);void 0 !== o[u] ? (i = o[u].desc, i && i.length && d.desc && d.desc.length && (o[u].desc = i + "\n" + d.desc)) : o[u] = d;
        }), C.highlightedDates = e.extend(!0, [], o)), n.highlightedPeriods && e.isArray(n.highlightedPeriods) && n.highlightedPeriods.length && (o = e.extend(!0, [], C.highlightedDates), e.each(n.highlightedPeriods, function (a, n) {
          var i, s, d, u, l, f, c;if (e.isArray(n)) i = n[0], s = n[1], d = n[2], c = n[3];else {
            var m = e.map(n.split(","), e.trim);i = r.parseDate(m[0], C.formatDate), s = r.parseDate(m[1], C.formatDate), d = m[2], c = m[3];
          }for (; s >= i;) {
            u = new t(i, d, c), l = r.formatDate(i, C.formatDate), i.setDate(i.getDate() + 1), void 0 !== o[l] ? (f = o[l].desc, f && f.length && u.desc && u.desc.length && (o[l].desc = f + "\n" + u.desc)) : o[l] = u;
          }
        }), C.highlightedDates = e.extend(!0, [], o)), n.disabledDates && e.isArray(n.disabledDates) && n.disabledDates.length && (C.disabledDates = e.extend(!0, [], n.disabledDates)), n.disabledWeekDays && e.isArray(n.disabledWeekDays) && n.disabledWeekDays.length && (C.disabledWeekDays = e.extend(!0, [], n.disabledWeekDays)), !C.open && !C.opened || C.inline || a.trigger("open.xdsoft"), C.inline && (q = !0, J.addClass("xdsoft_inline"), a.after(J).hide()), C.inverseButton && (C.next = "xdsoft_prev", C.prev = "xdsoft_next"), C.datepicker ? I.addClass("active") : I.removeClass("active"), C.timepicker ? E.addClass("active") : E.removeClass("active"), C.value && (j.setCurrentTime(C.value), a && a.val && a.val(j.str)), C.dayOfWeekStart = isNaN(C.dayOfWeekStart) ? 0 : parseInt(C.dayOfWeekStart, 10) % 7, C.timepickerScrollbar || R.xdsoftScroller("hide"), C.minDate && /^[\+\-](.*)$/.test(C.minDate) && (C.minDate = r.formatDate(j.strToDateTime(C.minDate), C.formatDate)), C.maxDate && /^[\+\-](.*)$/.test(C.maxDate) && (C.maxDate = r.formatDate(j.strToDateTime(C.maxDate), C.formatDate)), V.toggle(C.showApplyButton), N.find(".xdsoft_today_button").css("visibility", C.todayButton ? "visible" : "hidden"), N.find("." + C.prev).css("visibility", C.prevButton ? "visible" : "hidden"), N.find("." + C.next).css("visibility", C.nextButton ? "visible" : "hidden"), s(C), C.validateOnBlur && a.off("blur.xdsoft").on("blur.xdsoft", function () {
          if (C.allowBlank && (!e.trim(e(this).val()).length || "string" == typeof C.mask && e.trim(e(this).val()) === C.mask.replace(/[0-9]/g, "_"))) e(this).val(null), J.data("xdsoft_datetime").empty();else {
            var t = r.parseDate(e(this).val(), C.format);if (t) e(this).val(r.formatDate(t, C.format));else {
              var a = +[e(this).val()[0], e(this).val()[1]].join(""),
                  n = +[e(this).val()[2], e(this).val()[3]].join("");e(this).val(!C.datepicker && C.timepicker && a >= 0 && 24 > a && n >= 0 && 60 > n ? [a, n].map(function (e) {
                return e > 9 ? e : "0" + e;
              }).join(":") : r.formatDate(j.now(), C.format));
            }J.data("xdsoft_datetime").setCurrentTime(e(this).val());
          }J.trigger("changedatetime.xdsoft"), J.trigger("close.xdsoft");
        }), C.dayOfWeekStartPrev = 0 === C.dayOfWeekStart ? 6 : C.dayOfWeekStart - 1, J.trigger("xchange.xdsoft").trigger("afterOpen.xdsoft");
      }, J.data("options", C).on("touchstart mousedown.xdsoft", function (e) {
        return e.stopPropagation(), e.preventDefault(), U.hide(), G.hide(), !1;
      }), R.append(B), R.xdsoftScroller(), J.on("afterOpen.xdsoft", function () {
        R.xdsoftScroller();
      }), J.append(I).append(E), C.withoutCopyright !== !0 && J.append(z), I.append(N).append(L).append(V), e(C.parentID).append(J), d = function d() {
        var t = this;t.now = function (e) {
          var a,
              r,
              n = new Date();return !e && C.defaultDate && (a = t.strToDateTime(C.defaultDate), n.setFullYear(a.getFullYear()), n.setMonth(a.getMonth()), n.setDate(a.getDate())), C.yearOffset && n.setFullYear(n.getFullYear() + C.yearOffset), !e && C.defaultTime && (r = t.strtotime(C.defaultTime), n.setHours(r.getHours()), n.setMinutes(r.getMinutes())), n;
        }, t.isValidDate = function (e) {
          return "[object Date]" !== Object.prototype.toString.call(e) ? !1 : !isNaN(e.getTime());
        }, t.setCurrentTime = function (e, a) {
          t.currentTime = "string" == typeof e ? t.strToDateTime(e) : t.isValidDate(e) ? e : e || a || !C.allowBlank ? t.now() : null, J.trigger("xchange.xdsoft");
        }, t.empty = function () {
          t.currentTime = null;
        }, t.getCurrentTime = function () {
          return t.currentTime;
        }, t.nextMonth = function () {
          (void 0 === t.currentTime || null === t.currentTime) && (t.currentTime = t.now());var a,
              r = t.currentTime.getMonth() + 1;return 12 === r && (t.currentTime.setFullYear(t.currentTime.getFullYear() + 1), r = 0), a = t.currentTime.getFullYear(), t.currentTime.setDate(Math.min(new Date(t.currentTime.getFullYear(), r + 1, 0).getDate(), t.currentTime.getDate())), t.currentTime.setMonth(r), C.onChangeMonth && e.isFunction(C.onChangeMonth) && C.onChangeMonth.call(J, j.currentTime, J.data("input")), a !== t.currentTime.getFullYear() && e.isFunction(C.onChangeYear) && C.onChangeYear.call(J, j.currentTime, J.data("input")), J.trigger("xchange.xdsoft"), r;
        }, t.prevMonth = function () {
          (void 0 === t.currentTime || null === t.currentTime) && (t.currentTime = t.now());var a = t.currentTime.getMonth() - 1;return -1 === a && (t.currentTime.setFullYear(t.currentTime.getFullYear() - 1), a = 11), t.currentTime.setDate(Math.min(new Date(t.currentTime.getFullYear(), a + 1, 0).getDate(), t.currentTime.getDate())), t.currentTime.setMonth(a), C.onChangeMonth && e.isFunction(C.onChangeMonth) && C.onChangeMonth.call(J, j.currentTime, J.data("input")), J.trigger("xchange.xdsoft"), a;
        }, t.getWeekOfYear = function (t) {
          if (C.onGetWeekOfYear && e.isFunction(C.onGetWeekOfYear)) {
            var a = C.onGetWeekOfYear.call(J, t);if ("undefined" != typeof a) return a;
          }var r = new Date(t.getFullYear(), 0, 1);return 4 != r.getDay() && r.setMonth(0, 1 + (4 - r.getDay() + 7) % 7), Math.ceil(((t - r) / 864e5 + r.getDay() + 1) / 7);
        }, t.strToDateTime = function (e) {
          var a,
              n,
              o = [];return e && e instanceof Date && t.isValidDate(e) ? e : (o = /^(\+|\-)(.*)$/.exec(e), o && (o[2] = r.parseDate(o[2], C.formatDate)), o && o[2] ? (a = o[2].getTime() - 6e4 * o[2].getTimezoneOffset(), n = new Date(t.now(!0).getTime() + parseInt(o[1] + "1", 10) * a)) : n = e ? r.parseDate(e, C.format) : t.now(), t.isValidDate(n) || (n = t.now()), n);
        }, t.strToDate = function (e) {
          if (e && e instanceof Date && t.isValidDate(e)) return e;var a = e ? r.parseDate(e, C.formatDate) : t.now(!0);return t.isValidDate(a) || (a = t.now(!0)), a;
        }, t.strtotime = function (e) {
          if (e && e instanceof Date && t.isValidDate(e)) return e;var a = e ? r.parseDate(e, C.formatTime) : t.now(!0);return t.isValidDate(a) || (a = t.now(!0)), a;
        }, t.str = function () {
          return r.formatDate(t.currentTime, C.format);
        }, t.currentTime = this.now();
      }, j = new d(), V.on("touchend click", function (e) {
        e.preventDefault(), J.data("changed", !0), j.setCurrentTime(i()), a.val(j.str()), J.trigger("close.xdsoft");
      }), N.find(".xdsoft_today_button").on("touchend mousedown.xdsoft", function () {
        J.data("changed", !0), j.setCurrentTime(0, !0), J.trigger("afterOpen.xdsoft");
      }).on("dblclick.xdsoft", function () {
        var e,
            t,
            r = j.getCurrentTime();r = new Date(r.getFullYear(), r.getMonth(), r.getDate()), e = j.strToDate(C.minDate), e = new Date(e.getFullYear(), e.getMonth(), e.getDate()), e > r || (t = j.strToDate(C.maxDate), t = new Date(t.getFullYear(), t.getMonth(), t.getDate()), r > t || (a.val(j.str()), a.trigger("change"), J.trigger("close.xdsoft")));
      }), N.find(".xdsoft_prev,.xdsoft_next").on("touchend mousedown.xdsoft", function () {
        var t = e(this),
            a = 0,
            r = !1;!function n(e) {
          t.hasClass(C.next) ? j.nextMonth() : t.hasClass(C.prev) && j.prevMonth(), C.monthChangeSpinner && (r || (a = setTimeout(n, e || 100)));
        }(500), e([document.body, window]).on("touchend mouseup.xdsoft", function o() {
          clearTimeout(a), r = !0, e([document.body, window]).off("touchend mouseup.xdsoft", o);
        });
      }), E.find(".xdsoft_prev,.xdsoft_next").on("touchend mousedown.xdsoft", function () {
        var t = e(this),
            a = 0,
            r = !1,
            n = 110;!function o(e) {
          var i = R[0].clientHeight,
              s = B[0].offsetHeight,
              d = Math.abs(parseInt(B.css("marginTop"), 10));t.hasClass(C.next) && s - i - C.timeHeightInTimePicker >= d ? B.css("marginTop", "-" + (d + C.timeHeightInTimePicker) + "px") : t.hasClass(C.prev) && d - C.timeHeightInTimePicker >= 0 && B.css("marginTop", "-" + (d - C.timeHeightInTimePicker) + "px"), R.trigger("scroll_element.xdsoft_scroller", [Math.abs(parseInt(B[0].style.marginTop, 10) / (s - i))]), n = n > 10 ? 10 : n - 10, r || (a = setTimeout(o, e || n));
        }(500), e([document.body, window]).on("touchend mouseup.xdsoft", function i() {
          clearTimeout(a), r = !0, e([document.body, window]).off("touchend mouseup.xdsoft", i);
        });
      }), u = 0, J.on("xchange.xdsoft", function (t) {
        clearTimeout(u), u = setTimeout(function () {
          if (void 0 === j.currentTime || null === j.currentTime) {
            if (C.allowBlank) return;j.currentTime = j.now();
          }for (var t, i, s, d, u, l, f, c, m, h, g = "", p = new Date(j.currentTime.getFullYear(), j.currentTime.getMonth(), 1, 12, 0, 0), y = 0, v = j.now(), b = !1, D = !1, k = [], x = !0, T = "", S = ""; p.getDay() !== C.dayOfWeekStart;) {
            p.setDate(p.getDate() - 1);
          }for (g += "<table><thead><tr>", C.weeks && (g += "<th></th>"), t = 0; 7 > t; t += 1) {
            g += "<th>" + C.i18n[o].dayOfWeekShort[(t + C.dayOfWeekStart) % 7] + "</th>";
          }for (g += "</tr></thead>", g += "<tbody>", C.maxDate !== !1 && (b = j.strToDate(C.maxDate), b = new Date(b.getFullYear(), b.getMonth(), b.getDate(), 23, 59, 59, 999)), C.minDate !== !1 && (D = j.strToDate(C.minDate), D = new Date(D.getFullYear(), D.getMonth(), D.getDate())); y < j.currentTime.countDaysInMonth() || p.getDay() !== C.dayOfWeekStart || j.currentTime.getMonth() === p.getMonth();) {
            k = [], y += 1, s = p.getDay(), d = p.getDate(), u = p.getFullYear(), l = p.getMonth(), f = j.getWeekOfYear(p), h = "", k.push("xdsoft_date"), c = C.beforeShowDay && e.isFunction(C.beforeShowDay.call) ? C.beforeShowDay.call(J, p) : null, C.allowDateRe && "[object RegExp]" === Object.prototype.toString.call(C.allowDateRe) ? C.allowDateRe.test(r.formatDate(p, C.formatDate)) || k.push("xdsoft_disabled") : C.allowDates && C.allowDates.length > 0 ? -1 === C.allowDates.indexOf(r.formatDate(p, C.formatDate)) && k.push("xdsoft_disabled") : b !== !1 && p > b || D !== !1 && D > p || c && c[0] === !1 ? k.push("xdsoft_disabled") : -1 !== C.disabledDates.indexOf(r.formatDate(p, C.formatDate)) ? k.push("xdsoft_disabled") : -1 !== C.disabledWeekDays.indexOf(s) ? k.push("xdsoft_disabled") : a.is("[readonly]") && k.push("xdsoft_disabled"), c && "" !== c[1] && k.push(c[1]), j.currentTime.getMonth() !== l && k.push("xdsoft_other_month"), (C.defaultSelect || J.data("changed")) && r.formatDate(j.currentTime, C.formatDate) === r.formatDate(p, C.formatDate) && k.push("xdsoft_current"), r.formatDate(v, C.formatDate) === r.formatDate(p, C.formatDate) && k.push("xdsoft_today"), (0 === p.getDay() || 6 === p.getDay() || -1 !== C.weekends.indexOf(r.formatDate(p, C.formatDate))) && k.push("xdsoft_weekend"), void 0 !== C.highlightedDates[r.formatDate(p, C.formatDate)] && (i = C.highlightedDates[r.formatDate(p, C.formatDate)], k.push(void 0 === i.style ? "xdsoft_highlighted_default" : i.style), h = void 0 === i.desc ? "" : i.desc), C.beforeShowDay && e.isFunction(C.beforeShowDay) && k.push(C.beforeShowDay(p)), x && (g += "<tr>", x = !1, C.weeks && (g += "<th>" + f + "</th>")), g += '<td data-date="' + d + '" data-month="' + l + '" data-year="' + u + '" class="xdsoft_date xdsoft_day_of_week' + p.getDay() + " " + k.join(" ") + '" title="' + h + '"><div>' + d + "</div></td>", p.getDay() === C.dayOfWeekStartPrev && (g += "</tr>", x = !0), p.setDate(d + 1);
          }if (g += "</tbody></table>", L.html(g), N.find(".xdsoft_label span").eq(0).text(C.i18n[o].months[j.currentTime.getMonth()]), N.find(".xdsoft_label span").eq(1).text(j.currentTime.getFullYear()), T = "", S = "", l = "", m = function m(t, n) {
            var o,
                i,
                s = j.now(),
                d = C.allowTimes && e.isArray(C.allowTimes) && C.allowTimes.length;s.setHours(t), t = parseInt(s.getHours(), 10), s.setMinutes(n), n = parseInt(s.getMinutes(), 10), o = new Date(j.currentTime), o.setHours(t), o.setMinutes(n), k = [], C.minDateTime !== !1 && C.minDateTime > o || C.maxTime !== !1 && j.strtotime(C.maxTime).getTime() < s.getTime() || C.minTime !== !1 && j.strtotime(C.minTime).getTime() > s.getTime() ? k.push("xdsoft_disabled") : C.minDateTime !== !1 && C.minDateTime > o || C.disabledMinTime !== !1 && s.getTime() > j.strtotime(C.disabledMinTime).getTime() && C.disabledMaxTime !== !1 && s.getTime() < j.strtotime(C.disabledMaxTime).getTime() ? k.push("xdsoft_disabled") : a.is("[readonly]") && k.push("xdsoft_disabled"), i = new Date(j.currentTime), i.setHours(parseInt(j.currentTime.getHours(), 10)), d || i.setMinutes(Math[C.roundTime](j.currentTime.getMinutes() / C.step) * C.step), (C.initTime || C.defaultSelect || J.data("changed")) && i.getHours() === parseInt(t, 10) && (!d && C.step > 59 || i.getMinutes() === parseInt(n, 10)) && (C.defaultSelect || J.data("changed") ? k.push("xdsoft_current") : C.initTime && k.push("xdsoft_init_time")), parseInt(v.getHours(), 10) === parseInt(t, 10) && parseInt(v.getMinutes(), 10) === parseInt(n, 10) && k.push("xdsoft_today"), T += '<div class="xdsoft_time ' + k.join(" ") + '" data-hour="' + t + '" data-minute="' + n + '">' + r.formatDate(s, C.formatTime) + "</div>";
          }, C.allowTimes && e.isArray(C.allowTimes) && C.allowTimes.length) for (y = 0; y < C.allowTimes.length; y += 1) {
            S = j.strtotime(C.allowTimes[y]).getHours(), l = j.strtotime(C.allowTimes[y]).getMinutes(), m(S, l);
          } else for (y = 0, t = 0; y < (C.hours12 ? 12 : 24); y += 1) {
            for (t = 0; 60 > t; t += C.step) {
              S = (10 > y ? "0" : "") + y, l = (10 > t ? "0" : "") + t, m(S, l);
            }
          }for (B.html(T), n = "", y = 0, y = parseInt(C.yearStart, 10) + C.yearOffset; y <= parseInt(C.yearEnd, 10) + C.yearOffset; y += 1) {
            n += '<div class="xdsoft_option ' + (j.currentTime.getFullYear() === y ? "xdsoft_current" : "") + '" data-value="' + y + '">' + y + "</div>";
          }for (U.children().eq(0).html(n), y = parseInt(C.monthStart, 10), n = ""; y <= parseInt(C.monthEnd, 10); y += 1) {
            n += '<div class="xdsoft_option ' + (j.currentTime.getMonth() === y ? "xdsoft_current" : "") + '" data-value="' + y + '">' + C.i18n[o].months[y] + "</div>";
          }G.children().eq(0).html(n), e(J).trigger("generate.xdsoft");
        }, 10), t.stopPropagation();
      }).on("afterOpen.xdsoft", function () {
        if (C.timepicker) {
          var e, t, a, r;B.find(".xdsoft_current").length ? e = ".xdsoft_current" : B.find(".xdsoft_init_time").length && (e = ".xdsoft_init_time"), e ? (t = R[0].clientHeight, a = B[0].offsetHeight, r = B.find(e).index() * C.timeHeightInTimePicker + 1, r > a - t && (r = a - t), R.trigger("scroll_element.xdsoft_scroller", [parseInt(r, 10) / (a - t)])) : R.trigger("scroll_element.xdsoft_scroller", [0]);
        }
      }), P = 0, L.on("touchend click.xdsoft", "td", function (t) {
        t.stopPropagation(), P += 1;var r = e(this),
            n = j.currentTime;return (void 0 === n || null === n) && (j.currentTime = j.now(), n = j.currentTime), r.hasClass("xdsoft_disabled") ? !1 : (n.setDate(1), n.setFullYear(r.data("year")), n.setMonth(r.data("month")), n.setDate(r.data("date")), J.trigger("select.xdsoft", [n]), a.val(j.str()), C.onSelectDate && e.isFunction(C.onSelectDate) && C.onSelectDate.call(J, j.currentTime, J.data("input"), t), J.data("changed", !0), J.trigger("xchange.xdsoft"), J.trigger("changedatetime.xdsoft"), (P > 1 || C.closeOnDateSelect === !0 || C.closeOnDateSelect === !1 && !C.timepicker) && !C.inline && J.trigger("close.xdsoft"), void setTimeout(function () {
          P = 0;
        }, 200));
      }), B.on("touchend click.xdsoft", "div", function (t) {
        t.stopPropagation();var a = e(this),
            r = j.currentTime;return (void 0 === r || null === r) && (j.currentTime = j.now(), r = j.currentTime), a.hasClass("xdsoft_disabled") ? !1 : (r.setHours(a.data("hour")), r.setMinutes(a.data("minute")), J.trigger("select.xdsoft", [r]), J.data("input").val(j.str()), C.onSelectTime && e.isFunction(C.onSelectTime) && C.onSelectTime.call(J, j.currentTime, J.data("input"), t), J.data("changed", !0), J.trigger("xchange.xdsoft"), J.trigger("changedatetime.xdsoft"), void (C.inline !== !0 && C.closeOnTimeSelect === !0 && J.trigger("close.xdsoft")));
      }), I.on("mousewheel.xdsoft", function (e) {
        return C.scrollMonth ? (e.deltaY < 0 ? j.nextMonth() : j.prevMonth(), !1) : !0;
      }), a.on("mousewheel.xdsoft", function (e) {
        return C.scrollInput ? !C.datepicker && C.timepicker ? (A = B.find(".xdsoft_current").length ? B.find(".xdsoft_current").eq(0).index() : 0, A + e.deltaY >= 0 && A + e.deltaY < B.children().length && (A += e.deltaY), B.children().eq(A).length && B.children().eq(A).trigger("mousedown"), !1) : C.datepicker && !C.timepicker ? (I.trigger(e, [e.deltaY, e.deltaX, e.deltaY]), a.val && a.val(j.str()), J.trigger("changedatetime.xdsoft"), !1) : void 0 : !0;
      }), J.on("changedatetime.xdsoft", function (t) {
        if (C.onChangeDateTime && e.isFunction(C.onChangeDateTime)) {
          var a = J.data("input");C.onChangeDateTime.call(J, j.currentTime, a, t), delete C.value, a.trigger("change");
        }
      }).on("generate.xdsoft", function () {
        C.onGenerate && e.isFunction(C.onGenerate) && C.onGenerate.call(J, j.currentTime, J.data("input")), q && (J.trigger("afterOpen.xdsoft"), q = !1);
      }).on("click.xdsoft", function (e) {
        e.stopPropagation();
      }), A = 0, H = function H(e, t) {
        do {
          if (e = e.parentNode, t(e) === !1) break;
        } while ("HTML" !== e.nodeName);
      }, Y = function Y() {
        var t, a, r, n, o, i, s, d, u, l, f, c, m;if (d = J.data("input"), t = d.offset(), a = d[0], l = "top", r = t.top + a.offsetHeight - 1, n = t.left, o = "absolute", u = e(window).width(), c = e(window).height(), m = e(window).scrollTop(), document.documentElement.clientWidth - t.left < I.parent().outerWidth(!0)) {
          var h = I.parent().outerWidth(!0) - a.offsetWidth;n -= h;
        }"rtl" === d.parent().css("direction") && (n -= J.outerWidth() - d.outerWidth()), C.fixed ? (r -= m, n -= e(window).scrollLeft(), o = "fixed") : (s = !1, H(a, function (e) {
          return "fixed" === window.getComputedStyle(e).getPropertyValue("position") ? (s = !0, !1) : void 0;
        }), s ? (o = "fixed", r + J.outerHeight() > c + m ? (l = "bottom", r = c + m - t.top) : r -= m) : r + a.offsetHeight > c + m && (r = t.top - a.offsetHeight + 1), 0 > r && (r = 0), n + a.offsetWidth > u && (n = u - a.offsetWidth)), i = J[0], H(i, function (e) {
          var t;return t = window.getComputedStyle(e).getPropertyValue("position"), "relative" === t && u >= e.offsetWidth ? (n -= (u - e.offsetWidth) / 2, !1) : void 0;
        }), f = { position: o, left: n, top: "", bottom: "" }, f[l] = r, J.css(f);
      }, J.on("open.xdsoft", function (t) {
        var a = !0;C.onShow && e.isFunction(C.onShow) && (a = C.onShow.call(J, j.currentTime, J.data("input"), t)), a !== !1 && (J.show(), Y(), e(window).off("resize.xdsoft", Y).on("resize.xdsoft", Y), C.closeOnWithoutClick && e([document.body, window]).on("touchstart mousedown.xdsoft", function r() {
          J.trigger("close.xdsoft"), e([document.body, window]).off("touchstart mousedown.xdsoft", r);
        }));
      }).on("close.xdsoft", function (t) {
        var a = !0;N.find(".xdsoft_month,.xdsoft_year").find(".xdsoft_select").hide(), C.onClose && e.isFunction(C.onClose) && (a = C.onClose.call(J, j.currentTime, J.data("input"), t)), a === !1 || C.opened || C.inline || J.hide(), t.stopPropagation();
      }).on("toggle.xdsoft", function () {
        J.trigger(J.is(":visible") ? "close.xdsoft" : "open.xdsoft");
      }).data("input", a), X = 0, J.data("xdsoft_datetime", j), J.setOptions(C), j.setCurrentTime(i()), a.data("xdsoft_datetimepicker", J).on("open.xdsoft focusin.xdsoft mousedown.xdsoft touchstart", function () {
        a.is(":disabled") || a.data("xdsoft_datetimepicker").is(":visible") && C.closeOnInputClick || (clearTimeout(X), X = setTimeout(function () {
          a.is(":disabled") || (q = !0, j.setCurrentTime(i(), !0), C.mask && s(C), J.trigger("open.xdsoft"));
        }, 100));
      }).on("keydown.xdsoft", function (t) {
        var a,
            r = t.which;return -1 !== [p].indexOf(r) && C.enterLikeTab ? (a = e("input:visible,textarea:visible,button:visible,a:visible"), J.trigger("close.xdsoft"), a.eq(a.index(this) + 1).focus(), !1) : -1 !== [T].indexOf(r) ? (J.trigger("close.xdsoft"), !0) : void 0;
      }).on("blur.xdsoft", function () {
        J.trigger("close.xdsoft");
      });
    }, d = function d(t) {
      var a = t.data("xdsoft_datetimepicker");a && (a.data("xdsoft_datetime", null), a.remove(), t.data("xdsoft_datetimepicker", null).off(".xdsoft"), e(window).off("resize.xdsoft"), e([window, document.body]).off("mousedown.xdsoft touchstart"), t.unmousewheel && t.unmousewheel());
    }, e(document).off("keydown.xdsoftctrl keyup.xdsoftctrl").on("keydown.xdsoftctrl", function (e) {
      e.keyCode === h && (F = !0);
    }).on("keyup.xdsoftctrl", function (e) {
      e.keyCode === h && (F = !1);
    }), this.each(function () {
      var t,
          a = e(this).data("xdsoft_datetimepicker");if (a) {
        if ("string" === e.type(n)) switch (n) {case "show":
            e(this).select().focus(), a.trigger("open.xdsoft");break;case "hide":
            a.trigger("close.xdsoft");break;case "toggle":
            a.trigger("toggle.xdsoft");break;case "destroy":
            d(e(this));break;case "reset":
            this.value = this.defaultValue, this.value && a.data("xdsoft_datetime").isValidDate(r.parseDate(this.value, C.format)) || a.data("changed", !1), a.data("xdsoft_datetime").setCurrentTime(this.value);break;case "validate":
            t = a.data("input"), t.trigger("blur.xdsoft");break;default:
            a[n] && e.isFunction(a[n]) && (u = a[n](i));} else a.setOptions(n);return 0;
      }"string" !== e.type(n) && (!C.lazyInit || C.open || C.inline ? s(e(this)) : A(e(this)));
    }), u;
  }, e.fn.datetimepicker.defaults = a;
}), function (e) {
  "function" == typeof define && define.amd ? define(["jquery"], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = e : e(jQuery);
}(function (e) {
  function t(t) {
    var i = t || window.event,
        s = d.call(arguments, 1),
        u = 0,
        f = 0,
        c = 0,
        m = 0,
        h = 0,
        g = 0;if (t = e.event.fix(i), t.type = "mousewheel", "detail" in i && (c = -1 * i.detail), "wheelDelta" in i && (c = i.wheelDelta), "wheelDeltaY" in i && (c = i.wheelDeltaY), "wheelDeltaX" in i && (f = -1 * i.wheelDeltaX), "axis" in i && i.axis === i.HORIZONTAL_AXIS && (f = -1 * c, c = 0), u = 0 === c ? f : c, "deltaY" in i && (c = -1 * i.deltaY, u = c), "deltaX" in i && (f = i.deltaX, 0 === c && (u = -1 * f)), 0 !== c || 0 !== f) {
      if (1 === i.deltaMode) {
        var p = e.data(this, "mousewheel-line-height");u *= p, c *= p, f *= p;
      } else if (2 === i.deltaMode) {
        var y = e.data(this, "mousewheel-page-height");u *= y, c *= y, f *= y;
      }if (m = Math.max(Math.abs(c), Math.abs(f)), (!o || o > m) && (o = m, r(i, m) && (o /= 40)), r(i, m) && (u /= 40, f /= 40, c /= 40), u = Math[u >= 1 ? "floor" : "ceil"](u / o), f = Math[f >= 1 ? "floor" : "ceil"](f / o), c = Math[c >= 1 ? "floor" : "ceil"](c / o), l.settings.normalizeOffset && this.getBoundingClientRect) {
        var v = this.getBoundingClientRect();h = t.clientX - v.left, g = t.clientY - v.top;
      }return t.deltaX = f, t.deltaY = c, t.deltaFactor = o, t.offsetX = h, t.offsetY = g, t.deltaMode = 0, s.unshift(t, u, f, c), n && clearTimeout(n), n = setTimeout(a, 200), (e.event.dispatch || e.event.handle).apply(this, s);
    }
  }function a() {
    o = null;
  }function r(e, t) {
    return l.settings.adjustOldDeltas && "mousewheel" === e.type && t % 120 === 0;
  }var n,
      o,
      i = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
      s = "onwheel" in document || document.documentMode >= 9 ? ["wheel"] : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
      d = Array.prototype.slice;if (e.event.fixHooks) for (var u = i.length; u;) {
    e.event.fixHooks[i[--u]] = e.event.mouseHooks;
  }var l = e.event.special.mousewheel = { version: "3.1.12", setup: function setup() {
      if (this.addEventListener) for (var a = s.length; a;) {
        this.addEventListener(s[--a], t, !1);
      } else this.onmousewheel = t;e.data(this, "mousewheel-line-height", l.getLineHeight(this)), e.data(this, "mousewheel-page-height", l.getPageHeight(this));
    }, teardown: function teardown() {
      if (this.removeEventListener) for (var a = s.length; a;) {
        this.removeEventListener(s[--a], t, !1);
      } else this.onmousewheel = null;e.removeData(this, "mousewheel-line-height"), e.removeData(this, "mousewheel-page-height");
    }, getLineHeight: function getLineHeight(t) {
      var a = e(t),
          r = a["offsetParent" in e.fn ? "offsetParent" : "parent"]();return r.length || (r = e("body")), parseInt(r.css("fontSize"), 10) || parseInt(a.css("fontSize"), 10) || 16;
    }, getPageHeight: function getPageHeight(t) {
      return e(t).height();
    }, settings: { adjustOldDeltas: !0, normalizeOffset: !0 } };e.fn.extend({ mousewheel: function mousewheel(e) {
      return e ? this.bind("mousewheel", e) : this.trigger("mousewheel");
    }, unmousewheel: function unmousewheel(e) {
      return this.unbind("mousewheel", e);
    } });
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (i) {
  "use strict";
  "function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery);
}(function (i) {
  "use strict";
  var e = window.Slick || {};(e = function () {
    var e = 0;return function (t, o) {
      var s,
          n = this;n.defaults = { accessibility: !0, adaptiveHeight: !1, appendArrows: i(t), appendDots: i(t), arrows: !0, asNavFor: null, prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>', nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>', autoplay: !1, autoplaySpeed: 3e3, centerMode: !1, centerPadding: "50px", cssEase: "ease", customPaging: function customPaging(e, t) {
          return i('<button type="button" />').text(t + 1);
        }, dots: !1, dotsClass: "slick-dots", draggable: !0, easing: "linear", edgeFriction: .35, fade: !1, focusOnSelect: !1, focusOnChange: !1, infinite: !0, initialSlide: 0, lazyLoad: "ondemand", mobileFirst: !1, pauseOnHover: !0, pauseOnFocus: !0, pauseOnDotsHover: !1, respondTo: "window", responsive: null, rows: 1, rtl: !1, slide: "", slidesPerRow: 1, slidesToShow: 1, slidesToScroll: 1, speed: 500, swipe: !0, swipeToSlide: !1, touchMove: !0, touchThreshold: 5, useCSS: !0, useTransform: !0, variableWidth: !1, vertical: !1, verticalSwiping: !1, waitForAnimate: !0, zIndex: 1e3 }, n.initials = { animating: !1, dragging: !1, autoPlayTimer: null, currentDirection: 0, currentLeft: null, currentSlide: 0, direction: 1, $dots: null, listWidth: null, listHeight: null, loadIndex: 0, $nextArrow: null, $prevArrow: null, scrolling: !1, slideCount: null, slideWidth: null, $slideTrack: null, $slides: null, sliding: !1, slideOffset: 0, swipeLeft: null, swiping: !1, $list: null, touchObject: {}, transformsEnabled: !1, unslicked: !1 }, i.extend(n, n.initials), n.activeBreakpoint = null, n.animType = null, n.animProp = null, n.breakpoints = [], n.breakpointSettings = [], n.cssTransitions = !1, n.focussed = !1, n.interrupted = !1, n.hidden = "hidden", n.paused = !0, n.positionProp = null, n.respondTo = null, n.rowCount = 1, n.shouldClick = !0, n.$slider = i(t), n.$slidesCache = null, n.transformType = null, n.transitionType = null, n.visibilityChange = "visibilitychange", n.windowWidth = 0, n.windowTimer = null, s = i(t).data("slick") || {}, n.options = i.extend({}, n.defaults, o, s), n.currentSlide = n.options.initialSlide, n.originalSettings = n.options, void 0 !== document.mozHidden ? (n.hidden = "mozHidden", n.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (n.hidden = "webkitHidden", n.visibilityChange = "webkitvisibilitychange"), n.autoPlay = i.proxy(n.autoPlay, n), n.autoPlayClear = i.proxy(n.autoPlayClear, n), n.autoPlayIterator = i.proxy(n.autoPlayIterator, n), n.changeSlide = i.proxy(n.changeSlide, n), n.clickHandler = i.proxy(n.clickHandler, n), n.selectHandler = i.proxy(n.selectHandler, n), n.setPosition = i.proxy(n.setPosition, n), n.swipeHandler = i.proxy(n.swipeHandler, n), n.dragHandler = i.proxy(n.dragHandler, n), n.keyHandler = i.proxy(n.keyHandler, n), n.instanceUid = e++, n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, n.registerBreakpoints(), n.init(!0);
    };
  }()).prototype.activateADA = function () {
    this.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
  }, e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
    var s = this;if ("boolean" == typeof t) o = t, t = null;else if (t < 0 || t >= s.slideCount) return !1;s.unload(), "number" == typeof t ? 0 === t && 0 === s.$slides.length ? i(e).appendTo(s.$slideTrack) : o ? i(e).insertBefore(s.$slides.eq(t)) : i(e).insertAfter(s.$slides.eq(t)) : !0 === o ? i(e).prependTo(s.$slideTrack) : i(e).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function (e, t) {
      i(t).attr("data-slick-index", e);
    }), s.$slidesCache = s.$slides, s.reinit();
  }, e.prototype.animateHeight = function () {
    var i = this;if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({ height: e }, i.options.speed);
    }
  }, e.prototype.animateSlide = function (e, t) {
    var o = {},
        s = this;s.animateHeight(), !0 === s.options.rtl && !1 === s.options.vertical && (e = -e), !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({ left: e }, s.options.speed, s.options.easing, t) : s.$slideTrack.animate({ top: e }, s.options.speed, s.options.easing, t) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft), i({ animStart: s.currentLeft }).animate({ animStart: e }, { duration: s.options.speed, easing: s.options.easing, step: function step(i) {
        i = Math.ceil(i), !1 === s.options.vertical ? (o[s.animType] = "translate(" + i + "px, 0px)", s.$slideTrack.css(o)) : (o[s.animType] = "translate(0px," + i + "px)", s.$slideTrack.css(o));
      }, complete: function complete() {
        t && t.call();
      } })) : (s.applyTransition(), e = Math.ceil(e), !1 === s.options.vertical ? o[s.animType] = "translate3d(" + e + "px, 0px, 0px)" : o[s.animType] = "translate3d(0px," + e + "px, 0px)", s.$slideTrack.css(o), t && setTimeout(function () {
      s.disableTransition(), t.call();
    }, s.options.speed));
  }, e.prototype.getNavTarget = function () {
    var e = this,
        t = e.options.asNavFor;return t && null !== t && (t = i(t).not(e.$slider)), t;
  }, e.prototype.asNavFor = function (e) {
    var t = this.getNavTarget();null !== t && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t.each(function () {
      var t = i(this).slick("getSlick");t.unslicked || t.slideHandler(e, !0);
    });
  }, e.prototype.applyTransition = function (i) {
    var e = this,
        t = {};!1 === e.options.fade ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.autoPlay = function () {
    var i = this;i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed));
  }, e.prototype.autoPlayClear = function () {
    var i = this;i.autoPlayTimer && clearInterval(i.autoPlayTimer);
  }, e.prototype.autoPlayIterator = function () {
    var i = this,
        e = i.currentSlide + i.options.slidesToScroll;i.paused || i.interrupted || i.focussed || (!1 === i.options.infinite && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 == 0 && (i.direction = 1))), i.slideHandler(e));
  }, e.prototype.buildArrows = function () {
    var e = this;!0 === e.options.arrows && (e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
  }, e.prototype.buildDots = function () {
    var e,
        t,
        o = this;if (!0 === o.options.dots) {
      for (o.$slider.addClass("slick-dotted"), t = i("<ul />").addClass(o.options.dotsClass), e = 0; e <= o.getDotCount(); e += 1) {
        t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
      }o.$dots = t.appendTo(o.options.appendDots), o.$dots.find("li").first().addClass("slick-active");
    }
  }, e.prototype.buildOut = function () {
    var e = this;e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function (e, t) {
      i(t).attr("data-slick-index", e).data("originalStyling", i(t).attr("style") || "");
    }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? i('<div class="slick-track"/>').appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track"/>').parent(), e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1), i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable");
  }, e.prototype.buildRows = function () {
    var i,
        e,
        t,
        o,
        s,
        n,
        r,
        l = this;if (o = document.createDocumentFragment(), n = l.$slider.children(), l.options.rows > 1) {
      for (r = l.options.slidesPerRow * l.options.rows, s = Math.ceil(n.length / r), i = 0; i < s; i++) {
        var d = document.createElement("div");for (e = 0; e < l.options.rows; e++) {
          var a = document.createElement("div");for (t = 0; t < l.options.slidesPerRow; t++) {
            var c = i * r + (e * l.options.slidesPerRow + t);n.get(c) && a.appendChild(n.get(c));
          }d.appendChild(a);
        }o.appendChild(d);
      }l.$slider.empty().append(o), l.$slider.children().children().children().css({ width: 100 / l.options.slidesPerRow + "%", display: "inline-block" });
    }
  }, e.prototype.checkResponsive = function (e, t) {
    var o,
        s,
        n,
        r = this,
        l = !1,
        d = r.$slider.width(),
        a = window.innerWidth || i(window).width();if ("window" === r.respondTo ? n = a : "slider" === r.respondTo ? n = d : "min" === r.respondTo && (n = Math.min(a, d)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
      s = null;for (o in r.breakpoints) {
        r.breakpoints.hasOwnProperty(o) && (!1 === r.originalSettings.mobileFirst ? n < r.breakpoints[o] && (s = r.breakpoints[o]) : n > r.breakpoints[o] && (s = r.breakpoints[o]));
      }null !== s ? null !== r.activeBreakpoint ? (s !== r.activeBreakpoint || t) && (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : (r.activeBreakpoint = s, "unslick" === r.breakpointSettings[s] ? r.unslick(s) : (r.options = i.extend({}, r.originalSettings, r.breakpointSettings[s]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), l = s) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e), l = s), e || !1 === l || r.$slider.trigger("breakpoint", [r, l]);
    }
  }, e.prototype.changeSlide = function (e, t) {
    var o,
        s,
        n,
        r = this,
        l = i(e.currentTarget);switch (l.is("a") && e.preventDefault(), l.is("li") || (l = l.closest("li")), n = r.slideCount % r.options.slidesToScroll != 0, o = n ? 0 : (r.slideCount - r.currentSlide) % r.options.slidesToScroll, e.data.message) {case "previous":
        s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide - s, !1, t);break;case "next":
        s = 0 === o ? r.options.slidesToScroll : o, r.slideCount > r.options.slidesToShow && r.slideHandler(r.currentSlide + s, !1, t);break;case "index":
        var d = 0 === e.data.index ? 0 : e.data.index || l.index() * r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d), !1, t), l.children().trigger("focus");break;default:
        return;}
  }, e.prototype.checkNavigable = function (i) {
    var e, t;if (e = this.getNavigableIndexes(), t = 0, i > e[e.length - 1]) i = e[e.length - 1];else for (var o in e) {
      if (i < e[o]) {
        i = t;break;
      }t = e[o];
    }return i;
  }, e.prototype.cleanUpEvents = function () {
    var e = this;e.options.dots && null !== e.$dots && (i("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", i.proxy(e.interrupt, e, !0)).off("mouseleave.slick", i.proxy(e.interrupt, e, !1)), !0 === e.options.accessibility && e.$dots.off("keydown.slick", e.keyHandler)), e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler), e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), i(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().off("click.slick", e.selectHandler), i(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), i(window).off("resize.slick.slick-" + e.instanceUid, e.resize), i("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
  }, e.prototype.cleanUpSlideEvents = function () {
    var e = this;e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
  }, e.prototype.cleanUpRows = function () {
    var i,
        e = this;e.options.rows > 1 && ((i = e.$slides.children().children()).removeAttr("style"), e.$slider.empty().append(i));
  }, e.prototype.clickHandler = function (i) {
    !1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
  }, e.prototype.destroy = function (e) {
    var t = this;t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), i(".slick-cloned", t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function () {
      i(this).attr("style", i(this).data("originalStyling"));
    }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass("slick-slider"), t.$slider.removeClass("slick-initialized"), t.$slider.removeClass("slick-dotted"), t.unslicked = !0, e || t.$slider.trigger("destroy", [t]);
  }, e.prototype.disableTransition = function (i) {
    var e = this,
        t = {};t[e.transitionType] = "", !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
  }, e.prototype.fadeSlide = function (i, e) {
    var t = this;!1 === t.cssTransitions ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }), t.$slides.eq(i).animate({ opacity: 1 }, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }), e && setTimeout(function () {
      t.disableTransition(i), e.call();
    }, t.options.speed));
  }, e.prototype.fadeSlideOut = function (i) {
    var e = this;!1 === e.cssTransitions ? e.$slides.eq(i).animate({ opacity: 0, zIndex: e.options.zIndex - 2 }, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
  }, e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
    var e = this;null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit());
  }, e.prototype.focusHandler = function () {
    var e = this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function (t) {
      t.stopImmediatePropagation();var o = i(this);setTimeout(function () {
        e.options.pauseOnFocus && (e.focussed = o.is(":focus"), e.autoPlay());
      }, 0);
    });
  }, e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
    return this.currentSlide;
  }, e.prototype.getDotCount = function () {
    var i = this,
        e = 0,
        t = 0,
        o = 0;if (!0 === i.options.infinite) {
      if (i.slideCount <= i.options.slidesToShow) ++o;else for (; e < i.slideCount;) {
        ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
      }
    } else if (!0 === i.options.centerMode) o = i.slideCount;else if (i.options.asNavFor) for (; e < i.slideCount;) {
      ++o, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
    } else o = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);return o - 1;
  }, e.prototype.getLeft = function (i) {
    var e,
        t,
        o,
        s,
        n = this,
        r = 0;return n.slideOffset = 0, t = n.$slides.first().outerHeight(!0), !0 === n.options.infinite ? (n.slideCount > n.options.slidesToShow && (n.slideOffset = n.slideWidth * n.options.slidesToShow * -1, s = -1, !0 === n.options.vertical && !0 === n.options.centerMode && (2 === n.options.slidesToShow ? s = -1.5 : 1 === n.options.slidesToShow && (s = -2)), r = t * n.options.slidesToShow * s), n.slideCount % n.options.slidesToScroll != 0 && i + n.options.slidesToScroll > n.slideCount && n.slideCount > n.options.slidesToShow && (i > n.slideCount ? (n.slideOffset = (n.options.slidesToShow - (i - n.slideCount)) * n.slideWidth * -1, r = (n.options.slidesToShow - (i - n.slideCount)) * t * -1) : (n.slideOffset = n.slideCount % n.options.slidesToScroll * n.slideWidth * -1, r = n.slideCount % n.options.slidesToScroll * t * -1))) : i + n.options.slidesToShow > n.slideCount && (n.slideOffset = (i + n.options.slidesToShow - n.slideCount) * n.slideWidth, r = (i + n.options.slidesToShow - n.slideCount) * t), n.slideCount <= n.options.slidesToShow && (n.slideOffset = 0, r = 0), !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow ? n.slideOffset = n.slideWidth * Math.floor(n.options.slidesToShow) / 2 - n.slideWidth * n.slideCount / 2 : !0 === n.options.centerMode && !0 === n.options.infinite ? n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2) - n.slideWidth : !0 === n.options.centerMode && (n.slideOffset = 0, n.slideOffset += n.slideWidth * Math.floor(n.options.slidesToShow / 2)), e = !1 === n.options.vertical ? i * n.slideWidth * -1 + n.slideOffset : i * t * -1 + r, !0 === n.options.variableWidth && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, !0 === n.options.centerMode && (o = n.slideCount <= n.options.slidesToShow || !1 === n.options.infinite ? n.$slideTrack.children(".slick-slide").eq(i) : n.$slideTrack.children(".slick-slide").eq(i + n.options.slidesToShow + 1), e = !0 === n.options.rtl ? o[0] ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, e += (n.$list.width() - o.outerWidth()) / 2)), e;
  }, e.prototype.getOption = e.prototype.slickGetOption = function (i) {
    return this.options[i];
  }, e.prototype.getNavigableIndexes = function () {
    var i,
        e = this,
        t = 0,
        o = 0,
        s = [];for (!1 === e.options.infinite ? i = e.slideCount : (t = -1 * e.options.slidesToScroll, o = -1 * e.options.slidesToScroll, i = 2 * e.slideCount); t < i;) {
      s.push(t), t = o + e.options.slidesToScroll, o += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
    }return s;
  }, e.prototype.getSlick = function () {
    return this;
  }, e.prototype.getSlideCount = function () {
    var e,
        t,
        o = this;return t = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0, !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
      if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft) return e = n, !1;
    }), Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll;
  }, e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
    this.changeSlide({ data: { message: "index", index: parseInt(i) } }, e);
  }, e.prototype.init = function (e) {
    var t = this;i(t.$slider).hasClass("slick-initialized") || (i(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger("init", [t]), !0 === t.options.accessibility && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay());
  }, e.prototype.initADA = function () {
    var e = this,
        t = Math.ceil(e.slideCount / e.options.slidesToShow),
        o = e.getNavigableIndexes().filter(function (i) {
      return i >= 0 && i < e.slideCount;
    });e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }), null !== e.$dots && (e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) {
      var s = o.indexOf(t);i(this).attr({ role: "tabpanel", id: "slick-slide" + e.instanceUid + t, tabindex: -1 }), -1 !== s && i(this).attr({ "aria-describedby": "slick-slide-control" + e.instanceUid + s });
    }), e.$dots.attr("role", "tablist").find("li").each(function (s) {
      var n = o[s];i(this).attr({ role: "presentation" }), i(this).find("button").first().attr({ role: "tab", id: "slick-slide-control" + e.instanceUid + s, "aria-controls": "slick-slide" + e.instanceUid + n, "aria-label": s + 1 + " of " + t, "aria-selected": null, tabindex: "-1" });
    }).eq(e.currentSlide).find("button").attr({ "aria-selected": "true", tabindex: "0" }).end());for (var s = e.currentSlide, n = s + e.options.slidesToShow; s < n; s++) {
      e.$slides.eq(s).attr("tabindex", 0);
    }e.activateADA();
  }, e.prototype.initArrowEvents = function () {
    var i = this;!0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, i.changeSlide), !0 === i.options.accessibility && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler)));
  }, e.prototype.initDotEvents = function () {
    var e = this;!0 === e.options.dots && (i("li", e.$dots).on("click.slick", { message: "index" }, e.changeSlide), !0 === e.options.accessibility && e.$dots.on("keydown.slick", e.keyHandler)), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && i("li", e.$dots).on("mouseenter.slick", i.proxy(e.interrupt, e, !0)).on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
  }, e.prototype.initSlideEvents = function () {
    var e = this;e.options.pauseOnHover && (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)), e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
  }, e.prototype.initializeEvents = function () {
    var e = this;e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", { action: "start" }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", { action: "move" }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", { action: "end" }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), i(document).on(e.visibilityChange, i.proxy(e.visibility, e)), !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), i(window).on("orientationchange.slick.slick-" + e.instanceUid, i.proxy(e.orientationChange, e)), i(window).on("resize.slick.slick-" + e.instanceUid, i.proxy(e.resize, e)), i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), i(e.setPosition);
  }, e.prototype.initUI = function () {
    var i = this;!0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show();
  }, e.prototype.keyHandler = function (i) {
    var e = this;i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && !0 === e.options.accessibility ? e.changeSlide({ data: { message: !0 === e.options.rtl ? "next" : "previous" } }) : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({ data: { message: !0 === e.options.rtl ? "previous" : "next" } }));
  }, e.prototype.lazyLoad = function () {
    function e(e) {
      i("img[data-lazy]", e).each(function () {
        var e = i(this),
            t = i(this).attr("data-lazy"),
            o = i(this).attr("data-srcset"),
            s = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
            r = document.createElement("img");r.onload = function () {
          e.animate({ opacity: 0 }, 100, function () {
            o && (e.attr("srcset", o), s && e.attr("sizes", s)), e.attr("src", t).animate({ opacity: 1 }, 200, function () {
              e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");
            }), n.$slider.trigger("lazyLoaded", [n, e, t]);
          });
        }, r.onerror = function () {
          e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, e, t]);
        }, r.src = t;
      });
    }var t,
        o,
        s,
        n = this;if (!0 === n.options.centerMode ? !0 === n.options.infinite ? s = (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (o = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)), s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (o = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide, s = Math.ceil(o + n.options.slidesToShow), !0 === n.options.fade && (o > 0 && o--, s <= n.slideCount && s++)), t = n.$slider.find(".slick-slide").slice(o, s), "anticipated" === n.options.lazyLoad) for (var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0; a < n.options.slidesToScroll; a++) {
      r < 0 && (r = n.slideCount - 1), t = (t = t.add(d.eq(r))).add(d.eq(l)), r--, l++;
    }e(t), n.slideCount <= n.options.slidesToShow ? e(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? e(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && e(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow));
  }, e.prototype.loadSlider = function () {
    var i = this;i.setPosition(), i.$slideTrack.css({ opacity: 1 }), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
  }, e.prototype.next = e.prototype.slickNext = function () {
    this.changeSlide({ data: { message: "next" } });
  }, e.prototype.orientationChange = function () {
    var i = this;i.checkResponsive(), i.setPosition();
  }, e.prototype.pause = e.prototype.slickPause = function () {
    var i = this;i.autoPlayClear(), i.paused = !0;
  }, e.prototype.play = e.prototype.slickPlay = function () {
    var i = this;i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1;
  }, e.prototype.postSlide = function (e) {
    var t = this;t.unslicked || (t.$slider.trigger("afterChange", [t, e]), t.animating = !1, t.slideCount > t.options.slidesToShow && t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), !0 === t.options.accessibility && (t.initADA(), t.options.focusOnChange && i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()));
  }, e.prototype.prev = e.prototype.slickPrev = function () {
    this.changeSlide({ data: { message: "previous" } });
  }, e.prototype.preventDefault = function (i) {
    i.preventDefault();
  }, e.prototype.progressiveLazyLoad = function (e) {
    e = e || 1;var t,
        o,
        s,
        n,
        r,
        l = this,
        d = i("img[data-lazy]", l.$slider);d.length ? (t = d.first(), o = t.attr("data-lazy"), s = t.attr("data-srcset"), n = t.attr("data-sizes") || l.$slider.attr("data-sizes"), (r = document.createElement("img")).onload = function () {
      s && (t.attr("srcset", s), n && t.attr("sizes", n)), t.attr("src", o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === l.options.adaptiveHeight && l.setPosition(), l.$slider.trigger("lazyLoaded", [l, t, o]), l.progressiveLazyLoad();
    }, r.onerror = function () {
      e < 3 ? setTimeout(function () {
        l.progressiveLazyLoad(e + 1);
      }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), l.$slider.trigger("lazyLoadError", [l, t, o]), l.progressiveLazyLoad());
    }, r.src = o) : l.$slider.trigger("allImagesLoaded", [l]);
  }, e.prototype.refresh = function (e) {
    var t,
        o,
        s = this;o = s.slideCount - s.options.slidesToShow, !s.options.infinite && s.currentSlide > o && (s.currentSlide = o), s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0), t = s.currentSlide, s.destroy(!0), i.extend(s, s.initials, { currentSlide: t }), s.init(), e || s.changeSlide({ data: { message: "index", index: t } }, !1);
  }, e.prototype.registerBreakpoints = function () {
    var e,
        t,
        o,
        s = this,
        n = s.options.responsive || null;if ("array" === i.type(n) && n.length) {
      s.respondTo = s.options.respondTo || "window";for (e in n) {
        if (o = s.breakpoints.length - 1, n.hasOwnProperty(e)) {
          for (t = n[e].breakpoint; o >= 0;) {
            s.breakpoints[o] && s.breakpoints[o] === t && s.breakpoints.splice(o, 1), o--;
          }s.breakpoints.push(t), s.breakpointSettings[t] = n[e].settings;
        }
      }s.breakpoints.sort(function (i, e) {
        return s.options.mobileFirst ? i - e : e - i;
      });
    }
  }, e.prototype.reinit = function () {
    var e = this;e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && i(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e]);
  }, e.prototype.resize = function () {
    var e = this;i(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function () {
      e.windowWidth = i(window).width(), e.checkResponsive(), e.unslicked || e.setPosition();
    }, 50));
  }, e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
    var o = this;if (i = "boolean" == typeof i ? !0 === (e = i) ? 0 : o.slideCount - 1 : !0 === e ? --i : i, o.slideCount < 1 || i < 0 || i > o.slideCount - 1) return !1;o.unload(), !0 === t ? o.$slideTrack.children().remove() : o.$slideTrack.children(this.options.slide).eq(i).remove(), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slidesCache = o.$slides, o.reinit();
  }, e.prototype.setCSS = function (i) {
    var e,
        t,
        o = this,
        s = {};!0 === o.options.rtl && (i = -i), e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px", t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px", s[o.positionProp] = i, !1 === o.transformsEnabled ? o.$slideTrack.css(s) : (s = {}, !1 === o.cssTransitions ? (s[o.animType] = "translate(" + e + ", " + t + ")", o.$slideTrack.css(s)) : (s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)", o.$slideTrack.css(s)));
  }, e.prototype.setDimensions = function () {
    var i = this;!1 === i.options.vertical ? !0 === i.options.centerMode && i.$list.css({ padding: "0px " + i.options.centerPadding }) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), !0 === i.options.centerMode && i.$list.css({ padding: i.options.centerPadding + " 0px" })), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), !1 === i.options.vertical && !1 === i.options.variableWidth ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : !0 === i.options.variableWidth ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();!1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
  }, e.prototype.setFade = function () {
    var e,
        t = this;t.$slides.each(function (o, s) {
      e = t.slideWidth * o * -1, !0 === t.options.rtl ? i(s).css({ position: "relative", right: e, top: 0, zIndex: t.options.zIndex - 2, opacity: 0 }) : i(s).css({ position: "relative", left: e, top: 0, zIndex: t.options.zIndex - 2, opacity: 0 });
    }), t.$slides.eq(t.currentSlide).css({ zIndex: t.options.zIndex - 1, opacity: 1 });
  }, e.prototype.setHeight = function () {
    var i = this;if (1 === i.options.slidesToShow && !0 === i.options.adaptiveHeight && !1 === i.options.vertical) {
      var e = i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height", e);
    }
  }, e.prototype.setOption = e.prototype.slickSetOption = function () {
    var e,
        t,
        o,
        s,
        n,
        r = this,
        l = !1;if ("object" === i.type(arguments[0]) ? (o = arguments[0], l = arguments[1], n = "multiple") : "string" === i.type(arguments[0]) && (o = arguments[0], s = arguments[1], l = arguments[2], "responsive" === arguments[0] && "array" === i.type(arguments[1]) ? n = "responsive" : void 0 !== arguments[1] && (n = "single")), "single" === n) r.options[o] = s;else if ("multiple" === n) i.each(o, function (i, e) {
      r.options[i] = e;
    });else if ("responsive" === n) for (t in s) {
      if ("array" !== i.type(r.options.responsive)) r.options.responsive = [s[t]];else {
        for (e = r.options.responsive.length - 1; e >= 0;) {
          r.options.responsive[e].breakpoint === s[t].breakpoint && r.options.responsive.splice(e, 1), e--;
        }r.options.responsive.push(s[t]);
      }
    }l && (r.unload(), r.reinit());
  }, e.prototype.setPosition = function () {
    var i = this;i.setDimensions(), i.setHeight(), !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i]);
  }, e.prototype.setProps = function () {
    var i = this,
        e = document.body.style;i.positionProp = !0 === i.options.vertical ? "top" : "left", "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === i.options.useCSS && (i.cssTransitions = !0), i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = "OTransform", i.transformType = "-o-transform", i.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = "MozTransform", i.transformType = "-moz-transform", i.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = "webkitTransform", i.transformType = "-webkit-transform", i.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = "msTransform", i.transformType = "-ms-transform", i.transitionType = "msTransition", void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && !1 !== i.animType && (i.animType = "transform", i.transformType = "transform", i.transitionType = "transition"), i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType;
  }, e.prototype.setSlideClasses = function (i) {
    var e,
        t,
        o,
        s,
        n = this;if (t = n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), n.$slides.eq(i).addClass("slick-current"), !0 === n.options.centerMode) {
      var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;e = Math.floor(n.options.slidesToShow / 2), !0 === n.options.infinite && (i >= e && i <= n.slideCount - 1 - e ? n.$slides.slice(i - e + r, i + e + 1).addClass("slick-active").attr("aria-hidden", "false") : (o = n.options.slidesToShow + i, t.slice(o - e + 1 + r, o + e + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === i ? t.eq(t.length - 1 - n.options.slidesToShow).addClass("slick-center") : i === n.slideCount - 1 && t.eq(n.options.slidesToShow).addClass("slick-center")), n.$slides.eq(i).addClass("slick-center");
    } else i >= 0 && i <= n.slideCount - n.options.slidesToShow ? n.$slides.slice(i, i + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : t.length <= n.options.slidesToShow ? t.addClass("slick-active").attr("aria-hidden", "false") : (s = n.slideCount % n.options.slidesToShow, o = !0 === n.options.infinite ? n.options.slidesToShow + i : i, n.options.slidesToShow == n.options.slidesToScroll && n.slideCount - i < n.options.slidesToShow ? t.slice(o - (n.options.slidesToShow - s), o + s).addClass("slick-active").attr("aria-hidden", "false") : t.slice(o, o + n.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));"ondemand" !== n.options.lazyLoad && "anticipated" !== n.options.lazyLoad || n.lazyLoad();
  }, e.prototype.setupInfinite = function () {
    var e,
        t,
        o,
        s = this;if (!0 === s.options.fade && (s.options.centerMode = !1), !0 === s.options.infinite && !1 === s.options.fade && (t = null, s.slideCount > s.options.slidesToShow)) {
      for (o = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, e = s.slideCount; e > s.slideCount - o; e -= 1) {
        t = e - 1, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
      }for (e = 0; e < o + s.slideCount; e += 1) {
        t = e, i(s.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
      }s.$slideTrack.find(".slick-cloned").find("[id]").each(function () {
        i(this).attr("id", "");
      });
    }
  }, e.prototype.interrupt = function (i) {
    var e = this;i || e.autoPlay(), e.interrupted = i;
  }, e.prototype.selectHandler = function (e) {
    var t = this,
        o = i(e.target).is(".slick-slide") ? i(e.target) : i(e.target).parents(".slick-slide"),
        s = parseInt(o.attr("data-slick-index"));s || (s = 0), t.slideCount <= t.options.slidesToShow ? t.slideHandler(s, !1, !0) : t.slideHandler(s);
  }, e.prototype.slideHandler = function (i, e, t) {
    var o,
        s,
        n,
        r,
        l,
        d = null,
        a = this;if (e = e || !1, !(!0 === a.animating && !0 === a.options.waitForAnimate || !0 === a.options.fade && a.currentSlide === i)) if (!1 === e && a.asNavFor(i), o = i, d = a.getLeft(o), r = a.getLeft(a.currentSlide), a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft, !1 === a.options.infinite && !1 === a.options.centerMode && (i < 0 || i > a.getDotCount() * a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o));else if (!1 === a.options.infinite && !0 === a.options.centerMode && (i < 0 || i > a.slideCount - a.options.slidesToScroll)) !1 === a.options.fade && (o = a.currentSlide, !0 !== t ? a.animateSlide(r, function () {
      a.postSlide(o);
    }) : a.postSlide(o));else {
      if (a.options.autoplay && clearInterval(a.autoPlayTimer), s = o < 0 ? a.slideCount % a.options.slidesToScroll != 0 ? a.slideCount - a.slideCount % a.options.slidesToScroll : a.slideCount + o : o >= a.slideCount ? a.slideCount % a.options.slidesToScroll != 0 ? 0 : o - a.slideCount : o, a.animating = !0, a.$slider.trigger("beforeChange", [a, a.currentSlide, s]), n = a.currentSlide, a.currentSlide = s, a.setSlideClasses(a.currentSlide), a.options.asNavFor && (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <= l.options.slidesToShow && l.setSlideClasses(a.currentSlide), a.updateDots(), a.updateArrows(), !0 === a.options.fade) return !0 !== t ? (a.fadeSlideOut(n), a.fadeSlide(s, function () {
        a.postSlide(s);
      })) : a.postSlide(s), void a.animateHeight();!0 !== t ? a.animateSlide(d, function () {
        a.postSlide(s);
      }) : a.postSlide(s);
    }
  }, e.prototype.startLoad = function () {
    var i = this;!0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass("slick-loading");
  }, e.prototype.swipeDirection = function () {
    var i,
        e,
        t,
        o,
        s = this;return i = s.touchObject.startX - s.touchObject.curX, e = s.touchObject.startY - s.touchObject.curY, t = Math.atan2(e, i), (o = Math.round(180 * t / Math.PI)) < 0 && (o = 360 - Math.abs(o)), o <= 45 && o >= 0 ? !1 === s.options.rtl ? "left" : "right" : o <= 360 && o >= 315 ? !1 === s.options.rtl ? "left" : "right" : o >= 135 && o <= 225 ? !1 === s.options.rtl ? "right" : "left" : !0 === s.options.verticalSwiping ? o >= 35 && o <= 135 ? "down" : "up" : "vertical";
  }, e.prototype.swipeEnd = function (i) {
    var e,
        t,
        o = this;if (o.dragging = !1, o.swiping = !1, o.scrolling) return o.scrolling = !1, !1;if (o.interrupted = !1, o.shouldClick = !(o.touchObject.swipeLength > 10), void 0 === o.touchObject.curX) return !1;if (!0 === o.touchObject.edgeHit && o.$slider.trigger("edge", [o, o.swipeDirection()]), o.touchObject.swipeLength >= o.touchObject.minSwipe) {
      switch (t = o.swipeDirection()) {case "left":case "down":
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide + o.getSlideCount()) : o.currentSlide + o.getSlideCount(), o.currentDirection = 0;break;case "right":case "up":
          e = o.options.swipeToSlide ? o.checkNavigable(o.currentSlide - o.getSlideCount()) : o.currentSlide - o.getSlideCount(), o.currentDirection = 1;}"vertical" != t && (o.slideHandler(e), o.touchObject = {}, o.$slider.trigger("swipe", [o, t]));
    } else o.touchObject.startX !== o.touchObject.curX && (o.slideHandler(o.currentSlide), o.touchObject = {});
  }, e.prototype.swipeHandler = function (i) {
    var e = this;if (!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))) switch (e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {case "start":
        e.swipeStart(i);break;case "move":
        e.swipeMove(i);break;case "end":
        e.swipeEnd(i);}
  }, e.prototype.swipeMove = function (i) {
    var e,
        t,
        o,
        s,
        n,
        r,
        l = this;return n = void 0 !== i.originalEvent ? i.originalEvent.touches : null, !(!l.dragging || l.scrolling || n && 1 !== n.length) && (e = l.getLeft(l.currentSlide), l.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX, l.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY, l.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))), !l.options.verticalSwiping && !l.swiping && r > 4 ? (l.scrolling = !0, !1) : (!0 === l.options.verticalSwiping && (l.touchObject.swipeLength = r), t = l.swipeDirection(), void 0 !== i.originalEvent && l.touchObject.swipeLength > 4 && (l.swiping = !0, i.preventDefault()), s = (!1 === l.options.rtl ? 1 : -1) * (l.touchObject.curX > l.touchObject.startX ? 1 : -1), !0 === l.options.verticalSwiping && (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1), o = l.touchObject.swipeLength, l.touchObject.edgeHit = !1, !1 === l.options.infinite && (0 === l.currentSlide && "right" === t || l.currentSlide >= l.getDotCount() && "left" === t) && (o = l.touchObject.swipeLength * l.options.edgeFriction, l.touchObject.edgeHit = !0), !1 === l.options.vertical ? l.swipeLeft = e + o * s : l.swipeLeft = e + o * (l.$list.height() / l.listWidth) * s, !0 === l.options.verticalSwiping && (l.swipeLeft = e + o * s), !0 !== l.options.fade && !1 !== l.options.touchMove && (!0 === l.animating ? (l.swipeLeft = null, !1) : void l.setCSS(l.swipeLeft))));
  }, e.prototype.swipeStart = function (i) {
    var e,
        t = this;if (t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow) return t.touchObject = {}, !1;void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, t.dragging = !0;
  }, e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
    var i = this;null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit());
  }, e.prototype.unload = function () {
    var e = this;i(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
  }, e.prototype.unslick = function (i) {
    var e = this;e.$slider.trigger("unslick", [e, i]), e.destroy();
  }, e.prototype.updateArrows = function () {
    var i = this;Math.floor(i.options.slidesToShow / 2), !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === i.currentSlide ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode ? (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
  }, e.prototype.updateDots = function () {
    var i = this;null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").end(), i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active"));
  }, e.prototype.visibility = function () {
    var i = this;i.options.autoplay && (document[i.hidden] ? i.interrupted = !0 : i.interrupted = !1);
  }, i.fn.slick = function () {
    var i,
        t,
        o = this,
        s = arguments[0],
        n = Array.prototype.slice.call(arguments, 1),
        r = o.length;for (i = 0; i < r; i++) {
      if ("object" == (typeof s === "undefined" ? "undefined" : _typeof(s)) || void 0 === s ? o[i].slick = new e(o[i], s) : t = o[i].slick[s].apply(o[i].slick, n), void 0 !== t) return t;
    }return o;
  };
});
(function ($, undefined) {

	'use strict';

	var win;
	var winWidth;
	var winHeight;
	var items;

	var autoScreenHeight = function autoScreenHeight() {
		items.each(function () {
			var t = $(this);
			var attr = t.data('autoScreenAttr') === undefined ? 'min-height' : t.attr('data-auto-screen-attr');
			var offset = t.data('autoScreenOffset') !== undefined ? t.data('autoScreenOffset').replace(/\s+/g, '').split(',') : 0;
			var factor = t.data('autoScreenFactor') !== undefined ? t.data('autoScreenFactor') : 1;
			var offsetHeight = 0;

			$.each(offset, function (i) {
				var t = $(offset[i]);
				offsetHeight += t.outerHeight();
			});

			var newHeight = winHeight * factor - offsetHeight;

			t.css(attr, newHeight);
		});
	};

	var init = function init() {
		win = $(window);
		winWidth = win.width();
		winHeight = win.height();
		items = $('.js-auto-screen-height');

		autoScreenHeight();

		win.resize(function () {
			winWidth = win.width();
			winHeight = win.height();

			autoScreenHeight();
		});
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function ($, undefined) {

	'use strict';

	var createSelects = function createSelects() {
		var selects = document.querySelectorAll('select.change-select-js');

		for (var i = 0; i < selects.length; i++) {
			var select = selects[i];
			var options = select.querySelectorAll('option');
			var parent = select.parentNode;
			var newSelect = document.createElement('div');
			var optionsContainer = document.createElement('div');
			var selectedValue = document.createElement('div');
			var optionsValues = '';

			for (var k = 0; k < select.attributes.length; k++) {
				var selectAttr = select.attributes[k];
				selectedValue.setAttribute(selectAttr.name, selectAttr.nodeValue || selectAttr.value);
			}

			newSelect.className = 'select-changed-js';

			optionsContainer.className = 'select-options-container';

			selectedValue.classList.remove('change-select-js');
			selectedValue.classList.add('select-value');
			selectedValue.setAttribute('tabindex', '0');

			for (var j = 0; j < options.length; j++) {
				var option = options[j];
				var newOption = document.createElement('div');
				var value = getValue(option);
				newOption.setAttribute('data-value', value);
				newOption.textContent = option.textContent;

				for (var l = 0; l < option.attributes.length; l++) {
					var optionAttr = option.attributes[l];
					newOption.setAttribute(optionAttr.name, optionAttr.nodeValue || optionAttr.value);
				}

				if (option.selected) {
					selectedValue.textContent = newOption.textContent;
					selectedValue.setAttribute('data-value', value);
					newOption.className = 'select-option selected hover';
					if (selectedValue.textContent.trim().length && value.trim().length) {
						parent.classList.add('has-value');
					}
				} else {
					newOption.className = 'select-option';
				}

				if (optionsValues.length) {
					optionsValues += '\n';
				}
				optionsValues += option.textContent;

				optionsContainer.appendChild(newOption);
			}

			newSelect.setAttribute('data-items', optionsValues);

			newSelect.appendChild(selectedValue);
			newSelect.appendChild(optionsContainer);
			parent.insertBefore(newSelect, select);
			parent.removeChild(select);

			setupListeners(newSelect, selectedValue, optionsContainer);
		}
	};

	var setupListeners = function setupListeners(newSelect, selectValue, optionsContainer) {
		var options = optionsContainer.querySelectorAll('.select-option');

		selectValue.addEventListener('mousedown', toggleOptionsContainer);
		newSelect.addEventListener('focusin', startListeningForKeys);
		newSelect.addEventListener('focusout', stopListeningForKeys);

		for (var i = 0; i < options.length; i++) {
			var option = options[i];
			option.addEventListener('mouseup', updateSelectedValue);
			option.addEventListener('mouseover', optionOver);
			option.addEventListener('mouseout', optionOver);
		}
	};

	var optionOver = function optionOver(e) {
		if (e.type === 'mouseout') {
			var target = document.elementFromPoint(e.clientX, e.clientY);
			if (target) {
				if (target.classList.contains('select-option')) {
					this.classList.remove('hover');
				}
			}
			this.removeEventListener('mousemove', optionOver);
		} else if (e.type === 'mouseover' || e.type === 'mousemove') {
			var hovered = getHovered(this.parentNode);

			if (e.type === 'mouseover' || hovered !== this) {
				hovered.classList.remove('hover');
				this.classList.add('hover');
			}

			if (e.type === 'mouseover') {
				this.addEventListener('mousemove', optionOver);
			}
		}
	};

	var startListeningForKeys = function startListeningForKeys() {
		window.addEventListener('keydown', selectKeydown);
		this.classList.add('select-focused');
	};

	var stopListeningForKeys = function stopListeningForKeys() {
		window.removeEventListener('keydown', selectKeydown);
		this.classList.remove('select-focused');
	};

	var selectKeydown = function selectKeydown(e) {
		var container = document.querySelector('.select-focused .select-options-container');
		var isOpened = container.classList.contains('show-options');
		var key = getKey(e.code || e.which);

		// Allows for other keys to work as they should
		if (key.isOneOfKeys || isOpened && !key.isOneOfKeys) {
			e.preventDefault();
			e.stopPropagation();

			if (key.code === 'Tab' || key.code === 9) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		}

		if (isOpened) {
			if (key.isEnter || key.isEscape) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		} else {
			if (key.isSpace) {
				toggleOptionsContainer.apply(container.previousElementSibling);
			}
		}

		if (key.isUp) {
			goToPrevValue(container, e);
		} else if (key.isDown) {
			goToNextValue(container, e);
		} else if (key.isKey) {
			goToNextKeyValue(container, e, key.code);
		}
	};

	var toggleOptionsContainer = function toggleOptionsContainer() {
		var options = this.nextElementSibling;
		var inputCtn = options;
		var currentHover = getHovered(options);
		var currentSelected = getSelected(options);

		var stop = false;
		while (!stop) {
			inputCtn = inputCtn.parentNode;

			if ((' ' + inputCtn.className + ' ').indexOf(' ' + 'form-input-big-ctn' + ' ') > -1) {
				stop = true;
			}
		}

		options.classList.toggle('show-options');
		inputCtn.classList.toggle('options-panel-open');

		if ((' ' + inputCtn.className + ' ').indexOf(' ' + 'required' + ' ') > -1) {
			inputCtn.classList.remove('error');
			inputCtn.classList.add('success');
		}

		currentHover.classList.remove('hover');
		currentSelected.classList.add('hover');

		if (options.classList.contains('show-options')) {
			setTimeout(function () {
				window.addEventListener('mousedown', closeToggled);
			}, 1);
		} else {
			window.removeEventListener('mousedown', closeToggled);
		}
	};

	var closeToggled = function closeToggled(e) {
		var classesRegex = /select-option|select-changed-js|select-value|select-options-container/;
		var target = e.target;
		var isSelect = false;
		if (e.target.className.match(classesRegex)) {
			if (target.classList.contains('select-focused')) {
				isSelect = true;
			} else {
				while (target) {
					if (target.classList.contains('select-focused')) {
						isSelect = true;
						break;
					} else if (!target.className.match(classesRegex)) {
						break;
					}
					target = target.parentNode;
				}
			}
		}

		if (!isSelect) {
			var containers = document.querySelectorAll('.show-options');
			for (var i = 0; i < containers.length; i++) {
				var option = containers[i];
				toggleOptionsContainer.apply(option.previousElementSibling);
			}
		}
	};

	var updateSelectedValue = function updateSelectedValue(e, fromKey) {
		var parent = this.parentNode;
		var select = parent.parentNode;
		var selectedValue = parent.previousElementSibling;
		var previousOption = getSelected(parent);
		var previousOver = getHovered(parent);
		var changeEvent;
		var inputCtn = select.parentNode;

		if (e) {
			if (typeof window.CustomEvent === 'function') {
				changeEvent = new CustomEvent('change', {
					originalEvent: e,
					type: 'change'
				});
			} else {
				changeEvent = document.createEvent('CustomEvent');
				changeEvent.initCustomEvent('change', true, true, {
					originalEvent: e,
					type: 'change'
				});
			}

			e.preventDefault();
		}

		previousOption.classList.remove('selected');
		this.classList.add('selected');

		selectedValue.setAttribute('data-value', this.getAttribute('data-value'));
		selectedValue.innerHTML = this.innerHTML;

		if (!fromKey && e) {
			toggleOptionsContainer.apply(selectedValue);
		} else {
			parent.scrollTop = this.offsetTop;
			previousOver.classList.remove('hover');
			this.classList.add('hover');
		}

		if (selectedValue.getAttribute('data-value').length || selectedValue.textContent.length) {
			inputCtn.classList.add('has-value');
		} else {
			inputCtn.classList.remove('has-value');
		}

		if (e) {
			if (selectedValue.dispatchEvent) {
				selectedValue.dispatchEvent(changeEvent);
			} else {
				selectedValue.fireEvent(changeEvent);
			}
		}
	};

	var goToPrevValue = function goToPrevValue(container, e) {
		var hover = getHovered(container);
		var prev = hover.previousElementSibling;

		if (prev) {
			updateSelectedValue.apply(prev, [e, true]);
		}
	};

	var goToNextValue = function goToNextValue(container, e) {
		var hover = getHovered(container);
		var next = hover.nextElementSibling;

		if (next) {
			updateSelectedValue.apply(next, [e, true]);
		}
	};

	var goToNextKeyValue = function goToNextKeyValue(container, e, key) {
		var hover = getHovered(container);
		var options = container.querySelectorAll('.select-option');
		var found = false;
		var isNumber = !isNaN(key);
		var keyReplaced = isNumber ? 'asdsadas' : key.replace(/Key|Digit/, '');
		var next = hover;

		for (var i = 0; i < options.length; i++) {
			next = next.nextElementSibling;

			if (!next) {
				next = container.children[0];
			}

			if (isNumber) {
				if (next.innerHTML.charCodeAt(0) === key) {
					found = true;
					break;
				}
			} else {
				if (next.innerHTML.charAt(0).toUpperCase() === keyReplaced) {
					found = true;
					break;
				}
			}
		}

		if (found) {
			updateSelectedValue.apply(next, [e, true]);
		}
	};

	var getValue = function getValue(option) {
		if (!option.hasAttribute('value')) {
			return option.textContent;
		} else {
			return option.getAttribute('value');
		}
	};

	var getKey = function getKey(key) {
		var data = {
			code: key,
			isEnter: false,
			isKey: false,
			isEscape: false,
			isSpace: false,
			isUp: false,
			isDown: false,
			isOneOfKeys: false,
			keyValue: undefined
		};
		var isNumber = key >= 48 && key <= 57;
		var isLetter = key >= 65 && key <= 90;

		if (key === 13 || key === 'Enter') {
			data.isEnter = true;
		} else if (key === 27 || key === 'Escape') {
			data.isEscape = true;
		} else if (key === 32 || key === ' ' || key === 'Space') {
			data.isSpace = true;
		} else if (key === 38 || key === 37 || key === 'ArrowLeft' || key === 'ArrowUp') {
			data.isUp = true;
		} else if (key === 40 || key === 39 || key === 'ArrowRight' || key === 'ArrowDown') {
			data.isDown = true;
		} else if (isNumber || isLetter || /[a-z0-9]{1}/i.test(key) && key.length === 1 || /(Key[A-Z])|(Digit[0-9])/.test(key)) {
			data.isKey = true;

			if (isNumber || isLetter) {
				data.keyValue = String.fromCharCode(key);
			} else {
				data.keyValue = key;
			}
		}

		if (data.isEnter || data.isEscape || data.isSpace || data.isUp || data.isDown || data.isKey) {
			data.isOneOfKeys = true;
		}

		return data;
	};

	var getHovered = function getHovered(container) {
		var hover = container.querySelector('.hover');

		if (!hover) {
			hover = container.querySelector('.select-option');
		}

		return hover;
	};

	var getSelected = function getSelected(container) {
		var selected = container.querySelector('.selected');

		if (!selected) {
			selected = container.querySelector('.select-option');
		}

		return selected;
	};

	var getSelectValue = function getSelectValue(selectCtn) {
		var selectItem;
		if (typeof selectCtn === 'string') {
			selectItem = document.querySelector(selectCtn);
			if (!selectItem) {
				return null;
			}
		} else if ((typeof selectCtn === 'undefined' ? 'undefined' : _typeof(selectCtn)) === 'object') {
			if (selectCtn[0]) {
				selectItem = selectCtn[0];
			} else {
				return null;
			}
		} else if (selectCtn && selectCtn.nodeType) {
			selectItem = selectCtn;
		} else {
			return null;
		}

		try {
			return selectItem.querySelector('.select-value').getAttribute('data-value');
		} catch (ex) {
			console.error(ex);
			return null;
		}
	};

	var setSelectValue = function setSelectValue(selectCtn, optionSel) {
		var optionToSelect = selectCtn.querySelector(optionSel);
		updateSelectedValue.apply(optionToSelect, [null, false]);
	};

	$(document).ready(function () {
		createSelects();
	});

	Fw.component.export('customSelect', {
		val: getSelectValue,
		setupListeners: setupListeners,
		setSelectValue: setSelectValue
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var init = function init() {
		if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
			$('html').addClass('mobile');
		}
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var checkForExplorerDownload = function checkForExplorerDownload() {
		//If IE11
		if (!!window.MSInputMethodContext && !!document.documentMode) {
			$('[download]').removeAttr('download').attr('target', '_blank');
		}
	};

	var init = function init() {
		checkForExplorerDownload();
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var editableText;

	var moveEditableText = function moveEditableText() {
		var text = $('.editable-text-ctn');

		text.each(function () {
			var t = $(this);
			var ctn = t.parent('.js-editable-container');
			var pos;
			var receiver;

			if (t.attr('data-position') !== 0) {
				pos = t.attr('data-position');
			} else {
				pos = 1;
			}

			if ($('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn).length !== 0) {
				receiver = $('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn);
			} else {
				receiver = $('.js-editable-receiver', ctn);
			}

			if ($('.js-editable-receiver[data-editable-receiver-position]', ctn).length !== 0 && $('.js-editable-receiver[data-editable-receiver-position = ' + pos + ']', ctn).length === 0 && t.attr('data-position') !== '') {
				t.remove();
			} else if (ctn.length !== 0 && receiver.length !== 0) {
				t.detach().appendTo(receiver);
			}
		});
	};

	var addEditableTextClass = function addEditableTextClass() {
		$('.componentContainerDiv').addClass('js-editable-container');

		editableText.each(function () {
			var t = $(this);
			var parent = t.parent();

			parent.addClass('editable-text-ctn');
		});
	};

	var addEditableTextPosition = function addEditableTextPosition() {
		$('.js-editable-container').each(function () {
			var index = 1;
			var t = $(this);

			$('.editable-text-ctn', t).each(function () {
				var t = $(this);

				t.attr('data-position', index);

				index++;
			});
		});
	};

	var init = function init() {
		editableText = $('div[id^=displayTextInnerWindow]');

		addEditableTextClass();
		addEditableTextPosition();
		moveEditableText();
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var addExternalLinkTarget = function addExternalLinkTarget() {
		$.expr[':'].external = function (obj) {
			var hostname = obj.hostname === '' ? location.hostname : obj.hostname;

			return !obj.href.match(/^mailto\:/) && hostname != location.hostname && !obj.href.match(/^javascript\:/) && !obj.href.match(/^tel\:/) && !obj.href.match(/^$/) || obj.href.match(/\.pdf$/);
		};

		$('a:external').attr('target', '_blank');
	};

	var init = function init() {
		addExternalLinkTarget();
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var isLoggedIn = false;
	var isMobile = false;
	var win = $(window);
	var winWidth;
	var winHeight;

	var header;
	var navItems;

	var toggleMenuBtn;
	var headerHeight;
	var addContentMargin = !$('body').hasClass('minified-header-footer');

	var toggleScroll = function toggleScroll() {
		if ($('html').hasClass('no-scroll')) {
			removeScroll();
		} else {
			addScroll();
		}
	};

	var addScroll = function addScroll() {
		$('html').removeClass('no-scroll');
		changeScrollDiff(0);
	};

	var removeScroll = function removeScroll() {
		var w1 = win.width();
		$('html').addClass('no-scroll');
		var w2 = win.width();
		changeScrollDiff(w2 - w1);
	};

	var changeScrollDiff = function changeScrollDiff(diff) {
		$('.js-scroll-padding').css('padding-right', diff + 'px');
		$('.js-scroll-right').css('right', diff + 'px');
	};

	var onClickMenuToggle = function onClickMenuToggle() {
		if (!!$('body').hasClass('menu-open')) {
			var transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';
			$('body').removeClass('menu-open');

			header.on(transitionEnd, function (e) {
				$('html').removeClass('no-scroll');
				changeScrollDiff(0);
				$(this).off(e);
			});
		} else {
			var target = 0;

			if ($('.site-header').css('scroll-y') !== 'fixed' && $('.site-header').offset().top > 0) {
				target = $('.site-header').offset().top;
			}

			if (win.scrollTop() <= $('.site-header').offset().top) {
				$('html').animate({ scrollTop: target }, 300);
				$('body').animate({ scrollTop: target }, 300, function () {
					openMenu();
				});
			} else {
				openMenu();
			}
		}
	};

	var openMenu = function openMenu() {
		$('body').addClass('menu-open');
		toggleScroll();
	};

	var closeMenu = function closeMenu() {
		if ($('body').hasClass('menu-open')) {
			$('body').removeClass('menu-open');
			toggleScroll();
		}
	};

	var updateNavSelected = function updateNavSelected(page) {
		navItems.removeClass('selected');
		var handleObj = $('.main-content ' + page);
		var handle = handleObj.attr('data-page-nav');

		navItems.each(function () {
			var t = $(this);

			if (t.data('pageNav') === handle) {
				t.addClass('selected');
			}
		});
	};

	var updateMainContentMargin = function updateMainContentMargin(checkHeight) {
		if (checkHeight) {
			var height = $('.site-header').height();
			headerHeight = height;
		}

		var searchHeight = 62;

		if ($('.resp-detector-ph').css('visibility') === 'visible') {
			searchHeight = 46;
		}

		var newHeight = headerHeight;
		if ($('body').hasClass('search-open')) {
			newHeight = headerHeight + searchHeight;
		}

		$('.main-content').css('margin-top', newHeight + 'px');
		$('.demo-player-popup').css('top', newHeight + 10 + 'px');
	};

	var toggleSearch = function toggleSearch() {
		$('body').toggleClass('search-open');
		$('.site-header-bottom-inner.search').slideToggle(function () {
			$('.header-search-input').focus();
		});
		if (addContentMargin) {
			updateMainContentMargin(false);
		}
	};

	var toggleUserDesktopMenu = function toggleUserDesktopMenu() {
		var ctn = $('.whole-container');

		if (ctn.hasClass('pushed')) {
			removeDesktopMenu();
		} else {
			ctn.addClass('pushed');
			setTimeout(function () {
				$(document).on('click', outsideClickMenu);
			}, 200);
		}
	};

	var removeDesktopMenu = function removeDesktopMenu() {
		$('.whole-container').removeClass('pushed');
		$(document).off('click', outsideClickMenu);
	};

	var outsideClickMenu = function outsideClickMenu() {
		if (!$(event.target).closest('.pushed-user-menu-ctn').length && !$(event.target).closest('.popover').length && !$(event.target).closest('.tour-backdrop').length) {
			removeDesktopMenu();
		}
	};

	var showLeftMenu = function showLeftMenu() {
		$('.mobile-side-menu.left').toggleClass('open');
		onClickMenuToggle();
	};

	var showRightMenu = function showRightMenu() {
		$('.mobile-side-menu.right').toggleClass('open');
		onClickMenuToggle();
	};

	var toggleLoginPopover = function toggleLoginPopover() {
		$('.login-popover-mobile').toggleClass('open');
	};

	var closeSideMenus = function closeSideMenus() {
		$('.mobile-side-menu').removeClass('open');
		$('html').removeClass('no-scroll');
	};

	var headerScroll = function headerScroll() {
		if (window.pageYOffset !== 0) {
			$('.site-header').addClass('scrolled');
		} else {
			$('.site-header').removeClass('scrolled');
		}
	};

	var toggleHeaderPreview = function toggleHeaderPreview() {
		var t = $(this);
		var id = t.attr('data-id');
		var previewCtn = $('.header-preview-ctn[data-id=' + id + ']');
		var delay = 0;

		$('.header-preview-ctn.open').each(function () {
			if ($(this).attr('data-id') !== id) {
				delay = 300;
				$(this).slideUp();
				$(this).removeClass('open');
			}
		});

		setTimeout(function () {
			previewCtn.slideToggle();
			previewCtn.toggleClass('open');
		}, delay);
	};

	var closeHeaderPreview = function closeHeaderPreview() {
		var t = $(this);

		t.closest('.header-preview-ctn').slideUp();
	};

	var toggleSubNav = function toggleSubNav() {
		$(this).hasClass('subnav-open') ? $(this).removeClass('subnav-open') : $(this).addClass('subnav-open');

		if ($('.resp-detector-sm').css('visibility') === 'visible') {
			$(this).find('.sub-nav-ctn').slideToggle();
		}
	};

	var init = function init() {
		winWidth = win.width();
		winHeight = win.height();
		$('html').removeClass('no-scroll');

		header = $('.site-header');
		navItems = $('.nav-item-link', header);

		toggleMenuBtn = $('.site-header-menu-toggle-btn', header);

		if (!(navigator.userAgent.includes("Chrome") || navigator.userAgent.includes("Firefox"))) {
			$('.site-browser-notice-ctn').removeClass('hide');
		}

		$('.header-search-btn:not(.header-search-input-icon)').click(toggleSearch);
		$('.header-account-btn').click(toggleUserDesktopMenu);

		if ($('body').hasClass('is-logged-in')) {
			isLoggedIn = true;
		}

		toggleMenuBtn.click(showLeftMenu);
		$('.header-account-responsive-btn:not(.show-login)').click(showRightMenu);
		$('.header-account-responsive-btn.show-login').click(toggleLoginPopover);
		$('.side-menu-overlay').click(closeSideMenus);
		$('.nav-item-link:not(.has-subnav)').on('click', closeSideMenus);
		$('.open-header-preview-btn').click(toggleHeaderPreview);
		$('.close-header-preview-btn').click(closeHeaderPreview);
		$('.nav-item-link.has-subnav').click(toggleSubNav);

		if (addContentMargin) {
			updateMainContentMargin(true);

			setTimeout(function () {
				$('html').animate({ scrollTop: 0 });
				$('body').animate({ scrollTop: 0 });
			}, 300);
		}

		if (!addContentMargin) {
			win.scroll(function () {
				headerScroll();
			});
			headerScroll();
		}

		win.resize(function () {
			if (win.width() != winWidth) {
				winHeight = win.height();
				winWidth = win.width();
				$('.whole-container').removeClass('pushed');
				$('.login-popover-mobile').removeClass('open');
				closeSideMenus();
				$('html').removeClass('no-scroll');
				if ($('body').hasClass('search-open')) {
					toggleSearch();
					setTimeout(function () {
						if (addContentMargin) {
							updateMainContentMargin(true);
						}
					}, 400);
				}
				if (addContentMargin) {
					updateMainContentMargin(true);
				}
			}
		});

		if ($('.has-processing, .processing-loader').length > 0) {
			$('.has-processing, .processing-loader').attr('data-processing-content', $('body').attr('data-processing'));
		}
	};

	$(init);

	Fw.modules.export('header', {
		removeScroll: removeScroll,
		addScroll: addScroll
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var init = function init() {
		$('.notifications-page .single-notification.highlight').on('click', onSetNotificationAsRead);
	};

	var onSetNotificationAsRead = function onSetNotificationAsRead(e) {
		e.preventDefault();
		var btn = $(this);
		setNotificationAsRead(btn.attr('data-id'), function (response) {
			if (response.indexOf('success') !== -1) {
				btn.removeClass("highlight");
				btn.unbind();
				updateHeaderCounter();
			}
		});
	};

	var updateHeaderCounter = function updateHeaderCounter() {
		var icon = $(".header-icon-link");
		if (icon.length !== 0) {
			icon.each(function () {
				var i = $(this).find(".notification-count");
				var nbr = i.text();
				var newNbr = parseInt(nbr) - 1;
				i.empty();
				i.text(newNbr);
				if (newNbr === 0) {
					$(this).find(".notification-count-ctn").hide();
				}
			});
		}
	};

	/**
  * Sends a notification on the website, and if specified, as sms and/or as email.
  * The label is the key of a notification label, which text can have custom values.
  * e.g.: "%1 a modfié le contenu de la visite du %2 à %3 avec %4"
  *		^ dans ce cas, values=Serge,20 janvier,21h30,Sergine
  * 
  * @param   label 		 the label which contains the notification text (with %1%, %2%, %3%... for custom values)
  * @param   userIds		 list of comma separated USER ids to which to send the notification (can be just 1)
  * @param   personIds	 list of comma separated PERSON ids to which to send the notification (can be just 1)
  * @param   types		the notification type (list of comma separated values, can be [email,sms])
  * @param   values  	 the custom values of the label
  * @param   category 	 the category of the notification (automatically set with the data below)
  * @param 	fields		 an object containing the values of the extra fields for the notification (field7...12)
  * @param   sendToAdmin  send the notification to all admins from the group "receiveNotifications"
  * @param   callback    callback function when the ajax call is completed
  * @param   sendEmail   initial parameter to include sending emails with the notification
  * 
  * Sinon, on peut ajouter un call à FormsUtil.notify(label, sendSMS, userIds...) n'importe où dans java
  */
	var sendNotification = function sendNotification(label) {
		var userIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var personIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
		var types = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
		var values = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
		var category = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
		var fields = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
		var sendToAdmin = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
		var callback = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : function () {};
		var sendEmail = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : true;

		types = types.toLowerCase();
		var params = {
			ajax: true,
			label: label,
			values: values,
			field7: category,
			perPerson: true,
			sendEmail: sendEmail,
			splitChar: '\\*\\|\\|\\|\\*'
		};
		if (userIds != null) {
			params.userIds = userIds;
		}
		if (personIds != null) {
			params.personIds = personIds;
		}
		if (types.indexOf('sms') !== -1) {
			params.sendSMS = true;
		}
		if (types.indexOf('email') !== -1) {
			params.sendEmail = true;
		}
		if (sendToAdmin) {
			params.admin = true;
		}
		for (var key in fields) {
			if (fields.hasOwnProperty(key) && /^field([89]|10|11|12)$/.test(key)) {
				params[key] = fields[key];
			}
		}
		$.ajax({
			url: "/action/createNotification",
			method: "post",
			data: params,
			complete: function complete(response) {
				// Une erreur fait que ça retourne toujours dans le "error" de ajax, donc on doit laisser ça à complete
				callback(response.reponseText);
			}
		});
	};

	var sendNotificationPerson = function sendNotificationPerson(personId, notifKey, values) {
		var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
		var fields = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
		var sendEmail = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

		if (NOTIF_KEYS.hasOwnProperty(notifKey)) {
			var strValues = values instanceof Array ? values.join('*|||*') : values;
			var types = getNotificationsPreferences(NOTIF_KEYS[notifKey], personId);
			sendNotification(NOTIF_KEYS[notifKey].label, null, personId, types, strValues, NOTIF_KEYS[notifKey].category.id, fields, false, callback, sendEmail);
		} else {
			callback("error: notification key does not exist");
		}
	};

	var sendMultipleNotificationsUsers = function sendMultipleNotificationsUsers(userIds, notifKey, values) {
		var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};

		if (userIds.length === 0) {
			return callback();
		}
		var idsArray = !(userIds instanceof Array) ? userIds.split(',') : userIds;
		var userId = idsArray[0];
		sendNotificationUser(userId, notifKey, values, function () {
			if (idsArray.length > 0) {
				sendMultipleNotificationsUsers(idsArray.slice(1), notifKey, values, callback);
			} else {
				callback();
			}
		});
	};

	var sendMultipleNotificationsPersons = function sendMultipleNotificationsPersons(personIds, notifKey, values) {
		var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
		var fields = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

		var idsArray = !(personIds instanceof Array) ? personIds.split(',') : personIds;
		var personId = idsArray[0];
		sendNotificationPerson(personId, notifKey, values, function () {
			if (idsArray.length > 0) {
				sendMultipleNotificationsPersons(idsArray.slice(1), notifKey, values, callback, fields);
			} else {
				callback();
			}
		}, fields);
	};

	var sendMultipleNotificationsPersonsDifferentData = function sendMultipleNotificationsPersonsDifferentData(personIds, notifKey, valuesArray) {
		var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
		var fieldsArray = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

		var idsArray = !(personIds instanceof Array) ? personIds.split(',') : personIds;
		var personId = idsArray[0];
		var values = valuesArray[0];
		var fields = fieldsArray[0];
		sendNotificationPerson(personId, notifKey, values, function () {
			if (idsArray.length > 0) {
				sendMultipleNotificationsPersonsDifferentData(idsArray.slice(1), notifKey, valuesArray.slice(1), callback, fieldsArray.slice(1));
			} else {
				callback();
			}
		}, fields);
	};

	var setNotificationAsRead = function setNotificationAsRead(id) {
		var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

		$.ajax({
			url: "/action/createNotification",
			method: "post",
			data: {
				id: id,
				read: "true"
			},
			complete: function complete(response) {
				callback(response.responseText);
			}
		});
	};

	var getNotificationsPreferences = function getNotificationsPreferences(notif, id) {
		//		if (notif.category.hasPreferences) {
		//			var notifPreferencesNodeText = $('.notifications-preferences-info').find('.preference[data-category=' + notif.category.id + "][data-person-id=" + id + "]").text();
		//			return notifPreferencesNodeText !== "none" ? notifPreferencesNodeText : notif.defaultTypes;
		//		} else {
		return notif.defaultTypes;
		//		}
	};

	$(window).ready(init);

	Fw.component.export('notificationUtils', {
		sendNotification: sendNotification,
		sendNotificationPerson: sendNotificationPerson,
		sendMultipleNotificationsUsers: sendMultipleNotificationsUsers,
		sendMultipleNotificationsPersons: sendMultipleNotificationsPersons,
		sendMultipleNotificationsPersonsDifferentData: sendMultipleNotificationsPersonsDifferentData,
		setNotificationAsRead: setNotificationAsRead
	});
})(jQuery);

var NOTIF_CATEGORIES = {
	"MESSAGE": {
		"id": "messagerie"
	},
	"AUDITION": {
		"id": "audition"
	}
};
var NOTIF_KEYS = {
	"NEW_MESSAGE": { //Values : nom de la personne qui envoie le message
		"label": "notification-messagerie-new-message",
		"category": NOTIF_CATEGORIES.MESSAGE,
		"defaultTypes": ""
	},
	"AUDITION_EDIT": { // values: nom de l'audition, lien de l'audition
		"label": "notification-audition-edit",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_AGENCY": { // values: Nom de l'audition, lien vers l'audition
		"label": "notification-audition-request-agency",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_AGENCY_FOR_ARTIST": { // values: Nom de l'audition, nom de l'artiste, lien vers l'audition + param
		"label": "notification-audition-request-agency-for-artist",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST": { // values: Nom de l'audition, lien vers l'audition 
		"label": "notification-audition-request-artist",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_REVIEW": { // values: Nom de l'audition, lien vers l'audition
		"label": "notification-audition-request-artist-edit",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"APPLICATION_SUBMITTED": { // values: Nom de l'audition, URL de l'audition
		"label": "notification-audition-submitted",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_SELECTED": { // values: Nom de l'audition, URL de l'audition
		// retenu - recommande
		"label": "notification-audition-artist-selected",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_SELECTED_AGENCY": { // values: Nom de l'audition, URL de l'audition
		// retenu - recommande
		"label": "notification-audition-agency-selected",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_NOT_SELECTED": { // values: Nom de l'audition, URL de l'audition
		// aucun choix
		"label": "notification-audition-artist-not-selected",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_NOT_SELECTED_AGENCY": { // values: Nom de l'audition, URL de l'audition
		// aucun choix
		"label": "notification-audition-agency-not-selected",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_SELECTED_FINAL": { // values: Nom de l'audition, URL de l'audition
		// choisi
		"label": "notification-audition-artist-selected-final",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_SELECTED_FINAL_AGENCY": { // values: Nom de l'audition, URL de l'audition
		// choisi
		"label": "notification-audition-agency-selected-final",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_AGENT_APPLICATION_REVIEW": { // values: Nom de l'artiste, Nom de l'audition, lien vers l'application, URL de l'audition
		"label": "notification-audition-agent-application-review",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_CHERCHEUR_APPLICATION_SUBMITTED": { // values: Nom de l'artiste, Nom de l'audition, URL de l'audition
		"label": "notification-audition-chercheur-application-submitted",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	//	"AUDITION_CLIENT_CHOICE": { // values:  Nom de l'audition, URL de l'audition
	// 	"label": "notification-audition-client-choice", 
	// 	"category": NOTIF_CATEGORIES.AUDITION,
	// 	"defaultTypes": ""
	// },
	"AUDITION_CLOSED": { // values:  Nom de l'audition
		"label": "notification-audition-closed",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	//	"AUDITION_ARTIST_ACCEPTED": { // values:  Nom de l'artiste, Nom de l'audition, URL de l'audition
	// 	"label": "notification-audition-participate", 
	// 	"category": NOTIF_CATEGORIES.AUDITION,
	// 	"defaultTypes": ""
	// },
	// "AUDITION_ARTIST_ACCEPTED_TO_RESEARCHER": { // values:  Nom de l'artiste, Nom de l'audition, URL de l'audition
	// 	"label": "notification-audition-participate-to-researcher", 
	// 	"category": NOTIF_CATEGORIES.AUDITION,
	// 	"defaultTypes": ""
	// },
	"AUDITION_ARTIST_REFUSED": { // values:  Nom de l'artiste, Nom de l'audition, URL de l'audition
		"label": "notification-audition-refuse",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_ARTIST_REFUSED_TO_RESEARCHER": { // values:  Nom de l'artiste, Nom de l'audition, URL de l'audition
		"label": "notification-audition-refuse-to-researcher",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_AGENCY_REFUSED_TO_RESEARCHER": { // values:  Nom de l'agence, Nom de l'audition, URL de l'audition
		"label": "notification-audition-refuse-agency-to-researcher",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_NEW_COMMENT": { // values:  Nom de l'audition, Nom de l'audition, URL de l'audition
		"label": "notification-audition-new-comment",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_AUTONOMOUS_ARTIST_TO_AGENT": { // values:  Nom de l'artiste, Nom de l'audition
		"label": "notification-audition-autonomous-artist-submit-to-agent",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_NEW_COMMENT_PARTNER": { // values:  Nom de l'audition, URL de l'audition
		"label": "notification-audition-new-comment-partner",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	},
	"AUDITION_NEW_COMMENT_CLIENT": { // values:  Nom de l'audition, URL de l'audition
		"label": "notification-audition-new-comment-client",
		"category": NOTIF_CATEGORIES.AUDITION,
		"defaultTypes": ""
	}
};
//notificationUtils = Fw.component.models().notificationUtils; 

//notificationUtils.sendNotificationPerson("ID DE LA PERSONNE A QUI ENVOYER LE SMS", "NEW_MESSAGE", "NOM DE LA PERSONNE QUI ENVOIE LE MESSAGE", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DES LA PERSONNE A QUI ENVOYER LE SMS", "AUDITION_EDIT", "NOM DE L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DES AGENCES A QUI ENVOYER LE SMS", "AUDITION_AGENCY", "NOM DE L'AUDITION,LIEN VERS L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DES ARTISTES A QUI ENVOYER LE SMS", "AUDITION_ARTIST", "NOM DE L'AUDITION,LIEN VERS L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DE L'ARTISTE A QUI ENVOYER LE SMS", "AUDITION_ARTIST_REVIEW", "NOM DE L'AUDITION,LIEN VERS L'APPLICATION � L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DE L'ARTISTE A QUI ENVOYER LE SMS", "APPLICATION_SUBMITTED", "NOM DE L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DE L'ARTISTE A QUI ENVOYER LE SMS", "AUDITION_ARTIST_SELECTED", "NOM DE L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DE L'ARTISTE A QUI ENVOYER LE SMS", "AUDITION_ARTIST_NOT_SELECTED", "NOM DE L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DE L'AGENT A QUI ENVOYER LE SMS", "AUDITION_AGENT_APPLICATION_REVIEW", "NOM DE L'ARTISTE,NOM DE L'AUDITION, LIEN VERS L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DU CHERCHEUR A QUI ENVOYER LE SMS", "AUDITION_CHERCHEUR_APPLICATION_SUBMITTED", "NOM DE L'ARTISTE,NOM DE L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DU CHERCHEUR A QUI ENVOYER LE SMS", "AUDITION_CLIENT_CHOICE", "NOM DE L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
//notificationUtils.sendNotificationPerson("ID DES PARTICIPANTS", "AUDITION_CLOSED", "NOM DE L'AUDITION", function () {}, {field8: ID DE LA PERSONNE QUI ENVOIE});
(function ($, undefined) {

	'use strict';

	var searchInput;
	var searchCtn;
	var resultsCtn;
	var clonesCtn;
	var artistsCtn;
	var agenciesCtn;
	var demosCtn;
	var blogsCtn;
	var infosJson;
	var noResultsText;

	var searchRequest;
	var searchTimeout;
	var searchDelay = 500;

	var ajaxSearch = function ajaxSearch(e) {
		var $inp = $(e.target);
		var val = $inp.val().trim();

		if (searchRequest) searchRequest.abort();
		if (searchTimeout) clearTimeout(searchTimeout);

		if (val !== $inp.attr('data-mem')) {
			if (val.length > 1) {
				searchTimeout = setTimeout(function () {
					$inp.attr('data-mem', val);
					searchRequest = $.ajax({
						url: '/action/vcSiteSearch',
						cache: false,
						method: 'POST',
						data: { q: val, ajax: true },
						success: displaySearchResults
					});
				}, searchDelay);
			} else if (val.length === 1) {
				$inp.attr('data-mem', val);
				displaySearchResults('');
			} else {
				$inp.attr('data-mem', val);
				resetSearch(true);
			}
		}
	};

	var displaySearchResults = function displaySearchResults(response) {
		cleanSearchCtn(artistsCtn);
		cleanSearchCtn(agenciesCtn);
		cleanSearchCtn(demosCtn);
		cleanSearchCtn(blogsCtn);

		if (response.length) {
			response.forEach(function (category) {
				generateAndAppendItems(category);
			});
		}

		toggleSearchCtn(artistsCtn);
		toggleSearchCtn(agenciesCtn);
		toggleSearchCtn(demosCtn);
		toggleSearchCtn(blogsCtn);

		!response || response.length === 0 ? noResultsText.slideDown(200) : noResultsText.slideUp(200);
		searchCtn.slideDown(200);

		// !response || response.length === 0 ? searchCtn.slideUp(100) : searchCtn.slideDown(200);
	};

	var generateAndAppendItems = function generateAndAppendItems(category) {
		var ctn;
		var itemsArray;
		var type = Object.getOwnPropertyNames(category)[0];

		if (type === 'artists') {
			ctn = artistsCtn;
			itemsArray = category.artists;
		} else if (type === 'agencies') {
			ctn = agenciesCtn;
			itemsArray = category.agencies;
		} else if (type === 'demos') {
			ctn = demosCtn;
			itemsArray = category.demos;
		} else if (type === 'blogs') {
			ctn = blogsCtn;
			itemsArray = category.blogs;
		}

		var readMore = ctn.closest('.search-results-section').find('.search-section-read-more');

		itemsArray.forEach(function (item, index) {
			readMore.attr('href', readMore.attr('data-prefix') + searchInput.val() + readMore.attr('data-suffix'));
			itemsArray.length > 3 ? readMore.slideDown() : readMore.slideUp();

			if (index < 3) {
				var clone, urlId, img, title, text;

				if (type === 'artists') {
					clone = clonesCtn.find('.search-result.artist').clone();
					urlId = item.id;
					title = item.firstName + ' ' + item.lastName;
					text = '';

					if (item.addInfo13 !== undefined && item.addInfo13 !== '') {
						var ids = item.addInfo13.split(',');
						ids.forEach(function (item, index) {
							if (index !== 0) {
								text += '/ ';
							}
							text += infosJson[item];
						});
					}
				} else if (type === 'agencies') {
					clone = clonesCtn.find('.search-result.agency').clone();
					urlId = item.id;
					title = item.addInfo3 !== undefined && item.addInfo3.length ? name = item.addInfo3 : item.firstName + ' ' + item.lastName;
					text = '';

					if (item.addInfo12 !== undefined && item.addInfo12 !== '') {
						var ids = item.addInfo12.split(',');
						ids.forEach(function (item, index) {
							if (index !== 0) {
								text += '/ ';
							}
							text += infosJson[item];
						});
					}
				} else if (type === 'demos') {
					clone = clonesCtn.find('.search-result.demo').clone();
					urlId = item.friendlyUrl;
					title = item.field2;
					text = item.firstName + ' ' + item.lastName;
				} else if (type === 'blogs') {
					clone = clonesCtn.find('.search-result.blog').clone();
					urlId = item.friendlyUrl;
					title = item.title;
					text = item.intro.length < 200 ? item.intro : item.intro.substring(0, 200) + '...';
				}

				clone.attr('href', clone.attr('data-url') + urlId);
				img = clone.find('.search-result-img');
				img.attr('style', img.attr('data-prefix') + item.mediaId + img.attr('data-suffix'));
				clone.find('.search-result-title').html(encodeText(title));
				clone.find('.search-result-text').html(encodeText(text));

				ctn.append(clone);
			}
		});
	};

	var cleanSearchCtn = function cleanSearchCtn(ctn) {
		ctn.children().remove();
	};

	var toggleSearchCtn = function toggleSearchCtn(ctn) {
		ctn.children().length === 0 ? ctn.closest('.search-results-section').slideUp() : ctn.closest('.search-results-section').slideDown();
	};

	var encodeText = function encodeText(str) {
		if (str !== undefined) {
			str = str.replace(/\\xE0/g, '\xE0');
			str = str.replace(/\\xE2/g, '\xE2');
			str = str.replace(/\\xE3/g, '\xE3');
			str = str.replace(/\\xE4/g, '\xE4');
			str = str.replace(/\\xE5/g, '\xE5');
			str = str.replace(/\\xE7/g, '\xE7');
			str = str.replace(/\\xE9/g, '\xE9');
			str = str.replace(/\\xE8/g, '\xE8');
			str = str.replace(/\\xEA/g, '\xEA');
			str = str.replace(/\\xEB/g, '\xEB');
			str = str.replace(/\\xEE/g, '\xEE');
			str = str.replace(/\\xEF/g, '\xEF');
			str = str.replace(/\\xF1/g, '\xF1');
			str = str.replace(/\\xF2/g, '\xF2');
			str = str.replace(/\\xF3/g, '\xF3');
			str = str.replace(/\\xF4/g, '\xF4');
			str = str.replace(/\\xF6/g, '\xF6');
			str = str.replace(/\\xF9/g, '\xF9');
			str = str.replace(/\\xFB/g, '\xFB');
			str = str.replace(/\\xC0/g, '\xC0');
			str = str.replace(/\\xC2/g, '\xC2');
			str = str.replace(/\\xC7/g, '\xC7');
			str = str.replace(/\\xC8/g, '\xC8');
			str = str.replace(/\\xC9/g, '\xC9');
			str = str.replace(/\\xCA/g, '\xCA');
			str = str.replace(/\\xCB/g, '\xCB');
			str = str.replace(/\\xCE/g, '\xCE');
			str = str.replace(/\\xCF/g, '\xCF');
			str = str.replace(/\\xD1/g, '\xD1');
			str = str.replace(/\\xD4/g, '\xD4');
			str = str.replace(/\\xD9/g, '\xD9');
			str = str.replace(/\\xDB/g, '\xDB');
			return str;
		}
	};

	var resetSearch = function resetSearch(keepValue) {
		searchCtn.slideUp(200);
		noResultsText.slideDown();
		cleanSearchCtn(artistsCtn);
		cleanSearchCtn(agenciesCtn);
		cleanSearchCtn(demosCtn);
		cleanSearchCtn(blogsCtn);
		toggleSearchCtn(artistsCtn);
		toggleSearchCtn(agenciesCtn);
		toggleSearchCtn(demosCtn);
		toggleSearchCtn(blogsCtn);
		if (!keepValue) {
			searchInput.val('');
			searchInput.attr('data-mem', '');
		}
	};

	var closeSearch = function closeSearch() {
		resetSearch();
	};

	var init = function init() {
		searchInput = $('.header-search-input');
		searchCtn = $('.site-ajax-search-ctn');
		resultsCtn = $('.site-ajax-results-ctn');
		clonesCtn = $('.site-ajax-clones-ctn');
		artistsCtn = resultsCtn.find('.search-results-section.artists .search-results-inner');
		agenciesCtn = resultsCtn.find('.search-results-section.agencies .search-results-inner');
		demosCtn = resultsCtn.find('.search-results-section.demos .search-results-inner');
		blogsCtn = resultsCtn.find('.search-results-section.blogs .search-results-inner');
		noResultsText = $('.site-ajax-search-no-results-found');
		$('.close-ajax-site-search-btn').click(closeSearch);

		if (searchCtn.length) {
			infosJson = JSON.parse(searchCtn.attr('data-json'));
		}

		searchInput.on("input", ajaxSearch);

		if (searchCtn.length || resultsCtn.length) {
			$(window).resize(function () {
				resetSearch();
			});
		}
	};

	$(init);
})(jQuery);
/* global actionPath, Fw */

(function ($, d, g) {
	"use strict";

	var comForm;

	var resetCaptcha = function resetCaptcha() {
		if (g.grecaptcha) g.grecaptcha.reset();
	};

	var send = function send(recaptchaToken) {
		var $it = $(this);
		var $form = $it.closest("form");

		comForm.validateForm($form);

		if ($form.hasClass("has-error")) {
			$form.find(".contact-form-error").slideDown(200);
			resetCaptcha();
			return false;
		}
		$form.find(".contact-form-error").slideUp(200);

		if (!recaptchaToken) {
			$form.find(".contact-form-error-recaptcha").slideDown(200);
		} else {
			var dataStr = "";

			$form.find(".contact-form-error-recaptcha").slideUp(200);
			$it.addClass("processing");

			dataStr += $form.serialize();

			ajax(actionPath + "contactUs?" + dataStr, _complete, true);
		}

		function _complete() {
			$it.removeClass("processing");
			$form.removeClass("is-checked");
			$form[0].reset();
			resetCaptcha();
			comForm.showSuccessPopup("contact-sent-success");
		}
	};

	var init = function init(page) {
		comForm = Fw.component.models().form;

		$(".contact-form-btn").each(function (i, btn) {
			Fw.component.models().utils.recaptcha(btn, function (response) {
				send.call(btn, response);
			});
		});
	};

	$(g).ready(init);
})(jQuery, document, window);
(function ($, undefined) {

	'use strict';

	var notificationUtils;
	var formValidator;
	var utils;
	var form;
	var popup;
	var lang;
	var titles;
	var personId;
	var personName;
	var personFName;
	var personLName;
	var auditionState;
	var auditionId;
	var auditionName;
	var auditionClientJson;
	var auditionFileType;
	var isVideo;
	var searcherId;
	var agencyId;
	var inviteId;
	var researcherId;
	var agencyName;
	var isAutonomous;
	var agenciesListForAutonomous;
	var applicationId;
	var acceptAuditionBtn;
	var denyInvitationAgencyBtn;
	var addDemoInput;
	var addDemoBtn;
	var submitDemoByAgency;
	var reviewDemoByAgency;
	var submitDemoToResearcher;
	var submitApplicationBtn;
	var demoLimit;
	var scriptDemoRecommendedCheck;
	var orderBtns;
	var moreApplicationsBtns;
	var orderReverse;
	var mainContent;
	var orderListCtn;
	var commentaireBtn;
	var commentaireDelBtn;
	var isOwnerResearcher;
	var sendToForm;
	var sendSelectEmail;
	var sendToSelect;
	var auditionDemoStateSelect;
	var toggleArtistRecommendedMsgCheckbox;
	var toggleArtistNotRecommendedMsgCheckbox;
	var demoState;
	var recommendedDate;
	var applicationNotification;

	var dateChanged = false;
	var emailLimit = 0;
	var emailCount = 0;
	var changedNowSelected = [];
	var changedNowNotSelected = [];
	var currAuditionState = null;

	var toggleContent = function toggleContent() {
		var t = $(this);
		var ctn = t.closest('.audition-specs-item');

		if (ctn.hasClass('open')) {
			ctn.removeClass('open');
			$('.audition-specs-content', ctn).slideUp(200);
		} else {
			ctn.addClass('open');
			$('.audition-specs-content', ctn).slideDown(200);
		}
	};

	var acceptAudition = function acceptAudition() {
		var t = $(this);
		var hasAgency = agencyId !== '';
		var currAgencyId = $('.audition-single-agency-select').length !== 0 ? $('.audition-single-agency-select').attr('data-value') : agencyId;
		var field7 = '';
		var participationDetails = t.closest('.popup').find('.audition-availability-questions-content-ctn');

		if (t.attr('data-extra') !== undefined) {
			field7 = t.attr('data-extra');
		}
		if (participationDetails.length > 0) {
			formValidator.validateForm(participationDetails);

			if (participationDetails.hasClass('has-error')) {
				return false;
			} else {
				field7 = JSON.stringify({
					"no-concurrence": participationDetails.find('.concurrent-participation-check').prop('checked'),
					"concurrence-details": participationDetails.find('input[name="concurrent-participation-details"]').val(),
					"availability": participationDetails.find('.audition-availability-check').prop('checked'),
					"availability-details": participationDetails.find('input[name="audition-availability-details"]').val(),
					"artist-recording": participationDetails.find('.artist-recording-check').prop('checked'),
					"artist-recording-details": participationDetails.find('input[name="artist-recording-details"]').val()
				});
			}
		}

		t.closest('.popup').addClass('is-processing');
		var data = {
			id: applicationId,
			field1: 'application',
			field2: auditionId,
			field3: '1',
			field4: currAgencyId,
			field5: personFName,
			field6: personLName,
			field7: field7,
			field9: personId,
			field19: auditionFileType,
			ajax: true
		};

		// console.log(data)
		var newDate = new Date();
		if (applicationId === '') {
			data.dateField1Year = newDate.getFullYear();
			data.dateField1Month = newDate.getMonth();
			data.dateField1Day = newDate.getDate();
			data.dateField1Hour = newDate.getHours();
			data.dateField1Minute = newDate.getMinutes();
			data.dateField1Second = newDate.getSeconds();
		}

		function acceptAuditionChangeState() {
			var dataMessage1 = new FormData();
			dataMessage1.append('link', 'true');
			dataMessage1.append('personId', personId);
			dataMessage1.append('targetPersonId', searcherId);
			dataMessage1.append('genDataId', auditionId);
			dataMessage1.append('ajax', 'true');

			var dataMessage2 = new FormData();
			dataMessage2.append('link', 'true');
			dataMessage2.append('personId', currAgencyId);
			dataMessage2.append('targetPersonId', searcherId);
			dataMessage2.append('genDataId', auditionId);
			dataMessage2.append('ajax', 'true');

			$.ajax({
				url: '/action/writeMessage',
				cache: false,
				contentType: false,
				processData: false,
				method: 'POST',
				data: dataMessage1,
				success: function success(response) {
					// console.log('Message link artist : ' + response);
					$.ajax({
						url: '/action/writeMessage',
						cache: false,
						contentType: false,
						processData: false,
						method: 'POST',
						data: dataMessage2,
						success: function success(response) {
							// console.log('Message link agency : ' + response);
							$.ajax({
								url: '/action/manageGenData',
								cache: false,
								method: 'POST',
								data: data,
								success: function success(response) {
									var newId = response.substring('success-'.length);
									// console.log('script: ' + newId);

									if (inviteId !== undefined) {
										$.ajax({
											url: '/action/manageGenData',
											cache: false,
											data: {
												id: inviteId,
												field5: '1',
												ajax: true
											},
											success: function success(response) {
												// console.log('Accept invite : ' + response);
												if (hasAgency && !isAutonomous) {
													// notificationUtils.sendNotificationPerson(currAgencyId,
													//	 'AUDITION_ARTIST_ACCEPTED',
													//	 personName + '*|||*' + auditionName + '*|||*' + window.location.href.split('?')[0],
													//	 function () {
													window.location.href = window.location.href.split('?')[0];
													//	 },
													//	 {field8: personId}
													// );
												} else {
													// notificationUtils.sendNotificationPerson(researcherId,
													//	 'AUDITION_ARTIST_ACCEPTED_TO_RESEARCHER',
													//	 personName + '*|||*' + auditionName + '*|||*' + window.location.href.split('?')[0],
													//	 function () {
													window.location.href = window.location.href.split('?')[0];
													//	 },
													//	 {field8: personId}
													// );
												}
											}
										});
									} else {
										if (hasAgency && !isAutonomous) {
											// notificationUtils.sendNotificationPerson(currAgencyId,
											//	 'AUDITION_ARTIST_ACCEPTED',
											//	 personName + '*|||*' + auditionName + '*|||*' + window.location.href.split('?')[0],
											//	 function () {
											window.location.href = window.location.href.split('?')[0];
											//	 },
											//	 {field8: personId}
											// );
										} else {
											// notificationUtils.sendNotificationPerson(researcherId,
											//	 'AUDITION_ARTIST_ACCEPTED_TO_RESEARCHER',
											//	 personName + '*|||*' + auditionName + '*|||*' + window.location.href.split('?')[0],
											//	 function () {
											window.location.href = window.location.href.split('?')[0];
											//	 },
											//	 {field8: personId}
											// );
										}
									}
								}
							});
						}
					});
				}
			});
		}

		if (hasAgency) {
			$.ajax({
				url: '/action/vcSendAuditionInvitations',
				cache: false,
				method: 'POST',
				data: {
					agentId: currAgencyId,
					auditionId: auditionId,
					ajax: true
				},
				success: function success(response) {
					// console.log('Audition link to agency : ' +  response);

					acceptAuditionChangeState();
				}
			});
		} else {
			acceptAuditionChangeState();
		}
	};

	var denyInvitationAgency = function denyInvitationAgency() {
		var t = $(this);
		var popup = t.closest('.popup');
		var redirect = t.attr('data-redirect');
		var sendMessage = popup.find('input[name="toggle-agency-refuse-invitation-msg-checkbox"]').prop('checked');
		var message = popup.find('textarea[name="audtion-single-form-message-agency-refuse-text"]').val();

		popup.addClass('is-processing');
		// console.log(inviteId);
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: inviteId,
				field4: '0',
				ajax: true
			},
			success: function success(response) {
				// console.log('Deny invite agency : ' + response);

				notificationUtils.sendNotificationPerson(researcherId, 'AUDITION_AGENCY_REFUSED_TO_RESEARCHER', agencyName + '*|||*' + auditionName + '*|||*' + window.location.href.split('?')[0], function () {
					if (sendMessage && message.length > 0) {
						var data = new FormData();
						data.append('refuseAuditionId', auditionId);
						data.append('targetPersonId', searcherId);
						data.append('message', message);
						data.append('ajax', true);
						//for (var pair of data.entries()) {
						//	console.log(pair[0]+ ', ' + pair[1]); 
						//}

						$.ajax({
							url: '/action/vcWriteMessage',
							cache: false,
							contentType: false,
							processData: false,
							method: 'POST',
							data: data,
							success: function success(response) {
								console.log(response);
								notificationUtils.sendNotificationPerson(researcherId, 'NEW_MESSAGE', agencyName, function () {
									window.location.href = redirect + '?auditionDeny';
								}, { field8: personId });
							}
						});
					} else {
						window.location.href = redirect + '?auditionDeny';
					}
				}, { field8: personId });
			}
		});
	};

	var checkDemoCount = function checkDemoCount() {
		var t = $(this);
		var file = this.files[0];
		var filename = file !== undefined ? file.name : '';
		var currForm = $('.audition-single-add-form');
		var tab = t.closest('.tab-ctn');
		var currDemoCount = $('.audition-single-demo-item:not(.clone)', tab).length + 1;

		if (filename !== '' && currDemoCount >= demoLimit) {
			$('.form-item-field[name="audition-single-add-file"]', tab).addClass('disabled').attr('disabled', 'true');
			$('.form-item-field[name="audition-single-add-file"]', tab).closest('.form-item-upload').addClass('disabled');
			$('.audition-single-add-form-note', tab).addClass('highlight');
		}
	};

	var addDemoSubmitFromInput = function addDemoSubmitFromInput() {
		var input = $(this);
		var tab = input.closest('.tab-ctn');

		addDemoSubmitInput(tab);
	};

	var addDemoSubmit = function addDemoSubmit() {
		var currForm = $('.audition-single-add-form');
		var title = $('.action-form-item', currForm);
		var scriptId = title.attr('data-script-id');
		var tab = $('.tab-ctn[data-tab="' + scriptId + '"]');

		popup.closeAllPopup();

		addDemoSubmitInput(tab);
	};

	var addDemoSubmitInput = function addDemoSubmitInput(tab) {
		var scriptId = tab.attr('data-tab');
		var input = $('.form-item-field[name="audition-single-add-file"]', tab);
		var files = input[0].files;
		var clone = $('.audition-single-demo-item.clone', tab);
		var inputForm = $('.audition-single-add-from', tab);
		var list = $('.audition-single-demo-list', tab);
		var addBtn = $('.audition-single-add-button', tab);
		var hasAgency = agencyId !== '';
		var allowedExt = isVideo ? ['mp4', 'webm', 'mov'] : ['mp3', 'm4a', 'wav'];
		var allowedSize = isVideo ? 104857600 : 10485760; // 100mb video / 10mb audio
		var currAgencyId = $('.audition-single-agency-select').length !== 0 ? $('.audition-single-agency-select').attr('data-value') : agencyId;

		addBtn.addClass('disabled').attr('disabled', 'true');

		if (files !== undefined) {
			if (files.length) {
				for (var i = 0; i < files.length; i++) {
					var re = /(?:\.([^.]+))?$/;
					var ext = re.exec(files[i].name)[1];
					var size = files[i].size;
					var filename = files[i].name;

					var data = new FormData();
					data.append('image', files[i]);
					data.append('customLabel', 'file');
					data.append('directory', 'Audition');
					data.append('ajax', 'true');

					if (size <= allowedSize) {
						if (allowedExt.indexOf(ext.toLowerCase()) !== -1) {
							inputForm.addClass('is-processing');

							$.ajax({
								url: '/action/uploadCroppedImage',
								cache: false,
								contentType: false,
								processData: false,
								method: 'POST',
								data: data,
								success: function success(response) {
									var newFileId = response.substring(response.indexOf('mediaId=') + 'mediaId='.length).trim();
									// console.log('file: ' + newFileId);
									var newDate = new Date();

									var dataSecondStep = {
										field1: 'application-demo',
										field2: scriptId,
										field3: applicationId,
										field4: newFileId,
										field5: filename,
										field6: ext,
										field7: auditionId,
										field8: '0',
										field9: personId,
										field11: searcherId,
										field19: auditionFileType,
										dateField1Year: newDate.getFullYear(),
										dateField1Month: newDate.getMonth(),
										dateField1Day: newDate.getDate(),
										dateField1Hour: newDate.getHours(),
										dateField1Minute: newDate.getMinutes(),
										dateField1Second: newDate.getSeconds(),
										ajax: true
									};

									if (hasAgency) {
										dataSecondStep.field10 = currAgencyId;
									}

									// console.log('application-demo : ');
									// console.log(dataSecondStep);

									$.ajax({
										url: '/action/manageGenData',
										cache: false,
										data: dataSecondStep,
										success: function success(genResponse) {
											var newScriptId = genResponse.substring('success-'.length);
											// console.log('application-demo: ' + newScriptId);

											inputForm.removeClass('is-processing');
											form.resetUpload(input);

											var newElt = clone.clone().removeClass('clone').attr('data-id', newScriptId).attr('data-file-id', newFileId);
											$('.audition-single-demo-item-title', newElt).html(filename);
											var num = Math.random();
											newElt.find('.toggle-tooltip-btn').attr('data-id', num);
											newElt.find('.tooltip-big-ctn').attr('data-id', num);

											list.prepend(newElt);

											updateScriptCount();
											submitApplicationBtn.removeClass('disabled').removeAttr('disabled');
											$('.audition-single-demo-validate-warning').css('display', 'inline-block');

											var currDemoCount = $('.audition-single-demo-item:not(.clone)', tab).length;
											if (currDemoCount === demoLimit) {
												$('.audition-single-add-form-note', tab).addClass('highlight');
											}

											if (isVideo) {
												var video = document.createElement('VIDEO');
												video.src = '/static/uploaded/Audition/' + newFileId + '-file.' + ext;
												video.controls = 'controls';
												$('.audition-single-demo-item-audio', newElt).append(video);
											} else {
												var audio = document.createElement('AUDIO');
												audio.src = '/static/uploaded/Audition/' + newFileId + '-file.' + ext;
												audio.controls = 'controls';
												$('.audition-single-demo-item-audio', newElt).append(audio);
											}
										}
									});
								}
							});
						} else {
							if (isVideo) {
								form.showErrorPopupAnimation('audition-form-artist-file-ext-video-error');
							} else {
								form.showErrorPopupAnimation('audition-form-artist-file-ext-error');
							}
						}
					} else {
						if (isVideo) {
							form.showErrorPopupAnimation('demo-form-file-video-size-message-error');
						} else {
							form.showErrorPopupAnimation('demo-form-file-size-message-error');
						}
					}
				}
			}
		}
	};

	var delDemo = function delDemo() {
		var t = $(this);
		var item = t.closest('.audition-single-demo-item');
		var id = item.attr('data-id');
		var script = t.closest('.tab-ctn');
		var currDemoCount = $('.audition-single-demo-item:not(.clone)', script).length - 1;

		if (currDemoCount === 0) {
			submitApplicationBtn.addClass('disabled').attr('disabled', 'true');
			$('.audition-single-demo-validate-warning').slideUp(200);
		}

		if (currDemoCount < demoLimit) {
			$('.form-item-field[name="audition-single-add-file"]', script).removeClass('disabled').removeAttr('disabled');
			$('.form-item-field[name="audition-single-add-file"]', script).closest('.form-item-upload').removeClass('disabled');
			$('.audition-single-add-form-note', script).removeClass('highlight');
		}

		item.slideUp(200, function () {
			item.remove();
			updateScriptCount();
		});

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: id,
				delete: true,
				ajax: true
			},
			success: function success(response) {
				// console.log('remove application-demo: ' + response);
			}
		});
	};

	var updateScriptCount = function updateScriptCount() {
		var elt = $('.audition-scripts-script-count');
		var count = 0;

		$('.tab-ctn[data-tab-family="audition-scripts-tabs"]').each(function () {
			if ($('.audition-single-demo-item:not(.clone)', $(this)).length) {
				count++;
			}
		});

		elt.html(count);
	};

	// @TODO: CHECK ALL CODE IN THIS FUNCTION.
	var changeScriptDemoState = function changeScriptDemoState() {
		var t = $(this);
		var demo = t.closest('.audition-single-artist-item-script-demo-item');
		var main = t.closest('.audition-single-artist-item');
		var classToAdd = 'is-recommended';

		if (t.is(':checked')) {
			demo.addClass(classToAdd);
		} else {
			demo.removeClass(classToAdd);
		}

		//For agency
		var totalMainCount = $('.audition-single-artist-item-script-demo-recommend:checked', main).length;

		if (totalMainCount !== 0) {
			$('.audition-single-select-agency-btn', main).removeClass('disabled').removeAttr('disabled');
		} else {
			$('.audition-single-select-agency-btn', main).addClass('disabled').attr('disabled', true);
		}

		//For researcher
		var newCount = $('.audition-single-artist-item-script-demo-item.is-recommended').length;
		var stateChageCount = $('.audition-single-artist-item-script-demo-item[data-init-checked="false"].is-recommended, .audition-single-artist-item-script-demo-item[data-init-checked="true"]:not(.is-recommended)').length;
		$('.audition-single-researcher-tools-recommended-count').html(newCount);

		if (stateChageCount) {
			$('.audition-single-select-by-researcher-btn, .audition-single-update-agency-btn').removeClass('disabled').removeAttr('disabled');
		} else {
			$('.audition-single-select-by-researcher-btn, .audition-single-update-agency-btn').addClass('disabled').attr('disabled', 'true');
		}

		changedNowSelected = [];
		changedNowNotSelected = [];

		var stateToCheck = 'data-default-state';

		if (auditionState === '3') {
			stateToCheck = 'data-is-selected';
		} else if ($('.audition-single-audition-is-agency').val() === 'true') {
			stateToCheck = 'data-agency-recommend';
		}

		$('.audition-single-artist-item-script-demo-item[' + stateToCheck + ']').each(function () {
			var c = $(this);
			var cId = c.attr('data-id');
			var defaultState = c.attr(stateToCheck);
			var isChecked = $('.audition-single-artist-item-script-demo-recommend', c).is(':checked');

			if ((defaultState === 'not-checked' || defaultState === 'not-selected' || defaultState === 'agency-not-recommend') && isChecked) {
				changedNowSelected.push(cId);
			} else if ((defaultState === 'checked' || defaultState === 'selected' || defaultState === 'agency-recommend') && !isChecked) {
				changedNowNotSelected.push(cId);
			}
		});

		if (changedNowSelected.length || changedNowNotSelected.length) {
			$('.audition-single-update-recommended-btn, .audition-single-update-client-btn').removeClass('disabled').removeAttr('disabled');
		} else {
			$('.audition-single-update-recommended-btn, .audition-single-update-client-btn').addClass('disabled').attr('disabled', 'true');
		}
	};

	var notifSent = false;
	var submitDemoByAgencySubmit = function submitDemoByAgencySubmit() {
		var t = $(this);
		var artistId = t.attr('data-item-id');
		var currArtistCtn = $('.audition-single-artist-item[data-id="' + artistId + '"]');
		var currArtistHeader = $('.audition-single-artist-item-header', currArtistCtn);
		var currPopup = $(this).closest('.popup');
		var total = $('.audition-single-artist-item-script-demo-recommend', currArtistCtn).length;
		var count = 0;
		var newDate = new Date();

		currPopup.addClass('is-processing');

		$('.audition-single-artist-item-script-demo-recommend', currArtistCtn).each(function () {
			var t = $(this);
			var item = t.closest('.audition-single-artist-item-script-demo-item');
			var id = item.attr('data-id');

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: {
					id: id,
					field8: t.is(':checked') ? '4' : '3',
					dateField2Year: newDate.getFullYear(),
					dateField2Month: newDate.getMonth(),
					dateField2Day: newDate.getDate(),
					dateField2Hour: newDate.getHours(),
					dateField2Minute: newDate.getMinutes(),
					dateField2Second: newDate.getSeconds(),
					ajax: true
				},
				success: function success(response) {
					count++;
					// console.log('count: ' + count)
					// console.log('total: ' + total)
					if (count === total) {
						sendHeaderInfo(function () {
							var url = window.location.href;
							url.indexOf('?') !== -1 ? url += '&' : url += '?';
							window.location.href = url + 'successToReseacher';
						}, currArtistCtn);
					} else {
						sendHeaderInfo(function () {
							// Void
						}, currArtistCtn);
					}
				}
			});
		});

		function sendHeaderInfo(callback, currArtistCtn) {
			var currHeader = $('.audition-single-artist-item-header', currArtistCtn);
			var artistId = currHeader.attr('data-artist-id');
			var artistName = currHeader.find(".audition-single-artist-item-name").text();
			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: {
					id: currHeader.attr('data-application-id'),
					field3: '1',
					dateField2Year: newDate.getFullYear(),
					dateField2Month: newDate.getMonth(),
					dateField2Day: newDate.getDate(),
					dateField2Hour: newDate.getHours(),
					dateField2Minute: newDate.getMinutes(),
					dateField2Second: newDate.getSeconds(),
					ajax: true
				},
				success: function success(response) {
					if (!notifSent) {
						// Application soumise au chercheur
						notificationUtils.sendNotificationPerson(artistId, "APPLICATION_SUBMITTED", auditionName + "*|||*" + window.location.href.split('?')[0], callback, { field8: personId });
						if (applicationNotification !== '1') {
							notificationUtils.sendNotificationPerson(searcherId, "AUDITION_CHERCHEUR_APPLICATION_SUBMITTED", artistName + "*|||*" + auditionName + "*|||*" + window.location.href.split('?')[0], callback, { field8: personId });
						}
					} else {
						callback();
					}
					notifSent = true;
				}
			});
		}
	};

	var reviewDemoByAgencySubmit = function reviewDemoByAgencySubmit() {
		var t = $(this);
		var artistId = t.attr('data-item-id');
		var currArtistCtn = $('.audition-single-artist-item[data-id="' + artistId + '"]');
		var currArtistHeader = $('.audition-single-artist-item-header', currArtistCtn);
		var currPopup = $(this).closest('.popup');
		var total = $('.audition-single-artist-item-script-demo-recommend', currArtistCtn).length;
		var count = 0;

		currPopup.addClass('is-processing');

		$('.audition-single-artist-item-script-demo-recommend', currArtistCtn).each(function () {
			var t = $(this);
			var item = t.closest('.audition-single-artist-item-script-demo-item');
			var id = item.attr('data-id');

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: {
					id: id,
					field8: '3',
					ajax: true
				},
				success: function success(response) {
					count++;

					if (count === total) {
						var sendEmail = currArtistHeader.attr('data-email');
						var message = $('.form-input[name="audition-review-by-agency-text"]').val() !== undefined ? $('.form-input[name="audition-review-by-agency-text"]').val().trim() : '';
						var subject = $('input[name="audition-review-by-agency-subject"]').val() !== undefined ? $('input[name="audition-review-by-agency-subject"]').val().trim() : '';

						sendHeaderInfo(function () {
							sendEmailAndReload(sendEmail, message, subject, 'audition-agency-not-recommended', { field1: auditionName });
						}, currArtistCtn);
					} else {
						sendHeaderInfo(function () {}, currArtistCtn);
					}
				}
			});
		});

		function sendHeaderInfo(callback, currArtistCtn) {
			var currHeader = $('.audition-single-artist-item-header', currArtistCtn);
			var artistId = currHeader.attr('data-artist-id');

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: {
					id: currHeader.attr('data-application-id'),
					field3: '2',
					ajax: true
				},
				success: function success(response) {
					// Demande à l'artiste de réviser sa candidature par l'agent
					notificationUtils.sendNotificationPerson(artistId, "AUDITION_ARTIST_REVIEW", auditionName + "*|||*" + window.location.href.split('?')[0], callback, { field8: personId });
				}
			});
		}
	};

	var submitDemoToResearcherSubmit = function submitDemoToResearcherSubmit() {
		var t = $(this);
		var total = $('.audition-single-demo-item:not(.clone)').length + 1;
		var count = 0;
		var hasAgency = agencyId !== '';
		var currPopup = t.closest('.popup');
		var applicationData = {
			id: applicationId,
			field3: '1',
			ajax: true
		};

		var newDate = new Date();

		if (!hasAgency) {
			applicationData.dateField2Year = newDate.getFullYear();
			applicationData.dateField2Month = newDate.getMonth();
			applicationData.dateField2Day = newDate.getDate();
			applicationData.dateField2Hour = newDate.getHours();
			applicationData.dateField2Minute = newDate.getMinutes();
			applicationData.dateField2Second = newDate.getSeconds();
		} else {
			applicationData.dateField3Year = newDate.getFullYear();
			applicationData.dateField3Month = newDate.getMonth();
			applicationData.dateField3Day = newDate.getDate();
			applicationData.dateField3Hour = newDate.getHours();
			applicationData.dateField3Minute = newDate.getMinutes();
			applicationData.dateField3Second = newDate.getSeconds();
		}

		var _complete = function _complete() {
			count++;
			if (count === total) {
				//				var sendEmail = $('.audition-single-submit-email-agency-email').val().trim();
				//				var url = $('.audition-single-submit-email-url').val().trim();
				//				var subject = $('.audition-single-submit-email-subject').val().trim();
				//				var artistName = $('.audition-single-submit-email-name').val().trim();
				var urlParam = hasAgency ? 'successToAgency' : 'successToReseacher';

				// sendEmailAndReload(sendEmail, false, subject, 'artist-send-to-agency-to-recommended', {field1: auditionName, field2: artistName, field3: url}, urlParam);
				var redirect = window.location.href.split('?')[0];
				redirect += '?' + urlParam;
				window.location.href = redirect;
			}
		};

		var _notifyAutonomous = function _notifyAutonomous() {
			if (agenciesListForAutonomous.length !== 0) {
				notificationUtils.sendNotificationPerson(agenciesListForAutonomous, "AUDITION_AUTONOMOUS_ARTIST_TO_AGENT", personName + "*|||*" + auditionName, _complete, { field8: personId });
			} else {
				_complete();
			}
		};

		currPopup.addClass('is-processing');
		// Audition submit demo
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: applicationData,
			success: function success() {
				if (hasAgency) {
					notificationUtils.sendNotificationPerson(agencyId, "AUDITION_AGENT_APPLICATION_REVIEW", personName + "*|||*" + auditionName + "*|||*" + window.location.href.split('?')[0], _complete, { field8: personId });
				} else if (applicationNotification !== '1') {
					notificationUtils.sendNotificationPerson(searcherId, "AUDITION_CHERCHEUR_APPLICATION_SUBMITTED", personName + "*|||*" + auditionName + "*|||*" + window.location.href.split('?')[0], _notifyAutonomous, { field8: personId });
				} else {
					_notifyAutonomous();
				}
			}
		});

		$('.audition-single-demo-item:not(.clone)').each(function () {
			var t = $(this);
			var id = t.attr('data-id');

			var data = {
				id: id,
				field8: parseInt(t.attr('data-state')) > 0 && t.attr('data-state') !== '2' && t.attr('data-state') !== '3' ? t.attr('data-state') : hasAgency ? '1' : '4',
				ajax: true
			};

			if (!hasAgency) {
				data.dateField2Year = newDate.getFullYear();
				data.dateField2Month = newDate.getMonth();
				data.dateField2Day = newDate.getDate();
				data.dateField2Hour = newDate.getHours();
				data.dateField2Minute = newDate.getMinutes();
				data.dateField2Second = newDate.getSeconds();
			} else {
				data.dateField3Year = newDate.getFullYear();
				data.dateField3Month = newDate.getMonth();
				data.dateField3Day = newDate.getDate();
				data.dateField3Hour = newDate.getHours();
				data.dateField3Minute = newDate.getMinutes();
				data.dateField3Second = newDate.getSeconds();
			}

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: data,
				success: _complete
			});
		});
	};

	var informArtistsSubmit = function informArtistsSubmit(popup, winnerNotifName, winnerEmailName, loserNotifName, loserEmailName, isFinal) {
		var loosers = [];
		var loosersNamesByAgency = {};
		var loosersAgencies = [];
		var loosersAgenciesIds = [];
		var losersMsg = $('.form-input[name="audition-single-inform-artists-loosers-text"]', popup).val() !== undefined ? $('.form-input[name="audition-single-inform-artists-loosers-text"]', popup).val().trim() : '';
		var winners = [];
		var winnersNamesByAgency = {};
		var winnersAgencies = [];
		var winnersAgenciesIds = [];
		var winnersMsg = $('.form-input[name="audition-single-inform-artists-winners-text"]', popup).val() !== undefined ? $('.form-input[name="audition-single-inform-artists-winners-text"]', popup).val().trim() : '';
		var selectedIds = [];
		var deselectedIds = [];
		var refusedApplicationIds = [];
		var refusedArtistsCount = 0;
		var previouslyRefusedApplicationIds = [];
		var approvedArtistsCount = 0;

		if (isFinal === undefined) {
			isFinal = false;
		}

		popup.addClass('is-processing');

		$('.audition-single-artist-item').each(function () {
			var t = $(this);
			var header = $('.audition-single-artist-item-header', t);
			var agencyId = header.attr('data-agency-id');
			var agencyEmail = header.attr('data-agency-email');
			var recommandedDemosCount = 0;
			var selectedDemoCount = 0;

			t.find('.audition-application-demo-state-select').each(function () {
				switch (this.value) {
					case "5":
						recommandedDemosCount++;
						break;
					case "7":
						selectedDemoCount++;
						break;
				}
			});

			if (recommandedDemosCount > 0 && !isFinal || selectedDemoCount > 0 && isFinal) {
				winners.push(header.attr('data-email'));
				if (!winnersNamesByAgency[agencyEmail]) {
					winnersNamesByAgency[agencyEmail] = [];
				}
				winnersNamesByAgency[agencyEmail].push(header.attr('data-artist-name'));

				selectedIds.push(header.attr('data-artist-id'));
				// To reduce the spamming on the agency emails, group the info from each recommendation of artists belong to the same agency
				if ((agencyEmail.length !== 0 || agencyId.length !== 0) && winnersAgencies.indexOf(agencyEmail) === -1 && winnersAgenciesIds.indexOf(agencyId) === -1) {
					winnersAgencies.push(agencyEmail);
					winnersAgenciesIds.push(agencyId);
				}
				if (t.hasClass('already-rejected')) {
					previouslyRefusedApplicationIds.push(header.attr('data-application-id'));
				}
			} else {
				if (!t.hasClass('already-rejected')) {
					loosers.push(header.attr('data-email'));
					if (!loosersNamesByAgency[agencyEmail]) {
						loosersNamesByAgency[agencyEmail] = [];
					}
					loosersNamesByAgency[agencyEmail].push(header.attr('data-artist-name'));

					deselectedIds.push(header.attr('data-artist-id'));
					// To reduce the spamming on the agency emails, group the info from non-selected artists belong to the same agency
					if ((agencyEmail.length !== 0 || agencyId.length !== 0) && loosersAgencies.indexOf(agencyEmail) === -1 && loosersAgenciesIds.indexOf(agencyId) === -1) {
						loosersAgencies.push(agencyEmail);
						loosersAgenciesIds.push(agencyId);
					}
					refusedApplicationIds.push(header.attr('data-application-id'));
				}
			}
		});

		var sendLoserMsg = loosers.length > 0 && losersMsg !== '' && refusedApplicationIds.length > 0;
		var sendLoserAgenciesMsg = loosersAgencies.length > 0 && losersMsg !== '' && refusedApplicationIds.length > 0;
		var sendWinnerMsg = winners.length > 0 && winnersMsg !== '';
		var sendWinnerAgenciesMsg = winnersAgencies.length > 0 && winnersMsg !== '';

		if (sendLoserMsg) emailLimit++;
		if (sendLoserAgenciesMsg) emailLimit++;
		if (sendWinnerMsg) emailLimit++;
		if (sendWinnerAgenciesMsg) emailLimit++;

		var sendEmailsLosers = function sendEmailsLosers() {
			if (sendLoserMsg) {
				var subjectInput = $('input[name="audition-single-inform-artists-loosers-subject"]', popup);
				var agencySubjectInput = $('input[name="audition-single-inform-artists-loosers-agency-subject"]', popup);
				var subject = subjectInput.val() !== undefined ? subjectInput.val().trim() : '';
				var agencySubject = agencySubjectInput.val() !== undefined ? agencySubjectInput.val().trim() : '';
				var fieldsByAgency = {};
				for (var i in loosersAgencies) {
					var la = loosersAgencies[i];
					fieldsByAgency[la] = { "field1": auditionName, "field2": loosersNamesByAgency[la].join(", ") };
				}

				// add an indication that they were refused in their application, to prevent more negative messages
				refusedApplicationIds.forEach(function (id) {
					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						data: {
							id: id,
							field8: true,
							ajax: true
						},
						success: function success(response) {
							refusedArtistsCount++;

							if (refusedArtistsCount >= refusedApplicationIds.length) {
								// Send email to Artists
								sendEmailAndReload(loosers, losersMsg, subject, loserEmailName, { field1: auditionName }, 'messageSent');
								if (sendLoserAgenciesMsg) {
									// Send email to Agencies
									sendEmailsSeparateFieldsAndReload(loosersAgencies, losersMsg, agencySubject, loserEmailName + '-agency', fieldsByAgency, 'messageSent');
								}
							}
						}
					});
				});
			}
		};

		var sendEmailsWinners = function sendEmailsWinners() {
			if (sendWinnerMsg) {
				var subjectInput = $('input[name="audition-single-inform-artists-winners-subject"]', popup);
				var agencySubjectInput = $('input[name="audition-single-inform-artists-winners-agency-subject"]', popup);
				var subject = subjectInput.val() !== undefined ? subjectInput.val().trim() : '';
				var agencySubject = agencySubjectInput.val() !== undefined ? agencySubjectInput.val().trim() : '';
				var fieldsByAgency = {};
				for (var i in winnersAgencies) {
					var wa = winnersAgencies[i];
					fieldsByAgency[wa] = { "field1": auditionName, "field2": winnersNamesByAgency[wa].join(", ") };
				}

				// if negative message received in the past, remove the indication in the application (approved now)
				if (previouslyRefusedApplicationIds.length > 0) {
					previouslyRefusedApplicationIds.forEach(function (id) {
						$.ajax({
							url: '/action/manageGenData',
							cache: false,
							data: {
								id: id,
								field8: false,
								ajax: true
							},
							success: function success(response) {
								approvedArtistsCount++;

								if (approvedArtistsCount >= previouslyRefusedApplicationIds.length) {
									// Send email to Artists
									sendEmailAndReload(winners, winnersMsg, subject, winnerEmailName, { field1: auditionName }, 'messageSent');
									if (sendWinnerAgenciesMsg) {
										// Send email to Agencies
										sendEmailsSeparateFieldsAndReload(winnersAgencies, winnersMsg, agencySubject, winnerEmailName + '-agency', fieldsByAgency, 'messageSent');
									}
								}
							}
						});
					});
				} else {
					// Send email to Artists
					sendEmailAndReload(winners, winnersMsg, subject, winnerEmailName, { field1: auditionName }, 'messageSent');
					if (sendWinnerAgenciesMsg) {
						// Send email to Agencies
						sendEmailsSeparateFieldsAndReload(winnersAgencies, winnersMsg, agencySubject, winnerEmailName + '-agency', fieldsByAgency, 'messageSent');
					}
				}
			}
		};

		if (deselectedIds.length !== 0 && sendLoserMsg || selectedIds.length !== 0 && sendWinnerMsg) {
			if (sendLoserMsg) {
				// Artiste non retenu pour l'audition
				notificationUtils.sendNotificationPerson(deselectedIds.join(','), loserNotifName, auditionName + "*|||*" + window.location.href.split('?')[0], function () {
					var valuesArray = [];
					var fieldsArray = [];
					for (var i in loosersAgencies) {
						var la = loosersAgencies[i];
						valuesArray.push(auditionName + "*|||*" + loosersNamesByAgency[la].join(", ") + "*|||*" + window.location.href.split('?')[0]);
						fieldsArray.push({ field8: personId });
					}
					// Send SMS to Agencies
					notificationUtils.sendMultipleNotificationsPersonsDifferentData(loosersAgenciesIds.join(","), loserNotifName + '_AGENCY', valuesArray, sendEmailsLosers, fieldsArray, false);
				}, { field8: personId }, false);
			}

			if (sendWinnerMsg) {
				// Artiste retenu pour l'audition
				notificationUtils.sendNotificationPerson(selectedIds.join(','), winnerNotifName, auditionName + "*|||*" + window.location.href.split('?')[0], function () {
					var valuesArray = [];
					var fieldsArray = [];
					for (var i in winnersAgencies) {
						var wa = winnersAgencies[i];
						valuesArray.push(auditionName + "*|||*" + winnersNamesByAgency[wa].join(", ") + "*|||*" + window.location.href.split('?')[0]);
						fieldsArray.push({ field8: personId });
					}
					// Send SMS to Agencies
					notificationUtils.sendMultipleNotificationsPersonsDifferentData(winnersAgenciesIds.join(","), winnerNotifName + '_AGENCY', valuesArray, sendEmailsWinners, fieldsArray, false);
				}, { field8: personId }, false);
			}
		} else {
			window.location.reload();
		}
	};

	var sendEmailAndReload = function sendEmailAndReload(sendEmail, message, subject, email, fields, successParam) {
		if (message.length !== 0 || message === false) {
			utils.sendEmail(sendEmail.toString(), subject, message, email + '-' + lang, fields, function (response) {
				// console.log(email + ' : ' + response);
				emailCount++;

				if (emailCount >= emailLimit) {
					var redirect = window.location.href.split('?')[0];

					if (typeof successParam === 'string') {
						if (successParam.length !== 0) {
							redirect += '?' + successParam;
						}
					}

					window.location.href = redirect;
				}
			});
		} else {
			window.location.reload();
		}
	};

	var sendEmailsSeparateFieldsAndReload = function sendEmailsSeparateFieldsAndReload(sendEmails, message, subject, html, fieldsByEmail, successParam) {
		if (message.length !== 0 || message === false) {
			var currentEmailsCount = sendEmails.length;

			for (var i in sendEmails) {
				var email = sendEmails[i];
				utils.sendEmail(email, subject, message, html + '-' + lang, fieldsByEmail[email], function (response) {
					currentEmailsCount--; // current 
					emailCount++; // global

					if (currentEmailsCount === 0 && emailCount >= emailLimit) {
						var redirect = window.location.href.split('?')[0];

						if (typeof successParam === 'string') {
							if (successParam.length !== 0) {
								redirect += '?' + successParam;
							}
						}

						window.location.href = redirect;
					}
				});
			}
		} else {
			window.location.reload();
		}
	};

	var confirmFinalChoice = function confirmFinalChoice() {
		var popup = $(this).closest('.popup');
		popup.addClass('is-processing');

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: auditionId,
				field13: '3',
				ajax: true
			},
			success: function success(response) {
				if (response.indexOf('success') !== -1) {
					informArtistsSubmit(popup, 'AUDITION_ARTIST_SELECTED_FINAL', 'audition-selected', 'AUDITION_ARTIST_NOT_SELECTED', 'audition-not-selected', true);
				} else {
					popup.removeClass('is-processing');
				}
			}
		});
	};
	var loadMoreList = function loadMoreList() {
		var t = $(this);
		var type = t.attr('data-id');
		var param = '?more=true';

		if (type === 'alpha') {
			param += '&sortBy=alpha';
		}
		/* Since the descending sorting is done by css, we don't send the order to the request
  if (mainContent.hasClass('inverted')) {
      param += '&sortOrder=desc';
  }*/
		/* Disabled backend filter so that the unselected artists can be notified
  if ($('.audition-filter-by-state').val() !== '') {
      param += '&field8=' + $('.audition-filter-by-state').val();
  }*/

		mainContent.addClass('is-processing');
		$.ajax({
			url: window.location.href.split('?')[0] + param,
			cache: false,
			success: function success(response) {
				var temp = $('<div></div>');
				$('.moreApplications').val('true');
				temp.html(response);
				$('.audition-single-artist-ctn', orderListCtn).remove();
				orderListCtn.prepend($('.audition-single-artist-ctn', temp).clone());
				$('.audition-application-demo-state-select', orderListCtn).change(changeAuditionDemoState);
				mainContent.removeClass('is-processing');
				t.hide();
			}
		});
	};

	var loadOrderedList = function loadOrderedList() {
		var t = $(this);
		var type = t.attr('data-id');

		if (!$('.audition-single-artist-ctn', orderListCtn).hasClass(type)) {
			orderBtns.removeClass('selected').filter('[data-id="' + type + '"]').addClass('selected');
			moreApplicationsBtns.attr('data-id', type);

			var param = '?sortBy=dateField2';

			if (type === 'alpha') {
				param = '?sortBy=alpha';
			}
			/* Since the descending sorting is done by css, we don't send the order to the request
   if (mainContent.hasClass('inverted')) {
       param += '&sortOrder=desc';
   }*/
			/* Disabled backend filter so that the unselected artists can be notified
   if ($('.audition-filter-by-state').val() !== '') {
   param += '&field8=' + $('.audition-filter-by-state').val();
   }*/
			if ($('.moreApplications').val() === 'true') {
				param += '&more=true';
			}

			mainContent.addClass('is-processing');
			$.ajax({
				url: window.location.href.split('?')[0] + param,
				cache: false,
				success: function success(response) {
					var temp = $('<div></div>');
					temp.html(response);
					$('.audition-single-artist-ctn', orderListCtn).remove();
					orderListCtn.prepend($('.audition-single-artist-ctn', temp).clone());
					$('.audition-application-demo-state-select', orderListCtn).change(changeAuditionDemoState);
					mainContent.removeClass('is-processing');
				}
			});
		}
	};

	var showOrderedList = function showOrderedList(type) {
		var selected = $('.audition-single-artist-ctn').filter(function () {
			return $(this).css('display') === 'block';
		});

		if ($('.audition-single-artist-ctn.' + type).css('display') === 'none') {
			$('.audition-single-researcher-tools-order-btn').removeClass('selected');
			$('.audition-single-researcher-tools-order-btn[data-id="' + type + '"]').addClass('selected');

			selected.fadeOut(300, function () {
				$('.audition-single-artist-ctn.' + type).fadeIn(300);
			});
		}
	};

	var toggleOrderReverse = function toggleOrderReverse() {
		mainContent.toggleClass('inverted');

		var selectedBtn = $('.audition-single-artist-ctn').filter(function () {
			return $(this).css('display') === 'block';
		});
		selectedBtn.trigger('click');
	};

	var commentaireBtnSubmit = function commentaireBtnSubmit() {
		var currForm = $(this).closest('form');
		currForm.addClass('is-processing');

		var newDate = new Date();
		$('.audition-commentaire-form input[name="dateField1Year"]').val(newDate.getFullYear());
		$('.audition-commentaire-form input[name="dateField1Month"]').val(newDate.getMonth());
		$('.audition-commentaire-form input[name="dateField1Day"]').val(newDate.getDate());
		$('.audition-commentaire-form input[name="dateField1Hour"]').val(newDate.getHours());
		$('.audition-commentaire-form input[name="dateField1Minute"]').val(newDate.getMinutes());
		$('.audition-commentaire-form input[name="dateField1Second"]').val(newDate.getSeconds());

		notificationUtils.sendNotificationPerson($('.audition-single-audition-invitees').val(), 'AUDITION_NEW_COMMENT', auditionName + '*|||*' + window.location.href.split('?')[0], function () {
			currForm.submit();
		}, { field8: personId });

		return false;
	};

	var commentaireDelBtnSubmit = function commentaireDelBtnSubmit() {
		var t = $(this);
		var item = t.closest('.audition-commentaire-item');
		var itemId = item.attr('data-id');

		item.slideUp(200, function () {
			item.remove();
		});

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			method: 'POST',
			data: {
				id: itemId,
				delete: true,
				ajax: true
			},
			success: function success(response) {
				// console.log('Commentaire del : ' + response);
			}
		});
	};

	var toggleDetails = function toggleDetails() {
		var $ctn = $(".dashboard-style-page");
		$ctn.toggleClass("mobile-open");
	};

	var saveConfidentiality = function saveConfidentiality() {
		var t = $(this);
		var auditionId = t.attr('data-extra').split('-')[0];
		var personId = t.attr('data-extra').split('-')[1];
		var currPopup = t.closest('.popup');

		var data = {
			field1: 'audition-confidentiality',
			field2: auditionId,
			field3: personId,
			ajax: true
		};

		currPopup.addClass('is-processing');

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			method: 'POST',
			data: data,
			success: function success(response) {
				// console.log('confidentiality : ' + response);

				if (t.hasClass('js-trigger-accept-audition-btn')) {
					currPopup.find('.js-audition-single-audition').trigger('click');
				} else {
					window.location.reload();
				}
			}
		});
	};

	var sendSelectEmailSubmit = function sendSelectEmailSubmit() {
		var btn = $(this);
		var popup = btn.closest('.popup');
		var subject = $('input[name="audition-single-send-select-subject"]', popup).val();
		var href = $('input[name="audition-single-select-partner-default-url"]', popup).val();
		var name = $('input[name="audition-single-send-select-winners-name"]', popup).val();
		var sendEmail = $('input[name="audition-single-send-select-send-email"]', popup).val();
		var message = $('textarea[name="audition-single-send-select-message"]', popup).val();
		var popupForm = popup.find('.js-audition-single-send-select-form');
		var doSendEmail = true;
		var doSetListToken = true;

		if (popupForm.find('[name=toggle-share-client-artists-list-checkbox]').length > 0) {
			doSendEmail = popupForm.find('[name=toggle-share-client-artists-list-checkbox]').prop('checked');
		}

		if (popup.find('[name=toggle-share-client-artists-list-checkbox]').length > 0) {
			doSetListToken = popup.find('[name=toggle-share-client-artists-list-checkbox]').prop('checked');
		}

		var sendTo = $('[name="audition-single-send-select-to"]', popup).attr('data-value');

		var tokenJson;
		if (auditionClientJson !== '') {
			tokenJson = JSON.parse(auditionClientJson);
		} else {
			tokenJson = {};
		}

		tokenJson.client = $('input[name="audition-single-select-client-token"]', popup).attr('data-token');
		tokenJson.partner = $('input[name="audition-single-select-partner-token"]', popup).attr('data-token');

		if (sendTo === 'client' && tokenJson.client.length === 0) {
			tokenJson.client = $('input[name="audition-single-select-client-token"]', popup).val();
		} else if (sendTo === 'partner' && tokenJson.partner.length === 0) {
			tokenJson.partner = $('input[name="audition-single-select-partner-token"]', popup).val();
		}

		if (sendTo === 'client' && tokenJson.client.length !== 0) {
			href += '?t=' + tokenJson.client;
		} else if (sendTo === 'partner' && tokenJson.partner.length !== 0) {
			href += '?p=' + tokenJson.partner;
		}

		if (popupForm.attr('data-extra-param') !== undefined && popupForm.attr('data-extra-param').length > 0) {
			href += '&' + popupForm.attr('data-extra-param');
		}

		var _onSubmit = function _onSubmit() {
			if (btn.hasClass('inform-artists') && (popup.find(toggleArtistRecommendedMsgCheckbox).prop('checked') || popup.find(toggleArtistNotRecommendedMsgCheckbox).prop('checked'))) {
				informArtistsSubmit(popup, 'AUDITION_ARTIST_SELECTED', 'audition-recommended', 'AUDITION_ARTIST_NOT_SELECTED', 'audition-not-recommended');
			} else {
				var forward = popupForm.attr('data-forward');
				if (popup.find('[name=toggle-share-client-artists-list-checkbox]').prop('checked') && popup.find('[name=toggle-share-client-artists-list-checkbox]').prop('checked') || popup.find('[name=toggle-share-client-artists-list-checkbox]').length === 0) {
					forward.indexOf('?') !== -1 ? forward += '&' : forward += '?';
					forward += 'messageSent';
				}

				window.location.href = forward;
			}
		};

		form.validateForm(popupForm);

		if (!popupForm.hasClass('has-error')) {
			popup.addClass('is-processing');

			if (doSetListToken) {
				$.ajax({
					url: '/action/manageGenData',
					cache: false,
					data: {
						id: auditionId,
						field7: JSON.stringify(tokenJson),
						ajax: true
					},
					success: function success(response) {
						if (doSendEmail) {
							utils.sendEmail(sendEmail.toString(), subject, message, popupForm.attr('data-email-name') + lang, { field1: auditionName, field2: href }, _onSubmit);
						} else {
							_onSubmit();
						}
					}
				});
			} else {
				_onSubmit();
			}
		}
	};

	var sendEmailToggleForm = function sendEmailToggleForm() {
		var t = $(this);

		if (t.attr('value') !== '') {
			sendToForm.slideDown(200);

			sendToForm.attr('data-cat', t.attr('value'));
		} else {
			sendToForm.slideUp(200);
		}
	};

	// new recommended / final choice change for searcher
	var changeAuditionDemoState = function changeAuditionDemoState() {
		var t = $(this);
		var currHeader = t.closest('.audition-single-artist-item').find('.audition-single-artist-item-header');
		var item = t.closest('.audition-single-artist-item-script-demo-item');
		var id = item.attr('data-id');
		var item = $('.audition-single-artist-item-script-demo-item[data-id=' + id + ']');
		var newState = '6';
		var artist = currHeader.find(".audition-single-artist-item-name").text();
		var demo = item.find('.audition-single-artist-item-script-demo-title').text();
		var artistsRecommendedList = $('.audition-single-send-select-form-artists-list.recommended');
		var artistsFinalList = $('.audition-single-send-select-form-artists-list.final');
		var demoStateTextCtn = item.find(demoState);

		if (t.val() !== '') {
			newState = t.val();
		}

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: id,
				field8: newState,
				ajax: true
			},
			success: function success(response) {
				if (response.indexOf('success') !== -1) {
					var data = {
						id: auditionId,
						ajax: true
					};

					if (newState === '5' && recommendedDate.length === 0) {
						var newDate = new Date();
						recommendedDate = newDate;
						dateChanged = true;
						data.dateField4Year = newDate.getFullYear();
						data.dateField4Month = newDate.getMonth();
						data.dateField4Day = newDate.getDate();
						data.dateField4Hour = newDate.getHours();
						data.dateField4Minute = newDate.getMinutes();
						data.dateField4Second = newDate.getSeconds();
						item.find('select[name=audition-application-demo-state-select]').val('5');
					} else if (newState !== '5' && recommendedDate.length !== 0 && auditionDemoStateSelect.filter(function () {
						return $(this).val() === '5';
					}).length === 0) {
						recommendedDate = '';
						dateChanged = true;
						data.deleteDateField4 = true;
					}

					item.attr('data-state', newState);
					item.removeClass('is-recommended is-preselected is-selected');

					if (newState !== '6') {
						if (newState === '5') {
							item.addClass('is-recommended');
							_addToArtistList(artistsRecommendedList);
							_removeFromArtistList(artistsFinalList);
							_checkFinal();
							demoStateTextCtn.html(demoStateTextCtn.attr('data-recommended'));
							item.find('select[name=audition-application-demo-state-select]').val('5');
						} else if (newState === '7') {
							if (item.attr('data-client') === 'true') {
								item.addClass('is-recommended');
								_addToArtistList(artistsRecommendedList);
							} else if (item.attr('data-audition-state') === '3') {
								item.addClass('is-selected');
							} else {
								item.addClass('is-recommended is-preselected');
								_addToArtistList(artistsRecommendedList);
							}
							_addToArtistList(artistsFinalList);
							artistsFinalList.closest('.audition-choice-popup-content-ctn').attr('data-cat', 'choice');
							demoStateTextCtn.html(demoStateTextCtn.attr('data-final'));
							item.find('select[name=audition-application-demo-state-select]').val('7');
						}

						if (item.attr('data-audition-state') === '1' && currAuditionState !== '2') {
							data.field13 = '2';
							$.ajax({
								url: '/action/manageGenData',
								cache: false,
								data: data,
								success: function success(response) {
									if (response.indexOf('success') !== -1) {
										dateChanged = false;
										$('.audition-single-send-select-btn').removeAttr('disabled').removeAttr('title');
										// change audition state bar display
										$('.audition-single-artist-state-info-val').html($('.audition-single-main-title').attr('data-state-recommended'));
										$('.audition-single-artist-state-info').addClass('warning');
										currAuditionState = '2';
									}
								}
							});
						}
					} else {
						demoStateTextCtn.html(demoStateTextCtn.attr('data-refused'));
						item.find('select[name=audition-application-demo-state-select]').val('');

						_removeFromArtistList(artistsRecommendedList);
						_removeFromArtistList(artistsFinalList);
						_checkFinal();
					}

					$('.audition-single-researcher-tools-recommended-count').text(artistsRecommendedList.find('p[data-id]').length);

					setTimeout(function () {
						$.ajax({
							url: '/action/manageGenData',
							cache: false,
							data: data,
							success: function success(response) {
								// console.log(response)
								if (response.indexOf('success') !== -1) {
									dateChanged = false;
								}
							}
						});
					}, 1000);
				}
			}
		});

		var _addToArtistList = function _addToArtistList(list) {
			if (list.find('p[data-id=' + id + ']').length === 0) {
				list.append('<p data-id="' + id + '">' + artist + ' - ' + demo + '</p>');
			}
		};

		var _removeFromArtistList = function _removeFromArtistList(list) {
			if (list.find('p[data-id=' + id + ']').length > 0) {
				list.find('p[data-id=' + id + ']').remove();
			}
		};

		var _checkFinal = function _checkFinal() {
			if (artistsFinalList.find('p').length === 0) {
				artistsFinalList.closest('.audition-choice-popup-content-ctn').attr('data-cat', 'no-choice');
			}
		};
	};

	var toggleRelatedInputContent = function toggleRelatedInputContent() {
		var t = $(this);
		var id = t.attr('data-id');
		var textarea = $('.element-to-toggle[data-id=' + id + '] textarea');

		if (!t.prop('checked')) {
			textarea.attr('data-misc', textarea.val());
			textarea.val('');
		} else {
			textarea.val(textarea.attr('data-misc'));
		}
	};

	var returnToChoicesState = function returnToChoicesState() {
		var btn = $(this);
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: auditionId,
				field13: '2',
				ajax: true
			},
			success: function success(response) {
				if (response.indexOf('success') !== -1) {
					window.location.href = btn.attr('data-redirect');
				}
			}
		});
	};

	var submitClientComment = function submitClientComment() {
		var btn = $(this);
		var popup = btn.closest('.popup');
		var ctn = popup.find('.audition-single-client-textarea-ctn');
		var json = JSON.parse(auditionClientJson);
		var type = ctn.attr('data-clienttype');

		json[type + '-comment'] = ctn.find('textarea').val();
		json[type + '-comment-read'] = false;

		formValidator.validateForm(ctn);

		if (!ctn.hasClass('has-error')) {
			popup.addClass('is-processing');
			$.ajax({
				url: '/action/vcValidateClientChoice',
				cache: false,
				data: {
					id: auditionId,
					comment: JSON.stringify(json),
					ajax: true
				},
				success: function success(response) {
					if (response.indexOf('success') !== -1) {
						var notifName = '';

						window.location.href.indexOf('p=') !== -1 ? notifName = 'AUDITION_NEW_COMMENT_PARTNER' : 'AUDITION_NEW_COMMENT_CLIENT';

						notificationUtils.sendNotificationPerson(searcherId, notifName, auditionName + '*|||*' + window.location.href.split('?')[0], function () {
							window.location.href = btn.attr('data-redirect');
						}, { field8: personId });
					} else {
						popup.removeClass('is-processing');
					}
				}
			});
		}
	};

	var deleteApplication = function deleteApplication() {
		var t = $(this);
		var redirect = t.attr('data-redirect');
		var ids = t.attr('data-extra');
		$(this).closest('.popup').addClass('is-processing');

		var hasAgency = agencyId !== '';
		var currAgencyId = $('.audition-single-agency-select').length !== 0 ? $('.audition-single-agency-select').attr('data-value') : agencyId;

		// delete application
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: ids.split('-')[0],
				delete: true,
				ajax: true
			},
			success: function success(response) {
				if (ids.indexOf('!') !== -1 && ids.split('!')[1].length > 0) {
					// artist applied on a public audition without being invited and isn't autonomous
					// delete audition link, if with agency (audition-invitation)
					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						data: {
							id: ids.split('!')[1],
							delete: true,
							ajax: true
						},
						success: function success(response) {
							window.location.href = redirect + '?auditionCancel';
						}
					});
				} else if (ids.split('-')[1].length > 0 && ids.indexOf('!') === -1) {
					// was invited by someone
					// reset invitation (application-invitation) state
					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						data: {
							id: ids.split('-')[1],
							field5: '',
							ajax: true
						},
						success: function success(response) {
							if (hasAgency && !isAutonomous) {
								notificationUtils.sendNotificationPerson(currAgencyId, 'AUDITION_ARTIST_REFUSED', personName + '*|||*' + auditionName + '*|||*' + window.location.href.split('?')[0], function () {
									window.location.href = redirect + '?auditionCancel';
								}, { field8: personId });
							} else {
								// notify the searcher
								notificationUtils.sendNotificationPerson(researcherId, 'AUDITION_ARTIST_REFUSED_TO_RESEARCHER', personName + '*|||*' + auditionName + '*|||*' + window.location.href.split('?')[0], function () {
									window.location.href = redirect + '?auditionCancel';
								}, { field8: personId });
							}
						}
					});
				} else {
					// artist applied on a public audition without being invited and is autonomous
					window.location.href = redirect + '?auditionCancel';
				}
			}
		});
	};

	var markCommentsAsRead = function markCommentsAsRead() {
		var t = $(this);
		var tokenJson = JSON.parse(auditionClientJson);
		tokenJson["client-comment-read"] = true;
		tokenJson["partner-comment-read"] = true;

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: auditionId,
				field7: JSON.stringify(tokenJson),
				ajax: true
			},
			success: function success(response) {
				if (response.indexOf('success') !== -1) {
					t.find('.notification-count-ctn').fadeOut();
				}
			}
		});
	};

	var removeParamsOnLoad = function removeParamsOnLoad(paramsToRemove) {
		var params = location.search.substr(1).split('&');
		var found = false;

		for (var i in paramsToRemove) {
			var p = paramsToRemove[i];
			if (params.indexOf(p) !== -1) {
				found = true;
				params.splice(params.indexOf(p), 1);
			}
		}

		if (found) {
			var paramsString = params.length > 0 ? "?" : "";
			paramsString += params.join('&');

			history.pushState(null, "", location.origin + location.pathname + paramsString);

			setTimeout(function () {
				$('.form-popup-message.form-audition-created-msg.show').removeClass("show");
				$('.form-popup-message.form-audition-edited-msg.show').removeClass("show");
			}, 6000);
		}
	};

	var updateShareType = function updateShareType() {
		var select = $(this);
		var form = $(select).closest('.popup-inner');
		var upload = $('.form-item-upload', form);
		var gendataId = $('input[name="gendataId"]', form).val();
		var mediaId = $('input[name="userMediaId"]', form).val();
		var field26Data = $('input[name="field26Data"]', form).val();

		var tokenJson;
		if (field26Data.length != 0 && field26Data !== '') {
			tokenJson = JSON.parse(field26Data);
		} else {
			tokenJson = {};
		}

		if (select.val() == 'customImage') {
			upload.removeClass('hide');

			tokenJson.whiteLabel = "true";
			tokenJson.type = "custom";

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: gendataId,
					field26: JSON.stringify(tokenJson),
					ajax: true
				},
				success: function success(response) {
					console.log('save-share : ' + response);
					$('input[name="field26Data"]', form).val(JSON.stringify(tokenJson));
				}
			});
		} else if (select.val() == 'profileImage') {
			upload.addClass('hide');

			tokenJson.whiteLabel = "true";
			tokenJson.type = "profile";
			tokenJson.file = '/static/uploaded/Profile/' + mediaId + '-main.jpg';

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: gendataId,
					field26: JSON.stringify(tokenJson),
					ajax: true
				},
				success: function success(response) {
					console.log('save-share : ' + response);
					$('input[name="field26Data"]', form).val(JSON.stringify(tokenJson));
				}
			});
		} else {
			upload.addClass('hide');

			tokenJson.whiteLabel = "false";
			tokenJson.type = "default";

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: gendataId,
					field26: JSON.stringify(tokenJson),
					ajax: true
				},
				success: function success(response) {
					console.log('save-share : ' + response);
					$('input[name="field26Data"]', form).val(JSON.stringify(tokenJson));
				}
			});
		}
	};

	var changeSharePic = function changeSharePic() {
		var t = $(this);
		var form = $(t).closest('.popup-inner');
		var gendataId = $('input[name="gendataId"]', form).val();
		var files = t[0].files;
		var size = files[0].size;
		var field26Data = $('input[name="field26Data"]', form).val();

		var tokenJson;
		if (field26Data.length != 0 && field26Data !== '') {
			tokenJson = JSON.parse(field26Data);
		} else {
			tokenJson = {};
		}

		console.log('size : ' + size);

		if (files !== undefined) {
			if (size <= 1048576) {
				// 1MB
				// $('.account-pic-img-ctn').addClass('is-processing');

				for (var i = 0; i < files.length; i++) {

					var re = /(?:\.([^.]+))?$/;
					var ext = re.exec(files[i].name)[1].toLowerCase();

					if (ext === 'jpg' || ext === 'jpeg' || ext === 'png') {
						var data = new FormData();
						data.append('image', files[i]);
						data.append('customLabel', 'share');
						data.append('directory', 'Share');
						data.append('ajax', 'true');

						$.ajax({
							url: '/action/uploadCroppedImage',
							cache: false,
							contentType: false,
							processData: false,
							method: 'POST',
							data: data,
							success: function success(response) {
								console.log(response);
								var newFileId = response.substring(response.indexOf('mediaId=') + 'mediaId='.length).trim();
								console.log('file: ' + newFileId);

								var newDate = new Date();

								tokenJson.file = '/static/uploaded/Share/' + newFileId + '-share.jpg';

								$.ajax({
									url: '/action/manageGenData',
									cache: false,
									data: {
										id: gendataId,
										field26: JSON.stringify(tokenJson),
										ajax: true
									},
									success: function success(genResponse) {
										// var newScriptId = genResponse.substring('success-'.length);
										console.log('Gendata: ' + genResponse);

										// fileCtn.removeClass('is-processing');
										// form.resetUpload(file);

										// callback(newFileId, ext, filename, newScriptId);
									}
								});
							}
						});
					} else {
						$('.account-pic').removeClass('is-processing');
						var errorMessage = $('.form-popup-message.profile-pic-error');

						errorMessage.addClass('show');

						setTimeout(function () {
							errorMessage.removeClass('show');
						}, 5000);
					}
				}
			} else {
				form.showErrorPopupAnimation('profile-pic-size-message-error');
			}
		}
	};

	var filterApplications = function filterApplications(e) {
		var it = e.currentTarget;
		var elems = $('.audition-single-artist-item');

		if (it.value !== '') {
			elems.has('.audition-single-artist-item-script-demo-item:not([data-state="' + it.value + '"])').addClass('hide');
			elems.has('.audition-single-artist-item-script-demo-item[data-state="' + it.value + '"]').removeClass('hide');
		} else {
			elems.removeClass('hide');
		}
	};

	var init = function init() {
		notificationUtils = Fw.component.models().notificationUtils;
		formValidator = Fw.component.models().form;
		utils = Fw.component.models().utils;
		form = Fw.component.models().form;
		popup = Fw.component.models().popup;

		lang = $('html').attr('lang');
		titles = $('.audition-specs-title');
		auditionState = $('.audition-single-audition-state').val();
		auditionId = $('.audition-single-audition-id').val();
		auditionName = $('.audition-single-main-title').text();
		auditionClientJson = $('.audition-single-client-json').val();
		auditionFileType = $('.auditionFileType').val() !== '' ? $('.auditionFileType').val() : '0';
		isVideo = auditionFileType === '1';
		searcherId = $('.audition-single-audition-researcher-id').val();
		personName = $('.logged-user-profile-name', $(".site-header")).text();
		personFName = $('.audition-single-person-fname').val();
		personLName = $('.audition-single-person-lname').val();
		personId = $('.audition-single-person-id').val();
		applicationId = $('.audition-single-application-id').val();
		agencyId = $('.audition-single-artist-agency').val() !== undefined ? $('.audition-single-artist-agency').val() : '';
		inviteId = $('.audition-single-invite').val() !== undefined ? $('.audition-single-invite').val() : '';
		researcherId = $('.researcherId').val() !== undefined ? $('.researcherId').val() : '';
		agencyName = $('.agencyName').val() !== undefined ? $('.agencyName').val() : '';
		isAutonomous = $('.isAutonomous').val() === 'true';
		agenciesListForAutonomous = $('.isArtistListForAutonomous').val();
		recommendedDate = $('.audition-single-recommended-date').val();
		acceptAuditionBtn = $('.js-audition-single-audition');
		denyInvitationAgencyBtn = $('.js-audition-single-deny-invitation-agency');
		addDemoInput = $('.form-item-field[name="audition-single-add-file"]');
		addDemoBtn = $('.js-audition-single-add-btn');
		submitDemoByAgency = $('.js-audition-single-select-by-agency');
		reviewDemoByAgency = $('.js-audition-single-review-by-agency');
		submitDemoToResearcher = $('.js-audition-single-submit-researcher');
		submitApplicationBtn = $('.audition-single-submit-application-btn');
		demoLimit = parseInt($('.audition-single-add-from').eq(0).attr('data-limit'));
		scriptDemoRecommendedCheck = $('.audition-single-artist-item-script-demo-recommend');
		orderBtns = $('.audition-single-researcher-tools-order-btn');
		moreApplicationsBtns = $('.application-more-btn');
		orderReverse = $('.audition-single-researcher-tools-order-reverse');
		mainContent = $('.audition-single-researcher-content');
		orderListCtn = $('.audition-single-artist-big-ctn');
		commentaireBtn = $('.audition-commentaire-form-btn');
		commentaireDelBtn = $('.audition-specs-item-del-btn');
		isOwnerResearcher = $('.isOwnerResearcher').val() === 'true';
		sendSelectEmail = $('.js-audition-single-send-select');
		sendToSelect = $('.audition-single-send-select-to');
		sendToForm = $('.audition-single-send-select-form');
		auditionDemoStateSelect = $('.audition-application-demo-state-select');
		toggleArtistRecommendedMsgCheckbox = $('[name=toggle-artist-recommended-msg-checkbox]');
		toggleArtistNotRecommendedMsgCheckbox = $('[name=toggle-artist-not-recommended-msg-checkbox]');
		demoState = $('.audition-single-artist-item-script-demo-item-state');
		applicationNotification = $('.applicationNotification').val();

		titles.click(toggleContent);
		acceptAuditionBtn.click(acceptAudition);
		denyInvitationAgencyBtn.click(denyInvitationAgency);
		addDemoInput.change(checkDemoCount);
		// addDemoBtn.click(addDemoSubmit);
		addDemoInput.change(addDemoSubmitFromInput);
		submitDemoByAgency.click(submitDemoByAgencySubmit);
		reviewDemoByAgency.click(reviewDemoByAgencySubmit);
		submitDemoToResearcher.click(submitDemoToResearcherSubmit);
		$('body').on('click', '.audition-single-demo-item-del', delDemo);
		scriptDemoRecommendedCheck.change(changeScriptDemoState);
		orderBtns.click(loadOrderedList);
		moreApplicationsBtns.click(loadMoreList);
		orderReverse.click(toggleOrderReverse);
		commentaireBtn.click(commentaireBtnSubmit);
		commentaireDelBtn.click(commentaireDelBtnSubmit);
		$('.save-confidentiality-agreement-btn').click(saveConfidentiality);
		sendSelectEmail.click(sendSelectEmailSubmit);
		sendToSelect.on('click', '.select-option', sendEmailToggleForm);
		auditionDemoStateSelect.change(changeAuditionDemoState);
		$('.js-audition-single-final-choice').click(confirmFinalChoice);
		toggleArtistRecommendedMsgCheckbox.click(toggleRelatedInputContent);
		toggleArtistNotRecommendedMsgCheckbox.click(toggleRelatedInputContent);
		$(".audition-single-details-btn").on("click", toggleDetails);
		$('.js-audition-single-modify-choices').click(returnToChoicesState);
		$('.js-audition-client-comment').click(submitClientComment);
		$('.js-audition-single-delete-application').click(deleteApplication);
		$('.audition-specs-title.notif-comments-read').click(markCommentsAsRead);
		$('[name="audition-single-form-type"]').change(updateShareType);
		$('[name="audition-single-custom-pic"]').change(changeSharePic);
		$('.audition-filter-by-state').change(filterApplications);

		removeParamsOnLoad(["auditionCreated", "auditionEdited"]);

		orderListCtn.removeClass('is-processing initiating');
	};

	$(window).ready(init);

	//    window.sendEmailTest999 = function() {
	//        emailCount = 0;
	//        emailLimit = 1;
	//        sendEmailAndReload(
	//            "nelo.dev@outlook.com", 
	//            "Ce message est pour vous aviser que vous n'avez pas �t� retenu pour ce projet. Merci d'avoir particip� � cette audition.", 
	//            "Vous n'\xEAtes pas retenu pour le projet", 
	//            "audition-not-selected", 
	//            {field1: "Gin Jardin Verde GLAM"}, 
	//            'messageSent');
	//    };
})(jQuery);
(function ($, undefined) {

	'use strict';

	var form;
	var showBioBtn;
	var bioCtn;
	var bio;

	var showAllBio = function showAllBio() {
		bioCtn.height(bio.height());
		bioCtn.addClass('open');
		showBioBtn.slideUp();

		setTimeout(function () {
			bioCtn.height('auto');
		}, 300);
	};

	var linkToAgency = function linkToAgency() {
		var t = $(this);
		var id = t.attr('data-id');

		$.ajax({
			url: '/action/vcManageInvitations',
			cache: false,
			data: {
				personId: id
			},
			success: function success(response) {
				console.log('agency : ' + response);

				if (response === 'fail wrong type account') {
					form.showErrorPopupAnimation('agency-link-error');
				} else if (response === 'already-in-process') {
					form.showErrorPopupAnimation('agency-already-in-progress');
				} else if (response === 'already-linked') {
					form.showErrorPopupAnimation('agency-already-linked');
				} else {
					form.showErrorPopupAnimation('agency-link-success');

					$('.account-agency-pending').slideDown(200);
				}
			}
		});
	};

	var scrollToBottomCtn = function scrollToBottomCtn() {
		var target = $('.profile-bottom-ctn').offset().top - $('.site-header').height();

		$('html').animate({ scrollTop: target });
		$('body').animate({ scrollTop: target });
	};

	var checkBioLength = function checkBioLength() {
		if (bio.height() > bioCtn.height()) {
			showBioBtn.slideDown();
			showBioBtn.click(showAllBio);
		} else {
			bioCtn.addClass('open');
		}
	};

	var countContactClick = function countContactClick() {
		var t = $(this);
		var id = t.attr('data-personid');

		t.slideUp(function () {
			$(this).remove();
		});

		$.ajax({
			url: '/action/vcUpdateCounter',
			cache: false,
			data: {
				contact: true,
				personId: id,
				ajax: true
			},
			success: function success(response) {
				//console.log('contact click count : ' + response);
			}
		});
	};

	var init = function init() {
		form = Fw.component.models().form;
		bioCtn = $('.profile-bio-tab-inner-ctn');
		showBioBtn = $('.bio-learn-more-btn');
		bio = $('.profile-bio');

		$('.add-artist-to-agency-btn').click(linkToAgency);
		$('.scroll-to-demos-btn').click(scrollToBottomCtn);
		$('.count-contact-click-btn').click(countContactClick);
		checkBioLength();
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

				'use strict';

				var playerTools;
				var popup;
				var formValidator;
				var session;
				var utils;

				var changeOrder = function changeOrder() {
								var t = $(this);

								$('.order-input').val(t.attr('data-val'));

								if (t.hasClass('no-border')) {
												applyFilters();
								}

								$('.change-order-btn:not(.no-border)').addClass('no-border');
								t.removeClass('no-border');
				};

				var changeSortOrder = function changeSortOrder() {
								var t = $(this);
								var currSort = t.attr('data-val');
								var newSort = currSort === 'desc' ? 'asc' : 'desc';

								t.attr('data-val', newSort);
								$('.sort-order-input').val(newSort);
								applyFilters();
				};

				var changeStudioFilter = function changeStudioFilter() {
								var t = $(this);

								if (t.hasClass('no-border')) {
												t.removeClass('no-border');
												//            $('.change-sourceConnect-filter').removeClass('no-border');
												$('.studio-input').val(t.attr('data-val'));
												//            $('.sourceConnect-input').val(t.attr('data-val'));
								} else {
												t.addClass('no-border');
												//            $('.change-sourceConnect-filter').addClass('no-border');
												$('.studio-input').val("");
												//            $('.sourceConnect-input').val("");
								}
								applyFilters();
				};

				var changeSourceConnectFilter = function changeSourceConnectFilter() {
								var t = $(this);

								if (t.hasClass('no-border')) {
												$('.sourceConnect-input').val(t.attr('data-val'));
												t.removeClass('no-border');
												//			applyFilters();
								} else {
												//            if ($('.change-studio-filter').hasClass("no-border")) {
												$('.sourceConnect-input').val("");
												t.addClass('no-border');
												//                applyFilters();             
												//            }
								}
								applyFilters();
				};

				var changeMedia = function changeMedia() {
								var t = $(this);

								$('.media-input').val(t.attr('data-val'));

								if (t.hasClass('no-border')) {
												var data = '';
												var inputs = $('.filters-ctn-js').find('input:not(.ignore-media), select:not(.ignore-media)');

												inputs.each(function (i) {
																if ($(this).val().length !== 0) {
																				data.length === 0 ? data += '?' : data += '&';
																				data += $(this).attr('name') + '=' + $(this).val().trim();
																}
												});

												filterAjax(data, null, 'filter-media-js');
								}

								$('.change-media-btn:not(.no-border)').addClass('no-border');
								t.removeClass('no-border');
				};

				var toggleSubcatsCtn = function toggleSubcatsCtn() {
								var t = $(this);
								var catId = t.attr('data-id');
								var extraSel;
								var delay;

								t.hasClass('main-lang') ? extraSel = '.sub-lang' : extraSel = ':not(.sub-lang)';
								var openedCat = $('.voice-filter-subcats-outer-ctn' + extraSel + '.open').attr('data-id');

								if (!t.hasClass('main-lang')) {
												if ($('.voice-filter-subcats-outer-ctn' + extraSel + '.open').length > 0 && openedCat !== catId) {
																$('.voice-filter-subcats-outer-ctn' + extraSel + '.open').slideUp().removeClass('open');
																$('.voice-filter-cat-btn:not(.main-lang)[data-id=' + openedCat + ']').removeClass('voice-filter-selected');
																delay = 400;
												}
								}

								setTimeout(function () {
												$('.voice-filter-subcats-outer-ctn' + extraSel + '[data-id=' + catId + ']').slideToggle().toggleClass('open');
												if (!t.hasClass('main-lang')) {
																$('.voice-filter-cat-btn[data-id=' + catId + ']').toggleClass('voice-filter-selected');
												}
								}, delay);
				};

				var closeSubcatsCtn = function closeSubcatsCtn() {
								var ctn = $(this).closest('.voice-filter-subcats-outer-ctn');
								var id = ctn.attr('data-id');

								ctn.slideUp().removeClass('open');
								$('.voice-filter-cat-btn[data-id=' + id + '].voice-filter-selected').removeClass('voice-filter-selected');
				};

				var toggleSubcatSearch = function toggleSubcatSearch() {
								var t = $(this);
								var id = t.attr('id');
								var ctn = t.closest('.voice-filter-subcats-outer-ctn:not(.sub-lang)');
								var input = ctn.find('.field-input');
								var val = input.val().length ? input.val().split(',') : [];
								var qty = $('.voice-filter-cat-btn[data-id=' + ctn.attr('data-id') + ']').find('.qty');

								$('.voice-filter-subcat-btn[id=' + id + ']').toggleClass('voice-filter-selected');

								if (t.hasClass('voice-filter-selected')) {
												val.push(t.attr('id'));
								} else {
												val.splice(val.indexOf(t.attr('id')), 1);
								}

								input.val(val);

								var iwdPopup = $('.popup[data-id="international-womens-day-popup"]');
								//Trigger Popup for the international women's day
								if (input.val() == "m" && !t.hasClass('trigger-from-popup') && iwdPopup.length) {
												iwdPopup.addClass('open');
												if (!iwdPopup.hasClass('no-overlay')) {
																$('body').addClass('popup-show');
												}

												if (iwdPopup.find('.init-addthis').length > 0) {
																iwdPopup.find('.init-addthis').addClass(iwdPopup.find('.init-addthis').attr('data-class'));
																addthis.layers.refresh();
												}

												val = [];
												input.val(val);
												$("#m").removeClass('voice-filter-selected');
												$("#f").removeClass('voice-filter-selected');
												t.removeClass('trigger-from-popup');
								} else {
												if (t.hasClass('sub-lang') || t.hasClass('main-lang')) {
																$('.sub-langs-ctn.hide-responsive .voice-filter-subcats-outer-ctn.sub-lang').each(function () {
																				if ($(this).find('.voice-filter-subcat-btn.voice-filter-selected').length && val.indexOf($(this).attr('data-id')) !== -1) {
																								val.splice(val.indexOf($(this).attr('data-id')), 1);
																				}
																});
												}

												qty.html(val.length);

												if (t.hasClass('sub-lang')) {
																if (t.hasClass('sub-lang')) {
																				var subLangQtyCtn = ctn.find('.voice-filter-subcat-btn[data-id=' + t.closest('.voice-filter-subcats-outer-ctn.sub-lang').attr('data-id') + ']').find('.sub-lang-qty');
																				var subLangQty = t.closest('.voice-filter-subcats-outer-ctn.sub-lang').find('.voice-filter-subcat-btn.voice-filter-selected').length;
																				subLangQtyCtn.html(subLangQty);
																}
												}

												applyFilters();
								}
				};

				var applyFilters = function applyFilters() {
								var allFilters = $('.filters-ctn-js');
								var data = {};
								var inputs = allFilters.find('input, select');

								if (utils.getQuery('page')) {
												data.page = utils.getQuery('page');
								}

								inputs.each(function (i) {
												var $_ = $(this);
												if ($_.val().length !== 0 || ($_.attr('name') === 'month' || $_.attr('name') === 'year') && ($('select[name=month]').val().length !== 0 || $('select[name=year]').val().length !== 0)) {
																data[$_.attr('name')] = $_.val().trim();
												}
								});

								if ($('.auditions-invitation-studio-chk').length !== 0) {
												data.studio = $('.auditions-invitation-studio-chk').is(":checked");
								}
								if ($('.auditions-invitation-sourceConnect-chk').length !== 0) {
												data.sourceConnect = $('.auditions-invitation-sourceConnect-chk').is(":checked");
								}

								var str;
								for (var k in data) {
												if (!str) str = "?";else str += "&";
												str += k + "=" + data[k];
								}
								filterAjax(str);
				};

				var filterAjax = function filterAjax(data, callback, elementsCtnClass) {
								var url = $('.filters-ctn-js').attr('data-url');
								if (url !== undefined) {
												var ctn = $('.filter-outer-ctn-js');

												if (!elementsCtnClass) {
																ctn.addClass('is-processing');
																$('.voice-filter-subcats-outer-ctn').addClass('is-processing');
												} else {
																$('.' + elementsCtnClass).addClass('is-processing');
												}
												var studio = '';
												var source = '';
												if ($('.auditions-invitation-studio-chk').length !== 0) {
																studio = $('.auditions-invitation-studio-chk').is(":checked");
												}
												if ($('.auditions-invitation-sourceConnect-chk').length !== 0) {
																source = $('.auditions-invitation-sourceConnect-chk').is(":checked");
												}

												var encodedData = '';
												if (typeof data === 'string') {
																url += data;
																encodedData = encodeURIComponent(data);
												}
												session.save('searchFilters', encodedData, function () {
																$.ajax({
																				url: url,
																				cache: false,
																				method: 'GET',
																				success: function success(response) {
																								if (!elementsCtnClass) {
																												var elements = $('.filtered-elements-ctn-js', $.parseHTML(response));

																												if (studio !== '' && source !== '') {
																																$('.auditions-invitation-studio-chk', elements).prop('checked', studio);
																																$('.auditions-invitation-sourceConnect-chk', elements).prop('checked', source);
																												}

																												$('.filtered-elements-ctn-js').html(elements.children());

																												if ($('.js-copy-ctn').length > 0) {
																																var demosPopupsAndPager = $('.js-copy-ctn', $.parseHTML(response));
																																$('.js-copy-ctn').html(demosPopupsAndPager.children());
																												}
																												ctn.removeClass('is-processing');
																												$('.voice-filter-subcats-outer-ctn').removeClass('is-processing');
																								} else {
																												var elements = $('.' + elementsCtnClass, $.parseHTML(response));
																												$('.' + elementsCtnClass).html(elements.children());
																												$('.' + elementsCtnClass).removeClass('is-processing');
																								}

																								if (callback) {
																												callback();
																								}
																				},
																				error: function error(response) {
																								console.log('error : ' + response.statusText);
																				}
																});
												});
								}
				};

				var clearFilters = function clearFilters() {
								filterAjax('', function () {
												$('.find-a-voice-filter-q-input').val('');
												$('.change-order-btn').addClass('no-border');
												$('.change-studio-filter').addClass('no-border');
												$('.change-sourceConnect-filter').addClass('no-border');
												$('.change-order-btn[data-val=random]').removeClass('no-border');
												$('.qty').html(0);
												$('.sub-lang-qty').html(0);
												$('.voice-filter-cat-btn').removeClass('voice-filter-selected');
												$('.voice-filter-subcat-btn').removeClass('voice-filter-selected');
												$('.voice-filter-subcats-outer-ctn').slideUp();
												$('.filters-ctn-js').find('input[type=hidden]').val('');
												window.history.pushState({}, document.title, window.location.pathname);
								});
				};

				var enterApplyFilters = function enterApplyFilters(e) {
								if ((e.which || e.keyCode) === 13) {
												applyFilters();
								}
				};

				var toggleDemosOnly = function toggleDemosOnly() {
								var t = $(this);
								var input = $('.demos-only');
								t.toggleClass('no-border');

								!t.hasClass('no-border') ? input.val('true') : input.val('');

								applyFilters();
				};

				var changeDefaultRegion = function changeDefaultRegion() {
								var t = $(this);
								var popup = t.closest('.popup');
								var select = popup.find('select[name="region"]');
								var val = !t.hasClass('close-region-popup-btn') ? select.val() : '';

								t.addClass('disabled');
								popup.addClass('is-processing');

								session.save('region', val, function () {
												t.removeClass('disabled');
												if (!t.hasClass('close-region-popup-btn')) {
																formValidator.showSuccessPopup('changed-region-success');
												}
												window.location.reload();
								});
				};

				var hijackAccount = function hijackAccount() {
								var btn = $(this);
								btn.prev(".hijack-form").submit();
				};

				var activeWomenFilter = function activeWomenFilter() {
								$("#f").addClass('trigger-from-popup');
								$("#f").click();
								popup.closeAllPopup();
				};

				var activeManFilter = function activeManFilter() {
								$("#m").addClass('trigger-from-popup');
								$("#m").click();
								popup.closeAllPopup();
				};

				var init = function init() {
								playerTools = Fw.component.models().player;
								popup = Fw.component.models().popup;
								formValidator = Fw.component.models().form;
								session = Fw.component.models().session;
								utils = Fw.component.models().utils;

								$('body').on('click', '.change-order-btn', changeOrder);
								$('body').on('click', '.change-sort-order-btn', changeSortOrder);
								$('body').on('click', '.change-studio-filter', changeStudioFilter);
								$('body').on('click', '.change-sourceConnect-filter', changeSourceConnectFilter);
								$('body').on('click', '.change-media-btn', changeMedia);
								$('body').on('click', '.voice-filter-cat-btn', toggleSubcatsCtn);
								$('body').on('click', '.close-filter-cats-btn', closeSubcatsCtn);
								$('body').on('click', '.voice-filter-subcat-btn', toggleSubcatSearch);
								$('body').on('keyup', '.find-a-voice-filter-q-input', enterApplyFilters);
								$('body').on('click', '.voice-filter-btn.reload', applyFilters);
								$('body').on('click', '.voice-filter-btn.clear', clearFilters);
								$('body').on('click', '.demos-only-btn', toggleDemosOnly);
								$('body').on('click', '.change-default-region-btn', changeDefaultRegion);
								$('body').on('click', '.close-region-popup-btn', changeDefaultRegion);
								$('body').on('click', '.hijack-my-artist', hijackAccount);
								$('body').on('click', '.women-filter-btn', activeWomenFilter);
								$('body').on('click', '.man-filter-btn', activeManFilter);

								applyFilters();
				};

				$(window).ready(init);
})(jQuery);
/* global Fw */

(function ($, d, g) {
	'use strict';

	var updateSubscribe = function updateSubscribe() {
		var $btn = $(this);
		if (!$btn.hasClass("processing")) {
			$btn.addClass("processing");
			ajax("/action/updatePerson?ajax=true&newsletter=true", function (response) {
				$btn.removeClass("processing");
				if (response.indexOf("success") > -1) {
					$btn.closest(".site-footer-newsletter-ctn").hide();
					Fw.component.models().form.showSuccessPopup("subscribe-newsletter-success");
				} else {
					//Error
				}
			}, true);
		}
	};

	var openMCSignupForm = function openMCSignupForm() {
		openWindow("mc_embed_signup", true);
	};

	var closeMCSignupForm = function closeMCSignupForm() {
		closeWindow("mc_embed_signup");
	};

	var init = function init() {
		//		$("#mc-subscribe-btn").on("click", Fw.component.models().utils.showMCPopup);
		$("#mc-subscribe-btn").on("click", openMCSignupForm);
		$("#mc_embed_signup .mc-closeModal").on("click", closeMCSignupForm);
		$("#mg2-subscribe-btn").on("click", updateSubscribe);
	};

	$(g).ready(init);
})(jQuery, document, window);
(function ($, undefined) {

	'use strict';

	var formValidator;
	var submitForgotPwBtn;

	var submitForgotPwForm = function submitForgotPwForm() {
		var btn = $(this);
		var form = btn.closest('form');

		formValidator.validateForm(form, true);
		if (!form.hasClass('has-error')) {
			var url = '/action/forgotPassword';

			url += '?email=' + encodeURIComponent(form.find('input[name=email]').val());
			url += '&ajax=true';

			btn.addClass('disabled');

			var obj = ajax(url, function (response) {
				console.log(response);
				btn.removeClass('disabled');
				if (response.indexOf('not-validated') !== -1) {
					formValidator.showErrorPopup('not-validated');
					$('.show-resend-validation-btn').slideDown();
				} else {
					form.find('input').val('').removeClass('has-value');
					formValidator.showSuccessPopup('forgot-pw-success');
				}
			}, true);
		}
	};

	var resendValidation = function resendValidation() {
		var btn = $(this);
		var form = btn.closest('form');

		formValidator.validateForm(form, true);

		if (!form.hasClass('has-error')) {
			var url = '/action/createAccount';

			url += '?resendValidate=' + encodeURIComponent(form.find('input[name=email]').val());
			url += '&ajax=true';

			btn.addClass('disabled');

			ajax(url, function (response) {
				console.log(response);
				btn.removeClass('disabled');
				form.find('input').val('').removeClass('has-value');

				if (response.indexOf('no-account') !== -1) {
					formValidator.showErrorPopup('no-account');
				} else if (response.indexOf('account-validated') !== -1) {
					formValidator.showSuccessPopup('account-already-validated');
				} else if (response.indexOf('success') !== -1) {
					formValidator.showSuccessPopup('account-validation-sent');
				}
			}, true);
		}
	};

	var toggleForgotPw = function toggleForgotPw() {
		var forgotPwCtn = $('.forgot-pw-ctn');
		var t = $(this);

		if (t.hasClass('no-title')) {
			forgotPwCtn.addClass('no-title');
		}

		forgotPwCtn.fadeToggle(function () {
			if (!t.hasClass('no-title')) {
				forgotPwCtn.removeClass('no-title');
			}
		});
	};

	var toggleResendValidation = function toggleResendValidation() {
		$('.resend-validation-ctn').fadeToggle();
	};

	var init = function init() {
		formValidator = Fw.component.models().form;
		submitForgotPwBtn = $('.submit-forgot-pw-btn');

		$('.forgot-password-btn').click(toggleForgotPw);
		$('.show-resend-validation-btn').click(toggleResendValidation);
		$('.submit-resend-validation-btn').click(resendValidation);
		submitForgotPwBtn.click(submitForgotPwForm);
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var exportJson = function exportJson() {
		var selected = $('.mg2_manageGenList_item').filter(function () {
			return $('input[name="mg2_manageGenList_item_checkbox"]', $(this)).is(':checked');
		});

		var json = {};

		selected.each(function () {
			var info = $('.mg2_manageGenList_item_info', $(this));
			var id = info.attr('data-id');
			var field2 = info.attr('data-field2');
			var field3 = info.attr('data-field3');
			var field4 = info.attr('data-field4');
			var field10 = info.attr('data-field10');
			var field11 = info.attr('data-field11');
			var extraData = info.attr('data-extradata');

			json[id] = {
				id: id,
				field2: field2,
				field3: field3,
				field4: field4,
				field10: field10,
				field11: field11,
				extraData: extraData
			};
		});

		$('.mg2_manageGenList_result').html(JSON.stringify(json));
	};

	var importJson = function importJson() {
		var jsonString = $('.mg2_manageGenList_import').val();
		var json = JSON.parse(jsonString);
		var count = 0;
		var total = Object.keys(json).length;

		for (var key in json) {
			var data = {
				field1: 'gen-list-popup-admin',
				field2: json[key].field2,
				field3: json[key].field3,
				field4: json[key].field4,
				field10: json[key].field10,
				field11: json[key].field11,
				extraData: json[key].extraData,
				ajax: true
			};

			//Fetch id for duplicates
			$('.mg2_manageGenList_item').each(function () {
				if ($('.mg2_manageGenList_item_info', $(this)).attr('data-field11') === json[key].field11) {
					data.id = $('.mg2_manageGenList_item_info', $(this)).attr('data-id');
					console.log('Oh yes!');
				}
			});

			console.log(data);

			//ajax
			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: data,
				success: function success(response) {
					count++;

					if (count === total) {
						alert('Done!');
					}
				}
			});
		}
	};

	var init = function init() {
		exportJson();

		$('input[name="mg2_manageGenList_item_checkbox"]').change(exportJson);
		$('.mg2_manageGenList_import_btn').click(importJson);
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($) {

	'use strict';

	var formValidator;
	var subscriptionUpdate;
	var emailInput;

	var submitForm = function submitForm(e) {
		var btn = $(this);
		var form = btn.closest('form');

		if (btn.hasClass('disabled')) {
			return false;
		}

		btn.addClass('disabled');
		formValidator.validateForm(form);

		if (form.hasClass('has-error')) {
			formValidator.showErrorPopup();
			btn.removeClass('disabled');
			grecaptcha.reset(btn.attr('data-widget-id'));
			return false;
		}

		if (form.hasClass('checkout-form')) {
			validateEmail(function () {
				fbq('track', 'CompleteRegistration');
				form.find('.select-state-input-ctn:not(.selected)').remove();
				form[0].submit();
			}, function () {
				form.addClass('has-error');
				btn.removeClass('disabled');
				grecaptcha.reset(btn.attr('data-widget-id'));
			});
		} else {
			form[0].submit();
		}
	};

	var addToCart = function addToCart() {
		var btn = $(this);
		var tabCtn = btn.closest('.tab-ctn');
		var packages = tabCtn.find('.packages-outer-ctn');
		var formCtn = tabCtn.find('.registration-form-ctn');
		var productId = btn.attr('data-id');
		var url = '/action/shopAddCart';

		btn.addClass('disabled');

		// Clear cart
		ajax(url + '?clear=true&ajax=true', function () {
			// Add product
			ajax(url + '?ajax=true&quantity=1&productId=' + productId, function (response) {
				btn.removeClass('disabled');
				if (response.indexOf('success') !== -1) {
					btn.addClass('clear');
					packages.slideUp();
					formCtn.slideDown(function () {
						var target = formCtn.offset().top - $('.site-header').height();

						$('html').animate({ scrollTop: target });
						$('body').animate({ scrollTop: target });
						updateCartRecap(formCtn);
					});

					$('.register-ctn').nextAll().slideUp();
				}
			}, true);
		}, true);
	};

	var validateEmail = function validateEmail(successCallback, errorCallback) {
		$.ajax("/action/validateUsername", {
			data: "username=" + encodeURIComponent(emailInput.val()),
			success: function success(res) {
				if (res.trim() === "success") {
					if (typeof successCallback === 'function') {
						successCallback();
					}
				} else {
					if (typeof errorCallback === 'function') {
						errorCallback();
					}
					formValidator.showErrorPopup('email-error');
					emailInput.removeClass('success').addClass('error').closest('.form-input-big-ctn').removeClass('success').addClass('error');
				}
			},
			error: function error() {
				//Something went wrong with the internet or server.
			}
		});
	};

	var goBackToPackages = function goBackToPackages() {
		var btn = $(this);
		var tabCtn = btn.closest('.tab-ctn');
		var packages = tabCtn.find('.packages-outer-ctn');
		var formCtn = tabCtn.find('.registration-form-ctn');

		ajax('/action/shopAddCart?clear=true&ajax=true', function (response) {
			formCtn.slideUp();
			formCtn.find('.form-select[name=subscription-length]').val(1);
			packages.slideDown();
			$('.register-ctn').nextAll().slideDown();
		}, true);
	};

	var applyPromoCode = function applyPromoCode() {
		var t = $(this);
		var form = t.closest('form');
		var input = $('input[name=code]', form);
		var inputCtn = input.closest('.form-input-big-ctn');
		var success = inputCtn.find('.form-success-message.promo-success.plan');
		var error = inputCtn.find('.form-error-message.promo-invalid');
		var code = input.val();

		if (code !== '') {
			ajax('/action/shopApplyPromo?code=' + code + '&ajax=true', function (response) {
				inputCtn.removeClass('success error');
				error.slideUp();
				success.slideUp();

				if (response.indexOf('plan rebate') !== -1) {
					inputCtn.addClass('success');
					success.slideDown();
				} else if (response.indexOf('invalid') !== -1) {
					input.val('');
					inputCtn.addClass('error');
					error.slideDown();
				}

				if (t.closest('.user-subscription-modif-form').length > 0) {
					subscriptionUpdate.updateSubscriptionRecap(form);
				} else {
					updateCartRecap(t.closest('.registration-form-ctn'));
				}
			}, true);
		}
	};

	var updateCartRecap = function updateCartRecap(ctn) {
		var country = "CA";
		var state = "QC";
		if (ctn.find(".select-country-input").val() !== '') {
			country = ctn.find(".select-country-input").val();
		}
		if (ctn.find(".select-state-input.selected").val() !== '') {
			state = ctn.find(".select-state-input.selected").val();
		}
		var url = "/action/shopJsonCart";
		if (country !== "") {
			url += "?country=" + country;
		}
		if (state !== "") {
			if (country === "") {
				url += "?";
			} else {
				url += "&";
			}
			url += "state=" + state;
		}
		ajax(url, function (response) {
			var json = JSON.parse(response);
			var dot = $('html').attr('lang') === 'fr' ? ',' : '.';

			$('.registration-form-ctn').attr('data-id', json[0][0].id);

			ctn.find('.codename.tax1-recap').html(json[1].tax1Name + ": ");
			ctn.find('.codename.tax2-recap').html(json[1].tax2Name + ": ");
			ctn.find('.amount.subtotal-recap').html(json[0][0].price);
			ctn.find('.amount.tax1-recap').html(json[1].hasOwnProperty("futureTax1") ? json[1].futureTax1 : json[1].TPS);
			ctn.find('.amount.tax2-recap').html(json[1].hasOwnProperty("futureTax2") ? json[1].futureTax2 : json[1].TVQ);
			ctn.find('.amount.later-recap').html(json[1].hasOwnProperty("futureTotal") ? json[1].futureTotal : json[0][0].realPrice);
			ctn.find('.amount.total-recap').html(json[1].total);
			if (json[0][0].price > json[0][0].realPrice) {
				ctn.find('.yearly-plan-percent-off-recap').html($('.yearly-plan-percent-off[data-id=' + json[0][0].productId + ']').html());
				ctn.find('.yearly-plan-percent-off-ctn').slideDown();
			} else {
				ctn.find('.yearly-plan-percent-off-recap').html('');
				ctn.find('.yearly-plan-percent-off-ctn').slideUp();
			}
			if (json[0][0].addTextField3.toLowerCase() === 'non' && json[0][0].addTextField4.toLowerCase() === 'non') {
				ctn.find('.checkbox-understand-basic-plan').show().find('.form-check-input').addClass('required').prop('checked', false);
			} else {
				ctn.find('.checkbox-understand-basic-plan').hide().find('.form-check-input').removeClass('required').prop('checked', false);
			}

			// if (json[1].promoValue !== undefined) {
			// 	ctn.find('.promo-code-recap').html(json[1].promoValue);
			// 	ctn.find('.promo-code-code').html(json[1].promoCode);
			// 	ctn.find('.promo-code-discount-val').html(json[1].discountValue);
			// 	$('.promo-code-extra').slideDown();
			// } else {
			// 	ctn.find('.promo-code-recap').html('0' + dot + '00');
			// 	ctn.find('.promo-code-code').html('');
			// 	ctn.find('.promo-code-discount-val').html('');
			// 	$('.promo-code-extra').slideUp();
			// }
		}, true);
	};

	var changePlan = function changePlan() {
		var t = $(this);

		ajax('/action/shopAddCart?productId=' + t.closest('.registration-form-ctn').attr('data-id') + '&override=true&quantity=' + t.val() + '&ajax=true', function (response) {
			updateCartRecap(t.closest('.registration-form-ctn'));
		}, true);
	};

	var preventDefault = function preventDefault(e) {
		e.preventDefault();
	};

	var init = function init(e) {
		formValidator = Fw.component.models().form;
		subscriptionUpdate = Fw.page.models().subscriptionUpdate;
		emailInput = $('input[name="userEmail"]');

		var checkoutForm = $('.checkout-form');
		var registerForm = $('.register-form');

		checkoutForm.on('submit', preventDefault);
		checkoutForm.find('.buy-package-btn').each(function (i, el) {
			Fw.component.models().utils.recaptcha2(el, submitForm);
		});

		registerForm.on('submit', preventDefault);
		registerForm.find('.form-btn-ctn button').each(function (i, el) {
			Fw.component.models().utils.recaptcha2(el, submitForm);
		});

		$('.add-to-cart-btn').click(addToCart);
		$('.back-to-packages-btn').click(goBackToPackages);
		$('.package-cat-tab-btn').click(function () {
			$('.back-to-packages-btn').each(function () {
				$(this).trigger('click');
			});
		});
		$('.apply-promo-code-btn').click(applyPromoCode);
		$('.form-select[name="subscription-length"]').change(changePlan);

		$(".select-country-input", checkoutForm).on("change", function () {
			updateCartRecap(checkoutForm);
		});
		$(".select-state-input.selected", checkoutForm).on("change", function () {
			updateCartRecap(checkoutForm);
		});

		emailInput.focusout(validateEmail);

		if ($('div[id^="stripe-cc-form"]').length) {
			$('div[id^="stripe-cc-form"]').each(function () {
				Fw.component.models().stripeToken.init($(this));
			});
		}
	};

	$(window).ready(init);
})(jQuery);
(function ($, undefined) {

	'use strict';

	var toggleRenewSub = function toggleRenewSub() {
		var t = $(this);

		var data = {
			"renew": t.attr('data-value'),
			"ajax": true
		};

		$.ajax({
			url: '/action/updatePerson',
			cache: false,
			data: data,
			success: function success(response) {
				console.log('updatePerson : ', response);

				window.location.href = window.location.href;
			}
		});
	};

	var init = function init() {
		$('.toggle-renew-sub-btn').click(toggleRenewSub);
	};

	$(window).ready(init);
})(jQuery);
(function ($, undefined) {

	'use strict';

	var submitting = false;
	var form;
	var header;
	var accountForm;
	var accountFormSubmit;

	var changeEmail;
	var changePassword;

	var profileInput;

	var agencyField;
	var agencysubmit;
	var agencyAccept;
	var agencyRefuse;
	var agencyCancel;

	var intLang;

	var projectList;
	var projectForm;
	var projectSubmit;

	var resultsCtn;
	var emailLinkQuery = null;

	var nav;
	var selectedPersonId = null;
	var selectedPersonEmail = null;

	var profileStudio = null;
	var profileSourceConnect = null;

	var preventDefault = function preventDefault(e) {
		e.preventDefault();
	};

	var changeProfilePic = function changeProfilePic() {
		var t = $(this);
		var files = t[0].files;
		var size = files[0].size;

		if (files !== undefined) {
			if (size <= 1048576) {
				// 1MB
				$('.account-pic-img-ctn').addClass('is-processing');

				for (var i = 0; i < files.length; i++) {

					var re = /(?:\.([^.]+))?$/;
					var ext = re.exec(files[i].name)[1].toLowerCase();

					if (ext === 'jpg' || ext === 'jpeg' || ext === 'png') {
						var data = new FormData();
						data.append('pic', files[i]);
						data.append('center', true);
						data.append('smartCrop', false);
						data.append('ajax', true);

						$.ajax({
							url: '/action/uploadPersonPic',
							cache: false,
							contentType: false,
							processData: false,
							method: 'POST',
							data: data,
							success: function success(response) {
								var id = response;
								$('.account-pic-img-ctn').removeClass('is-processing');

								$('.account-pic-img-ctn').show();
								$('.account-pic-img').attr('src', '/static/uploaded/Profile/' + id.replace(/(\r\n\t|\n|\r\t)/gm, "") + '-main.jpg');

								form.resetUpload(t);

								var successMessage = $('.form-popup-message.profile-pic-success');
								successMessage.addClass('show');

								setTimeout(function () {
									successMessage.removeClass('show');
								}, 5000);
							}
						});
					} else {
						$('.account-pic').removeClass('is-processing');
						var errorMessage = $('.form-popup-message.profile-pic-error');

						errorMessage.addClass('show');

						setTimeout(function () {
							errorMessage.removeClass('show');
						}, 5000);
					}
				}
			} else {
				form.showErrorPopupAnimation('profile-pic-size-message-error');
			}
		}
	};

	var formatStringArray = function formatStringArray(list, form) {
		var data = '';

		$(list + ' .account-option-item:not(.clone)', form).each(function () {
			var t = $(this);

			if (data.length !== 0) {
				data += ',';
			}

			data += t.attr('data-value');

			// adding main lang id
			if (data.indexOf(t.attr('data-main')) === -1 && t.attr('data-main') !== undefined) {
				data += ',' + t.attr('data-main');
			}
		});

		return data;
	};

	var submitForm = function submitForm() {
		var $curCtn = $('.tab-ctn.selected');

		$('.form-input[name="agence"]', accountForm).val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success').find('.form-error-message').hide();
		$('.form-input[name="project-title"]', projectForm).val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success').find('.form-error-message').hide();
		$('.form-input[name="project-categories"]', projectForm).val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success').find('.form-error-message').hide();
		$('.form-input[name="project-role"]', projectForm).val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success').find('.form-error-message').hide();
		$('.form-input[name="project-director"]', projectForm).val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success').find('.form-error-message').hide();
		$('.form-input[name="project-producer"]', projectForm).val('').removeClass('error success').closest('.form-input-big-ctn').removeClass('error success').find('.form-error-message').hide();

		$('.account-form-tab').removeClass('has-error');
		$curCtn.removeClass('has-error');
		form.validateForm($curCtn);

		if ($curCtn.hasClass('has-error')) {
			form.showErrorPopup();

			$('.form-input-big-ctn.error').each(function () {
				var tabId = $(this).closest('.tab-ctn').attr('data-tab');
				$('.account-form-tab[data-tab="' + tabId + '"]').addClass('has-error');
			});
		} else {
			var accountType = accountForm.attr('data-type');

			var data = {
				"ajax": true
			};

			$curCtn.find('.form-submit-input').each(function () {
				if (this.tagName === 'DIV') {
					data[this.getAttribute('name')] = this.getAttribute('data-value');
				} else if (this.type === 'radio' || this.type === 'checkbox') {
					data[this.name] = this.checked ? 'true' : 'false';
				} else {
					data[this.name] = this.value;
				}
			});

			if (accountType === '0') {
				var type = formatStringArray('.account-type-list', accountForm);
				var regions = formatStringArray('.account-region-list', accountForm);
				var associations = formatStringArray('.account-associations-list', accountForm);
				var languagesInterpretation = formatStringArray('.account-int-lang-list', accountForm);
				var voiceAge = formatStringArray('.account-voice-age-list', accountForm);
				var interpretationType = formatStringArray('.account-interpretation-type-list', accountForm);
				var timbre = formatStringArray('.account-timbre-list', accountForm);
				var typeVideo = formatStringArray('.account-type-video-list', accountForm);
				var formatVideo = formatStringArray('.account-format-video-list', accountForm);
				var interpretationTypeVideo = formatStringArray('.account-interpretation-type-video-list', accountForm);

				data["gender"] = $('.form-input[name="gender"]').attr('data-value');
				data["field3"] = $('.form-input[name="field3"]').val();
				if ($curCtn.find('.account-type-list')[0]) {
					data.field4 = type;
				}
				if ($curCtn.find('.account-region-list')[0]) {
					data.field12 = regions;
				}
				if ($curCtn.find('.account-associations-list')[0]) {
					data.field13 = associations;
				}
				if ($curCtn.find('.account-int-lang-list')[0]) {
					data.field18 = languagesInterpretation;
				}
				if ($curCtn.find('.account-voice-age-list')[0]) {
					data.field19 = voiceAge;
				}
				if ($curCtn.find('.account-interpretation-type-list')[0]) {
					data.field20 = interpretationType;
				}
				if ($curCtn.find('.account-timbre-list')[0]) {
					data.field29 = timbre;
				}
				if ($curCtn.find('.account-type-video-list')[0]) {
					data.field32 = typeVideo;
				}
				if ($curCtn.find('.account-format-video-list')[0]) {
					data.field33 = formatVideo;
				}
				if ($curCtn.find('.account-interpretation-type-video-list')[0]) {
					data.field34 = interpretationTypeVideo;
				}
			} else if (accountType === '1') {} else if (accountType === '2') {
				var associationsAgency = formatStringArray('.account-agency-associations-list', accountForm);

				if ($curCtn.find('.account-agency-associations-list')[0]) {
					data.field13 = associationsAgency;
				}
			}

			if (accountType === '0' || accountType === '2') {
				if ($curCtn.find('.form-social-media-input')[0]) {
					var social = {
						"facebook": $('.form-social-media-input[name="facebook"]').val(),
						"twitter": $('.form-social-media-input[name="twitter"]').val(),
						"linkedin": $('.form-social-media-input[name="linkedin"]').val(),
						"youtube": $('.form-social-media-input[name="youtube"]').val(),
						"vimeo": $('.form-social-media-input[name="vimeo"]').val(),
						"website": $('.form-social-media-input[name="website"]').val()
					};
					data["field21"] = JSON.stringify(social);
				}
				try {
					// Biography
					data["field26"] = tinyMCE.get('field26', $curCtn).getContent();
				} catch (exception) {
					data["field26"] = $('.field26', $curCtn).val();
				}
				try {
					// Biography english
					data["field31"] = tinyMCE.get('field31', $curCtn).getContent();
				} catch (exception) {
					data["field31"] = $('.field31', $curCtn).val();
				}
			}

			if (data.hasOwnProperty('email')) {
				delete data.email;
			}

			$.ajax({
				url: '/action/updatePerson',
				cache: false,
				data: data,
				success: function success(response) {
					//					console.log('updatePerson : ', response);

					form.showSuccessPopup();
				}
			});
		}

		return false;
	};

	var submitAgencyRequest = function submitAgencyRequest() {
		var data = {};
		var email;

		if (selectedPersonId !== null) {
			data.personId = selectedPersonId;
		}

		selectedPersonEmail !== null ? email = selectedPersonEmail : email = agencyField.val();

		if (selectedPersonId === null) {
			data.email = email;
		}

		$('.account-agency-pending').slideUp(200);

		if (selectedPersonId != null) {
			$.ajax({
				url: '/action/vcManageInvitations',
				cache: false,
				data: data,
				success: function success(response) {
					//				console.log('agency : ' + response);
					var nameVal = agencyField.val();

					agencyField.val('').closest('.form-input-big-ctn').removeClass('error success');

					if (response === 'fail') {
						form.showErrorPopup();
					} else if (response === 'fail wrong type account') {
						form.showErrorPopupAnimation('agency-link-error');
					} else if (response === 'already-in-process') {
						form.showErrorPopupAnimation('agency-already-in-progress');
					} else if (response === 'already-linked') {
						form.showErrorPopupAnimation('agency-already-linked');
					} else {
						form.showErrorPopupAnimation('agency-link-success');

						$('.account-agency-pending').slideDown(200);
						var clone = $('.account-link-invitation-sent.clone').clone();
						var clonePopup = $('.account-form-link-artist-agency-cancel-popup.clone').clone();

						clonePopup.find('.action-form-item').html(email);
						clonePopup.attr('data-id', 'invitation-' + response.split('success-')[1]);
						clonePopup.find('.account-form-link-artist-agency-cancel').attr('data-item-id', response.split('success-')[1]);
						clone.find('.account-link-invitation-sent-email').html(email);
						clone.find('.account-link-invitation-sent-action .btn').attr('data-id', 'invitation-' + response.split('success-')[1]);
						if (nameVal !== email) {
							clone.find('.account-link-invitation-sent-name').html(nameVal);
						}
						clone.attr('data-id', response.split('success-')[1]);
						$('.account-form-link-invitation-sent-list-inner').append(clone);
						$('.account-form-link-invitation-sent-list-inner').append(clonePopup);
						clone.removeClass('hide clone');
						clonePopup.removeClass('clone');
						$('.account-form-error-message.invitation-sent').slideUp();
					}
				}
			});
		} else {
			form.showErrorPopup();
		}
	};

	var acceptInvite = function acceptInvite() {
		var t = $(this);
		var id = t.attr('data-id');

		$('.account-link-forms.accept[data-id="' + id + '"]').submit();
	};

	var refuseInvite = function refuseInvite() {
		var t = $(this);
		var id = t.attr('data-id');

		$('.account-link-forms.refuse[data-id="' + id + '"]').submit();
	};

	var cancelLink = function cancelLink(e) {
		var t = $(e.currentTarget);
		var itemId = t.attr('data-item-id');
		var item = $('.account-link-invitation-sent[data-id="' + itemId + '"]');

		$.ajax({
			url: '/action/vcManageInvitations',
			cache: false,
			data: {
				id: itemId,
				cancel: true
			},
			success: function success(response) {
				//				console.log('cancel invite : ' + response);

				if (response === 'success') {
					item.slideUp(200, function () {
						item.remove();

						$('.popup').removeClass('open');
						$('body').removeClass('popup-show');
						header.addScroll();

						if ($('.account-link-invitation-sent').length === 0) {
							$('.account-form-error-message.invitation-sent').slideDown(200);
						}
					});

					form.showErrorPopupAnimation('cancel-invitation-success');
				} else {
					form.showErrorPopupAnimation('cancel-invitation-error');
				}
			}
		});
	};

	var breakLink = function breakLink() {
		var itemId = $(this).attr('data-item-id');
		var item = $('.account-form-link-artist-agency-item[data-id="' + itemId + '"]');

		$.ajax({
			url: '/action/vcManageInvitations',
			cache: false,
			data: {
				personId: itemId,
				break: true
			},
			success: function success(response) {
				//				console.log('break link : ' + response);

				if (response === 'success') {
					item.slideUp(200, function () {
						item.remove();

						$('.popup').removeClass('open');
						$('body').removeClass('popup-show');
						header.addScroll();

						if ($('.account-form-link-artist-agency-item').length === 0) {
							$('.account-form-error-message.agency').slideDown(200);
						}
					});

					form.showErrorPopupAnimation('break-invitation-success');
				} else {
					form.showErrorPopupAnimation('break-invitation-error');
				}
			}
		});
	};

	var multipleSelectAdd = function multipleSelectAdd() {
		var t = $(this);
		var ctn = t.closest('.account-multiple-select-ctn');
		var list = $('.account-multiple-select', ctn);
		var newElt = $('.account-option-item.clone', list).clone().removeClass('clone');
		var value = t.attr('data-value');
		var mainLangId = t.attr('data-main');
		var title = t.text();

		if (value !== '') {
			t.hide();
			$('.account-option-item-value', newElt).html(title);
			newElt.attr('data-value', value);

			if (mainLangId !== undefined) {
				newElt.attr('data-main', mainLangId);
			}
			list.append(newElt);
			ctn.find('.form-select.form-input.select-value').html('');
		} else if (value === '' && ctn.find('.form-select-ctn').hasClass('empty-remove-tags')) {
			list.find('.account-option-item:not(.clone) .account-option-item-del').each(function () {
				$(this).trigger('click');
			});
		}
	};

	var delAccountItem = function delAccountItem(e) {
		var t = $(e.currentTarget);
		var item = t.closest('.account-option-item');
		var rel = item.attr('data-rel');
		var value = item.attr('data-value');

		$('.form-select[name="' + rel + '"]').closest('.form-input-ctn').find('.select-option[data-value="' + value + '"]').show();

		t.closest('.account-option-item').remove();
	};

	var submitProject = function submitProject() {
		$('.form-input, .form-item-upload-input', projectForm).addClass('required').closest('.form-input-big-ctn').addClass('required');

		form.validateForm(projectForm);

		if (!projectForm.hasClass('has-error')) {
			var title = $('.form-input[name="project-title"]', projectForm).val();
			var cat = $('.form-input[name="project-categories"]', projectForm).val();
			var role = $('.form-input[name="project-role"]', projectForm).val();
			var director = $('.form-input[name="project-director"]', projectForm).val();
			var producer = $('.form-input[name="project-producer"]', projectForm).val();

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				data: {
					field1: 'project',
					field2: $('.account-form').attr('data-person-id'),
					field3: title,
					field4: cat,
					field5: role,
					field6: director,
					field7: producer,
					ajax: true
				},
				method: 'POST',
				success: function success(response) {
					var newId = response.substring('success-'.length);
					//					console.log('project : ' + response);

					var newElt = $('.account-projects-item.clone').clone().removeClass('clone');
					$('.account-projects-item-title', newElt).html(title);
					$('.account-projects-item-info.cat span', newElt).html(cat);
					$('.account-projects-item-info.role span', newElt).html(role);
					$('.account-projects-item-info.director span', newElt).html(director);
					$('.account-projects-item-info.producer span', newElt).html(producer);
					$('.account-projects-item-del', newElt).attr('data-id', 'project-' + newId);
					newElt.attr('data-id', newId);

					var newPopup = $('.popup.action-form.clone').clone().removeClass('clone');
					newPopup.attr('data-id', 'project-' + newId);
					$('.action-form-item', newPopup).html(title);
					$('.js-account-projects-item-del', newPopup).attr('data-item-id', newId);

					projectList.append(newElt);
					projectList.append(newPopup);

					projectForm.find('.form-input').val('').removeClass('has-char success');
					projectForm.find('.form-input-big-ctn').removeClass('has-char success');

					if ($('.account-projects-item:not(.clone)').length >= 2) {
						$('.account-project-form').addClass('disabled');
					}
				}
			});
		}

		$('.form-input, .form-item-upload-input', projectForm).removeClass('required').closest('.form-input-big-ctn').removeClass('required');
	};

	var delProject = function delProject(e) {
		var t = $(e.currentTarget);
		var itemId = t.attr('data-item-id');
		var item = $('.account-projects-item[data-id="' + itemId + '"]');

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: itemId,
				delete: true,
				ajax: true
			},
			method: 'POST',
			success: function success(response) {
				var isSuccess = response.substring(0, response.indexOf('-')) === 'success';
				//				console.log('project : ' + response + ', ' + isSuccess);

				if (isSuccess) {
					form.showErrorPopupAnimation('project-delete-success');

					item.slideUp(200, function () {
						item.remove();
					});

					$('.popup').removeClass('open');
					$('body').removeClass('popup-show');
					$('.account-project-form').removeClass('disabled');
					header.addScroll();
				} else {
					form.showErrorPopupAnimation('project-delete-error');
				}
			}
		});
	};

	var validateChangeForm = function validateChangeForm(e) {
		if (e) e.preventDefault();

		var t = $(this);

		form.validateForm(t);

		if (t.hasClass('has-error') || submitting) {
			return false;
		}
		submitting = true;

		var $email = t.find('input[name="email"]');
		$.ajax("/action/validateUsername", {
			data: "username=" + encodeURIComponent($email.val()),
			cache: false,
			success: function success(res) {
				if (res.indexOf("success") > -1) {
					t[0].submit();
				} else {
					form.showErrorPopup('email-error');
					t.addClass('has-error');
					$email.removeClass('success').addClass('error').closest('.form-input-big-ctn').removeClass('success').addClass('error');
				}
			},
			error: function error() {
				form.showErrorPopup('email-error');
				t.addClass('has-error');
				$email.removeClass('success').addClass('error').closest('.form-input-big-ctn').removeClass('success').addClass('error');
				//Something went wrong with the internet or server.
			}
		});
	};

	var checkEmailChange = function checkEmailChange(e) {
		if (this.value.trim() !== this.getAttribute('data-misc')) {
			this.form.querySelector('button').disabled = false;
		} else {
			this.form.querySelector('button').disabled = true;
		}
	};

	var cancelEmailChange = function cancelEmailChange(e) {
		ajaxBlackout(true, false);
		$.ajax("/action/manageGenData", {
			data: "?ajax=true&delete=true&id=" + this.getAttribute("data-id"),
			cache: false,
			complete: function complete(response) {
				window.location.href = window.location.pathname;
			}
		});
	};

	var validateChangePassword = function validateChangePassword(e) {
		if (e) {
			e.preventDefault();
		}

		var t = $(this);

		form.validatePassword(t, true);
		if (t.hasClass('has-error') || submitting) {
			return false;
		}

		submitting = true;
		t[0].submit();
	};

	var navChangeTab = function navChangeTab() {
		var t = $(this);
		var tab = t.val();

		$('.tab[data-tab=' + tab + ']').trigger('click');
	};

	var createArtist = function createArtist(captcha) {
		var btn = $(this);
		var $form = btn.closest('form');
		var popup = btn.closest('.popup');

		if (btn.hasClass('disabled')) {
			return false;
		}

		form.validateForm($form);
		if ($form.hasClass('has-error')) {
			grecaptcha.reset(btn.attr('data-widget-id'));
			return false;
		}
		btn.addClass('disabled');
		popup.addClass('is-processing');

		var data = {
			"captcha": captcha,
			"email": $('.form-input[name="email"]', $form).val(),
			"password": $('input[name="password"]', $form).val(),
			"firstName": $('.form-input[name="firstName"]', $form).val(),
			"lastName": $('.form-input[name="lastName"]', $form).val(),
			"field1": "0",
			"field5": $('input[name="field5"]', $form).val(),
			"field16": 'change-pw',
			"returnId": true,
			"ajax": true
		};

		$.ajax({
			url: '/action/createAccount',
			type: 'POST',
			cache: false,
			data: data,
			success: function success(response) {
				if (response.indexOf('success') !== -1) {
					var id = response.split('-')[1];
					var artistsIds = btn.attr('data-artistsids').length ? btn.attr('data-artistsids') + ',' + id : id;

					$.ajax({
						url: '/action/updatePerson',
						cache: false,
						data: {
							"field5": artistsIds,
							"ajax": true
						},
						success: function success(response) {
							window.location.href = $('input[name="forward"]', $form).val();
						}
					});
				} else if (response.indexOf('fail') !== -1) {
					form.showErrorPopupAnimation('email-error');
					popup.removeClass('is-processing');
					btn.removeClass('disabled');
					grecaptcha.reset(btn.attr('data-widget-id'));
				}
			}
		});
	};

	var triggerHijackUser = function triggerHijackUser() {
		var t = $(this);
		var id = t.attr('data-id');

		$('.hijack-form[data-id=' + id + ']').submit();
	};

	var filterEmailLinks = function filterEmailLinks() {
		var input = $(this);
		var searchValue = input.val().toLowerCase();
		var ctn = input.closest('.find-link-email-ctn');

		selectedPersonId = null;
		selectedPersonEmail = null;

		if (searchValue === '') {
			$('.find-link-email-choice').addClass('hide-search');
			resultsCtn.slideUp();
			return false;
		}

		$('.find-link-email-choice').each(function () {
			var t = $(this);
			var name = t.attr('data-name').toLowerCase();
			var email = t.attr('data-email').toLowerCase();
			var agencyNameAttr = t.attr('data-agency-name');
			var agencyName = agencyNameAttr != undefined ? agencyNameAttr.toLowerCase() : "";
			var isOk = true;
			var qs = searchValue.split(" ").filter(function (item) {
				return item.length > 0;
			});

			for (var i in qs) {
				var q = qs[i].toLowerCase();
				if (!(email.indexOf(q) !== -1 || name.indexOf(q) !== -1 || agencyName.length > 0 && agencyName.indexOf(q) !== -1)) {
					isOk = false;
				}
			}

			if (isOk) {
				t.removeClass('hide-search');
			} else {
				t.addClass('hide-search');
			}
		});

		resultsCtn.find('.find-link-email-choice:not(.hide-search)').length !== 0 ? resultsCtn.slideDown() : resultsCtn.slideUp();
	};

	var checkfilterEmailInput = function checkfilterEmailInput(e) {
		var result = $('.find-link-email-choice:not(.hide-search)');
		var next = null;
		var prev = null;

		if ($(this).val() !== emailLinkQuery) {
			resultsCtn.find('.find-link-email-choice.selected').removeClass('selected');
			emailLinkQuery = $(this).val();
		}

		var selectedResult = resultsCtn.find('.find-link-email-choice.selected');

		if (selectedResult.next('.find-link-email-choice:not(.hide-search)').length !== 0) {
			next = selectedResult.next('.find-link-email-choice:not(.hide-search)');
		} else if (selectedResult.nextUntil('.find-link-email-choice:not(.hide-search)').last().next().length !== 0) {
			next = selectedResult.nextUntil('.find-link-email-choice:not(.hide-search)').last().next();
		}

		if (selectedResult.prev('.find-link-email-choice:not(.hide-search)').length !== 0) {
			prev = selectedResult.prev('.find-link-email-choice:not(.hide-search)');
		} else if (selectedResult.prevUntil('.find-link-email-choice:not(.hide-search)').last().prev().length !== 0) {
			prev = selectedResult.prevUntil('.find-link-email-choice:not(.hide-search)').last().prev();
		}

		if ((e.which === 40 || e.which === 38) && selectedResult.length === 0) {
			resultsCtn.find('.find-link-email-choice:not(.hide-search)').first().addClass('selected');
		} else if (e.which === 40 && next !== null) {
			// down
			selectedResult.removeClass('selected');
			next.addClass('selected');
			// resultsCtn.animate({scrollTop: next.offset().top});
		} else if (e.which === 38 && prev !== null) {
			// up
			selectedResult.removeClass('selected');
			prev.addClass('selected');
		}
	};

	var selectPerson = function selectPerson() {
		var t = $(this);
		var email = t.attr('data-email');
		var id = t.attr('data-id');

		if (id.length > 0) {
			selectedPersonId = id;
		}

		if (email.length > 0) {
			selectedPersonEmail = email;
		}

		$('.filter-email-links-input').val(t.find('.person').html());
		resultsCtn.find('.find-link-email-choice.selected').removeClass('selected').addClass('hide-search');
		resultsCtn.slideUp();
	};

	var updateManagementRights = function updateManagementRights(e) {
		var t = $(e.currentTarget);
		var item = t.closest(".artist-authorize-auditions-ctn");
		var personId = item.attr("data-id");
		var changeToArtist = item.attr('data-demos-to-change-artist') !== '' ? item.attr('data-demos-to-change-artist').split(',') : [];
		var changeToAgency = item.attr('data-demos-to-change-agency') !== '' ? item.attr('data-demos-to-change-agency').split(',') : [];

		var newChangeToArtist = changeToArtist.slice(0);
		var newChangeToAgency = changeToAgency.slice(0);

		var url = "/action/vcHijack";
		url += "?ajax=true";
		url += "&authorizeManagement=" + t.is(":checked");
		url += "&personId=" + personId;

		ajax(url, function () {
			// Update the existing application-demo for the reapproval status
			if (t.is(":checked")) {
				for (var h = 0; h < changeToArtist.length; h++) {
					newChangeToAgency.push(changeToArtist[h]);
					item.attr('data-demos-to-change-agency', newChangeToAgency);

					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						data: {
							id: changeToArtist[h],
							field8: '2',
							ajax: true
						},
						success: function success(response) {
							//console.log('Change to reaprove by artist : ' + response);
						}
					});
				}
				item.attr('data-demos-to-change-artist', '');
			} else {
				for (var k = 0; k < changeToAgency.length; k++) {
					newChangeToArtist.push(changeToAgency[k]);
					item.attr('data-demos-to-change-artist', newChangeToArtist);

					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						data: {
							id: changeToAgency[k],
							field8: '1',
							ajax: true
						},
						success: function success(response) {
							//console.log('Change to reaprove by agency : ' + response);
						}
					});
				}
				item.attr('data-demos-to-change-agency', '');
			}
		}, true);
	};

	var unclickSourceConnect = function unclickSourceConnect() {
		if (!$(this).is(":checked")) {
			profileSourceConnect.prop("checked", false);
		}
	};

	var clickStudio = function clickStudio() {
		if ($(this).is(":checked")) {
			profileStudio.prop("checked", true);
		}
	};

	var init = function init() {
		form = Fw.component.models().form;
		header = Fw.modules.models().header;
		accountForm = $('.account-form');
		accountFormSubmit = $('.account-form-submit');

		changeEmail = $('.account-change-email');
		changePassword = $('.account-change-password');

		profileInput = $('.form-item-upload-input[name="profile-pic"]');

		agencyField = $('.form-input[name="agence"]');
		agencysubmit = $('.account-agency-submit');
		agencyAccept = $('.account-link-invitation-action-accept');
		agencyRefuse = $('.account-link-invitation-action-refuse');
		agencyCancel = $('.account-link-invitation-sent-action-refuse');

		projectList = $('.account-projects-list');
		projectForm = $('.account-project-form');
		projectSubmit = $('.account-project-form-btn');

		resultsCtn = $('.find-link-email-choices-ctn');

		profileStudio = $('.profile-studio', accountForm);
		profileSourceConnect = $('.profile-source-connect', accountForm);

		nav = $('.account-nav-select');

		accountFormSubmit.click(submitForm);
		profileInput.on('change', changeProfilePic);
		$('.account-multiple-select-ctn').on('click', '.select-option', multipleSelectAdd);
		$('body').on('click', '.account-option-item-del', delAccountItem);
		agencysubmit.click(submitAgencyRequest);
		agencyAccept.click(acceptInvite);
		agencyRefuse.click(refuseInvite);
		agencyCancel.click(breakLink);
		projectSubmit.click(submitProject);
		$('body').on('click', '.account-form-link-artist-agency-cancel', cancelLink);
		$('body').on('click', '.js-account-projects-item-del', delProject);
		changeEmail.on('submit', validateChangeForm);
		changeEmail.find('.account-change-email-input').on('input', checkEmailChange);
		changePassword.on('submit', validateChangePassword);
		nav.change(navChangeTab);
		$('.account-change-email-cancel').on('click', cancelEmailChange);
		$('button[type=button].hijack-user-btn').click(triggerHijackUser);
		$('.filter-email-links-input').keyup(filterEmailLinks);
		// $('.filter-email-links-input').keydown(checkfilterEmailInput);
		$('.find-link-email-choice').click(selectPerson);
		$('body').on('change', '.authorize-audition-management', updateManagementRights);

		//        profileStudio.on("click", unclickSourceConnect);
		//        profileSourceConnect.on("click", clickStudio);

		$('.create-artist-btn').each(function (i, el) {
			$(el).closest('form').on('submit', preventDefault);
			Fw.component.models().utils.recaptcha2(el, createArtist);
		});
	};

	$(window).ready(init);

	Fw.page.export('account', {
		formatStringArray: formatStringArray
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var utils;
	var formValidator;
	var customSelect;

	var preventDefault = function preventDefault(e) {
		e.preventDefault();
	};

	var validateAccount = function validateAccount() {
		var btn = $(this);
		var form = btn.closest('form');

		var url = '/action/updatePerson';

		url += '?id=' + form.find('input[name=personId]').val();
		url += '&field10=account-validated';
		url += '&ajax=true';

		btn.addClass('disabled');

		var obj = ajax(url, function (response) {
			if (response.indexOf('success') !== -1) {
				btn.slideUp();
				formValidator.showSuccessPopup('account-validated-success');
			}
		}, true);
	};

	var toggleSubscription = function toggleSubscription() {
		var btn = $(this);
		var form = btn.closest('form');

		var url = '/action/shopAdminUpdateSubscription';

		url += '?id=' + form.find('input[name=id]').val();
		url += '&active=' + !btn.hasClass('disable');
		url += '&ajax=true';

		btn.addClass('disabled');

		var obj = ajax(url, function (response) {
			btn.hasClass('disable') ? btn.removeClass('disable').html(form.attr('data-enable')) : btn.addClass('disable').html(form.attr('data-disable'));

			if (response.indexOf('success') !== -1) {
				window.location.reload();
			}
			btn.removeClass('disabled');
		}, true);
	};

	var updateSubscription = function updateSubscription() {
		var btn = $(this);
		var form = btn.closest('form');

		var data = {
			ajax: true
		};

		if (form.find('input[name=id]').length !== 0) {
			data.id = form.find('input[name=id]').val();
		}
		if (form.find('input[name=personId]').length !== 0) {
			data.personId = form.find('input[name=personId]').val();
		}
		if (form.find('.form-select[name=quantity]').length !== 0) {
			data.quantity = parseInt(customSelect.val(form.find('.form-select[name=quantity]').closest('.select-changed-js')));
		}
		if (form.find('.form-select[name=productId]').length !== 0) {
			data.productId = customSelect.val(form.find('.form-select[name=productId]').closest('.select-changed-js'));
		}
		if (form.find('.form-select[name=plan]').length !== 0) {
			data.plan = customSelect.val(form.find('.form-select[name=plan]').closest('.select-changed-js'));
		}
		if (form.find('input[name=expiration]').length !== 0) {
			var expDate = form.find('input[name=expiration]').val().split('-');
			data.expirationDay = expDate[0];
			data.expirationMonth = expDate[1] - 1;
			data.expirationYear = expDate[2];
		}
		if (form.find('input[name=field13]').length !== 0 && form.find('input[name=field13]').val().length !== 0) {
			data.field13 = form.find('input[name=field13]').val();
		}
		if (form.find('input[name=field17]').length !== 0 && form.find('input[name=field17]').val().length !== 0) {
			data.field17 = form.find('input[name=field17]').val();
		}

		btn.addClass('disabled');

		$.ajax({
			url: '/action/shopAdminUpdateSubscription',
			cache: false,
			method: 'POST',
			data: data,
			success: function success(response) {
				if (response.indexOf('success') !== -1) {
					window.location.reload();
				}
				btn.removeClass('disabled');
			}
		});
	};

	var saveNotificationLabel = function saveNotificationLabel() {
		var btn = $(this);
		var lang = $('html').attr('lang');
		var label = btn.attr('data-label');
		var value = "";

		var row = btn.closest('tr');
		var textParts = row.find('td').eq(1).find('span').not('.link-label');

		var tokenCounter = 0;
		textParts.each(function (i, el) {
			if (i > 0) {
				value += " ";
			}
			if ($(el).hasClass('token')) {
				value += "%" + ++tokenCounter + "%";
			} else {
				value += $(el).text();
			}
		});

		value = value.replace(/\s([\s,\.;:!?])/g, "$1"); // remove double space and space before punctuation

		updateLabel(label, value.trim(), lang, function (response) {
			utils.animateCheck('success', btn);
		}, true);
	};

	var createAccount = function createAccount(captcha) {
		var t = $(this);
		var form = t.closest('form');
		var popup = t.closest('.popup');

		if (t.hasClass('disabled')) {
			return;
		}

		formValidator.validateForm(form);
		if (form.hasClass('has-error')) {
			grecaptcha.reset(t.attr('data-widget-id'));
			return;
		}
		t.addClass('disabled');
		popup.addClass('is-processing');

		var data = {
			"email": $('.form-input[name="email"]', form).val(),
			"password": $('input[name="password"]', form).val(),
			"firstName": $('.form-input[name="firstName"]', form).val(),
			"lastName": $('.form-input[name="lastName"]', form).val(),
			"field1": $('.form-input[name="account-type"]', form).val(),
			"field16": 'change-pw',
			"ajax": true,
			"captcha": captcha
		};

		$.ajax({
			url: '/action/createAccount',
			type: 'POST',
			cache: false,
			data: data,
			success: function success(response) {
				if (response.indexOf('success') !== -1) {
					window.location.href = $('input[name="forward"]', form).val();
				} else if (response.indexOf('fail') !== -1) {
					formValidator.showErrorPopupAnimation('email-error');
					popup.removeClass('is-processing');
					t.removeClass('disabled');
					grecaptcha.reset(t.attr('data-widget-id'));
				}
			}
		});
	};

	var init = function init() {
		utils = Fw.component.models().utils;
		formValidator = Fw.component.models().form;
		customSelect = Fw.component.models().customSelect;

		$('.validate-account-btn').click(validateAccount);
		$('.toggle-subscription-status-btn').click(toggleSubscription);
		$('.update-subscription-btn').click(updateSubscription);
		$('.save-notification-label-btn').on('click', saveNotificationLabel);

		$('.create-account-btn').each(function (i, el) {
			$(el).closest('form').on('submit', preventDefault);
			Fw.component.models().utils.recaptcha2(el, createAccount);
		});

		$('.mg2-admin-db-btn-hijack').on('click', function () {
			$(this).closest('.processing-loader').addClass('is-processing');
		});
	};

	$(init);
})(jQuery);
(function ($, undefined) {

	'use strict';

	var utils;
	var form;
	var header;
	var popup;

	var delAudition = function delAudition() {
		var lang = $('html').attr('lang');
		var t = $(this);
		var itemId = t.attr('data-item-id');
		var item = $('.audition-list-item[data-id="' + itemId + '"]');
		var tpopup = t.closest('.popup');
		var message = $('textarea[name=audition-single-delete-text]').val();
		var subject = $('input[name=audition-single-delete-subject]').val();
		var auditionName = $('.audition-single-main-title').html();
		var list = $('.audition-single-audition-invitees-emails').val();

		tpopup.addClass('is-processing');

		var _complete = function _complete() {
			$.ajax({
				url: '/action/vcSendAuditionInvitations',
				cache: false,
				data: {
					auditionId: itemId,
					delete: true,
					ajax: true
				},
				method: 'POST',
				success: function success(response) {
					var isSuccess = $.trim(response) === 'success';
					// console.log('project : ' + response + ', ' + isSuccess);

					if (isSuccess) {
						form.showErrorPopupAnimation('audition-delete-success');

						if (item.length) {
							item.slideUp(200, function () {
								item.remove();
							});
							popup.closeAllPopup();
						} else {
							window.location.href = t.attr('data-redirect');
						}
					} else {
						form.showErrorPopupAnimation('audition-delete-error');
					}
				}
			});
		};

		if (tpopup.find('input[name=toggle-audition-deleted-msg-checkbox]').is(':checked')) {
			var emailsArray = list.split(',');
			var count = 0;
			var total = emailsArray.length;

			emailsArray.forEach(function (emailAddr) {
				count++;

				utils.sendEmail(emailAddr, subject, message, 'audition-delete-' + lang, { field1: auditionName }, function (response) {
					// console.log('sending email : ' + response);

					if (count >= total) {
						_complete();
					}
				});
			});
		} else {
			_complete();
		}
	};

	var duplicateAudition = function duplicateAudition() {
		var t = $(this);
		var itemId = t.attr('data-item-id');
		var item = $('.audition-box[data-id="' + itemId + '"], .audition-single-data');
		var redirect = t.attr('data-redirect');
		var currDate = new Date();

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				field1: item.attr('data-field1'),
				field2: item.attr('data-field2'),
				field3: item.attr('data-field3'),
				field4: item.attr('data-field4'),
				field5: item.attr('data-field5'),
				field6: item.attr('data-field6'),
				field8: item.attr('data-field8'),
				field9: item.attr('data-field9'),
				field10: item.attr('data-field10'),
				field11: item.attr('data-field11'),
				field12: item.attr('data-field12'),
				field13: '0',
				field14: item.attr('data-field14'),
				field15: item.attr('data-field15'),
				field16: item.attr('data-field16'),
				field17: item.attr('data-field17'),
				field18: item.attr('data-field18'),
				field19: item.attr('data-field19'),
				dateField1Year: currDate.getFullYear(),
				dateField1Month: currDate.getMonth(),
				dateField1Day: currDate.getDate(),
				dateField1Hour: currDate.getHours(),
				dateField1Minute: currDate.getMinutes(),
				dateField1Second: currDate.getSeconds(),
				dateField2Year: item.attr('data-date2Year'),
				dateField2Month: item.attr('data-date2Month'),
				dateField2Day: item.attr('data-date2Day'),
				dateField2Hour: 0,
				dateField2Minute: 0,
				dateField2Second: 0,
				dateField3Year: item.attr('data-date3Year'),
				dateField3Month: item.attr('data-date3Month'),
				dateField3Day: item.attr('data-date3Day'),
				dateField3Hour: 0,
				dateField3Minute: 0,
				dateField3Second: 0,
				friendlyUrlField: 'field3',
				redirectToFriendlyUrl: true,
				ajax: true
			},
			method: 'POST',
			success: function success(response) {
				console.log('Auditions form : ' + response);
				var newId = response.substring('success-'.length);

				window.location.href = redirect + '/' + newId;
			}
		});
	};

	var publishAudition = function publishAudition() {
		var t = $(this);
		var itemId = t.attr('data-item-id');
		var popup = t.closest('.popup');

		popup.addClass('is-processing');

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: itemId,
				field13: '1',
				ajax: true
			},
			method: 'POST',
			success: function success(response) {
				var isSuccess = response.substring(0, response.indexOf('-')) === 'success';
				console.log('Audition publish : ' + response + ', ' + isSuccess);

				if (isSuccess) {
					form.showErrorPopupAnimation('audition-publish-success');

					var notifier = document.querySelector('.audition-list-item-publish-notification-' + itemId);
					if (notifier) {
						$.ajax({
							url: '/action/vcCreateNotification',
							data: {
								newPublicAudition: true,
								label: 'notification-audition-public-published',
								values: notifier.getAttribute('data-name') + ',' + notifier.getAttribute('data-url'),
								auditionId: itemId
							},
							cache: false,
							success: function success() {
								window.location.reload();
							}
						});
					} else {
						window.location.reload();
					}
				} else {
					popup.removeClass('is-processing');
					form.showErrorPopupAnimation('audition-publish-error');
				}
			}
		});
	};

	var draftAudition = function draftAudition() {
		var t = $(this);
		var itemId = t.attr('data-item-id');

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: itemId,
				field13: '0',
				ajax: true
			},
			method: 'POST',
			success: function success(response) {
				var isSuccess = response.substring(0, response.indexOf('-')) === 'success';
				console.log('Audition sketch : ' + response + ', ' + isSuccess);

				if (isSuccess) {
					form.showErrorPopupAnimation('audition-sketch-success');

					window.location.reload();
				} else {
					form.showErrorPopupAnimation('audition-sketch-error');
				}
			}
		});
	};

	var closeAudition = function closeAudition() {
		var t = $(this);
		var itemId = t.attr('data-item-id');
		var itemData = $('.audition-list-item-close-notification-' + itemId).data();
		var personId = itemData.person;
		var auditionName = itemData.name;
		var list = itemData.invitees;
		var notify = $('.notify-invitees-audition-closed-checkbox').prop('checked');
		var extraData = $('.audition-single-data').attr('data-extra').length !== 0 ? JSON.parse($('.audition-single-data').attr('data-extra')) : {};

		extraData['manualClose'] = true;

		if (personId === '') {
			personId = $('.audition-single-person-id').val();
		}
		if (auditionName === '') {
			auditionName = $('.audition-single-main-title').text();
		}
		if (list === '') {
			list = $('.audition-single-audition-invitees').val();
		}

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: itemId,
				extraData: JSON.stringify(extraData),
				ajax: true
			},
			method: 'POST',
			success: function success(response) {
				var isSuccess = response.substring(0, response.indexOf('-')) === 'success';
				console.log('Audition close : ' + response + ', ' + isSuccess);

				if (isSuccess) {
					form.showErrorPopupAnimation('audition-close-success');
					// Audition closed
					console.log(list, auditionName, personId);
					if (list !== '' && notify) {
						Fw.component.models().notificationUtils.sendNotificationPerson(list, "AUDITION_CLOSED", auditionName, function () {
							window.location.reload();
						}, { field8: personId });
					} else {
						window.location.reload();
					}
				} else {
					form.showErrorPopupAnimation('audition-close-error');
				}
			}
		});
	};

	var uncloseAudition = function uncloseAudition() {
		var t = $(this);
		var itemId = t.attr('data-item-id');
		var extraData = $('.audition-single-data').attr('data-extra').length !== 0 ? JSON.parse($('.audition-single-data').attr('data-extra')) : {};

		extraData['manualClose'] = false;

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: itemId,
				extraData: JSON.stringify(extraData),
				ajax: true
			},
			method: 'POST',
			success: function success(response) {
				var isSuccess = response.substring(0, response.indexOf('-')) === 'success';
				console.log('Audition unclose : ' + response + ', ' + isSuccess);

				if (isSuccess) {
					form.showErrorPopupAnimation('audition-unclose-success');

					window.location.reload();
				} else {
					form.showErrorPopupAnimation('audition-unclose-error');
				}
			}
		});
	};

	var archiveAudition = function archiveAudition() {
		var t = $(this);
		var itemId = t.attr('data-item-id');

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: itemId,
				field13: '4',
				ajax: true
			},
			method: 'POST',
			success: function success(response) {
				var isSuccess = response.substring(0, response.indexOf('-')) === 'success';
				console.log('Audition archive : ' + response + ', ' + isSuccess);

				if (isSuccess) {
					form.showErrorPopupAnimation('audition-archive-success');

					window.location.reload();
				} else {
					form.showErrorPopupAnimation('audition-archive-error');
				}
			}
		});
	};

	var showList = function showList(e) {
		var btn = e.currentTarget;
		var hash = btn.href.substr(btn.href.indexOf('#') + 1);

		$('.auditions-list-anchors-ctn .btn.selected').removeClass('selected');
		$('.auditions-list-wrap.selected').removeClass('selected');

		$(btn).addClass('selected');
		$('.auditions-list-wrap[data-anchor="' + hash + '"]').addClass('selected');
	};

	var checkEmptyList = function checkEmptyList() {
		var $it = $(this);
		var itemCount = $it.find('.audition-box').length;
		var emptyMsger = $it.prev('.auditions-list-empty');

		if (itemCount) {
			emptyMsger.hide();
			if (!$it.closest('.auditions-com-slider-ctn')[0]) {
				emptyMsger.before('<p>' + itemCount + ' auditions</div>');
			}
		} else {
			emptyMsger.show();
			if ($it.closest('.public-auditions-com').length !== 0) {
				$it.closest('.public-auditions-com').slideUp(0);
			}
		}
	};

	var init = function init() {
		utils = Fw.component.models().utils;
		form = Fw.component.models().form;
		header = Fw.modules.models().header;
		popup = Fw.component.models().popup;

		$('body').on('click', '.js-audition-list-item-del', delAudition);
		$('body').on('click', '.js-audition-list-item-duplicate', duplicateAudition);
		$('body').on('click', '.js-audition-list-item-publish', publishAudition);
		$('body').on('click', '.js-audition-list-item-sketch', draftAudition);
		$('body').on('click', '.js-audition-list-item-close', closeAudition);
		$('body').on('click', '.js-audition-list-item-unclose', uncloseAudition);
		$('body').on('click', '.js-audition-list-item-archive', archiveAudition);

		//        $('.auditions-list-anchors-ctn .btn').on('click', showList);
		//        if (!window.location.hash) {
		//            // Show the first content list
		//            $('.auditions-list-anchors-ctn .btn:eq(0)').trigger('click');
		//        } else {
		//            $('.auditions-list-anchors-ctn .btn[href*="' + window.location.hash + '"]').trigger('click');
		//        }
		$('.auditions-list').each(checkEmptyList);
		$('.auditions-list-ctn .processing-loader').removeClass('is-processing');
	};

	$(window).ready(init);
})(jQuery);
(function ($, undefined) {

	'use strict';

	var toggleBill = function toggleBill() {
		$(this).next('.mg2-admin-person-order-bottom').slideToggle();
	};

	var init = function init() {
		$('.mg2-admin-person-order-top').click(toggleBill);
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var session;
	var slider = $('.artist-most-played-demos-ctn');

	var toggleDashboardSide = function toggleDashboardSide() {
		var dashboardPage = $('.dashboard-style-page');
		var dashboardSideContent = $('.dashboard-style-page-side-content');
		var dashboardSideMinifiedContent = $('.dashboard-style-page-side-minified-content');
		dashboardPage.toggleClass('side-open');

		if (dashboardPage.hasClass('side-open')) {
			dashboardSideMinifiedContent.fadeOut(175, function () {
				dashboardSideContent.fadeIn(175);
			});
		} else {
			dashboardSideContent.fadeOut(100, function () {
				dashboardSideMinifiedContent.fadeIn(175);
			});
		}

		session.save('side-open', dashboardPage.hasClass('side-open'), function () {});
	};

	var initSlick = function initSlick() {
		if ($('.resp-detector-ph').css('visibility') === 'visible') {
			slider.slick({
				infinite: true,
				swipeToSlide: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: true,
				arrows: false
			});
		} else if (slider.hasClass('slick-initialized')) {
			slider.slick('unslick');
		}
	};

	var openDashboardMobileMenu = function openDashboardMobileMenu() {
		$('.dashboard-mobile-menu-ctn').addClass('dashboard-mobile-open');
	};

	var closeDashboardMobileMenu = function closeDashboardMobileMenu() {
		$('.dashboard-mobile-menu-ctn').removeClass('dashboard-mobile-open');
	};

	var init = function init() {
		session = Fw.component.models().session;

		$('.toggle-dashboard-side-btn').click(toggleDashboardSide);
		$('.dashboard-mobile-menu-toggle-btn').click(openDashboardMobileMenu);
		$('.dashboard-mobile-menu-btns-ctn').click(closeDashboardMobileMenu);

		if (slider.length) {
			initSlick();
		}

		$(window).resize(function () {
			initSlick();
		});
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var formValidator;
	var notificationUtils;
	var messagesListContainer;

	var sendNewMessage = function sendNewMessage(e) {
		var t = $(this);
		var form = t.closest('form');
		var receiverId;

		if (form.find('input[name=targetPersonId]').length !== 0) {
			receiverId = $('input[name=targetPersonId]', form).val();
		} else if (form.find('input[name=searcherId]').length !== 0) {
			receiverId = $('input[name=searcherId]', form).val();
		} else {
			receiverId = $('input[name=ids]', form).val();
		}
		if ($('input[name=ccId]', form).val()) {
			receiverId += ',' + $('input[name=ccId]', form).val();
		}

		formValidator.validateForm(form);
		if (form.hasClass('has-error')) {
			return false;
		}
		t.addClass('disabled');
		form.find('input[name="receiverIds"]').val(receiverId);
		setTimeout(function () {
			form.submit();
		}, 200);
	};

	$(window).ready(function () {
		formValidator = Fw.component.models().form;
		notificationUtils = Fw.component.models().notificationUtils;
		messagesListContainer = $('.messages-list')[0];

		$('.send-new-message-btn').click(sendNewMessage);

		if (messagesListContainer) {
			messagesListContainer.scrollTop = messagesListContainer.scrollHeight;
		}
	});
})(jQuery);
(function ($) {

	'use strict';

	var formValidator;
	var customSelect;

	var updateSubscriptionDetails = function updateSubscriptionDetails(e, sel) {
		var select = sel !== undefined ? sel : $(this);
		var form = select.closest('form');
		var packageInputs = select.closest('.fieldset');

		formValidator.validateForm(packageInputs);

		if (!packageInputs.hasClass('has-error')) {
			updateSubscriptionRecap(form);
		}
	};

	var updateSubscriptionRecap = function updateSubscriptionRecap(form) {
		var productId = form.find('.form-select[name=productId]').val();
		var quantity = form.find('.form-select[name=quantity]').val();
		var personId = form.find('input[name=personId]').val();
		var payerId = form.find('.form-select[name=useCardPersonId]').val();
		var payerId2 = form.find('.form-select[name=storeCardPersonId]').val();
		var url = '/action/shopUpdateSubscription';

		url += '?productId=' + productId;
		url += '&quantity=' + quantity;
		if (personId !== undefined) {
			url += '&personId=' + personId;
			if (payerId !== undefined && payerId !== '' && payerId !== 'new-card') {
				url += '&useCardPersonId=' + payerId;
			}
			if (payerId === 'new-card') {
				url += '&useCardPersonId=' + payerId2;
			}
		}
		url += '&summary=true';
		url += '&ajax=true';

		if (productId != '') {
			ajax(url, function (response) {
				var json = JSON.parse(response);
				$('.total-to-pay.amount', form).html(json.toPay);
				$('.pay-now.amount', form).html(json.toPayNow);
				if (json.promo !== '0.00' && json.promo !== '0,00') {
					$('.rebate-promo.amount', form).html(json.promo);
					$('.rebate-promo-ctn', form).slideDown();
				} else {
					$('.rebate-promo-ctn', form).slideUp();
				}
				if (json.rebatePerc !== '0.00' && json.rebatePerc !== '0,00') {
					$('.rebate-perc.amount', form).html(json.rebatePerc);
					$('.rebate-perc-ctn', form).slideDown();
				} else {
					$('.rebate-perc-ctn', form).slideUp();
				}
				if (json.rebateAmt !== '0.00' && json.rebateAmt !== '0,00') {
					$('.rebate-amt.amount', form).html(json.rebateAmt);
					$('.rebate-amt-ctn', form).slideDown();
				} else {
					$('.rebate-amt-ctn', form).slideUp();
				}
				if (json.tax1 !== '0.00' && json.tax1 !== '0,00') {
					$('.rebate-amt-tax1.amount', form).html(json.tax1);
					$('.rebate-amt-tax1.codename', form).html(json.taxName1 + " (" + json.taxNbr1 + "): ");
					$('.rebate-amt-tax1-ctn', form).slideDown();
				} else {
					$('.rebate-amt-tax1-ctn', form).slideUp();
				}
				if (json.tax2 !== '0.00' && json.tax2 !== '0,00') {
					$('.rebate-amt-tax2.amount', form).html(json.tax2);
					$('.rebate-amt-tax2.codename', form).html(json.taxName2 + " (" + json.taxNbr2 + "): ");
					$('.rebate-amt-tax2-ctn', form).slideDown();
				} else {
					$('.rebate-amt-tax2-ctn', form).slideUp();
				}
				if (parseFloat(json.alreadyPaid.replace(',', '.')) === 0) {
					$('.already-paid', form).parent().hide();
				} else {
					$('.already-paid', form).parent().show();
				}
				$('.already-paid.amount', form).html(json.alreadyPaid);
				$('.pay-later.amount', form).html(json.toPayLater);
				$('.form-input[name=code]', form).val(json.promoName);

				var zero = $('html').attr('lang') === 'en' ? '0.00' : '0,00';
				$('.next-payment-date', form).html(json.toPayLater === zero && json.toPayNow === zero ? '-' : json.payDate);

				$('.price-recap-ctn', form).slideDown();
			}, true);
		}
	};

	var toggleSaveCard = function toggleSaveCard() {
		var t = $(this);
		var form = t.closest('form');

		if (t.prop('checked')) {
			form.append('<input type="hidden" name="storeCard" value="true"/>');
		} else {
			form.find('input[name="storeCard"]').remove();
		}
	};

	var modifySubscription = function modifySubscription(e) {
		if (e) e.preventDefault();

		var form = $(this);

		if (form.hasClass('submitting')) {
			return false;
		}

		formValidator.validateForm(form);

		if (form.hasClass('has-error')) {
			formValidator.showErrorPopup();
			return false;
		}

		// If card info exists, remove unused elements
		if (form.find('input[name="useCard"]')[0]) {
			if (form.find('input[name="cardToken"]').val()) {
				form.find('input[name="useCard"]').remove();
			} else {
				form.find('.form-box[data-id="cc-box-form"]').remove();
			}
		}
		form.find('.get-stripe-token').addClass('disabled');
		form.find('.select-state-input-ctn:not(.selected)').remove();

		// Append the renew value in the form
		var autoRenew = form.find('.form-check-input[name="renewCheck"]').prop('checked');
		form.find('input[name="renew"]').val(autoRenew);

		form.addClass('submitting');
		form[0].submit();
	};

	var checkCardChoice = function checkCardChoice() {
		var t = $(this);
		var ccCtn = t.closest('form').find('.form-box[data-id="cc-box-form"]');

		if (t.val() === 'new-card') {
			ccCtn.slideDown();
			ccCtn.find('input.derequired, select.derequired').removeClass('derequired').addClass('required');
		} else {
			ccCtn.slideUp();
			ccCtn.find('input.required, select.required').removeClass('required').addClass('derequired');
		}
		updateSubscriptionRecap(t.closest(".user-subscription-modif-form"));
	};

	var cancelModifications = function cancelModifications() {
		var t = $(this);
		var personId = t.attr('data-id');

		$.ajax({
			url: '/action/shopUpdateSubscription',
			cache: false,
			method: 'POST',
			data: {
				personId: personId,
				cancelEdit: true,
				ajax: true
			},
			success: function success(response) {
				if (response.indexOf('success') !== -1) {
					formValidator.showSuccessPopup();
					t.closest('form').find('.cancel-subscription-modification-ctn').slideUp();
				}
			}
		});
	};

	var showDetails = function showDetails(e) {
		var dataId = $(this).attr("data-id");
		var form = $(".modif-subscription-form-outer-ctn[data-id = " + dataId + "]");
		if ($(".price-recap-ctn.hide", form).length !== 0) {
			updateSubscriptionDetails(null, $(".user-subscription-modif-form", form));
		}
	};

	var toggleSubscription = function toggleSubscription() {
		var t = $(this);
		var val = t.data('value');

		$.ajax({
			url: '/action/shopPauseSubscription',
			cache: false,
			method: 'POST',
			data: {
				pause: val,
				ajax: true
			},
			success: function success(response) {
				if (response.indexOf('success') !== -1) {
					window.location.reload();
				} else if (response.indexOf('fail') !== -1) {
					formValidator.showErrorPopupAnimation('error-pause-subscription-msg');
				}
			}
		});
	};

	var fetchErrorMessage = function fetchErrorMessage() {
		var ctn = $('.subscription-management-error');
		if (ctn.length) {
			ajax('/action/getCurrPaymentError', function (resp) {
				if (resp.trim() !== '') {
					ctn.find('.alert-content').append("<br/>").append(resp);
				}
			}, true);
			ajax('/action/getPaymentStoreCardError', function (resp) {
				if (resp.trim() !== '') {
					ctn.find('.alert-content').append("<br/>").append(resp);
				}
			}, true);
		}
	};

	$(window).ready(function (e) {
		formValidator = Fw.component.models().form;
		customSelect = Fw.component.models().customSelect;

		$('.modify-subscription-add-cart').change(updateSubscriptionDetails);
		$('.user-subscription-modif-form').on('submit', modifySubscription);
		$('.form-check-input[name=storeCardCheck]').click(toggleSaveCard);
		$('.form-input[name=useCardPersonId]').change(checkCardChoice);
		$('.form-input[name=storeCardPersonId]').change(function () {
			updateSubscriptionRecap($(this).closest(".user-subscription-modif-form"));
		});
		$('.cancel-subscription-modification').click(cancelModifications);
		$('.modify-artist-subscription-table-btn').click(showDetails);
		$('.toggle-pause-subscription-btn').click(toggleSubscription);

		if ($('.modify-artist-subscription-table-btn').length === 0 && $(".user-subscription-modif-form").length !== 0) {
			updateSubscriptionDetails(null, $(".user-subscription-modif-form"));
		}

		fetchErrorMessage();
	});

	Fw.page.export('subscriptionUpdate', {
		updateSubscriptionRecap: updateSubscriptionRecap
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var notificationUtils;
	var accountUtils;
	var customSelect;

	var win = $(window);
	var winWidth;
	var winHeight;
	var form;
	var auditionId;
	var auditionState;
	var publishCtn;
	var currForm;
	var formSubmit;
	var stepHeader;
	var stepNextBtn;
	var stepHeight;
	var addStudioDate;
	var directivesInput;
	var scriptsInput;
	var scriptAdd;
	var auditionType;
	var recordingCheck;
	var checkingPageLeave = false;
	var pageLeaveUrl;
	var redirect;
	var redirectInvites;
	var popupRedirect;
	var searcherId;
	var sendEditNotificationCheck;
	var sendInvitesPopupBtn;

	var studioChk;
	var sourceConnectChk;

	var submitAudition = function submitAudition(e) {
		e.preventDefault();
		e.stopPropagation();
		if (currForm.hasClass('is-processing')) {
			return false;
		}

		var t = $(this);
		var gotoDetail = false;
		var gotoStay = t.hasClass('stay');
		var goToInvites = false;
		var preview = t.hasClass('preview');
		var isVideo = $('.form-input[name="field19"]').val() === '1';
		var recordingCtn = isVideo ? $('.audition-recording-inputs.video-input') : $('.audition-recording-inputs.audio-input');
		redirect = publishCtn.attr('data-redirect-detail');
		redirectInvites = publishCtn.attr('data-redirect-invite');

		if (!preview) {
			form.validateForm(currForm, true);
		}

		if (!currForm.hasClass('has-error') || preview) {
			var recordingDates = $('.account-option-item[data-rel="audition-recording-dates"]:not(.clone)', recordingCtn);
			var $scripts = $('.audition-form-script-item:not(.clone)');

			if ($scripts.length || preview) {
				if (recordingDates.length && ($('.audition-forms-recording-responsable:checked').val() === 'false' && !isVideo || isVideo) || $('.audition-forms-recording-responsable:checked').val() === 'true' && !isVideo || preview) {
					var id = auditionId;
					var limit = $('.form-input[name="limit"]').val();
					var recResponsableDate = $('.form-input[name="audition-forms-recording-responsable-date"]').val();
					var publish = $('.auditions-form-publish-check').is(':checked');
					var auditionType = $('.form-input[name="field2"]').attr('data-value');
					var sendEditNotification = false;
					var history = $('input[name="edit-notification-detail-history"]').length === 0 || $('input[name="edit-notification-detail-history"]').val() === '' ? {} : JSON.parse($('input[name="edit-notification-detail-history"]').val());

					currForm.addClass('is-processing');

					if (id === undefined) {
						var currDate = new Date();

						$('input[name="dateField1Year"]').val(currDate.getFullYear());
						$('input[name="dateField1Month"]').val(currDate.getMonth());
						$('input[name="dateField1Day"]').val(currDate.getDate());
						$('input[name="dateField1Hour"]').val(currDate.getHours());
						$('input[name="dateField1Minute"]').val(currDate.getMinutes());
						$('input[name="dateField1Second"]').val(currDate.getSeconds());
					} else {
						sendEditNotification = $('.auditions-form-notify-check').is(':checked');

						var edit = $('.form-input[name="send-notification-detail"]').length > 0 ? tinymce.get($('.form-input[name="send-notification-detail"]').attr('id')).getContent() : '';
						if (edit !== '') {
							var currDate = new Date();
							var c = Object.keys(history).length / 2;
							history["edit" + c] = edit;
							var d = currDate.getDate() < 10 ? "0" + currDate.getDate() : currDate.getDate();
							var m = currDate.getMonth() + 1 < 10 ? "0" + (currDate.getMonth() + 1) : currDate.getMonth() + 1;
							var y = currDate.getFullYear();
							history["date" + c] = d + "." + m + "." + y;
						}
					}

					if (limit !== '') {
						var limitDateTime = limit.split(' ')[0];
						var limitDateDate = limit.split(' ')[1];
						var limitDateYear = parseInt(limitDateDate.substring(6));
						var limitDateMonth = parseInt(limitDateDate.substring(3, 5)) - 1;
						var limitDateDay = parseInt(limitDateDate.substring(0, 2));
						var limitDateminutes = parseInt(limitDateTime.substring(3));
						var limitDatehours = parseInt(limitDateTime.substring(0, 2));
						var limitDate = new Date(limitDateYear, limitDateMonth, limitDateDay, limitDatehours, limitDateminutes);

						$('input[name="dateField2Year"]').val(limitDate.getFullYear());
						$('input[name="dateField2Month"]').val(limitDate.getMonth());
						$('input[name="dateField2Day"]').val(limitDate.getDate());
						$('input[name="dateField2Hour"]').val(limitDate.getHours());
						$('input[name="dateField2Minute"]').val(limitDate.getMinutes());
						$('input[name="dateField2Second"]').val(limitDate.getSeconds());
						$('input[name="deleteDateField2"]').val('false');
					} else {
						$('input[name="dateField2Year"]').remove();
						$('input[name="dateField2Month"]').remove();
						$('input[name="dateField2Day"]').remove();
						$('input[name="dateField2Hour"]').remove();
						$('input[name="dateField2Minute"]').remove();
						$('input[name="dateField2Second"]').remove();
						$('input[name="deleteDateField2"]').val('true');
					}

					if (recResponsableDate !== '' && $('.audition-forms-recording-responsable:checked').val() === 'true' && !isVideo) {
						var recResponsableDateDateTime = recResponsableDate.split(' ')[0];
						var recResponsableDateDateDate = recResponsableDate.split(' ')[1];
						var recResponsableDateDateYear = parseInt(recResponsableDateDateDate.substring(6));
						var recResponsableDateDateMonth = parseInt(recResponsableDateDateDate.substring(3, 5)) - 1;
						var recResponsableDateDateDay = parseInt(recResponsableDateDateDate.substring(0, 2));
						var recResponsableDateDateminutes = parseInt(recResponsableDateDateTime.substring(3));
						var recResponsableDateDatehours = parseInt(recResponsableDateDateTime.substring(0, 2));
						var recResponsableDateDate = new Date(recResponsableDateDateYear, recResponsableDateDateMonth, recResponsableDateDateDay, recResponsableDateDatehours, recResponsableDateDateminutes);

						$('input[name="dateField3Year"]').val(recResponsableDateDate.getFullYear());
						$('input[name="dateField3Month"]').val(recResponsableDateDate.getMonth());
						$('input[name="dateField3Day"]').val(recResponsableDateDate.getDate());
						$('input[name="dateField3Hour"]').val(recResponsableDateDate.getHours());
						$('input[name="dateField3Minute"]').val(recResponsableDateDate.getMinutes());
						$('input[name="dateField3Second"]').val(recResponsableDateDate.getSeconds());
						$('input[name="deleteDateField3"]').val('false');
					} else {
						$('input[name="dateField3Year"]').remove();
						$('input[name="dateField3Month"]').remove();
						$('input[name="dateField3Day"]').remove();
						$('input[name="dateField3Hour"]').remove();
						$('input[name="dateField3Minute"]').remove();
						$('input[name="dateField3Second"]').remove();
						$('input[name="deleteDateField3"]').val('true');
					}

					var contractual = {
						cachet: $('input[name="contractual-cachet"]').val(),
						media: $('input[name="contractual-media"]').val(),
						cycle: $('input[name="contractual-cycle"]').val(),
						market: $('input[name="contractual-market"]').val()
					};

					var recording = {
						title: $('input[name="studio-title"]', recordingCtn).val(),
						address: $('input[name="studio-address"]', recordingCtn).val(),
						dates: {}
					};

					recordingDates.each(function (i) {
						recording.dates[i] = {
							date: $(this).attr('data-iso'),
							from: $(this).attr('data-from'),
							to: $(this).attr('data-to')
						};
					});

					var directives = {
						detail: tinymce.get($('.form-input[name="directives-detail"]').attr('id')).getContent(),
						files: {}
					};

					$('.account-option-item[data-rel="audition-forms-directives-files-item"]:not(.clone)').each(function (e) {
						var file = $(this);
						directives.files[e] = {
							filename: $('.account-option-item-value', file).html(),
							id: file.attr('data-id'),
							ext: file.attr('data-ext')
						};
					});

					var scripts = '';
					$('.audition-form-script-item:not(.clone)').each(function (e) {
						var file = $(this);
						var fileId = $(this).attr('data-id');

						if (fileId !== undefined) {
							if (scripts !== '') {
								scripts += ',';
							}

							scripts += fileId;
						}
					});

					var field4;
					var field14;
					var field21;
					var field24;
					var field25;

					if (isVideo) {
						field4 = accountUtils.formatStringArray('.account-type-list', $('.audition-project-types.video-input'));
						field14 = false;
						field21 = $('.form-input[name="field21"]').attr('data-value');
					} else {
						field4 = accountUtils.formatStringArray('.account-type-list', $('.audition-project-types.audio-input'));
						field14 = $('.audition-forms-recording-responsable:checked').val();
						field21 = '';
					}

					field24 = $('.form-check-input[name="field24"]')[0].checked;
					field25 = $('.form-check-input[name="field25"]')[0].checked;

					var changes = "";
					if (sendEditNotification) {
						changes = tinymce.get($('.form-input[name="directives-detail"]').attr('id')).getContent();
					}

					var data = {
						field1: 'audition',
						field2: auditionType,
						field4: field4,
						field6: JSON.stringify(recording),
						field8: JSON.stringify(contractual),
						field9: currForm.attr('data-person-id'),
						field10: JSON.stringify(directives),
						field11: scripts,
						field12: $('.form-input[name="field12"]').attr('data-value'),
						field13: '0',
						field14: field14,
						field16: accountUtils.formatStringArray('.audition-form-region-list'),
						field17: $('.form-input[name="field17"]').attr('data-value'),
						field18: accountUtils.formatStringArray('.audition-form-int-lang-list'),
						field19: $('.form-input[name="field19"]').val(),
						field20: $('.form-input[name="field20"]').attr('data-value'),
						field21: field21,
						field23: JSON.stringify(history),
						field24: field24,
						field25: field25,
						field27: $('.form-input[name="field27"]').attr('data-value'),
						ajax: true,
						friendlyUrlField: 'field3',
						redirectToFriendlyUrl: true
					};

					if (preview) {
						data.preview = true;
					}

					if (publish && (!auditionState || auditionState === '0')) {
						data.field13 = '1';
					} else if (!!auditionState) {
						data.field13 = auditionState;
					}

					if ($(".audition-type-select").attr("data-value") === '1' && t.hasClass('invites-popup') && data.field13 === '1') {
						goToInvites = true;
					}

					// Weird stuff here : if we are going to set a data object manually, why are we fetching everything automatically here ?
					// It messes up checkboxes since it depends on if they are checked or not
					$('input', currForm).each(function () {
						if ($(this).attr('name') !== 'field24' && $(this).attr('name') !== 'field25') {
							data[$(this).attr('name')] = $(this).val();
						}
					});

					//console.log(data);

					// Saving the audition
					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						data: data,
						method: 'POST',
						success: function success(response) {
							//console.log('Auditions form : ' + response);
							var currRedirectPage = currForm.attr('data-page-name');
							var responseArray = response.substring('success-'.length).split('-');
							auditionId = responseArray[responseArray.length - 1];

							if ($('input[name="id"]', currForm).length === 0) {
								currForm.append('<input name="id" type="hidden" value="' + auditionId + '"/>');
							}

							var array = currForm.attr('data-invitees').split(','),
							    inviteeIds = [],
							    requestTotal = 0,
							    redirectFriendlyUrl = response.substring('success-'.length);

							var _complete = function _complete() {
								if (preview) {
									window.open(t.attr('data-redirect'));
									currForm.removeClass('is-processing');
								} else if (requestTotal <= 0) {
									var messageToShow = '?' + ($('.audition-forms').attr('data-edit') === 'true' ? 'auditionEdited' : 'auditionCreated');

									//&& $('.audition-forms').attr('data-edit') !== 'true'
									if (gotoDetail) {
										if (data.field2 === '1') {
											currRedirectPage = currForm.attr('data-page-invitations');
										}
										window.location.href = currRedirectPage + '/' + redirectFriendlyUrl + messageToShow;
									} else if (goToInvites) {
										popupRedirect = '/' + redirectFriendlyUrl + messageToShow;
										$('.invites-choice-popup-btn').trigger('click');
									} else if (gotoStay) {
										window.location.href = redirect + '/' + redirectFriendlyUrl + messageToShow;
									} else {
										window.location.href = redirect + messageToShow;
									}
								}
							};

							var _notifyPublic = function _notifyPublic() {
								if (requestTotal <= 0) {
									$.ajax({
										url: '/action/vcCreateNotification',
										data: {
											newPublicAudition: true,
											label: 'notification-audition-public-published',
											values: $('input[name=field3]').val() + ',' + currForm.attr('data-page-domain') + currRedirectPage + '/' + redirectFriendlyUrl,
											auditionId: auditionId
										},
										cache: false,
										success: _complete
									});
								}
							};

							if (!preview && sendEditNotification) {
								for (var i = 0; i < array.length; i++) {
									if (array[i] !== undefined && array[i] !== "" && inviteeIds.indexOf(array[i]) === -1) {
										inviteeIds.push(array[i]);
									}
								}
								// Send notifications to all non-declined invitations of this audition
								if (inviteeIds.length !== 0) {
									notificationUtils.sendNotificationPerson(inviteeIds.join(','), 'AUDITION_EDIT', data.field3 + "*|||*" + currForm.find(".edit-notification-uri").val(), function () {}, { field8: data.field9 });
								}
							}

							if ($scripts.length > 0 || !preview) {
								requestTotal = $scripts.length;
								$scripts.each(function () {
									var file = $(this);
									var fileId = $(this).attr('data-id');
									// Saving scripts to GenData
									$.ajax({
										url: '/action/manageGenData',
										cache: false,
										method: 'POST',
										data: {
											id: fileId,
											field2: file.find('.form-input[name="audition-form-script-item-title"]').val(),
											field3: file.find('.form-input[name="audition-form-script-item-summary"]').val(),
											field4: file.attr('data-file-id'),
											field5: file.attr('data-filename'),
											field6: file.attr('data-ext'),
											field7: auditionId,
											preservePreviewCache: true,
											ajax: true
										},
										success: function success() {
											requestTotal--;
											if (publish && auditionType === '0' && !preview) {
												_notifyPublic();
											} else {
												_complete();
											}
										}
									});
								});
							} else if (preview) {
								_complete();
							}
						}
					});
				} else {
					form.showErrorPopupAnimation('audition-recording-dates-error');
					var recordingDatesStep = currForm.find('.audition-forms-recording-dates').closest('.audition-forms-step');
					if (recordingDatesStep.find('.audition-forms-step-content').css('display') !== 'block') {
						recordingDatesStep.find('.audition-forms-header').trigger('click');
					}
					currForm.removeClass('is-processing');
				}
			} else {
				form.showErrorPopupAnimation('audition-min-script-error');
				var scriptsStep = currForm.find('.audition-forms-scripts-files').closest('.audition-forms-step');
				if (scriptsStep.find('.audition-forms-step-content').css('display') !== 'block') {
					scriptsStep.find('.audition-forms-header').trigger('click');
				}
				currForm.removeClass('is-processing');
			}
		} else {
			var errors = currForm.find('.error');
			errors.each(function () {
				if ($(this).closest('.audition-forms-step:not(.selected)').length > 0) {
					$(this).closest('.audition-forms-step:not(.selected)').find('.audition-forms-header').trigger('click');
				}
			});
		}

		return false;
	};

	var addStudioDateItem = function addStudioDateItem() {
		var ctn = $(this).closest('.audition-forms-recording');
		var date = $('input[name="studio-date"]', ctn).val();
		var year = parseInt(date.substring(6));
		var month = parseInt(date.substring(3, 5)) - 1;
		var day = parseInt(date.substring(0, 2));
		var timeFrom = $('input[name="studio-time-from"]', ctn).val();
		var timeTo = $('input[name="studio-time-to"]', ctn).val();
		var dateTS = new Date(year, month, day);
		var isoDate = dateTS.toISOString();
		var newElt = $('.account-option-item[data-rel="audition-recording-dates"].clone', ctn).clone().removeClass('clone');

		if (date.length) {
			$('.account-option-item-value', newElt).html(date + ' ' + timeFrom + '-' + timeTo);
			newElt.attr('data-iso', isoDate).attr('data-from', timeFrom).attr('data-to', timeTo);

			$('input[name="studio-date"], input[name="studio-time-from"], input[name="studio-time-to"]', ctn).val('');

			$('.audition-forms-recording-dates-list', ctn).append(newElt);
		}
	};

	var addDirective = function addDirective() {
		addDocument($(this), function (newId, ext, filename) {
			var list = $('.audition-forms-directives-files-list');
			var clone = $('.account-option-item[data-rel="audition-forms-directives-files-item"].clone').clone().removeClass('clone');

			clone.attr('data-id', newId).attr('data-ext', ext);
			$('.account-option-item-value', clone).html(filename);

			list.append(clone);
		});
	};

	var addScripts = function addScripts() {
		addDocument($(this), function (newId, ext, filename, newGenDataId) {
			var list = $('.audition-forms-scripts-files-list');
			var clone = $('.audition-form-script-item.clone').clone().removeClass('clone');
			var position = list.find('.audition-form-script-item:not(.clone)').length + 1;

			clone.attr('data-id', newGenDataId).attr('data-file-id', newId).attr('data-ext', ext).attr('data-filename', filename);
			$('.audition-form-script-item-filename', clone).html(filename);
			clone.find('input[name=audition-form-script-item-title]').val('Script ' + position);

			list.append(clone);
		});
	};

	var addDocument = function addDocument(file, callback) {
		var fileCtn = file.closest('.form-input-big-ctn');
		var files = file[0].files;

		if (files !== undefined) {
			if (files.length) {
				fileCtn.addClass('is-processing');

				for (var i = 0; i < files.length; i++) {

					var re = /(?:\.([^.]+))?$/;
					var ext = re.exec(files[i].name)[1];
					var filename = files[i].name;

					var data = new FormData();
					data.append('image', files[i]);
					data.append('customLabel', 'file');
					data.append('directory', 'Audition');
					data.append('ajax', 'true');

					$.ajax({
						url: '/action/uploadCroppedImage',
						cache: false,
						contentType: false,
						processData: false,
						method: 'POST',
						data: data,
						success: function success(response) {
							var newFileId = response.substring(response.indexOf('mediaId=') + 'mediaId='.length).trim();
							// console.log('file: ' + newFileId);

							var newDate = new Date();

							$.ajax({
								url: '/action/manageGenData',
								cache: false,
								data: {
									field1: 'script',
									field4: newFileId,
									field5: filename,
									field6: ext,
									field7: auditionId,
									dateField1Year: newDate.getFullYear(),
									dateField1Month: newDate.getMonth(),
									dateField1Day: newDate.getDate(),
									dateField1Hour: newDate.getHours(),
									dateField1Minute: newDate.getMinutes(),
									dateField1Second: newDate.getSeconds(),
									ajax: true
								},
								success: function success(genResponse) {
									var newScriptId = genResponse.substring('success-'.length);
									// console.log('script: ' + newScriptId);

									fileCtn.removeClass('is-processing');
									form.resetUpload(file);

									callback(newFileId, ext, filename, newScriptId);
								}
							});
						}
					});
				}
			}
		}
	};

	var scriptDelClick = function scriptDelClick() {
		$(this).closest('.audition-form-script-item').remove();
	};

	var stepHeaderClick = function stepHeaderClick() {
		var t = $(this);
		var currStep = t.closest('.audition-forms-step');
		var currContent = $('.audition-forms-step-content', currStep);

		if (currStep.hasClass('selected')) {
			currStep.removeClass('selected');
			currContent.slideUp(300);
		} else {
			currStep.addClass('selected');
			currContent.slideDown(300);
		}

		manageSelectedSteps();
	};

	var manageSelectedSteps = function manageSelectedSteps() {
		var selectedSteps = $('.audition-forms-step.selected');

		$('.audition-forms-step').removeClass('selected-before');
		if (selectedSteps.length) {
			var lastOne = selectedSteps.eq(-1);
			var index = lastOne.index();

			for (var i = 0; i < index; i++) {
				$('.audition-forms-step').eq(i).addClass('selected-before');
			}
		}
	};

	var goToNextStep = function goToNextStep() {
		var t = $(this);
		var currStep = t.closest('.audition-forms-step');
		var currContent = $('.audition-forms-step-content', currStep);
		var currIndex = currStep.index();
		var nextStep = $('.audition-forms-step').eq(currIndex + 1);
		var nextContent = $('.audition-forms-step-content', nextStep);

		var target = currStep.offset().top + stepHeight - $('.site-header').outerHeight();

		$('html, body').animate({ scrollTop: target + 'px' }, 300);
		currStep.removeClass('selected');
		currContent.slideUp(300);
		nextStep.addClass('selected');
		nextContent.slideDown(300);
		manageSelectedSteps();
	};

	var auditionTypeToggle = function auditionTypeToggle() {
		var type = $(this).closest(".audition-type-select-ctn").find(".audition-type-select").attr("data-value");
		// console.log(type === '0');
		$('.auditions-form-publish-message').hide();
		if (type === '0') {
			// public
			$('.auditions-form-publish-message.public').show();
		} else {
			//invitation
			$('.auditions-form-publish-message.invite').show();
		}
	};

	var recordingToggle = function recordingToggle() {
		if ($(this).val() === 'true') {
			$('.audition-forms-recording-dates-ctn').slideUp(300, function () {
				$(this).find('input').val('');
				$(this).find('.account-option-item:not(.clone)').remove();
			});
			$('.audition-forms-recording-responsable-ctn').slideDown(300);
		} else {
			$('.audition-forms-recording-responsable-ctn').slideUp(300, function () {
				$(this).find('input').val('');
			});
			$('.audition-forms-recording-dates-ctn').slideDown(300);
		}
	};

	var initCheckPageLeave = function initCheckPageLeave() {
		if (!checkingPageLeave) {
			checkingPageLeave = true;
			$('a').click(function (event) {
				checkPageLeave(event, $(this));
			});
		}
	};

	var checkPageLeave = function checkPageLeave(event, link) {
		event.preventDefault();

		pageLeaveUrl = link.attr('href');

		$('.leave-page-popup-btn').trigger('click');
	};

	var confirmPageLeave = function confirmPageLeave() {
		window.location.href = pageLeaveUrl;
	};

	var forwardToInvitesPage = function forwardToInvitesPage() {
		$(this).closest('.popup').addClass('is-processing');
		window.location.href = redirectInvites + popupRedirect;
	};

	// @param   region   optional (ids of gendata available-region)
	var inviteAllAgencies = function inviteAllAgencies(regions) {
		var popup = $(this).closest('.popup');
		var agenciesIds = popup.find('.all-agencies-invites-details').attr('data-ids');
		//		console.log('before:', agenciesIds)
		if (regions && regions.length > 0) {
			agenciesIds = popup.find('.all-agencies-invites-details').attr('data-ids-with-regions').split(';').filter(function (s) {
				return s.split('|')[1].split(',').some(function (region) {
					return regions.split(',').indexOf(region) >= 0;
				});
			}).map(function (s) {
				return s.split('|')[0];
			}).join(",");
		}
		//		console.log('after:', agenciesIds)

		popup.addClass('is-processing');
		var data = {
			auditionId: auditionId,
			personIds: agenciesIds,
			// jsons: jsons,
			ajax: true
		};
		//		console.log(data)

		$.ajax({
			url: '/action/vcSendAuditionInvitations',
			cache: false,
			method: 'POST',
			data: data,
			success: function success(response) {
				//				console.log('Invite : ' + response);
				notificationUtils.sendNotificationPerson(agenciesIds, 'AUDITION_AGENCY', encodeURIComponent($('.form-input[name=field3]').val()) + '*|||*' + popup.find('.all-agencies-invites-details').attr('data-notif-url'), function () {
					window.location.href = redirect + popupRedirect;
				}, { field8: searcherId });
			}
		});
	};

	var handleAuditionTypeSpecificInputs = function handleAuditionTypeSpecificInputs() {
		var val = $(this).val();

		if (val === '0') {
			$('.video-input').slideUp(function () {
				$('.audio-input').slideDown();
			});
		} else {
			$('.audio-input').slideUp(function () {
				$('.video-input').slideDown();
			});
		}
	};

	var showDetail = function showDetail() {
		$(".edit-notification-detail").toggleClass("hide");
	};

	var sendInvitesPopupBtnClick = function sendInvitesPopupBtnClick() {
		var popup = $(this).closest('.popup');
		var selectedOption = $('[name=invite-agencies-radio]:checked').val();

		if (selectedOption == "all-agencies") {
			var regions = '';
			var selectedRegions = popup.find('.account-option-item:not(.clone)');
			selectedRegions.each(function (i) {
				regions += $(this).attr('data-value');
				if (i + 1 < selectedRegions.length) {
					regions += ',';
				}
			});
			inviteAllAgencies.call(this, regions);
		} else {
			popup.addClass('is-processing');
			window.location.href = redirectInvites + popupRedirect;
		}
	};

	var showDetail = function showDetail() {
		$(".edit-notification-detail").toggleClass("hide");
	};

	//	var changeStudioFilter = function() {
	//		var t = $(this);
	//
	//        if (sourceConnectChk.is(":checked")) {
	//            t.prop('checked', true);
	//            return;
	//        }
	//	};
	//    
	//	var changeSourceConnectFilter = function() {
	//		var t = $(this);
	//
	//
	//		if (t.is(':checked')) {
	//            studioChk.prop("checked", true);
	//		}
	//
	//	};

	var init = function init() {
		form = Fw.component.models().form;
		notificationUtils = Fw.component.models().notificationUtils;
		accountUtils = Fw.page.models().account;
		customSelect = Fw.component.models().customSelect;

		auditionId = $('input[name="id"]').val();
		auditionState = $('input[name="audition-state"]').val();
		currForm = $('.auditions-form');
		formSubmit = $('.auditions-form-btn');
		publishCtn = $('.auditions-form-publish-ctn');
		stepHeader = $('.audition-forms-header');
		stepNextBtn = $('.audition-forms-step-next-btn');
		stepHeight = $('.audition-forms-step:not(.selected)').outerHeight();
		addStudioDate = $('.audition-forms-recording-dates-add');
		directivesInput = $('.form-item-upload-input[name="audition-forms-directives-files-input"]');
		scriptsInput = $('.form-item-upload-input[name="audition-forms-scripts-files-input"]');
		scriptAdd = $('.audition-forms-scripts-files-submit');
		auditionType = $(".audition-type-select-ctn .select-option");
		recordingCheck = $('.audition-forms-recording-responsable');
		searcherId = $('.audition-single-audition-researcher-id').val();
		sendEditNotificationCheck = $('.auditions-form-notify-check');
		sendInvitesPopupBtn = $('.send-invites-popup-btn');
		studioChk = $('.auditions-invitation-studio-chk');
		sourceConnectChk = $('.auditions-invitation-sourceConnect-chk');

		currForm.find('.form-input').each(function () {
			$(this).blur(initCheckPageLeave);
		});
		$('.confirm-page-leave-btn').click(confirmPageLeave);
		formSubmit.click(submitAudition);
		addStudioDate.click(addStudioDateItem);
		directivesInput.change(addDirective);
		scriptsInput.change(addScripts);
		$('body').on('click', '.audition-form-script-item-del', scriptDelClick);
		stepHeader.click(stepHeaderClick);
		stepNextBtn.click(goToNextStep);
		auditionType.on("click", auditionTypeToggle);
		recordingCheck.change(recordingToggle);
		$('.forward-to-invites-page-btn').click(forwardToInvitesPage);
		$('.invite-all-agencies-btn').click(inviteAllAgencies);
		$('.audition-file-type-select').change(handleAuditionTypeSpecificInputs);
		sendEditNotificationCheck.click(showDetail);
		sendInvitesPopupBtn.on('click', sendInvitesPopupBtnClick);

		$('.popup[data-id=invites-choice-popup]').on('popup_closed', function () {
			$('.auditions-form').removeClass('is-processing');
		});

		$('.form-input[name="field16"]', currForm).on('change', function () {
			var regionId = $(this).attr('data-value');
			var regionSelect = $('.invites-choice-popup').find('[name=region]');
			regionSelect.val(regionId);
		});

		win.resize(function () {
			if (win.width() != winWidth) {
				winHeight = win.height();
				winWidth = win.width();

				if ($('.audition-forms-step:not(.selected)').length) {
					stepHeight = $('.audition-forms-step:not(.selected)').outerHeight();
				} else {
					$('.audition-forms-step').eq(0).removeClass('selected').find('.audition-forms-step-content').slideUp(0);
					stepHeight = $('.audition-forms-step').eq(0).outerHeight();
					$('.audition-forms-step').eq(0).addClass('selected').find('.audition-forms-step-content').slideDown(0);
				}
			}
		});

		//		studioChk.click(changeStudioFilter);
		//		sourceConnectChk.click(changeSourceConnectFilter);
	};

	$(window).ready(init);
})(jQuery);
(function ($, undefined) {

	'use strict';

	var notificationUtils;
	var formValidator;

	var auditionId;
	var auditionState;

	var updateAllSelected = function updateAllSelected() {
		var t = $(this);
		if (t.is(':checked')) {
			$('.auditions-invitation-select-invite-chk').prop('checked', true);
		} else {
			$('.auditions-invitation-select-invite-chk').prop('checked', false);
		}

		updateSelected();
	};

	/**
  * update selected artists
  * @param  {[array]} selectedArtists [optionnal]
  */
	var updateSelected = function updateSelected(selectedArtists) {
		if (selectedArtists && selectedArtists.length > 0) {
			$('.auditions-invitation-select-item:not(.hide)').each(function (i, el) {
				if (selectedArtists.indexOf($(el).attr('data-id')) != -1) {
					$(el).find('.auditions-invitation-select-invite-chk').prop("checked", true);
					$(el).find('.auditions-invitation-select-invite-chk').trigger("change");
				}
			});
		}
		var allChk = $('.auditions-invitation-select-item:not(.hide) .auditions-invitation-select-invite-chk:checked');
		var allNotChk = $('.auditions-invitation-select-item.hide .auditions-invitation-select-invite-chk, .auditions-invitation-select-invite-chk:not(:checked)');
		var total = $('.auditions-invitation-select-item:not(.hide) .auditions-invitation-select-invite-chk').length;
		var totalChk = allChk.length;
		var artistsChk = allChk.filter(function () {
			return $(this).closest('.auditions-invitation-select-item').attr('data-type') === '0';
		});
		var agenciesChk = allChk.filter(function () {
			return $(this).closest('.auditions-invitation-select-item').attr('data-type') === '2';
		});
		$('.auditions-invitation-artist-count').html(artistsChk.length);
		$('.auditions-invitation-agency-count').html(agenciesChk.length);
		// var newNameList = '';

		allChk.each(function () {
			var t = $(this);
			var item = t.closest('.auditions-invitation-select-item');
			var id = item.attr('data-id');
			var clone = $('.audition-availability-questions-ctn.clone').clone();
			var toggleBtn = clone.find('.audition-availability-toggle-btn');
			var concurrencyCheck = clone.find('.concurrent-participation-check');
			var availabilityCheck = clone.find('.audition-availability-check');
			var artistRecordingCheck = clone.find('.artist-recording-check');

			item.addClass('selected');

			if ($('.popup[data-id="audition-send-invitations"]').find('.audition-availability-questions-ctn[data-id=' + id + ']').length === 0) {
				clone.find('.audition-availability-person-name').html($.trim($('.auditions-invitation-select-name', item).text()));
				clone.attr('data-id', item.attr('data-id'));
				$(toggleBtn, clone).attr('data-id', $(toggleBtn, clone).attr('data-id') + id);
				$('.audition-availability-questions-content-ctn', clone).attr('data-id', $(toggleBtn, clone).attr('data-id'));
				$(concurrencyCheck, clone).attr('data-id', $(concurrencyCheck, clone).attr('data-id') + id);
				$('.concurrent-participation-details-ctn', clone).attr('data-id', $(concurrencyCheck, clone).attr('data-id'));
				$(availabilityCheck, clone).attr('data-id', $(availabilityCheck, clone).attr('data-id') + id);
				$('.audition-availability-details-ctn', clone).attr('data-id', $(availabilityCheck, clone).attr('data-id'));
				$(artistRecordingCheck, clone).attr('data-id', $(artistRecordingCheck, clone).attr('data-id') + id);
				$('.artist-recording-details-ctn', clone).attr('data-id', $(artistRecordingCheck, clone).attr('data-id'));

				clone.removeClass('clone hide');
				$('.popup[data-id="audition-send-invitations"]').find('.audition-availability-artists-ctn').append(clone);
			}
			// if (newNameList !== '') {
			// 	newNameList += ', ';
			// }

			// newNameList += $.trim($('.auditions-invitation-select-name', item).text());
		});

		allNotChk.each(function () {
			var t = $(this);
			var item = t.closest('.auditions-invitation-select-item');
			var id = item.attr('data-id');

			$('.popup[data-id="audition-send-invitations"]').find('.audition-availability-questions-ctn[data-id=' + id + ']').remove();
			item.removeClass('selected');
		});

		// if (!sendInvitePopup.hasClass('agency-invites')) {
		// 	$('.action-form-item', sendInvitePopup).html(newNameList);
		// } else {
		$('.popup[data-id="audition-send-invitations"] .audition-availability-selected-artists-count').html(allChk.length);
		// }

		if (total === totalChk) {
			$('.auditions-invitation-select-all-chk').prop('checked', true);
		} else {
			$('.auditions-invitation-select-all-chk').prop('checked', false);
		}

		if (totalChk !== 0) {
			$('.auditions-invitation-send-invite-btn').removeClass('disabled').removeAttr('disabled');
			$('.js-audition-send-invitations').removeClass('disabled').removeAttr('disabled');
		} else {
			$('.auditions-invitation-send-invite-btn').addClass('disabled').attr('disabled', 'true');
			$('.js-audition-send-invitations').addClass('disabled').attr('disabled', 'true');
		}
	};

	var invertNameList = function invertNameList() {
		$('.auditions-invitation-select').toggleClass('inverted');
	};

	/**
  * Update filter list
  * @param  {array} selectedArtists [optional]
  */
	var updateFilterList = function updateFilterList(selectedArtists) {
		var catSelectValue = $('.auditions-invitation-select-cat').val();
		var criteriaSelectValue = $('.auditions-invitation-select-criteria').val();

		if (!catSelectValue) {
			$('.auditions-invitation-count-item').removeClass('hide');
		} else {
			$('.auditions-invitation-count-item.cat-' + catSelectValue).removeClass('hide');
			$('.auditions-invitation-count-item:not(.cat-' + catSelectValue + ')').addClass('hide');
		}

		$('.auditions-invitation-select-item').each(function () {
			var t = $(this);
			var catVal = t.attr('data-type');
			//var criteriaVal = t.attr('data-criteria'); Unused
			var foundInProfile = t.attr('data-found-in-profile') === 'true';
			var foundInDemos = t.attr('data-found-in-demos') === 'true';

			var hideCat = catVal !== catSelectValue && catSelectValue.length !== 0;
			// La condition démo ne fait pas de sens, var si c'est dans démo, c'Est automatiquement dans profil.
			// J'enlève le choix demo du select, car ça revient au même que "all"
			var hideCriteria = criteriaSelectValue !== '' && (criteriaSelectValue === 'demo' && !(foundInDemos && !foundInProfile) || criteriaSelectValue === 'profile' && !(!foundInDemos && foundInProfile) || criteriaSelectValue === 'all' && !(foundInDemos && foundInProfile));

			if (hideCat || hideCriteria) {
				t.addClass('hide');
			} else {
				t.removeClass('hide');
			}
		});

		updateSelected(selectedArtists);
	};

	var sendInvite = function sendInvite() {
		var redirect = $(this).attr('data-redirect');
		var allChk = $('.auditions-invitation-select-item:not(.hide) .auditions-invitation-select-invite-chk:checked');
		var arrayId = '';
		var jsons = '';
		var artistIds = [];
		var agencyIds = [];
		var agencyIndirectArray = {};
		var count = 3;
		var popup = $('.popup[data-id="audition-send-invitations"]');
		var questioners = popup.find('.audition-availability-questions-ctn:not(.clone)');
		var hasInvitationDetails = questioners.find('.audition-availability-questions-content-ctn').length > 0;

		if (hasInvitationDetails) {
			questioners.each(function () {
				formValidator.validateForm($(this));
			});

			if (questioners.filter('.has-error').length > 0) {
				return false;
			}
		}
		if (!allChk.length) {
			// No invitees selected
			return false;
		}

		allChk.each(function () {
			var t = $(this);
			var item = t.closest('.auditions-invitation-select-item');
			var personId = item.attr('data-id');
			var currAgencyArray = item.attr('data-agency').split(',');

			if (arrayId !== '') {
				arrayId += ',';
			}

			arrayId += personId;

			if (jsons !== '') {
				jsons += '~';
			}

			if (hasInvitationDetails) {
				var personDetails = popup.find('.audition-availability-questions-ctn[data-id=' + personId + ']');
				var json = {
					"no-concurrence": personDetails.find('.concurrent-participation-check').prop('checked'),
					"concurrence-details": personDetails.find('input[name="concurrent-participation-details"]').val(),
					"availability": personDetails.find('.audition-availability-check').prop('checked'),
					"availability-details": personDetails.find('input[name="audition-availability-details"]').val(),
					"artist-recording": personDetails.find('.artist-recording-check').prop('checked'),
					"artist-recording-details": personDetails.find('input[name="artist-recording-details"]').val()
				};
				jsons += JSON.stringify(json);
			} else {
				// send empty json anyways so it gets assigned to proper artist in the application gendata
				jsons += JSON.stringify({});
			}

			if (item.attr('data-agency') === '' || item.attr("data-autonome") === 'true') {
				artistIds.push(personId);
			} else if (item.attr('data-type') === '2') {
				agencyIds.push(personId);
			} else if (item.attr('data-agency').length !== 0) {
				for (var k = 0; k < currAgencyArray.length; k++) {
					var id = currAgencyArray[k];
					if (id.length) {
						agencyIndirectArray[id] = {
							name: item.attr('data-name'),
							artistId: personId
						};
					}
				}
			}
		});

		var _complete = function _complete() {
			count--;
			if (count <= 0) {
				if (auditionState === '0') {
					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						method: 'POST',
						data: {
							id: auditionId,
							field13: '1',
							ajax: true
						},
						success: function success(response) {
							window.location.href = redirect;
						}
					});
				} else {
					window.location.href = redirect;
				}
			}
		};

		var data = {
			auditionId: auditionId,
			personIds: arrayId,
			jsons: jsons,
			ajax: true
		};

		popup.addClass('is-processing');
		$.ajax({
			url: '/action/vcSendAuditionInvitations',
			cache: false,
			method: 'POST',
			data: data,
			success: function success(response) {
				if (artistIds.length) {
					notificationUtils.sendNotificationPerson(artistIds.join(','), 'AUDITION_ARTIST', $('.auditions-invitation-audition-name').val() + '*|||*' + $('.auditions-invitation-audition-uri').val(), _complete, { field8: $('.auditions-invitation-sender-id').val() });
				} else {
					_complete();
				}
				if (agencyIds.length) {
					notificationUtils.sendNotificationPerson(agencyIds.join(','), 'AUDITION_AGENCY', $('.auditions-invitation-audition-name').val() + '*|||*' + $('.auditions-invitation-audition-uri').val(), _complete, { field8: $('.auditions-invitation-sender-id').val() });
				} else {
					_complete();
				}
				var agencyIndirectArrayLength = Object.keys(agencyIndirectArray).length;
				if (agencyIndirectArrayLength) {
					var agencyIndirectCount = 0;
					for (var key in agencyIndirectArray) {
						notificationUtils.sendNotificationPerson(key, 'AUDITION_AGENCY_FOR_ARTIST', $('.auditions-invitation-audition-name').val() + '*|||*' + agencyIndirectArray[key].name + '*|||*' + $('.auditions-invitation-audition-uri').val() + '?i=' + agencyIndirectArray[key].artistId, function () {
							agencyIndirectCount++;

							if (agencyIndirectCount === agencyIndirectArrayLength) {
								_complete();
							}
						}, { field8: $('.auditions-invitation-sender-id').val() });
					}
				} else {
					_complete();
				}
			}
		});
	};

	var checkForListReload = function checkForListReload(e, th) {
		var t = th !== undefined ? th : $(this);
		var list = $('.auditions-invitation-select-list');
		var ctn = $('.auditions-invitation-select');
		var data = {};

		ctn.addClass('is-processing');

		$('.filters-ctn-js').find('input').each(function (i) {
			if ($(this).val().length !== 0) {
				data[$(this).attr('name')] = $(this).val().trim();
			}
		});

		if ($('input[name=studio]').is(":checked")) {
			data["studio"] = "true";
		}

		if ($('input[name=sourceConnect]').is(":checked")) {
			data["sourceConnect"] = "true";
		}

		if ($('input[name=displayAll]').is(":checked")) {
			data["displayAll"] = "true";
		}

		var selectedArtists = $.map($('.auditions-invitation-select-item.selected'), function (e) {
			return $(e).attr('data-id');
		});

		$.ajax({
			url: window.location.href,
			cache: false,
			method: 'POST',
			data: data,
			success: function success(response) {
				var temp = $('<div></div>');
				temp.html(response);
				if (t.attr('name') === 'displayAll' || t.attr('name') === 'studio' || t.attr('name') === 'sourceConnect') {
					list.html($('.auditions-invitation-select-list', temp).html());
				} else {
					ctn.html($('.auditions-invitation-select', temp).html());
				}
				// selectChk = $('.auditions-invitation-select-invite-chk');

				ctn.removeClass('is-processing');
				updateFilterList(selectedArtists);
			}
		});
	};

	var updateSearch = function updateSearch() {
		var q = $('.auditions-invitation-select-input').val().toLowerCase();

		$('.auditions-invitation-select-item').each(function () {
			var t = $(this);
			var name = t.attr('data-name').toLowerCase();
			var info = $('.auditions-invitation-select-info', t).text().toLowerCase();
			var email = t.attr('data-email').toLowerCase();
			var agencyName = '';
			if (t.attr('data-agencyname') !== undefined) {
				agencyName = t.attr('data-agencyname').toLowerCase();
			}
			var criteria = $('.auditions-invitation-select-cell.criteria', t).text().toLowerCase();
			var isOk = false;

			// console.log(agencyName.indexOf(q))

			if (email.indexOf(q) !== -1 || name.indexOf(q) !== -1 || info.indexOf(q) !== -1 || criteria.indexOf(q) !== -1 || agencyName.indexOf(q) !== -1) {
				isOk = true;
			}

			if (isOk) {
				t.removeClass('hide-search');
			} else {
				t.addClass('hide-search');
			}
		});
	};

	// var emptyInvitesList = function() {
	// 	setTimeout(function() {
	// 		sendInvitePopup.find('.audition-availability-questions-ctn:not(.clone)').remove();
	// 	}, 300);
	// };

	var removeSelectedPerson = function removeSelectedPerson() {
		var t = $(this);
		var ctn = t.closest('.audition-availability-questions-ctn');
		var id = ctn.attr('data-id');

		ctn.slideUp();
		$('.auditions-invitation-select-item[data-id=' + id + ']').find('.auditions-invitation-select-invite-chk').trigger('click');
	};

	var changeStudioFilter = function changeStudioFilter() {
		var t = $(this);

		if (t.is(':checked')) {
			$('.auditions-invitation-sourceConnect-chk').prop("checked", true);
		} else {
			$('.auditions-invitation-sourceConnect-chk').prop("checked", false);
		}

		checkForListReload(t);
	};

	var changeSourceConnectFilter = function changeSourceConnectFilter() {
		var t = $(this);

		if ($('.auditions-invitation-studio-chk').is(":checked")) {
			t.prop('checked', true);
			return;
		}
		checkForListReload(t);
	};

	var init = function init() {
		notificationUtils = Fw.component.models().notificationUtils;
		formValidator = Fw.component.models().form;

		auditionId = $('.auditions-invitation-audition-id').val();
		auditionState = $('.auditions-invitation-audition-state').val();
		var hasPresets = false;

		$('.filters-ctn-js').find('input').each(function (i) {
			if ($(this).val().length !== 0) {
				hasPresets = true;
			}
		});
		hasPresets = $('.auditions-invitation-studio-chk').is(':checked') || $('.auditions-invitation-sourceConnect-chk').is(':checked');

		if (hasPresets && $('.filters-bar.invitations').length > 0) {
			checkForListReload();
		}
		updateSelected();

		$('.auditions-invitation').on('change', '.auditions-invitation-select-all-chk', updateAllSelected);
		$('.auditions-invitation').on('change', '.auditions-invitation-select-invite-chk', updateSelected);
		$('.auditions-invitation').on('click', '.auditions-invitation-select-invert-name', invertNameList);
		$('.auditions-invitation').on('keyup', '.auditions-invitation-select-input', updateSearch);
		$('.auditions-invitation').on('change', '.auditions-invitation-select-cat', updateFilterList);
		$('.auditions-invitation').on('change', '.auditions-invitation-select-criteria', updateFilterList);
		//		$('.auditions-invitation').on('click', '.auditions-invitation-studio-chk', changeStudioFilter);
		//		$('.auditions-invitation').on('click', '.auditions-invitation-sourceConnect-chk', changeSourceConnectFilter);
		$('.auditions-invitation').on('click', '.auditions-invitation-studio-chk', checkForListReload);
		$('.auditions-invitation').on('click', '.auditions-invitation-sourceConnect-chk', checkForListReload);
		$('body').on('click', '.js-audition-send-invitations', sendInvite);
		$('.auditions-invitation-send-invite-btn').click(updateSelected);
		$('body').on('click', '.audition-availability-remove-artist-btn', removeSelectedPerson);
		// $('.js-popup-close-btn', sendInvitePopup).click(emptyInvitesList);
		$('.auditions-invitation').on('click', 'input[name=displayAll]', checkForListReload);
	};

	$(window).ready(init);
})(jQuery);
(function ($, undefined) {

	'use strict';

	var favorites = null;

	var processFavorite = function processFavorite() {
		var t = $(this);
		var artistId = t.attr('data-artistid');
		var researcherId = t.attr('data-researcherid');
		var gendataId = t.attr('data-gendataid');
		var textCtn = t.find('.favorite-btn-text');
		var addText = t.attr('data-add');
		var removeText = t.attr('data-remove');

		if (favorites === null) {
			favorites = t.attr('data-favorites');
		}

		if (!favorites.length) {
			favorites = artistId;
		} else {
			if (favorites.split(',').indexOf(artistId) !== -1) {
				var newFavs = favorites.split(',');
				newFavs.splice(newFavs.indexOf(artistId), 1);

				favorites = newFavs.join();
			} else {
				favorites = favorites + ',' + artistId;
			}
		}

		//console.log(favorites);

		updateFavorites(t, researcherId, gendataId, favorites, function (response) {
			if (response.indexOf('success') !== -1) {
				var btns = $('.toggle-favorite-btn[data-artistid=' + artistId + ']');

				if (t.hasClass('favorite-page')) {
					t.closest('.artist-demo').fadeOut(function () {
						$(this).remove();
					});
				} else {
					if (t.hasClass('add')) {
						btns.removeClass('add');
						if (btns.attr('title')) {
							btns.attr('title', removeText);
						}
						if (btns.find('.favorite-btn-text').length) {
							textCtn.html(removeText);
						}
					} else {
						btns.addClass('add');
						if (btns.attr('title')) {
							btns.attr('title', addText);
						}
						if (btns.find('.favorite-btn-text').length) {
							textCtn.html(addText);
						}
					}
				}
			}
		});
	};

	var updateFavorites = function updateFavorites(btn, researcherId, id, favorites, callback) {
		//console.log('favoritesid:' + id);
		var data = {
			field1: 'favorites',
			field2: favorites,
			field9: researcherId,
			ajax: true
		};

		if (id !== null) {
			data.id = id;
		}

		//console.log('favorites data:');
		//console.log(JSON.stringify(data));
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: data,
			method: 'POST',
			success: function success(response) {
				//console.log('favorites new/edit : ' + response);

				if (btn.attr('data-gendataid').length === 0) {
					$('.toggle-favorite-btn').attr('data-gendataid', response.split('-')[1]);
				}

				if (typeof callback === 'function') {
					callback(response);
				}
			}
		});
	};

	var init = function init() {
		$('body').on('click', '.toggle-favorite-btn', processFavorite);
	};

	$(window).ready(function () {
		init();
	});
})(jQuery);
(function ($, undefined) {

	'use strict';

	var form;
	var popup;

	var processNewSave = function processNewSave() {
		var t = $(this);
		var currForm = t.closest('.saves-add-form');
		var currPopup = t.closest('.saves-form-popup');

		form.validateForm(currForm);

		if (!currForm.hasClass('has-error')) {
			currPopup.addClass('is-processing');

			createNewSave($('.form-input[name="title"]', currForm).val(), $('input[name="personId"]', currForm).val(), $('input[name="id"]', currForm).val(), function (response) {
				window.location.href = window.location.href;
			});
		}
	};

	var createNewSave = function createNewSave(title, personId, id, callback) {
		var data = {
			field1: 'save',
			field2: title,
			field9: personId,
			friendlyUrlField: 'field2',
			ajax: true
		};

		//Last edit date
		data.dateField2Year = new Date().getFullYear();
		data.dateField2Month = new Date().getMonth();
		data.dateField2Day = new Date().getDate();
		data.dateField2Hour = new Date().getHours();
		data.dateField2Minute = new Date().getMinutes();
		data.dateField2Second = new Date().getSeconds();

		if (id.length) {
			data.id = id;
		} else {
			//Creation date
			data.dateField1Year = new Date().getFullYear();
			data.dateField1Month = new Date().getMonth();
			data.dateField1Day = new Date().getDate();
			data.dateField1Hour = new Date().getHours();
			data.dateField1Minute = new Date().getMinutes();
			data.dateField1Second = new Date().getSeconds();
		}

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: data,
			method: 'POST',
			success: function success(response) {
				console.log('saves new/edit : ' + response);

				if (typeof callback === 'function') {
					callback(response);
				}
			}
		});
	};

	var delSave = function delSave() {
		var t = $(this);
		var currPopup = t.closest('.demo-action-form');
		var id = t.attr('data-item-id');

		currPopup.addClass('is-processing');

		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: {
				id: id,
				delete: true,
				ajax: true
			},
			method: 'POST',
			success: function success(response) {
				console.log('saves delete : ' + response);
				window.location.href = window.location.href;
			}
		});
	};

	var removeFromSave = function removeFromSave() {
		var t = $(this);
		var id = t.attr('data-item-id');
		var item = $('.save-demo-list-item[data-id="' + id + '"]');
		var saveId = $('.save-single-info').attr('data-id');

		popup.closeAllPopup();

		item.slideUp(200, function () {
			item.remove();
			var newArray = '';

			$('.save-demo-list-item').each(function () {
				if (newArray !== '') {
					newArray += ',';
				}

				newArray += $(this).attr('data-id');
			});

			$.ajax({
				url: '/action/manageGenData',
				cache: false,
				method: 'POST',
				data: {
					id: saveId,
					field3: newArray,
					ajax: true
				},
				success: function success(response) {
					console.log('Remove from list : ' + response);
				}
			});
		});
	};

	var init = function init() {
		popup = Fw.component.models().popup;
		form = Fw.component.models().form;

		$('body').on('click', '.saves-add-form-submit', processNewSave);
		$('body').on('click', '.saves-action-form-submit', delSave);
		$('body').on('click', '.artists-com-remove-from-save-confirm', removeFromSave);
	};

	$(window).ready(function () {
		init();
	});

	Fw.page.export('saves', {
		createNewSave: createNewSave
	});
})(jQuery);